export const espngames = [
  {
    "id": 401756846,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-23T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 47221,
    "venueId": 3504,
    "venue": "Aviva Stadium",
    "homeId": 2306,
    "homeTeam": "Kansas State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 21,
    "homeLineScores": [
      0,
      7,
      0,
      14
    ],
    "homePostgameWinProbability": 0.20154441893100739,
    "homePregameElo": 1669,
    "homePostgameElo": 1666,
    "awayId": 66,
    "awayTeam": "Iowa State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      0,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.7984555810689926,
    "awayPregameElo": 1616,
    "awayPostgameElo": 1619,
    "excitementIndex": 6.029094160739601,
    "highlights": "",
    "notes": "Aer Lingus College Football Classic",
    "playoff": null
  },
  {
    "id": 401760371,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-23T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25723,
    "venueId": 6501,
    "venue": "Allegiant Stadium",
    "homeId": 2439,
    "homeTeam": "UNLV",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 38,
    "homeLineScores": [
      0,
      14,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9787868857383728,
    "homePregameElo": null,
    "homePostgameElo": null,
    "awayId": 304,
    "awayTeam": "Idaho State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 31,
    "awayLineScores": [
      10,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.021213114261627197,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 9.598561710191433,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756847,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-23T22:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 41525,
    "venueId": 3833,
    "venue": "Memorial Stadium",
    "homeId": 2305,
    "homeTeam": "Kansas",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 31,
    "homeLineScores": [
      14,
      10,
      7,
      0
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1583,
    "homePostgameElo": 1632,
    "awayId": 278,
    "awayTeam": "Fresno State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1490,
    "awayPostgameElo": 1441,
    "excitementIndex": 3.7830408481663227,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757218,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-23T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15312,
    "venueId": 3796,
    "venue": "Houchens Industries-L.T. Smith Stadium",
    "homeId": 98,
    "homeTeam": "Western Kentucky",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 41,
    "homeLineScores": [
      7,
      13,
      14,
      7
    ],
    "homePostgameWinProbability": 0.8728970289230347,
    "homePregameElo": 1409,
    "homePostgameElo": 1450,
    "awayId": 2534,
    "awayTeam": "Sam Houston",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      7,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.12710297107696533,
    "awayPregameElo": 1452,
    "awayPostgameElo": 1411,
    "excitementIndex": 6.04146368507938,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754516,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-23T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15194,
    "venueId": 7220,
    "venue": "Clarence T.C. Ching Athletics Complex",
    "homeId": 62,
    "homeTeam": "Hawai'i",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 23,
    "homeLineScores": [
      7,
      7,
      3,
      6
    ],
    "homePostgameWinProbability": 0.41016319394111633,
    "homePregameElo": 1257,
    "homePostgameElo": 1258,
    "awayId": 24,
    "awayTeam": "Stanford",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 20,
    "awayLineScores": [
      10,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.5898368060588837,
    "awayPregameElo": 1283,
    "awayPostgameElo": 1282,
    "excitementIndex": 7.307567862447438,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762522,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-28T21:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 34707,
    "venueId": 3886,
    "venue": "Raymond James Stadium",
    "homeId": 58,
    "homeTeam": "South Florida",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 34,
    "homeLineScores": [
      0,
      10,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9718407988548279,
    "homePregameElo": 1456,
    "homePostgameElo": 1554,
    "awayId": 68,
    "awayTeam": "Boise State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.02815920114517212,
    "awayPregameElo": 1676,
    "awayPostgameElo": 1578,
    "excitementIndex": 5.137221554324761,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752794,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-28T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 46907,
    "venueId": 6577,
    "venue": "SHI Stadium",
    "homeId": 164,
    "homeTeam": "Rutgers",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 34,
    "homeLineScores": [
      7,
      24,
      0,
      3
    ],
    "homePostgameWinProbability": 0.9000661373138428,
    "homePregameElo": 1522,
    "homePostgameElo": 1524,
    "awayId": 195,
    "awayTeam": "Ohio",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      10,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.09993386268615723,
    "awayPregameElo": 1621,
    "awayPostgameElo": 1619,
    "excitementIndex": 6.943864856309906,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762790,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-28T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 19328,
    "venueId": 3700,
    "venue": "Doyt L. Perry Stadium",
    "homeId": 189,
    "homeTeam": "Bowling Green",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 26,
    "homeLineScores": [
      7,
      10,
      6,
      3
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1461,
    "homePostgameElo": 1461,
    "awayId": 322,
    "awayTeam": "Lafayette",
    "awayClassification": "fcs",
    "awayConference": "Patriot",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.717791924914604,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754373,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-28T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 56919,
    "venueId": 3670,
    "venue": "Carter-Finley Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 24,
    "homeLineScores": [
      3,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.7480055689811707,
    "homePregameElo": 1501,
    "homePostgameElo": 1507,
    "awayId": 151,
    "awayTeam": "East Carolina",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      7,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.25199443101882935,
    "awayPregameElo": 1435,
    "awayPostgameElo": 1429,
    "excitementIndex": 4.6509769467251365,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761588,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-28T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 12459,
    "venueId": 3817,
    "venue": "Malone Stadium",
    "homeId": 2433,
    "homeTeam": "UL Monroe",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 29,
    "homeLineScores": [
      7,
      3,
      7,
      12
    ],
    "homePostgameWinProbability": 0.9948040246963501,
    "homePregameElo": 1281,
    "homePostgameElo": 1281,
    "awayId": 2598,
    "awayTeam": "Saint Francis",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.005195975303649902,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.5420324150475073,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756848,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-28T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 43043,
    "venueId": 3652,
    "venue": "FBC Mortgage Stadium",
    "homeId": 2116,
    "homeTeam": "UCF",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 17,
    "homeLineScores": [
      0,
      0,
      3,
      14
    ],
    "homePostgameWinProbability": 0.9146236181259155,
    "homePregameElo": 1538,
    "homePostgameElo": 1554,
    "awayId": 55,
    "awayTeam": "Jacksonville State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.08537638187408447,
    "awayPregameElo": 1650,
    "awayPostgameElo": 1634,
    "excitementIndex": 7.405744591220826,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762789,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-28T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 9138,
    "venueId": 3768,
    "venue": "InfoCision Stadium",
    "homeId": 2006,
    "homeTeam": "Akron",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 0,
    "homeLineScores": [
      0,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.10256508737802505,
    "homePregameElo": 1245,
    "homePostgameElo": 1235,
    "awayId": 2751,
    "awayTeam": "Wyoming",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.897434912621975,
    "awayPregameElo": 1367,
    "awayPostgameElo": 1377,
    "excitementIndex": 4.853832638856986,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757219,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-28T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 17895,
    "venueId": 3695,
    "venue": "Delaware Stadium",
    "homeId": 48,
    "homeTeam": "Delaware",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 35,
    "homeLineScores": [
      0,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.948571503162384,
    "homePregameElo": 1500,
    "homePostgameElo": 1500,
    "awayId": 2169,
    "awayTeam": "Delaware State",
    "awayClassification": "fcs",
    "awayConference": "MEAC",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      3,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.05142849683761597,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.477316433427869,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752674,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-28T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 57321,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 61,
    "homeLineScores": [
      9,
      17,
      14,
      21
    ],
    "homePostgameWinProbability": 0.9923890829086304,
    "homePregameElo": 1640,
    "homePostgameElo": 1640,
    "awayId": 2110,
    "awayTeam": "Central Arkansas",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      0,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.007610917091369629,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.2619476923306743,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756876,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-28T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 44809,
    "venueId": 3646,
    "venue": "Boone Pickens Stadium",
    "homeId": 197,
    "homeTeam": "Oklahoma State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 27,
    "homeLineScores": [
      14,
      3,
      3,
      7
    ],
    "homePostgameWinProbability": 0.8100014328956604,
    "homePregameElo": 1334,
    "homePostgameElo": 1334,
    "awayId": 2630,
    "awayTeam": "UT Martin",
    "awayClassification": "fcs",
    "awayConference": "OVC-Big South",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.1899985671043396,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.472374103395647,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754517,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-28T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15677,
    "venueId": 3982,
    "venue": "Wallace Wade Stadium",
    "homeId": 150,
    "homeTeam": "Duke",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 45,
    "homeLineScores": [
      3,
      7,
      14,
      21
    ],
    "homePostgameWinProbability": 0.9597823023796082,
    "homePregameElo": 1526,
    "homePostgameElo": 1526,
    "awayId": 2210,
    "awayTeam": "Elon",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      10,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.040217697620391846,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.767314867159874,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756852,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-29T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 28150,
    "venueId": 4728,
    "venue": "TDECU Stadium",
    "homeId": 248,
    "homeTeam": "Houston",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 27,
    "homeLineScores": [
      7,
      10,
      7,
      3
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1375,
    "homePostgameElo": 1375,
    "awayId": 2617,
    "awayTeam": "Stephen F. Austin",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.3544950535553952,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752793,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-29T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 47774,
    "venueId": 3953,
    "venue": "Huntington Bank Stadium",
    "homeId": 135,
    "homeTeam": "Minnesota",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 23,
    "homeLineScores": [
      0,
      10,
      3,
      10
    ],
    "homePostgameWinProbability": 0.9927180409431458,
    "homePregameElo": 1616,
    "homePostgameElo": 1625,
    "awayId": 2084,
    "awayTeam": "Buffalo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.007281959056854248,
    "awayPregameElo": 1416,
    "awayPostgameElo": 1407,
    "excitementIndex": 4.44321876439467,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762430,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-29T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 26294,
    "venueId": 7221,
    "venue": "Protective Stadium",
    "homeId": 5,
    "homeTeam": "UAB",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 52,
    "homeLineScores": [
      10,
      7,
      21,
      14
    ],
    "homePostgameWinProbability": 0.622718095779419,
    "homePregameElo": 1319,
    "homePostgameElo": 1319,
    "awayId": 2011,
    "awayTeam": "Alabama State",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 42,
    "awayLineScores": [
      7,
      14,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.37728190422058105,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 7.242758388206213,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752796,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-29T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 72884,
    "venueId": 3622,
    "venue": "GEHA Field at Arrowhead Stadium",
    "homeId": 2132,
    "homeTeam": "Cincinnati",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 17,
    "homeLineScores": [
      3,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.6352569460868835,
    "homePregameElo": 1475,
    "homePostgameElo": 1477,
    "awayId": 158,
    "awayTeam": "Nebraska",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      13,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.36474305391311646,
    "awayPregameElo": 1524,
    "awayPostgameElo": 1522,
    "excitementIndex": 6.207148038057158,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762791,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-29T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 65952,
    "venueId": 347,
    "venue": "Camp Randall Stadium",
    "homeId": 275,
    "homeTeam": "Wisconsin",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 17,
    "homeLineScores": [
      3,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1536,
    "homePostgameElo": 1573,
    "awayId": 193,
    "awayTeam": "Miami (OH)",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1528,
    "awayPostgameElo": 1491,
    "excitementIndex": 3.94006770879842,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760357,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-29T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20624,
    "venueId": 7311,
    "venue": "Snapdragon Stadium",
    "homeId": 21,
    "homeTeam": "San Diego State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 42,
    "homeLineScores": [
      14,
      6,
      8,
      14
    ],
    "homePostgameWinProbability": 0.9745745062828064,
    "homePregameElo": 1318,
    "homePostgameElo": 1318,
    "awayId": 2619,
    "awayTeam": "Stony Brook",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.025425493717193604,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.150955628954011,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762432,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-29T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23032,
    "venueId": 3841,
    "venue": "Michie Stadium",
    "homeId": 349,
    "homeTeam": "Army",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 27,
    "homeLineScores": [
      7,
      10,
      7,
      0,
      3
    ],
    "homePostgameWinProbability": 0.6962294578552246,
    "homePregameElo": 1607,
    "homePostgameElo": 1607,
    "awayId": 2627,
    "awayTeam": "Tarleton State",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 30,
    "awayLineScores": [
      3,
      7,
      7,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.3037705421447754,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.9127413278628165,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401766898,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-29T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 18034,
    "venueId": 2031,
    "venue": "Pitbull Stadium",
    "homeId": 2229,
    "homeTeam": "Florida International",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 42,
    "homeLineScores": [
      7,
      21,
      7,
      7
    ],
    "homePostgameWinProbability": 0.952778697013855,
    "homePregameElo": 1372,
    "homePostgameElo": 1372,
    "awayId": 2065,
    "awayTeam": "Bethune-Cookman",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 9,
    "awayLineScores": [
      3,
      3,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.04722130298614502,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.5516503900016345,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754374,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-29T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 30789,
    "venueId": 3630,
    "venue": "Allegacy Federal Credit Union Stadium",
    "homeId": 154,
    "homeTeam": "Wake Forest",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 10,
    "homeLineScores": [
      7,
      0,
      3,
      0
    ],
    "homePostgameWinProbability": 0.7367027401924133,
    "homePregameElo": 1397,
    "homePostgameElo": 1394,
    "awayId": 338,
    "awayTeam": "Kennesaw State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 9,
    "awayLineScores": [
      6,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.26329725980758667,
    "awayPregameElo": 1266,
    "awayPostgameElo": 1269,
    "excitementIndex": 6.22130557202866,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761589,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-29T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 35718,
    "venueId": 3628,
    "venue": "Bank of America Stadium",
    "homeId": 2429,
    "homeTeam": "Charlotte",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 11,
    "homeLineScores": [
      3,
      0,
      0,
      8
    ],
    "homePostgameWinProbability": 0.042695220559835434,
    "homePregameElo": 1254,
    "homePostgameElo": 1221,
    "awayId": 2026,
    "awayTeam": "App State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 34,
    "awayLineScores": [
      0,
      17,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.9573047794401646,
    "awayPregameElo": 1428,
    "awayPostgameElo": 1461,
    "excitementIndex": 3.6672300484451488,
    "highlights": "",
    "notes": "Duke’s Mayo Classic",
    "playoff": null
  },
  {
    "id": 401752802,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-29T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 71657,
    "venueId": 3936,
    "venue": "Spartan Stadium",
    "homeId": 127,
    "homeTeam": "Michigan State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 23,
    "homeLineScores": [
      7,
      14,
      2,
      0
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1368,
    "homePostgameElo": 1403,
    "awayId": 2711,
    "awayTeam": "Western Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      0,
      0,
      6
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1345,
    "awayPostgameElo": 1310,
    "excitementIndex": 3.7661354973196874,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752795,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-29T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 56040,
    "venueId": 3832,
    "venue": "Memorial Stadium (Champaign, IL)",
    "homeId": 356,
    "homeTeam": "Illinois",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 52,
    "homeLineScores": [
      14,
      17,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9946691989898682,
    "homePregameElo": 1578,
    "homePostgameElo": 1578,
    "awayId": 2710,
    "awayTeam": "Western Illinois",
    "awayClassification": "fcs",
    "awayConference": "OVC-Big South",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.005330801010131836,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.8018660135329183,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756854,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-29T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 39129,
    "venueId": 3833,
    "venue": "Memorial Stadium",
    "homeId": 2305,
    "homeTeam": "Kansas",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 46,
    "homeLineScores": [
      14,
      15,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9886996150016785,
    "homePregameElo": 1633,
    "homePostgameElo": 1633,
    "awayId": 2681,
    "awayTeam": "Wagner",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.011300384998321533,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.6144160037316513,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754375,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 52868,
    "venueId": 3726,
    "venue": "Folsom Field",
    "homeId": 38,
    "homeTeam": "Colorado",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 20,
    "homeLineScores": [
      7,
      3,
      3,
      7
    ],
    "homePostgameWinProbability": 0.19433777034282684,
    "homePregameElo": 1634,
    "homePostgameElo": 1613,
    "awayId": 59,
    "awayTeam": "Georgia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      13,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.8056622296571732,
    "awayPregameElo": 1536,
    "awayPostgameElo": 1557,
    "excitementIndex": 5.409469095229784,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752667,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 45233,
    "venueId": 4727,
    "venue": "McLane Stadium",
    "homeId": 239,
    "homeTeam": "Baylor",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 24,
    "homeLineScores": [
      3,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.3652919828891754,
    "homePregameElo": 1604,
    "homePostgameElo": 1569,
    "awayId": 2,
    "awayTeam": "Auburn",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      10,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.6347080171108246,
    "awayPregameElo": 1574,
    "awayPostgameElo": 1609,
    "excitementIndex": 5.207606567811596,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757224,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T01:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 5837,
    "venueId": 3631,
    "venue": "BBVA Compass Stadium",
    "homeId": 2534,
    "homeTeam": "Sam Houston",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 21,
    "homeLineScores": [
      7,
      0,
      0,
      14
    ],
    "homePostgameWinProbability": 0.03245411068201065,
    "homePregameElo": 1411,
    "homePostgameElo": 1397,
    "awayId": 2439,
    "awayTeam": "UNLV",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 38,
    "awayLineScores": [
      14,
      10,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9675458893179893,
    "awayPregameElo": 1619,
    "awayPostgameElo": 1633,
    "excitementIndex": 3.6618211785683403,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760358,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 14877,
    "venueId": 3935,
    "venue": "CEFCU Stadium",
    "homeId": 23,
    "homeTeam": "San José State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.12722167372703552,
    "homePregameElo": 1484,
    "homePostgameElo": 1467,
    "awayId": 2117,
    "awayTeam": "Central Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 16,
    "awayLineScores": [
      10,
      3,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.8727783262729645,
    "awayPregameElo": 1235,
    "awayPostgameElo": 1252,
    "excitementIndex": 6.0997865114863705,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752673,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 33485,
    "venueId": 3815,
    "venue": "M. M. Roberts Stadium",
    "homeId": 2572,
    "homeTeam": "Southern Miss",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 17,
    "homeLineScores": [
      3,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.0314677357673645,
    "homePregameElo": 1119,
    "homePostgameElo": 1107,
    "awayId": 344,
    "awayTeam": "Mississippi State",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 34,
    "awayLineScores": [
      10,
      3,
      21,
      0
    ],
    "awayPostgameWinProbability": 0.9685322642326355,
    "awayPregameElo": 1412,
    "awayPostgameElo": 1424,
    "excitementIndex": 4.441994027739813,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762792,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 8647,
    "venueId": 3696,
    "venue": "Dix Stadium",
    "homeId": 2309,
    "homeTeam": "Kent State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 21,
    "homeLineScores": [
      0,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.7979961633682251,
    "homePregameElo": 1006,
    "homePostgameElo": 1006,
    "awayId": 2771,
    "awayTeam": "Merrimack",
    "awayClassification": "fcs",
    "awayConference": "FCS Independents",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      3,
      3,
      11
    ],
    "awayPostgameWinProbability": 0.2020038366317749,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.481133614709961,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752801,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 53994,
    "venueId": 3907,
    "venue": "Ross-Ade Stadium",
    "homeId": 2509,
    "homeTeam": "Purdue",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 31,
    "homeLineScores": [
      14,
      7,
      7,
      3
    ],
    "homePostgameWinProbability": 0.988307774066925,
    "homePregameElo": 1207,
    "homePostgameElo": 1293,
    "awayId": 2050,
    "awayTeam": "Ball State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.011692225933074951,
    "awayPregameElo": 1224,
    "awayPostgameElo": 1138,
    "excitementIndex": 2.588454535328131,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752676,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 45918,
    "venueId": 5348,
    "venue": "Mercedes-Benz Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 45,
    "homeLineScores": [
      17,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9442566633224487,
    "homePregameElo": 1776,
    "homePostgameElo": 1799,
    "awayId": 183,
    "awayTeam": "Syracuse",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 26,
    "awayLineScores": [
      0,
      14,
      6,
      6
    ],
    "awayPostgameWinProbability": 0.05574333667755127,
    "awayPregameElo": 1499,
    "awayPostgameElo": 1476,
    "excitementIndex": 4.3399094147520065,
    "highlights": "",
    "notes": "Aflac Kickoff",
    "playoff": null
  },
  {
    "id": 401752797,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 35067,
    "venueId": 3665,
    "venue": "SECU Stadium",
    "homeId": 120,
    "homeTeam": "Maryland",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 39,
    "homeLineScores": [
      7,
      26,
      6,
      0
    ],
    "homePostgameWinProbability": 0.9894888997077942,
    "homePregameElo": 1438,
    "homePostgameElo": 1509,
    "awayId": 2226,
    "awayTeam": "Florida Atlantic",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.01051110029220581,
    "awayPregameElo": 1311,
    "awayPostgameElo": 1240,
    "excitementIndex": 4.6495327038332155,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752803,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 22103,
    "venueId": 4729,
    "venue": "Yulman Stadium",
    "homeId": 2655,
    "homeTeam": "Tulane",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 23,
    "homeLineScores": [
      7,
      13,
      3,
      0
    ],
    "homePostgameWinProbability": 0.9883838891983032,
    "homePregameElo": 1616,
    "homePostgameElo": 1644,
    "awayId": 77,
    "awayTeam": "Northwestern",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 3,
    "awayLineScores": [
      3,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.011616110801696777,
    "awayPregameElo": 1431,
    "awayPostgameElo": 1403,
    "excitementIndex": 3.4735579019831504,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754520,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 53006,
    "venueId": 3752,
    "venue": "Acrisure Stadium",
    "homeId": 221,
    "homeTeam": "Pittsburgh",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 61,
    "homeLineScores": [
      14,
      20,
      14,
      13
    ],
    "homePostgameWinProbability": 0.9959656000137329,
    "homePregameElo": 1470,
    "homePostgameElo": 1470,
    "awayId": 2184,
    "awayTeam": "Duquesne",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 9,
    "awayLineScores": [
      0,
      6,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.00403439998626709,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.47575245890134,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762434,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 30014,
    "venueId": 3852,
    "venue": "Navy-Marine Corps Memorial Stadium",
    "homeId": 2426,
    "homeTeam": "Navy",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 52,
    "homeLineScores": [
      7,
      21,
      10,
      14
    ],
    "homePostgameWinProbability": 0.996229350566864,
    "homePregameElo": 1543,
    "homePostgameElo": 1543,
    "awayId": 2678,
    "awayTeam": "VMI",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0037706494331359863,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.789700254532362,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752677,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 107524,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.750937283039093,
    "homePregameElo": 1974,
    "homePostgameElo": 1977,
    "awayId": 251,
    "awayTeam": "Texas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.24906271696090698,
    "awayPregameElo": 1861,
    "awayPostgameElo": 1858,
    "excitementIndex": 3.8398377534422923,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752670,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 56457,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      7,
      3,
      0,
      14
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1498,
    "homePostgameElo": 1507,
    "awayId": 2649,
    "awayTeam": "Toledo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      2,
      0,
      14
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1454,
    "awayPostgameElo": 1445,
    "excitementIndex": 4.645077771761659,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754518,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 41221,
    "venueId": 3615,
    "venue": "Alumni Stadium (Chestnut Hill, MA)",
    "homeId": 103,
    "homeTeam": "Boston College",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 66,
    "homeLineScores": [
      14,
      7,
      24,
      21
    ],
    "homePostgameWinProbability": 0.9878271818161011,
    "homePregameElo": 1508,
    "homePostgameElo": 1508,
    "awayId": 2230,
    "awayTeam": "Fordham",
    "awayClassification": "fcs",
    "awayConference": "Patriot",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.012172818183898926,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.976087307715974,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757167,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 37594,
    "venueId": 3892,
    "venue": "Pratt & Whitney Stadium",
    "homeId": 41,
    "homeTeam": "UConn",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 59,
    "homeLineScores": [
      14,
      21,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9877551794052124,
    "homePregameElo": 1454,
    "homePostgameElo": 1454,
    "awayId": 2115,
    "awayTeam": "Central Connecticut",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 13,
    "awayLineScores": [
      7,
      3,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.012244820594787598,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.95550409152391,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756878,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 57093,
    "venueId": 3842,
    "venue": "Milan Puskar Stadium",
    "homeId": 277,
    "homeTeam": "West Virginia",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 45,
    "homeLineScores": [
      7,
      3,
      14,
      21
    ],
    "homePostgameWinProbability": 0.9934393763542175,
    "homePregameElo": 1470,
    "homePostgameElo": 1470,
    "awayId": 2523,
    "awayTeam": "Robert Morris",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.006560623645782471,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.57973720985092,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752806,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T18:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 47109,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 27,
    "homeLineScores": [
      7,
      10,
      10,
      0
    ],
    "homePostgameWinProbability": 0.5844941139221191,
    "homePregameElo": 1800,
    "homePostgameElo": 1800,
    "awayId": 295,
    "awayTeam": "Old Dominion",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.41550588607788086,
    "awayPregameElo": 1480,
    "awayPostgameElo": 1480,
    "excitementIndex": 3.9242669449124707,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754519,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 50536,
    "venueId": 3873,
    "venue": "L&N Federal Credit Union Stadium",
    "homeId": 97,
    "homeTeam": "Louisville",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 51,
    "homeLineScores": [
      21,
      20,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9598361849784851,
    "homePregameElo": 1706,
    "homePostgameElo": 1706,
    "awayId": 2198,
    "awayTeam": "Eastern Kentucky",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      7,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.04016381502151489,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.0636716021323727,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760359,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 30207,
    "venueId": 3713,
    "venue": "Falcon Stadium",
    "homeId": 2005,
    "homeTeam": "Air Force",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 49,
    "homeLineScores": [
      14,
      14,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9948325753211975,
    "homePregameElo": 1438,
    "homePostgameElo": 1438,
    "awayId": 2083,
    "awayTeam": "Bucknell",
    "awayClassification": "fcs",
    "awayConference": "Patriot",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      7,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.00516742467880249,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.441692868709148,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752665,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 67277,
    "venueId": 3697,
    "venue": "Doak Campbell Stadium",
    "homeId": 52,
    "homeTeam": "Florida State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 31,
    "homeLineScores": [
      7,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9667693972587585,
    "homePregameElo": 1408,
    "homePostgameElo": 1477,
    "awayId": 333,
    "awayTeam": "Alabama",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.033230602741241455,
    "awayPregameElo": 1824,
    "awayPostgameElo": 1755,
    "excitementIndex": 4.8906927608722865,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752669,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 93033,
    "venueId": 3917,
    "venue": "Sanford Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 45,
    "homeLineScores": [
      14,
      10,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9931291341781616,
    "homePregameElo": 1998,
    "homePostgameElo": 2053,
    "awayId": 276,
    "awayTeam": "Marshall",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.006870865821838379,
    "awayPregameElo": 1574,
    "awayPostgameElo": 1519,
    "excitementIndex": 2.831958872682932,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762793,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 10569,
    "venueId": 3764,
    "venue": "Huskie Stadium",
    "homeId": 2459,
    "homeTeam": "Northern Illinois",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 19,
    "homeLineScores": [
      3,
      3,
      0,
      13
    ],
    "homePostgameWinProbability": 0.8463576436042786,
    "homePregameElo": 1470,
    "homePostgameElo": 1470,
    "awayId": 107,
    "awayTeam": "Holy Cross",
    "awayClassification": "fcs",
    "awayConference": "Patriot",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      3,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.15364235639572144,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.2914887592355555,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756853,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 61500,
    "venueId": 3772,
    "venue": "Jack Trice Stadium",
    "homeId": 66,
    "homeTeam": "Iowa State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 55,
    "homeLineScores": [
      14,
      13,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9931229948997498,
    "homePregameElo": 1621,
    "homePostgameElo": 1621,
    "awayId": 233,
    "awayTeam": "South Dakota",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.006877005100250244,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.3546079527757073,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752807,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 106915,
    "venueId": 3632,
    "venue": "Beaver Stadium",
    "homeId": 213,
    "homeTeam": "Penn State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 46,
    "homeLineScores": [
      10,
      17,
      12,
      7
    ],
    "homePostgameWinProbability": 0.9887898564338684,
    "homePregameElo": 2063,
    "homePostgameElo": 2073,
    "awayId": 2440,
    "awayTeam": "Nevada",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 11,
    "awayLineScores": [
      0,
      3,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.011210143566131592,
    "awayPregameElo": 1294,
    "awayPostgameElo": 1284,
    "excitementIndex": 3.706021586002457,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762456,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 11565,
    "venueId": 3985,
    "venue": "Warren McGuirk Alumni Stadium",
    "homeId": 113,
    "homeTeam": "Massachusetts",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 10,
    "homeLineScores": [
      10,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.015759259462356567,
    "homePregameElo": 1193,
    "homePostgameElo": 1101,
    "awayId": 218,
    "awayTeam": "Temple",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 42,
    "awayLineScores": [
      7,
      21,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.9842407405376434,
    "awayPregameElo": 1192,
    "awayPostgameElo": 1284,
    "excitementIndex": 3.8483313691960914,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752804,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 57257,
    "venueId": 3626,
    "venue": "Autzen Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 59,
    "homeLineScores": [
      17,
      21,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9936597943305969,
    "homePregameElo": 1860,
    "homePostgameElo": 1860,
    "awayId": 147,
    "awayTeam": "Montana State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      3,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.006340205669403076,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.8004427689666893,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757220,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20337,
    "venueId": 3992,
    "venue": "Williams Stadium (VA)",
    "homeId": 2335,
    "homeTeam": "Liberty",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 28,
    "homeLineScores": [
      0,
      7,
      0,
      21
    ],
    "homePostgameWinProbability": 0.9477583765983582,
    "homePregameElo": 1502,
    "homePostgameElo": 1502,
    "awayId": 311,
    "awayTeam": "Maine",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.052241623401641846,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.501209893183468,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752666,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 70827,
    "venueId": 3887,
    "venue": "Razorback Stadium",
    "homeId": 8,
    "homeTeam": "Arkansas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 52,
    "homeLineScores": [
      10,
      21,
      14,
      7
    ],
    "homePostgameWinProbability": 0.954650342464447,
    "homePregameElo": 1574,
    "homePostgameElo": 1574,
    "awayId": 2010,
    "awayTeam": "Alabama A&M",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.04534965753555298,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.687395892523427,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762433,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25011,
    "venueId": 3805,
    "venue": "Simmons Bank Liberty Stadium",
    "homeId": 235,
    "homeTeam": "Memphis",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 45,
    "homeLineScores": [
      14,
      14,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9934501051902771,
    "homePregameElo": 1604,
    "homePostgameElo": 1604,
    "awayId": 236,
    "awayTeam": "Chattanooga",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0065498948097229,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.82049571942945,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752799,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 69250,
    "venueId": 3793,
    "venue": "Kinnick Stadium",
    "homeId": 2294,
    "homeTeam": "Iowa",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 34,
    "homeLineScores": [
      3,
      14,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9937663078308105,
    "homePregameElo": 1682,
    "homePostgameElo": 1682,
    "awayId": 399,
    "awayTeam": "UAlbany",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.006233692169189453,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.706247041004862,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761590,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24965,
    "venueId": 3651,
    "venue": "Bridgeforth Stadium",
    "homeId": 256,
    "homeTeam": "James Madison",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 45,
    "homeLineScores": [
      14,
      14,
      3,
      14
    ],
    "homePostgameWinProbability": 0.9937936067581177,
    "homePregameElo": 1627,
    "homePostgameElo": 1627,
    "awayId": 2692,
    "awayTeam": "Weber State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.006206393241882324,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.7608139230966167,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752675,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 83218,
    "venueId": 3835,
    "venue": "Memorial Stadium (Norman, OK)",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 35,
    "homeLineScores": [
      7,
      14,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9924291968345642,
    "homePregameElo": 1650,
    "homePostgameElo": 1650,
    "awayId": 2287,
    "awayTeam": "Illinois State",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.007570803165435791,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.9983928062016716,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754616,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 46143,
    "venueId": 3923,
    "venue": "Scott Stadium",
    "homeId": 258,
    "homeTeam": "Virginia",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 48,
    "homeLineScores": [
      7,
      21,
      14,
      6
    ],
    "homePostgameWinProbability": 0.9922709465026855,
    "homePregameElo": 1404,
    "homePostgameElo": 1521,
    "awayId": 324,
    "awayTeam": "Coastal Carolina",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.007729053497314453,
    "awayPregameElo": 1379,
    "awayPostgameElo": 1262,
    "excitementIndex": 3.3129902798197115,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752668,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 89451,
    "venueId": 3634,
    "venue": "Ben Hill Griffin Stadium",
    "homeId": 57,
    "homeTeam": "Florida",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 55,
    "homeLineScores": [
      14,
      24,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9889460802078247,
    "homePregameElo": 1678,
    "homePostgameElo": 1678,
    "awayId": 2341,
    "awayTeam": "Long Island University",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.011053919792175293,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.385883070261922,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752679,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 35000,
    "venueId": 3973,
    "venue": "FirstBank Stadium",
    "homeId": 238,
    "homeTeam": "Vanderbilt",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 45,
    "homeLineScores": [
      14,
      14,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9889649748802185,
    "homePregameElo": 1497,
    "homePostgameElo": 1497,
    "awayId": 2127,
    "awayTeam": "Charleston Southern",
    "awayClassification": "fcs",
    "awayConference": "OVC-Big South",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.011035025119781494,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.7451869108600695,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757222,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 18505,
    "venueId": 3725,
    "venue": "Johnny \"Red\" Floyd Stadium",
    "homeId": 2393,
    "homeTeam": "Middle Tennessee",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.04707856848835945,
    "homePregameElo": 1228,
    "homePostgameElo": 1228,
    "awayId": 2046,
    "awayTeam": "Austin Peay",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 34,
    "awayLineScores": [
      14,
      7,
      3,
      10
    ],
    "awayPostgameWinProbability": 0.9529214315116405,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.462974439157419,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756855,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 51927,
    "venueId": 3636,
    "venue": "Bill Snyder Family Stadium",
    "homeId": 2306,
    "homeTeam": "Kansas State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 38,
    "homeLineScores": [
      10,
      7,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9210139513015747,
    "homePregameElo": 1664,
    "homePostgameElo": 1664,
    "awayId": 155,
    "awayTeam": "North Dakota",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      14,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.07898604869842529,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 8.240626327135903,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757226,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 12226,
    "venueId": 3796,
    "venue": "Houchens Industries-L.T. Smith Stadium",
    "homeId": 98,
    "homeTeam": "Western Kentucky",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 55,
    "homeLineScores": [
      14,
      28,
      3,
      10
    ],
    "homePostgameWinProbability": 0.9874510169029236,
    "homePregameElo": 1445,
    "homePostgameElo": 1445,
    "awayId": 2453,
    "awayTeam": "North Alabama",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 6,
    "awayLineScores": [
      6,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.012548983097076416,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.3106136190380187,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761595,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25546,
    "venueId": 3975,
    "venue": "Veterans Memorial Stadium (AL)",
    "homeId": 2653,
    "homeTeam": "Troy",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 38,
    "homeLineScores": [
      0,
      7,
      3,
      28
    ],
    "homePostgameWinProbability": 0.9966633319854736,
    "homePregameElo": 1476,
    "homePostgameElo": 1476,
    "awayId": 2447,
    "awayTeam": "Nicholls",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      10,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.003336668014526367,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.052806292810168,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761593,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 14017,
    "venueId": 6526,
    "venue": "Hancock Whitney Stadium",
    "homeId": 6,
    "homeTeam": "South Alabama",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 38,
    "homeLineScores": [
      7,
      10,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9913713335990906,
    "homePregameElo": 1555,
    "homePostgameElo": 1555,
    "awayId": 2415,
    "awayTeam": "Morgan State",
    "awayClassification": "fcs",
    "awayConference": "MEAC",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.008628666400909424,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.2016841453645455,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752678,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 107521,
    "venueId": 3795,
    "venue": "Kyle Field",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 42,
    "homeLineScores": [
      7,
      14,
      14,
      7
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1674,
    "homePostgameElo": 1700,
    "awayId": 2636,
    "awayTeam": "UTSA",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1529,
    "awayPostgameElo": 1503,
    "excitementIndex": 5.030838796225625,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761591,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 18241,
    "venueId": 3625,
    "venue": "Centennial Bank Stadium",
    "homeId": 2032,
    "homeTeam": "Arkansas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 42,
    "homeLineScores": [
      7,
      21,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9935866594314575,
    "homePregameElo": 1344,
    "homePostgameElo": 1344,
    "awayId": 2546,
    "awayTeam": "Southeast Missouri State",
    "awayClassification": "fcs",
    "awayConference": "OVC-Big South",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      3,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.0064133405685424805,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.924281246577312,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752671,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 81500,
    "venueId": 3836,
    "venue": "Memorial Stadium (Clemson, SC)",
    "homeId": 228,
    "homeTeam": "Clemson",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 10,
    "homeLineScores": [
      3,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.30021852254867554,
    "homePregameElo": 1704,
    "homePostgameElo": 1692,
    "awayId": 99,
    "awayTeam": "LSU",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      3,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.6997814774513245,
    "awayPregameElo": 1718,
    "awayPostgameElo": 1730,
    "excitementIndex": 5.004065274365249,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757225,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 16448,
    "venueId": 3905,
    "venue": "Maverik Stadium",
    "homeId": 328,
    "homeTeam": "Utah State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 28,
    "homeLineScores": [
      10,
      10,
      8,
      0
    ],
    "homePostgameWinProbability": 0.8222848773002625,
    "homePregameElo": 1408,
    "homePostgameElo": 1418,
    "awayId": 2638,
    "awayTeam": "UTEP",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 16,
    "awayLineScores": [
      7,
      3,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.17771512269973755,
    "awayPregameElo": 1240,
    "awayPostgameElo": 1230,
    "excitementIndex": 4.996551118389414,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757221,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 12872,
    "venueId": 3776,
    "venue": "Joe Aillet Stadium",
    "homeId": 2348,
    "homeTeam": "Louisiana Tech",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 24,
    "homeLineScores": [
      0,
      3,
      21,
      0
    ],
    "homePostgameWinProbability": 0.9545804262161255,
    "homePregameElo": 1397,
    "homePostgameElo": 1397,
    "awayId": 2545,
    "awayTeam": "SE Louisiana",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.04541957378387451,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.7634267448994905,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752808,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 110648,
    "venueId": 3558,
    "venue": "Michigan Stadium",
    "homeId": 130,
    "homeTeam": "Michigan",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 34,
    "homeLineScores": [
      14,
      10,
      3,
      7
    ],
    "homePostgameWinProbability": 0.9898145198822021,
    "homePregameElo": 1772,
    "homePostgameElo": 1771,
    "awayId": 167,
    "awayTeam": "New Mexico",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.010185480117797852,
    "awayPregameElo": 1331,
    "awayPostgameElo": 1332,
    "excitementIndex": 3.6631597398085893,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756877,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 60229,
    "venueId": 3784,
    "venue": "Jones AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 67,
    "homeLineScores": [
      23,
      24,
      14,
      6
    ],
    "homePostgameWinProbability": 0.9876359701156616,
    "homePregameElo": 1571,
    "homePostgameElo": 1571,
    "awayId": 2029,
    "awayTeam": "Arkansas-Pine Bluff",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.012364029884338379,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.7990282330735847,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752798,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 62841,
    "venueId": 477,
    "venue": "Los Angeles Memorial Coliseum",
    "homeId": 30,
    "homeTeam": "USC",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 73,
    "homeLineScores": [
      14,
      28,
      14,
      17
    ],
    "homePostgameWinProbability": 0.9899773597717285,
    "homePregameElo": 1676,
    "homePostgameElo": 1841,
    "awayId": 2623,
    "awayTeam": "Missouri State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 13,
    "awayLineScores": [
      3,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.010022640228271484,
    "awayPregameElo": 1500,
    "awayPostgameElo": 1335,
    "excitementIndex": 3.0279735308189717,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752672,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-30T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 66378,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 63,
    "homeLineScores": [
      7,
      18,
      17,
      21
    ],
    "homePostgameWinProbability": 0.9937152862548828,
    "homePregameElo": 1838,
    "homePostgameElo": 1939,
    "awayId": 2247,
    "awayTeam": "Georgia State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0062847137451171875,
    "awayPregameElo": 1331,
    "awayPostgameElo": 1230,
    "excitementIndex": 3.4204603848447697,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756851,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 64494,
    "venueId": 3801,
    "venue": "LaVell Edwards Stadium",
    "homeId": 252,
    "homeTeam": "BYU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 69,
    "homeLineScores": [
      14,
      35,
      6,
      14
    ],
    "homePostgameWinProbability": 0.9965556859970093,
    "homePregameElo": 1644,
    "homePostgameElo": 1644,
    "awayId": 2502,
    "awayTeam": "Portland State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0034443140029907227,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.258035940051477,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762435,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20594,
    "venueId": 3825,
    "venue": "DATCU Stadium",
    "homeId": 249,
    "homeTeam": "North Texas",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 51,
    "homeLineScores": [
      13,
      24,
      14,
      0
    ],
    "homePostgameWinProbability": 0.990288496017456,
    "homePregameElo": 1411,
    "homePostgameElo": 1411,
    "awayId": 2320,
    "awayTeam": "Lamar",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.009711503982543945,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.982110770273526,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761594,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21082,
    "venueId": 3644,
    "venue": "Bobcat Stadium (TX)",
    "homeId": 326,
    "homeTeam": "Texas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 52,
    "homeLineScores": [
      14,
      10,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9995025992393494,
    "homePregameElo": 1593,
    "homePostgameElo": 1623,
    "awayId": 2199,
    "awayTeam": "Eastern Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 27,
    "awayLineScores": [
      3,
      14,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.0004974007606506348,
    "awayPregameElo": 1283,
    "awayPostgameElo": 1253,
    "excitementIndex": 4.503330170819301,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762457,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 17337,
    "venueId": 3674,
    "venue": "Chapman Stadium",
    "homeId": 202,
    "homeTeam": "Tulsa",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 35,
    "homeLineScores": [
      7,
      3,
      11,
      14
    ],
    "homePostgameWinProbability": 0.9792423248291016,
    "homePregameElo": 1041,
    "homePostgameElo": 1041,
    "awayId": 2000,
    "awayTeam": "Abilene Christian",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.020757675170898438,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.551272659203257,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761592,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 22148,
    "venueId": 3666,
    "venue": "Cajun Field",
    "homeId": 309,
    "homeTeam": "Louisiana",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 12,
    "homeLineScores": [
      3,
      3,
      6,
      0
    ],
    "homePostgameWinProbability": 0.2572910189628601,
    "homePregameElo": 1474,
    "homePostgameElo": 1463,
    "awayId": 242,
    "awayTeam": "Rice",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.7427089810371399,
    "awayPregameElo": 1326,
    "awayPostgameElo": 1337,
    "excitementIndex": 5.187988330546746,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754521,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 33044,
    "venueId": 3735,
    "venue": "Gerald J. Ford Stadium",
    "homeId": 2567,
    "homeTeam": "SMU",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 42,
    "homeLineScores": [
      14,
      7,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9487073421478271,
    "homePregameElo": 1717,
    "homePostgameElo": 1717,
    "awayId": 2837,
    "awayTeam": "East Texas A&M",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      3,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.05129265785217285,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.669642264908016,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757223,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 10058,
    "venueId": 3601,
    "venue": "Aggie Memorial Stadium",
    "homeId": 166,
    "homeTeam": "New Mexico State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 19,
    "homeLineScores": [
      6,
      3,
      0,
      10
    ],
    "homePostgameWinProbability": 0.8037628531455994,
    "homePregameElo": 1246,
    "homePostgameElo": 1246,
    "awayId": 2803,
    "awayTeam": "Bryant",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 3,
    "awayLineScores": [
      3,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.19623714685440063,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.18143893252369,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760361,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T01:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 36801,
    "venueId": 3660,
    "venue": "Valley Children's Stadium",
    "homeId": 278,
    "homeTeam": "Fresno State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 42,
    "homeLineScores": [
      10,
      3,
      15,
      14
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1441,
    "homePostgameElo": 1516,
    "awayId": 290,
    "awayTeam": "Georgia Southern",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1457,
    "awayPostgameElo": 1382,
    "excitementIndex": 5.103442618284628,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752947,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 28243,
    "venueId": 3820,
    "venue": "Gesa Field",
    "homeId": 265,
    "homeTeam": "Washington State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 13,
    "homeLineScores": [
      0,
      7,
      3,
      3
    ],
    "homePostgameWinProbability": 0.14942289888858795,
    "homePregameElo": 1520,
    "homePostgameElo": 1520,
    "awayId": 70,
    "awayTeam": "Idaho",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.850577101111412,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.3135115653866585,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756850,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 56759,
    "venueId": 3947,
    "venue": "Mountain America Stadium",
    "homeId": 9,
    "homeTeam": "Arizona State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 38,
    "homeLineScores": [
      14,
      3,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9859762191772461,
    "homePregameElo": 1700,
    "homePostgameElo": 1700,
    "awayId": 2464,
    "awayTeam": "Northern Arizona",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 19,
    "awayLineScores": [
      0,
      6,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.014023780822753906,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.068778435088151,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756849,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 42423,
    "venueId": 3619,
    "venue": "Arizona Stadium",
    "homeId": 12,
    "homeTeam": "Arizona",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 40,
    "homeLineScores": [
      7,
      10,
      14,
      9
    ],
    "homePostgameWinProbability": 0.9286626577377319,
    "homePregameElo": 1371,
    "homePostgameElo": 1451,
    "awayId": 62,
    "awayTeam": "Hawai'i",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 6,
    "awayLineScores": [
      3,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.07133734226226807,
    "awayPregameElo": 1258,
    "awayPostgameElo": 1178,
    "excitementIndex": 3.562811782110526,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752936,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 31630,
    "venueId": 3893,
    "venue": "Reser Stadium",
    "homeId": 204,
    "homeTeam": "Oregon State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 15,
    "homeLineScores": [
      0,
      3,
      6,
      6
    ],
    "homePostgameWinProbability": 0.19505853950977325,
    "homePregameElo": 1406,
    "homePostgameElo": 1371,
    "awayId": 25,
    "awayTeam": "California",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      14,
      3,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.8049414604902267,
    "awayPregameElo": 1519,
    "awayPostgameElo": 1554,
    "excitementIndex": 2.8187930693076786,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752805,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T03:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 67778,
    "venueId": 3765,
    "venue": "Husky Stadium",
    "homeId": 264,
    "homeTeam": "Washington",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      7,
      7,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9994847774505615,
    "homePregameElo": 1585,
    "homePostgameElo": 1604,
    "awayId": 36,
    "awayTeam": "Colorado State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0005152225494384766,
    "awayPregameElo": 1382,
    "awayPostgameElo": 1363,
    "excitementIndex": 5.217607914774461,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752800,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T03:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 35032,
    "venueId": 1056,
    "venue": "Rose Bowl",
    "homeId": 26,
    "homeTeam": "UCLA",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 10,
    "homeLineScores": [
      0,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1492,
    "homePostgameElo": 1404,
    "awayId": 254,
    "awayTeam": "Utah",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 43,
    "awayLineScores": [
      13,
      10,
      7,
      13
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1542,
    "awayPostgameElo": 1630,
    "excitementIndex": 2.96631481543708,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752680,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 55531,
    "venueId": 5348,
    "venue": "Mercedes-Benz Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      7,
      3,
      0,
      14
    ],
    "homePostgameWinProbability": 0.775375485420227,
    "homePregameElo": 1706,
    "homePostgameElo": 1729,
    "awayId": 259,
    "awayTeam": "Virginia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 11,
    "awayLineScores": [
      2,
      6,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.22462451457977295,
    "awayPregameElo": 1598,
    "awayPostgameElo": 1575,
    "excitementIndex": 5.151864455216693,
    "highlights": "",
    "notes": "Aflac Kickoff",
    "playoff": null
  },
  {
    "id": 401754522,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-08-31T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 66793,
    "venueId": 3948,
    "venue": "Hard Rock Stadium",
    "homeId": 2390,
    "homeTeam": "Miami",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 27,
    "homeLineScores": [
      0,
      14,
      7,
      6
    ],
    "homePostgameWinProbability": 0.9616499543190002,
    "homePregameElo": 1736,
    "homePostgameElo": 1743,
    "awayId": 87,
    "awayTeam": "Notre Dame",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      7,
      0,
      17
    ],
    "awayPostgameWinProbability": 0.038350045680999756,
    "awayPregameElo": 2173,
    "awayPostgameElo": 2166,
    "excitementIndex": 5.318312492748594,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754523,
    "season": 2025,
    "week": 1,
    "seasonType": "regular",
    "startDate": "2025-09-02T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 50500,
    "venueId": 3787,
    "venue": "Kenan Stadium",
    "homeId": 153,
    "homeTeam": "North Carolina",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 14,
    "homeLineScores": [
      7,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.029689423739910126,
    "homePregameElo": 1497,
    "homePostgameElo": 1417,
    "awayId": 2628,
    "awayTeam": "TCU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 48,
    "awayLineScores": [
      7,
      13,
      21,
      7
    ],
    "awayPostgameWinProbability": 0.9703105762600899,
    "awayPregameElo": 1633,
    "awayPostgameElo": 1713,
    "excitementIndex": 3.407486721191629,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754528,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-05T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 48717,
    "venueId": 3873,
    "venue": "L&N Federal Credit Union Stadium",
    "homeId": 97,
    "homeTeam": "Louisville",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 28,
    "homeLineScores": [
      0,
      6,
      8,
      14
    ],
    "homePostgameWinProbability": 0.7146517038345337,
    "homePregameElo": 1706,
    "homePostgameElo": 1727,
    "awayId": 256,
    "awayTeam": "James Madison",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.2853482961654663,
    "awayPregameElo": 1627,
    "awayPostgameElo": 1606,
    "excitementIndex": 7.134433804940607,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752817,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-05T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 9647,
    "venueId": 5960,
    "venue": "Lanny and Sharon Martin Stadium",
    "homeId": 77,
    "homeTeam": "Northwestern",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 42,
    "homeLineScores": [
      15,
      7,
      6,
      14
    ],
    "homePostgameWinProbability": 0.988507091999054,
    "homePregameElo": 1397,
    "homePostgameElo": 1397,
    "awayId": 2710,
    "awayTeam": "Western Illinois",
    "awayClassification": "fcs",
    "awayConference": "OVC-Big South",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.011492908000946045,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.7447744283164024,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752826,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-05T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 35331,
    "venueId": 3665,
    "venue": "SECU Stadium",
    "homeId": 120,
    "homeTeam": "Maryland",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 20,
    "homeLineScores": [
      3,
      7,
      3,
      7
    ],
    "homePostgameWinProbability": 0.27562257647514343,
    "homePregameElo": 1509,
    "homePostgameElo": 1526,
    "awayId": 2459,
    "awayTeam": "Northern Illinois",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 9,
    "awayLineScores": [
      0,
      3,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.7243774235248566,
    "awayPregameElo": 1470,
    "awayPostgameElo": 1453,
    "excitementIndex": 4.649374638913491,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760363,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 32887,
    "venueId": 3653,
    "venue": "Albertsons Stadium",
    "homeId": 68,
    "homeTeam": "Boise State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 51,
    "homeLineScores": [
      20,
      10,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9921911954879761,
    "homePregameElo": 1596,
    "homePostgameElo": 1596,
    "awayId": 331,
    "awayTeam": "Eastern Washington",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.007808804512023926,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.3689811519754373,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752813,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 42447,
    "venueId": 3953,
    "venue": "Huntington Bank Stadium",
    "homeId": 135,
    "homeTeam": "Minnesota",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 66,
    "homeLineScores": [
      35,
      24,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9938032031059265,
    "homePregameElo": 1630,
    "homePostgameElo": 1630,
    "awayId": 2466,
    "awayTeam": "Northwestern State",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.006196796894073486,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 1.8817563649333342,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752811,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 103818,
    "venueId": 3632,
    "venue": "Beaver Stadium",
    "homeId": 213,
    "homeTeam": "Penn State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 34,
    "homeLineScores": [
      7,
      3,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9701969027519226,
    "homePregameElo": 2073,
    "homePostgameElo": 2087,
    "awayId": 2229,
    "awayTeam": "Florida International",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.029803097248077393,
    "awayPregameElo": 1372,
    "awayPostgameElo": 1358,
    "excitementIndex": 4.026950736531958,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752822,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 61500,
    "venueId": 3772,
    "venue": "Jack Trice Stadium",
    "homeId": 66,
    "homeTeam": "Iowa State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 16,
    "homeLineScores": [
      6,
      7,
      0,
      3
    ],
    "homePostgameWinProbability": 0.8555827736854553,
    "homePregameElo": 1619,
    "homePostgameElo": 1621,
    "awayId": 2294,
    "awayTeam": "Iowa",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      10,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.14441722631454468,
    "awayPregameElo": 1682,
    "awayPostgameElo": 1680,
    "excitementIndex": 5.137924145830644,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754618,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 39391,
    "venueId": 1964,
    "venue": "JMA Wireless Dome",
    "homeId": 183,
    "homeTeam": "Syracuse",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 27,
    "homeLineScores": [
      0,
      6,
      0,
      14,
      7
    ],
    "homePostgameWinProbability": 0.2122134566307068,
    "homePregameElo": 1476,
    "homePostgameElo": 1484,
    "awayId": 41,
    "awayTeam": "UConn",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      14,
      3,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.7877865433692932,
    "awayPregameElo": 1454,
    "awayPostgameElo": 1446,
    "excitementIndex": 6.602095300884476,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756885,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 60229,
    "venueId": 3784,
    "venue": "Jones AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 62,
    "homeLineScores": [
      21,
      27,
      7,
      7
    ],
    "homePostgameWinProbability": 0.989311695098877,
    "homePregameElo": 1571,
    "homePostgameElo": 1639,
    "awayId": 2309,
    "awayTeam": "Kent State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.010688304901123047,
    "awayPregameElo": 1006,
    "awayPostgameElo": 938,
    "excitementIndex": 2.845913821655414,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752693,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 100841,
    "venueId": 3910,
    "venue": "DKR-Texas Memorial Stadium",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 38,
    "homeLineScores": [
      14,
      14,
      10,
      0
    ],
    "homePostgameWinProbability": 0.9815280437469482,
    "homePregameElo": 1858,
    "homePostgameElo": 1896,
    "awayId": 23,
    "awayTeam": "San José State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.018471956253051758,
    "awayPregameElo": 1467,
    "awayPostgameElo": 1429,
    "excitementIndex": 3.6535531729515283,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754524,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 56919,
    "venueId": 3670,
    "venue": "Carter-Finley Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 35,
    "homeLineScores": [
      7,
      7,
      21,
      0
    ],
    "homePostgameWinProbability": 0.6570654511451721,
    "homePregameElo": 1507,
    "homePostgameElo": 1510,
    "awayId": 258,
    "awayTeam": "Virginia",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 31,
    "awayLineScores": [
      14,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.3429345488548279,
    "awayPregameElo": 1521,
    "awayPostgameElo": 1518,
    "excitementIndex": 8.126042888443141,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757227,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20755,
    "venueId": 3662,
    "venue": "AmFirst Stadium",
    "homeId": 55,
    "homeTeam": "Jacksonville State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 34,
    "homeLineScores": [
      7,
      10,
      7,
      10
    ],
    "homePostgameWinProbability": 0.6668782830238342,
    "homePregameElo": 1634,
    "homePostgameElo": 1642,
    "awayId": 2335,
    "awayTeam": "Liberty",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      3,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.33312171697616577,
    "awayPregameElo": 1502,
    "awayPostgameElo": 1494,
    "excitementIndex": 4.611249661121996,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752825,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23893,
    "venueId": 3982,
    "venue": "Wallace Wade Stadium",
    "homeId": 150,
    "homeTeam": "Duke",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 19,
    "homeLineScores": [
      3,
      10,
      6,
      0
    ],
    "homePostgameWinProbability": 0.2791347801685333,
    "homePregameElo": 1526,
    "homePostgameElo": 1462,
    "awayId": 356,
    "awayTeam": "Illinois",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 45,
    "awayLineScores": [
      7,
      7,
      14,
      17
    ],
    "awayPostgameWinProbability": 0.7208652198314667,
    "awayPregameElo": 1578,
    "awayPostgameElo": 1642,
    "excitementIndex": 5.058968869408419,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754525,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 34852,
    "venueId": 3735,
    "venue": "Gerald J. Ford Stadium",
    "homeId": 2567,
    "homeTeam": "SMU",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 45,
    "homeLineScores": [
      10,
      14,
      0,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.7657668590545654,
    "homePregameElo": 1717,
    "homePostgameElo": 1703,
    "awayId": 239,
    "awayTeam": "Baylor",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 48,
    "awayLineScores": [
      0,
      21,
      3,
      14,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.23423314094543457,
    "awayPregameElo": 1569,
    "awayPostgameElo": 1583,
    "excitementIndex": 8.737381517894203,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754621,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 65430,
    "venueId": 3697,
    "venue": "Doak Campbell Stadium",
    "homeId": 52,
    "homeTeam": "Florida State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 77,
    "homeLineScores": [
      21,
      28,
      21,
      7
    ],
    "homePostgameWinProbability": 0.9972588419914246,
    "homePregameElo": 1452,
    "homePostgameElo": 1452,
    "awayId": 2837,
    "awayTeam": "East Texas A&M",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.0027411580085754395,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.7206631464915,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752812,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 43801,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 56,
    "homeLineScores": [
      14,
      7,
      21,
      14
    ],
    "homePostgameWinProbability": 0.9867881536483765,
    "homePregameElo": 1800,
    "homePostgameElo": 1869,
    "awayId": 338,
    "awayTeam": "Kennesaw State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 9,
    "awayLineScores": [
      0,
      6,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.013211846351623535,
    "awayPregameElo": 1269,
    "awayPostgameElo": 1200,
    "excitementIndex": 3.090302435948307,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754529,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 48424,
    "venueId": 3752,
    "venue": "Acrisure Stadium",
    "homeId": 221,
    "homeTeam": "Pittsburgh",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 45,
    "homeLineScores": [
      7,
      17,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9755685925483704,
    "homePregameElo": 1470,
    "homePostgameElo": 1518,
    "awayId": 2117,
    "awayTeam": "Central Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.02443140745162964,
    "awayPregameElo": 1252,
    "awayPostgameElo": 1204,
    "excitementIndex": 3.5595529031904913,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752694,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 100026,
    "venueId": 3795,
    "venue": "Kyle Field",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 44,
    "homeLineScores": [
      10,
      20,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9838184118270874,
    "homePregameElo": 1700,
    "homePostgameElo": 1724,
    "awayId": 328,
    "awayTeam": "Utah State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 22,
    "awayLineScores": [
      6,
      0,
      8,
      8
    ],
    "awayPostgameWinProbability": 0.016181588172912598,
    "awayPregameElo": 1418,
    "awayPostgameElo": 1394,
    "excitementIndex": 3.808337874202806,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762462,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15655,
    "venueId": 3806,
    "venue": "Lincoln Financial Field",
    "homeId": 218,
    "homeTeam": "Temple",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 55,
    "homeLineScores": [
      21,
      10,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9970473051071167,
    "homePregameElo": 1289,
    "homePostgameElo": 1289,
    "awayId": 47,
    "awayTeam": "Howard",
    "awayClassification": "fcs",
    "awayConference": "MEAC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0029526948928833008,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.9134675745817527,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754620,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 28239,
    "venueId": 3630,
    "venue": "Allegacy Federal Credit Union Stadium",
    "homeId": 154,
    "homeTeam": "Wake Forest",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 42,
    "homeLineScores": [
      21,
      0,
      21,
      0
    ],
    "homePostgameWinProbability": 0.988591194152832,
    "homePregameElo": 1394,
    "homePostgameElo": 1394,
    "awayId": 2717,
    "awayTeam": "Western Carolina",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.011408805847167969,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.787144642944783,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760366,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 17639,
    "venueId": 3971,
    "venue": "University Stadium (NM)",
    "homeId": 167,
    "homeTeam": "New Mexico",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 32,
    "homeLineScores": [
      7,
      7,
      3,
      15
    ],
    "homePostgameWinProbability": 0.9329351186752319,
    "homePregameElo": 1317,
    "homePostgameElo": 1317,
    "awayId": 304,
    "awayTeam": "Idaho State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 22,
    "awayLineScores": [
      0,
      10,
      6,
      6
    ],
    "awayPostgameWinProbability": 0.06706488132476807,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 9.93391428193871,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756880,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 35421,
    "venueId": 3854,
    "venue": "Nippert Stadium",
    "homeId": 2132,
    "homeTeam": "Cincinnati",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 34,
    "homeLineScores": [
      7,
      14,
      10,
      3
    ],
    "homePostgameWinProbability": 0.9651085734367371,
    "homePregameElo": 1477,
    "homePostgameElo": 1504,
    "awayId": 189,
    "awayTeam": "Bowling Green",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      3,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.03489142656326294,
    "awayPregameElo": 1461,
    "awayPostgameElo": 1434,
    "excitementIndex": 3.2207508534805123,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752686,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 58346,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 23,
    "homeLineScores": [
      7,
      6,
      7,
      3
    ],
    "homePostgameWinProbability": 0.18089134991168976,
    "homePregameElo": 1507,
    "homePostgameElo": 1524,
    "awayId": 145,
    "awayTeam": "Ole Miss",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 30,
    "awayLineScores": [
      0,
      17,
      10,
      3
    ],
    "awayPostgameWinProbability": 0.8191086500883102,
    "awayPregameElo": 1939,
    "awayPostgameElo": 1922,
    "excitementIndex": 5.576328550071941,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762458,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28325,
    "venueId": 3852,
    "venue": "Navy-Marine Corps Memorial Stadium",
    "homeId": 2426,
    "homeTeam": "Navy",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 38,
    "homeLineScores": [
      14,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1543,
    "homePostgameElo": 1553,
    "awayId": 5,
    "awayTeam": "UAB",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      17,
      0,
      0
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1319,
    "awayPostgameElo": 1309,
    "excitementIndex": 5.7014933667827785,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752689,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 57321,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 42,
    "homeLineScores": [
      6,
      15,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9204921126365662,
    "homePregameElo": 1640,
    "homePostgameElo": 1659,
    "awayId": 2305,
    "awayTeam": "Kansas",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 31,
    "awayLineScores": [
      21,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.07950788736343384,
    "awayPregameElo": 1632,
    "awayPostgameElo": 1613,
    "excitementIndex": 7.324718276252601,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752685,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 93033,
    "venueId": 3917,
    "venue": "Sanford Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9751682281494141,
    "homePregameElo": 2072,
    "homePostgameElo": 2072,
    "awayId": 2046,
    "awayTeam": "Austin Peay",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      3,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.024831771850585938,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.9867455253692707,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754637,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 77890,
    "venueId": 3836,
    "venue": "Memorial Stadium (Clemson, SC)",
    "homeId": 228,
    "homeTeam": "Clemson",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 27,
    "homeLineScores": [
      0,
      3,
      17,
      7
    ],
    "homePostgameWinProbability": 0.8717408776283264,
    "homePregameElo": 1692,
    "homePostgameElo": 1696,
    "awayId": 2653,
    "awayTeam": "Troy",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 16,
    "awayLineScores": [
      7,
      9,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.12825912237167358,
    "awayPregameElo": 1476,
    "awayPostgameElo": 1472,
    "excitementIndex": 5.6461113334510316,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756881,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 50341,
    "venueId": 3726,
    "venue": "Folsom Field",
    "homeId": 38,
    "homeTeam": "Colorado",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 31,
    "homeLineScores": [
      7,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9253472685813904,
    "homePregameElo": 1613,
    "homePostgameElo": 1660,
    "awayId": 48,
    "awayTeam": "Delaware",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.07465273141860962,
    "awayPregameElo": 1500,
    "awayPostgameElo": 1453,
    "excitementIndex": 3.906826980049366,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761603,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 45778,
    "venueId": 3604,
    "venue": "Alamodome",
    "homeId": 2636,
    "homeTeam": "UTSA",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 36,
    "homeLineScores": [
      0,
      14,
      14,
      8
    ],
    "homePostgameWinProbability": 0.27091893553733826,
    "homePregameElo": 1503,
    "homePostgameElo": 1499,
    "awayId": 326,
    "awayTeam": "Texas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 43,
    "awayLineScores": [
      2,
      17,
      10,
      14
    ],
    "awayPostgameWinProbability": 0.7290810644626617,
    "awayPregameElo": 1623,
    "awayPostgameElo": 1627,
    "excitementIndex": 7.993288344920428,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754622,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 37775,
    "venueId": 721,
    "venue": "Bobby Dodd Stadium",
    "homeId": 59,
    "homeTeam": "Georgia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 59,
    "homeLineScores": [
      7,
      21,
      14,
      17
    ],
    "homePostgameWinProbability": 0.9895111918449402,
    "homePregameElo": 1556,
    "homePostgameElo": 1556,
    "awayId": 2241,
    "awayTeam": "Gardner-Webb",
    "awayClassification": "fcs",
    "awayConference": "OVC-Big South",
    "awayPoints": 12,
    "awayLineScores": [
      6,
      0,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.010488808155059814,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.322248368858751,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752937,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 28068,
    "venueId": 3893,
    "venue": "Reser Stadium",
    "homeId": 204,
    "homeTeam": "Oregon State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 27,
    "homeLineScores": [
      6,
      9,
      6,
      6
    ],
    "homePostgameWinProbability": 0.8809866905212402,
    "homePregameElo": 1371,
    "homePostgameElo": 1365,
    "awayId": 278,
    "awayTeam": "Fresno State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 36,
    "awayLineScores": [
      7,
      13,
      0,
      16
    ],
    "awayPostgameWinProbability": 0.11901330947875977,
    "awayPregameElo": 1516,
    "awayPostgameElo": 1522,
    "excitementIndex": 10.016643565438494,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752815,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 100624,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 70,
    "homeLineScores": [
      21,
      14,
      21,
      14
    ],
    "homePostgameWinProbability": 0.9849264025688171,
    "homePregameElo": 1978,
    "homePostgameElo": 1978,
    "awayId": 2755,
    "awayTeam": "Grambling",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.015073597431182861,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 1.5906830881361842,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752692,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 101915,
    "venueId": 3853,
    "venue": "Neyland Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 72,
    "homeLineScores": [
      24,
      24,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9897788166999817,
    "homePregameElo": 1808,
    "homePostgameElo": 1808,
    "awayId": 2193,
    "awayTeam": "East Tennessee State",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      7,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.01022118330001831,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.9136991274366872,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762794,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15740,
    "venueId": 3965,
    "venue": "UB Stadium",
    "homeId": 2084,
    "homeTeam": "Buffalo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 45,
    "homeLineScores": [
      17,
      7,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9676299691200256,
    "homePregameElo": 1402,
    "homePostgameElo": 1402,
    "awayId": 2598,
    "awayTeam": "Saint Francis",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      0,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.032370030879974365,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.157436147263064,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752824,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 57266,
    "venueId": 3626,
    "venue": "Autzen Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 69,
    "homeLineScores": [
      20,
      21,
      28,
      0
    ],
    "homePostgameWinProbability": 0.9958012700080872,
    "homePregameElo": 1860,
    "homePostgameElo": 1992,
    "awayId": 197,
    "awayTeam": "Oklahoma State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.004198729991912842,
    "awayPregameElo": 1334,
    "awayPostgameElo": 1202,
    "excitementIndex": 2.6418738763775176,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762816,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 3714,
    "venueId": 3985,
    "venue": "Warren McGuirk Alumni Stadium",
    "homeId": 113,
    "homeTeam": "Massachusetts",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 26,
    "homeLineScores": [
      6,
      14,
      3,
      3
    ],
    "homePostgameWinProbability": 0.9382573366165161,
    "homePregameElo": 1096,
    "homePostgameElo": 1096,
    "awayId": 2803,
    "awayTeam": "Bryant",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      10,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.06174266338348389,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 12.276715985149488,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761596,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 34921,
    "venueId": 3792,
    "venue": "Kidd Brewer Stadium",
    "homeId": 2026,
    "homeTeam": "App State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 20,
    "homeLineScores": [
      14,
      0,
      3,
      3
    ],
    "homePostgameWinProbability": 0.8596605062484741,
    "homePregameElo": 1477,
    "homePostgameElo": 1477,
    "awayId": 2815,
    "awayTeam": "Lindenwood",
    "awayClassification": "fcs",
    "awayConference": "OVC-Big South",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      6,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.14033949375152588,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.7514841176252114,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752818,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 45981,
    "venueId": 6577,
    "venue": "SHI Stadium",
    "homeId": 164,
    "homeTeam": "Rutgers",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 45,
    "homeLineScores": [
      7,
      17,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9925628900527954,
    "homePregameElo": 1524,
    "homePostgameElo": 1593,
    "awayId": 193,
    "awayTeam": "Miami (OH)",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.00743710994720459,
    "awayPregameElo": 1491,
    "awayPostgameElo": 1422,
    "excitementIndex": 4.348794069458188,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762461,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20051,
    "venueId": 3980,
    "venue": "Waldo Stadium",
    "homeId": 2711,
    "homeTeam": "Western Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 30,
    "homeLineScores": [
      0,
      17,
      7,
      3,
      3
    ],
    "homePostgameWinProbability": 0.38369107246398926,
    "homePregameElo": 1310,
    "homePostgameElo": 1312,
    "awayId": 249,
    "awayTeam": "North Texas",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 33,
    "awayLineScores": [
      0,
      7,
      10,
      10,
      6
    ],
    "awayPostgameWinProbability": 0.6163089275360107,
    "awayPregameElo": 1411,
    "awayPostgameElo": 1409,
    "excitementIndex": 13.082157990893087,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752820,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 70368,
    "venueId": 347,
    "venue": "Camp Randall Stadium",
    "homeId": 275,
    "homeTeam": "Wisconsin",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 42,
    "homeLineScores": [
      0,
      14,
      14,
      14
    ],
    "homePostgameWinProbability": 0.969450056552887,
    "homePregameElo": 1573,
    "homePostgameElo": 1619,
    "awayId": 2393,
    "awayTeam": "Middle Tennessee",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.030549943447113037,
    "awayPregameElo": 1228,
    "awayPostgameElo": 1182,
    "excitementIndex": 8.256093668394996,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756883,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 26740,
    "venueId": 3876,
    "venue": "Peden Stadium",
    "homeId": 195,
    "homeTeam": "Ohio",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 17,
    "homeLineScores": [
      3,
      14,
      0,
      0
    ],
    "homePostgameWinProbability": 0.8477234244346619,
    "homePregameElo": 1619,
    "homePostgameElo": 1620,
    "awayId": 277,
    "awayTeam": "West Virginia",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 10,
    "awayLineScores": [
      7,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.15227657556533813,
    "awayPregameElo": 1470,
    "awayPostgameElo": 1469,
    "excitementIndex": 5.200094461188878,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760367,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25009,
    "venueId": 3984,
    "venue": "War Memorial Stadium",
    "homeId": 2751,
    "homeTeam": "Wyoming",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 31,
    "homeLineScores": [
      7,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9853284955024719,
    "homePregameElo": 1386,
    "homePostgameElo": 1386,
    "awayId": 2460,
    "awayTeam": "Northern Iowa",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.014671504497528076,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 8.168879135472618,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752684,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 89909,
    "venueId": 3634,
    "venue": "Ben Hill Griffin Stadium",
    "homeId": 57,
    "homeTeam": "Florida",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 16,
    "homeLineScores": [
      3,
      6,
      0,
      7
    ],
    "homePostgameWinProbability": 0.586835503578186,
    "homePregameElo": 1678,
    "homePostgameElo": 1668,
    "awayId": 58,
    "awayTeam": "South Florida",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 18,
    "awayLineScores": [
      0,
      6,
      9,
      3
    ],
    "awayPostgameWinProbability": 0.41316449642181396,
    "awayPregameElo": 1554,
    "awayPostgameElo": 1564,
    "excitementIndex": 6.071843438438032,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760365,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20535,
    "venueId": 3816,
    "venue": "Mackay Stadium",
    "homeId": 2440,
    "homeTeam": "Nevada",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 20,
    "homeLineScores": [
      0,
      13,
      0,
      7
    ],
    "homePostgameWinProbability": 0.394497275352478,
    "homePregameElo": 1249,
    "homePostgameElo": 1249,
    "awayId": 16,
    "awayTeam": "Sacramento State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.605502724647522,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 7.843347356319783,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752682,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 54224,
    "venueId": 3983,
    "venue": "War Memorial Stadium (AR)",
    "homeId": 8,
    "homeTeam": "Arkansas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 56,
    "homeLineScores": [
      28,
      7,
      14,
      7
    ],
    "homePostgameWinProbability": 0.998382568359375,
    "homePregameElo": 1574,
    "homePostgameElo": 1674,
    "awayId": 2032,
    "awayTeam": "Arkansas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.001617431640625,
    "awayPregameElo": 1344,
    "awayPostgameElo": 1244,
    "excitementIndex": 4.1021128537182205,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761602,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 32011,
    "venueId": 3815,
    "venue": "M. M. Roberts Stadium",
    "homeId": 2572,
    "homeTeam": "Southern Miss",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 38,
    "homeLineScores": [
      14,
      3,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9858771562576294,
    "homePregameElo": 1089,
    "homePostgameElo": 1089,
    "awayId": 2296,
    "awayTeam": "Jackson State",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      7,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.014122843742370605,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.4706589557839225,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754530,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 35898,
    "venueId": 3831,
    "venue": "California Memorial Stadium",
    "homeId": 25,
    "homeTeam": "California",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 35,
    "homeLineScores": [
      3,
      8,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9959644079208374,
    "homePregameElo": 1564,
    "homePostgameElo": 1564,
    "awayId": 2640,
    "awayTeam": "Texas Southern",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.004035592079162598,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.6396748926369975,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756887,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 51463,
    "venueId": 587,
    "venue": "Rice-Eccles Stadium",
    "homeId": 254,
    "homeTeam": "Utah",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 63,
    "homeLineScores": [
      14,
      21,
      21,
      7
    ],
    "homePostgameWinProbability": 0.9827632308006287,
    "homePregameElo": 1638,
    "homePostgameElo": 1638,
    "awayId": 13,
    "awayTeam": "Cal Poly",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 9,
    "awayLineScores": [
      3,
      3,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.017236769199371338,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.065962949677993,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762460,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21029,
    "venueId": 3715,
    "venue": "FAU Stadium",
    "homeId": 2226,
    "homeTeam": "Florida Atlantic",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 56,
    "homeLineScores": [
      22,
      17,
      0,
      17
    ],
    "homePostgameWinProbability": 0.977178156375885,
    "homePregameElo": 1237,
    "homePostgameElo": 1237,
    "awayId": 50,
    "awayTeam": "Florida A&M",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.02282184362411499,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.054075854019231,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762459,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 35120,
    "venueId": 3699,
    "venue": "Dowdy-Ficklen Stadium",
    "homeId": 151,
    "homeTeam": "East Carolina",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 56,
    "homeLineScores": [
      14,
      21,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9879902005195618,
    "homePregameElo": 1429,
    "homePostgameElo": 1429,
    "awayId": 2097,
    "awayTeam": "Campbell",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.012009799480438232,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.864519137775231,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761599,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 18111,
    "venueId": 3918,
    "venue": "S.B. Ballard Stadium",
    "homeId": 295,
    "homeTeam": "Old Dominion",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 54,
    "homeLineScores": [
      9,
      7,
      28,
      10
    ],
    "homePostgameWinProbability": 0.9922709465026855,
    "homePregameElo": 1470,
    "homePostgameElo": 1470,
    "awayId": 2428,
    "awayTeam": "North Carolina Central",
    "awayClassification": "fcs",
    "awayConference": "MEAC",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      3,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.007729053497314453,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.9235643234565463,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757228,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 28564,
    "venueId": 3775,
    "venue": "Joan C. Edwards Stadium",
    "homeId": 276,
    "homeTeam": "Marshall",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 20,
    "homeLineScores": [
      0,
      17,
      3,
      0
    ],
    "homePostgameWinProbability": 0.08841505646705627,
    "homePregameElo": 1519,
    "homePostgameElo": 1508,
    "awayId": 2623,
    "awayTeam": "Missouri State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9115849435329437,
    "awayPregameElo": 1335,
    "awayPostgameElo": 1346,
    "excitementIndex": 7.466062922611336,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760364,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 37023,
    "venueId": 5388,
    "venue": "Canvas Stadium",
    "homeId": 36,
    "homeTeam": "Colorado State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 21,
    "homeLineScores": [
      0,
      0,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9243268370628357,
    "homePregameElo": 1357,
    "homePostgameElo": 1357,
    "awayId": 2458,
    "awayTeam": "Northern Colorado",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0756731629371643,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.653801193242797,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761598,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 13625,
    "venueId": 4246,
    "venue": "Center Parc Stadium",
    "homeId": 2247,
    "homeTeam": "Georgia State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 16,
    "homeLineScores": [
      9,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.16244572401046753,
    "homePregameElo": 1230,
    "homePostgameElo": 1213,
    "awayId": 235,
    "awayTeam": "Memphis",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      10,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.8375542759895325,
    "awayPregameElo": 1604,
    "awayPostgameElo": 1621,
    "excitementIndex": 11.630263530136874,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754527,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 19233,
    "venueId": 4418,
    "venue": "Jerry Richardson Stadium",
    "homeId": 2429,
    "homeTeam": "Charlotte",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 3,
    "homeLineScores": [
      0,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1221,
    "homePostgameElo": 1200,
    "awayId": 153,
    "awayTeam": "North Carolina",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 20,
    "awayLineScores": [
      10,
      7,
      0,
      3
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1417,
    "awayPostgameElo": 1438,
    "excitementIndex": 3.333886477580821,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754641,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 60617,
    "venueId": 3948,
    "venue": "Hard Rock Stadium",
    "homeId": 2390,
    "homeTeam": "Miami",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 45,
    "homeLineScores": [
      14,
      14,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9784430861473083,
    "homePregameElo": 1752,
    "homePostgameElo": 1752,
    "awayId": 2065,
    "awayTeam": "Bethune-Cookman",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.02155691385269165,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.696307152207372,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756886,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 44009,
    "venueId": 3652,
    "venue": "FBC Mortgage Stadium",
    "homeId": 2116,
    "homeTeam": "UCF",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 68,
    "homeLineScores": [
      28,
      12,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9864861965179443,
    "homePregameElo": 1550,
    "homePostgameElo": 1550,
    "awayId": 2448,
    "awayTeam": "North Carolina A&T",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.013513803482055664,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.799409667852697,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756884,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 30116,
    "venueId": 3895,
    "venue": "Rice Stadium",
    "homeId": 242,
    "homeTeam": "Rice",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 9,
    "homeLineScores": [
      0,
      3,
      0,
      6
    ],
    "homePostgameWinProbability": 0.14996007084846497,
    "homePregameElo": 1337,
    "homePostgameElo": 1271,
    "awayId": 248,
    "awayTeam": "Houston",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 35,
    "awayLineScores": [
      0,
      7,
      7,
      21
    ],
    "awayPostgameWinProbability": 0.850039929151535,
    "awayPregameElo": 1375,
    "awayPostgameElo": 1441,
    "excitementIndex": 5.868186786577186,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762795,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15313,
    "venueId": 3912,
    "venue": "Rynearson Stadium",
    "homeId": 2199,
    "homeTeam": "Eastern Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 23,
    "homeLineScores": [
      3,
      7,
      0,
      13
    ],
    "homePostgameWinProbability": 0.012839652597904205,
    "homePregameElo": 1241,
    "homePostgameElo": 1241,
    "awayId": 2341,
    "awayTeam": "Long Island University",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.9871603474020958,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 10.841158200364873,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756882,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 52723,
    "venueId": 3636,
    "venue": "Bill Snyder Family Stadium",
    "homeId": 2306,
    "homeTeam": "Kansas State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 21,
    "homeLineScores": [
      3,
      10,
      8,
      0
    ],
    "homePostgameWinProbability": 0.4905949831008911,
    "homePregameElo": 1666,
    "homePostgameElo": 1658,
    "awayId": 349,
    "awayTeam": "Army",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      7,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.5094050168991089,
    "awayPregameElo": 1607,
    "awayPostgameElo": 1615,
    "excitementIndex": 4.812631689492559,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761601,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 16871,
    "venueId": 6526,
    "venue": "Hancock Whitney Stadium",
    "homeId": 6,
    "homeTeam": "South Alabama",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 31,
    "homeLineScores": [
      14,
      0,
      0,
      17
    ],
    "homePostgameWinProbability": 0.3140738010406494,
    "homePregameElo": 1555,
    "homePostgameElo": 1557,
    "awayId": 2655,
    "awayTeam": "Tulane",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 33,
    "awayLineScores": [
      14,
      10,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.6859261989593506,
    "awayPregameElo": 1644,
    "awayPostgameElo": 1642,
    "excitementIndex": 5.102549534733624,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752691,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 79705,
    "venueId": 3994,
    "venue": "Williams-Brice Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 38,
    "homeLineScores": [
      0,
      17,
      21,
      0
    ],
    "homePostgameWinProbability": 0.6999583840370178,
    "homePregameElo": 1729,
    "homePostgameElo": 1729,
    "awayId": 2569,
    "awayTeam": "South Carolina State",
    "awayClassification": "fcs",
    "awayConference": "MEAC",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.3000416159629822,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.217151204005949,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757232,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24138,
    "venueId": 3739,
    "venue": "Glass Bowl",
    "homeId": 2649,
    "homeTeam": "Toledo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 45,
    "homeLineScores": [
      21,
      10,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9942803382873535,
    "homePregameElo": 1445,
    "homePostgameElo": 1505,
    "awayId": 98,
    "awayTeam": "Western Kentucky",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.005719661712646484,
    "awayPregameElo": 1450,
    "awayPostgameElo": 1390,
    "excitementIndex": 3.1943613678729137,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752690,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 84107,
    "venueId": 3835,
    "venue": "Memorial Stadium (Norman, OK)",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      7,
      7,
      7,
      3
    ],
    "homePostgameWinProbability": 0.8956694006919861,
    "homePregameElo": 1650,
    "homePostgameElo": 1679,
    "awayId": 130,
    "awayTeam": "Michigan",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      0,
      13,
      0
    ],
    "awayPostgameWinProbability": 0.10433059930801392,
    "awayPregameElo": 1771,
    "awayPostgameElo": 1742,
    "excitementIndex": 4.288925346237761,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752683,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 42,
    "homeLineScores": [
      14,
      7,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9814049601554871,
    "homePregameElo": 1609,
    "homePostgameElo": 1661,
    "awayId": 2050,
    "awayTeam": "Ball State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.01859503984451294,
    "awayPregameElo": 1138,
    "awayPostgameElo": 1086,
    "excitementIndex": 3.1998303337378187,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752687,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 101667,
    "venueId": 3958,
    "venue": "Tiger Stadium (LA)",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 23,
    "homeLineScores": [
      7,
      3,
      7,
      6
    ],
    "homePostgameWinProbability": 0.9527506232261658,
    "homePregameElo": 1730,
    "homePostgameElo": 1735,
    "awayId": 2348,
    "awayTeam": "Louisiana Tech",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.04724937677383423,
    "awayPregameElo": 1397,
    "awayPostgameElo": 1392,
    "excitementIndex": 3.61155797671467,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752688,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 50808,
    "venueId": 3693,
    "venue": "Davis Wade Stadium",
    "homeId": 344,
    "homeTeam": "Mississippi State",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      10,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.8720696568489075,
    "homePregameElo": 1424,
    "homePostgameElo": 1436,
    "awayId": 9,
    "awayTeam": "Arizona State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      3,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.12793034315109253,
    "awayPregameElo": 1700,
    "awayPostgameElo": 1688,
    "excitementIndex": 5.4906623759619935,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752819,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 54663,
    "venueId": 3907,
    "venue": "Ross-Ade Stadium",
    "homeId": 2509,
    "homeTeam": "Purdue",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 34,
    "homeLineScores": [
      14,
      10,
      3,
      7
    ],
    "homePostgameWinProbability": 0.965205192565918,
    "homePregameElo": 1287,
    "homePostgameElo": 1287,
    "awayId": 79,
    "awayTeam": "Southern Illinois",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 17,
    "awayLineScores": [
      14,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.03479480743408203,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.482463605104785,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752814,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": null,
    "venueId": 477,
    "venue": "Los Angeles Memorial Coliseum",
    "homeId": 30,
    "homeTeam": "USC",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 59,
    "homeLineScores": [
      21,
      10,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9896509051322937,
    "homePregameElo": 1841,
    "homePostgameElo": 1895,
    "awayId": 290,
    "awayTeam": "Georgia Southern",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 20,
    "awayLineScores": [
      6,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.010349094867706299,
    "awayPregameElo": 1382,
    "awayPostgameElo": 1328,
    "excitementIndex": 4.561627952727972,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752810,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 86439,
    "venueId": 3834,
    "venue": "Memorial Stadium (Lincoln, NE)",
    "homeId": 158,
    "homeTeam": "Nebraska",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 68,
    "homeLineScores": [
      9,
      24,
      21,
      14
    ],
    "homePostgameWinProbability": 0.993889331817627,
    "homePregameElo": 1522,
    "homePostgameElo": 1699,
    "awayId": 2006,
    "awayTeam": "Akron",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.006110668182373047,
    "awayPregameElo": 1235,
    "awayPostgameElo": 1058,
    "excitementIndex": 3.0183376559001367,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761597,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 22217,
    "venueId": 3654,
    "venue": "Brooks Stadium (SC)",
    "homeId": 324,
    "homeTeam": "Coastal Carolina",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 13,
    "homeLineScores": [
      0,
      3,
      0,
      10
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1266,
    "homePostgameElo": 1266,
    "awayId": 2127,
    "awayTeam": "Charleston Southern",
    "awayClassification": "fcs",
    "awayConference": "OVC-Big South",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.838209441976197,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752816,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 70510,
    "venueId": 3936,
    "venue": "Spartan Stadium",
    "homeId": 127,
    "homeTeam": "Michigan State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 42,
    "homeLineScores": [
      7,
      7,
      10,
      3,
      7,
      8
    ],
    "homePostgameWinProbability": 0.06406517326831818,
    "homePregameElo": 1403,
    "homePostgameElo": 1405,
    "awayId": 103,
    "awayTeam": "Boston College",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 40,
    "awayLineScores": [
      0,
      21,
      3,
      3,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.9359348267316818,
    "awayPregameElo": 1508,
    "awayPostgameElo": 1506,
    "excitementIndex": 12.584589323403991,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752695,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 65632,
    "venueId": 3799,
    "venue": "Lane Stadium",
    "homeId": 259,
    "homeTeam": "Virginia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 20,
    "homeLineScores": [
      10,
      10,
      0,
      0
    ],
    "homePostgameWinProbability": 0.025915134698152542,
    "homePregameElo": 1575,
    "homePostgameElo": 1502,
    "awayId": 238,
    "awayTeam": "Vanderbilt",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 44,
    "awayLineScores": [
      0,
      10,
      13,
      21
    ],
    "awayPostgameWinProbability": 0.9740848653018475,
    "awayPregameElo": 1497,
    "awayPostgameElo": 1570,
    "excitementIndex": 5.012196213185042,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752681,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-06T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 100077,
    "venueId": 3657,
    "venue": "Bryant-Denny Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 73,
    "homeLineScores": [
      21,
      21,
      10,
      21
    ],
    "homePostgameWinProbability": 0.9963486790657043,
    "homePregameElo": 1755,
    "homePostgameElo": 1920,
    "awayId": 2433,
    "awayTeam": "UL Monroe",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0036513209342956543,
    "awayPregameElo": 1281,
    "awayPostgameElo": 1116,
    "excitementIndex": 2.6501214200961605,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752823,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-07T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 36117,
    "venueId": 6501,
    "venue": "Allegiant Stadium",
    "homeId": 2439,
    "homeTeam": "UNLV",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 30,
    "homeLineScores": [
      10,
      13,
      0,
      7
    ],
    "homePostgameWinProbability": 0.6303977370262146,
    "homePregameElo": 1633,
    "homePostgameElo": 1630,
    "awayId": 26,
    "awayTeam": "UCLA",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 23,
    "awayLineScores": [
      0,
      3,
      10,
      10
    ],
    "awayPostgameWinProbability": 0.3696022629737854,
    "awayPregameElo": 1404,
    "awayPostgameElo": 1407,
    "excitementIndex": 3.9478301598351275,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761600,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-07T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 26071,
    "venueId": 3666,
    "venue": "Cajun Field",
    "homeId": 309,
    "homeTeam": "Louisiana",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 34,
    "homeLineScores": [
      7,
      10,
      0,
      17
    ],
    "homePostgameWinProbability": 0.9940784573554993,
    "homePregameElo": 1465,
    "homePostgameElo": 1465,
    "awayId": 2377,
    "awayTeam": "McNeese",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 10,
    "awayLineScores": [
      7,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.005921542644500732,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.59242758315518,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757231,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-07T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 31122,
    "venueId": 3946,
    "venue": "Sun Bowl",
    "homeId": 2638,
    "homeTeam": "UTEP",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 42,
    "homeLineScores": [
      7,
      21,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9717544317245483,
    "homePregameElo": 1227,
    "homePostgameElo": 1227,
    "awayId": 2630,
    "awayTeam": "UT Martin",
    "awayClassification": "fcs",
    "awayConference": "OVC-Big South",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      7,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.02824556827545166,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.173238775038266,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757229,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-07T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 10240,
    "venueId": 3601,
    "venue": "Aggie Memorial Stadium",
    "homeId": 166,
    "homeTeam": "New Mexico State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 21,
    "homeLineScores": [
      3,
      0,
      7,
      11
    ],
    "homePostgameWinProbability": 0.8840934038162231,
    "homePregameElo": 1246,
    "homePostgameElo": 1244,
    "awayId": 202,
    "awayTeam": "Tulsa",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.11590659618377686,
    "awayPregameElo": 1041,
    "awayPostgameElo": 1043,
    "excitementIndex": 11.781728585430375,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756879,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-07T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 40038,
    "venueId": 3619,
    "venue": "Arizona Stadium",
    "homeId": 12,
    "homeTeam": "Arizona",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 48,
    "homeLineScores": [
      24,
      10,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9933739304542542,
    "homePregameElo": 1453,
    "homePostgameElo": 1453,
    "awayId": 2692,
    "awayTeam": "Weber State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.00662606954574585,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.9557139873504634,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754526,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-07T02:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 64692,
    "venueId": 3801,
    "venue": "LaVell Edwards Stadium",
    "homeId": 252,
    "homeTeam": "BYU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 27,
    "homeLineScores": [
      6,
      8,
      10,
      3
    ],
    "homePostgameWinProbability": 0.9625639915466309,
    "homePregameElo": 1644,
    "homePostgameElo": 1666,
    "awayId": 24,
    "awayTeam": "Stanford",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.03743600845336914,
    "awayPregameElo": 1282,
    "awayPostgameElo": 1260,
    "excitementIndex": 3.0627533927894794,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752948,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-07T02:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24330,
    "venueId": 3820,
    "venue": "Gesa Field",
    "homeId": 265,
    "homeTeam": "Washington State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 36,
    "homeLineScores": [
      7,
      12,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9699023365974426,
    "homePregameElo": 1520,
    "homePostgameElo": 1555,
    "awayId": 21,
    "awayTeam": "San Diego State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 13,
    "awayLineScores": [
      7,
      0,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.030097663402557373,
    "awayPregameElo": 1318,
    "awayPostgameElo": 1283,
    "excitementIndex": 4.663543658675971,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752821,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-07T03:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 65421,
    "venueId": 3765,
    "venue": "Husky Stadium",
    "homeId": 264,
    "homeTeam": "Washington",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 70,
    "homeLineScores": [
      14,
      28,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9920576214790344,
    "homePregameElo": 1610,
    "homePostgameElo": 1610,
    "awayId": 302,
    "awayTeam": "UC Davis",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.007942378520965576,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.828101092902816,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757230,
    "season": 2025,
    "week": 2,
    "seasonType": "regular",
    "startDate": "2025-09-07T03:59:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 11625,
    "venueId": 7220,
    "venue": "Clarence T.C. Ching Athletics Complex",
    "homeId": 62,
    "homeTeam": "Hawai'i",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 37,
    "homeLineScores": [
      7,
      10,
      3,
      17
    ],
    "homePostgameWinProbability": 0.8447800278663635,
    "homePregameElo": 1178,
    "homePostgameElo": 1238,
    "awayId": 2534,
    "awayTeam": "Sam Houston",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      3,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.15521997213363647,
    "awayPregameElo": 1397,
    "awayPostgameElo": 1337,
    "excitementIndex": 4.3975313896787345,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754531,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-11T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 29043,
    "venueId": 3630,
    "venue": "Allegacy Federal Credit Union Stadium",
    "homeId": 154,
    "homeTeam": "Wake Forest",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 24,
    "homeLineScores": [
      14,
      10,
      0,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1394,
    "homePostgameElo": 1383,
    "awayId": 152,
    "awayTeam": "NC State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      14,
      3,
      7,
      10
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1510,
    "awayPostgameElo": 1521,
    "excitementIndex": 5.133342505139144,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752836,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-12T22:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 46219,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 73,
    "homeLineScores": [
      21,
      24,
      21,
      7
    ],
    "homePostgameWinProbability": 0.9889745712280273,
    "homePregameElo": 1904,
    "homePostgameElo": 1904,
    "awayId": 282,
    "awayTeam": "Indiana State",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.011025428771972656,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.7617165358023894,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754532,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-12T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 37372,
    "venueId": 1964,
    "venue": "JMA Wireless Dome",
    "homeId": 183,
    "homeTeam": "Syracuse",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 66,
    "homeLineScores": [
      14,
      24,
      7,
      21
    ],
    "homePostgameWinProbability": 0.9922441840171814,
    "homePregameElo": 1475,
    "homePostgameElo": 1475,
    "awayId": 2142,
    "awayTeam": "Colgate",
    "awayClassification": "fcs",
    "awayConference": "Patriot",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      0,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.0077558159828186035,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.5273897868845587,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756893,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-12T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 37899,
    "venueId": 4728,
    "venue": "TDECU Stadium",
    "homeId": 248,
    "homeTeam": "Houston",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 36,
    "homeLineScores": [
      10,
      6,
      10,
      10
    ],
    "homePostgameWinProbability": 0.7838240265846252,
    "homePregameElo": 1441,
    "homePostgameElo": 1497,
    "awayId": 38,
    "awayTeam": "Colorado",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      14,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.21617597341537476,
    "awayPregameElo": 1660,
    "awayPostgameElo": 1604,
    "excitementIndex": 4.780995718894543,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756888,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 40051,
    "venueId": 3619,
    "venue": "Arizona Stadium",
    "homeId": 12,
    "homeTeam": "Arizona",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 23,
    "homeLineScores": [
      7,
      10,
      3,
      3
    ],
    "homePostgameWinProbability": 0.8432114124298096,
    "homePregameElo": 1451,
    "homePostgameElo": 1469,
    "awayId": 2306,
    "awayTeam": "Kansas State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 17,
    "awayLineScores": [
      3,
      0,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.15678858757019043,
    "awayPregameElo": 1658,
    "awayPostgameElo": 1640,
    "excitementIndex": 5.652025807713283,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752837,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 31163,
    "venueId": 1056,
    "venue": "Rose Bowl",
    "homeId": 26,
    "homeTeam": "UCLA",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 10,
    "homeLineScores": [
      0,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1407,
    "homePostgameElo": 1331,
    "awayId": 167,
    "awayTeam": "New Mexico",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      7,
      0,
      21
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1332,
    "awayPostgameElo": 1408,
    "excitementIndex": 3.584693048370142,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754623,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 48059,
    "venueId": 721,
    "venue": "Bobby Dodd Stadium",
    "homeId": 59,
    "homeTeam": "Georgia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 24,
    "homeLineScores": [
      3,
      10,
      0,
      11
    ],
    "homePostgameWinProbability": 0.38769611716270447,
    "homePregameElo": 1557,
    "homePostgameElo": 1560,
    "awayId": 228,
    "awayTeam": "Clemson",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.6123038828372955,
    "awayPregameElo": 1696,
    "awayPostgameElo": 1693,
    "excitementIndex": 5.843388219921077,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756891,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 41215,
    "venueId": 4727,
    "venue": "McLane Stadium",
    "homeId": 239,
    "homeTeam": "Baylor",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 42,
    "homeLineScores": [
      14,
      21,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9469010829925537,
    "homePregameElo": 1579,
    "homePostgameElo": 1579,
    "awayId": 2535,
    "awayTeam": "Samford",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.05309891700744629,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.414792147573618,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752831,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12023,
    "venueId": 5960,
    "venue": "Lanny and Sharon Martin Stadium",
    "homeId": 77,
    "homeTeam": "Northwestern",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 14,
    "homeLineScores": [
      0,
      0,
      0,
      14
    ],
    "homePostgameWinProbability": 0.03762400522828102,
    "homePregameElo": 1403,
    "homePostgameElo": 1411,
    "awayId": 2483,
    "awayTeam": "Oregon",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      10,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.962375994771719,
    "awayPregameElo": 1992,
    "awayPostgameElo": 1984,
    "excitementIndex": 3.2641501167463502,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752838,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 36780,
    "venueId": 3665,
    "venue": "SECU Stadium",
    "homeId": 120,
    "homeTeam": "Maryland",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 44,
    "homeLineScores": [
      17,
      17,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9941574335098267,
    "homePregameElo": 1528,
    "homePostgameElo": 1528,
    "awayId": 119,
    "awayTeam": "Towson",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      0,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.00584256649017334,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.8917466351206103,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761608,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23384,
    "venueId": 3975,
    "venue": "Veterans Memorial Stadium (AL)",
    "homeId": 2653,
    "homeTeam": "Troy",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 7,
    "homeLineScores": [
      0,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1472,
    "homePostgameElo": 1435,
    "awayId": 235,
    "awayTeam": "Memphis",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      14,
      0,
      7
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1621,
    "awayPostgameElo": 1658,
    "excitementIndex": 4.585106428375084,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752703,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24927,
    "venueId": 3806,
    "venue": "Lincoln Financial Field",
    "homeId": 218,
    "homeTeam": "Temple",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 3,
    "homeLineScores": [
      0,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1284,
    "homePostgameElo": 1221,
    "awayId": 201,
    "awayTeam": "Oklahoma",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 42,
    "awayLineScores": [
      11,
      17,
      14,
      0
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1679,
    "awayPostgameElo": 1742,
    "excitementIndex": 2.8145400659947084,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752828,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 86292,
    "venueId": 3834,
    "venue": "Memorial Stadium (Lincoln, NE)",
    "homeId": 158,
    "homeTeam": "Nebraska",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 59,
    "homeLineScores": [
      17,
      21,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9886107444763184,
    "homePregameElo": 1712,
    "homePostgameElo": 1712,
    "awayId": 2277,
    "awayTeam": "Houston Christian",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.01138925552368164,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.770745384073898,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754619,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 38512,
    "venueId": 3923,
    "venue": "Scott Stadium",
    "homeId": 258,
    "homeTeam": "Virginia",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 55,
    "homeLineScores": [
      14,
      28,
      10,
      3
    ],
    "homePostgameWinProbability": 0.9928979873657227,
    "homePregameElo": 1514,
    "homePostgameElo": 1514,
    "awayId": 2729,
    "awayTeam": "William & Mary",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      7,
      7,
      2
    ],
    "awayPostgameWinProbability": 0.007102012634277344,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.9915828835043174,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762817,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11833,
    "venueId": 3696,
    "venue": "Dix Stadium",
    "homeId": 2309,
    "homeTeam": "Kent State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.3225918412208557,
    "homePregameElo": 938,
    "homePostgameElo": 959,
    "awayId": 2084,
    "awayTeam": "Buffalo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 31,
    "awayLineScores": [
      0,
      10,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.6774081587791443,
    "awayPregameElo": 1407,
    "awayPostgameElo": 1386,
    "excitementIndex": 6.469148484749553,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752839,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 110740,
    "venueId": 3558,
    "venue": "Michigan Stadium",
    "homeId": 130,
    "homeTeam": "Michigan",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 63,
    "homeLineScores": [
      14,
      21,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9919071197509766,
    "homePregameElo": 1742,
    "homePostgameElo": 1852,
    "awayId": 2117,
    "awayTeam": "Central Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.008092880249023438,
    "awayPregameElo": 1204,
    "awayPostgameElo": 1094,
    "excitementIndex": 2.587065763775777,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752696,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 100077,
    "venueId": 3657,
    "venue": "Bryant-Denny Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 38,
    "homeLineScores": [
      7,
      14,
      14,
      3
    ],
    "homePostgameWinProbability": 0.8911544680595398,
    "homePregameElo": 1920,
    "homePostgameElo": 1948,
    "awayId": 275,
    "awayTeam": "Wisconsin",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.1088455319404602,
    "awayPregameElo": 1619,
    "awayPostgameElo": 1591,
    "excitementIndex": 3.036218096573123,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752697,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 31,
    "homeLineScores": [
      7,
      21,
      3,
      0
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1661,
    "homePostgameElo": 1686,
    "awayId": 6,
    "awayTeam": "South Alabama",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 15,
    "awayLineScores": [
      3,
      6,
      6,
      0
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1557,
    "awayPostgameElo": 1532,
    "excitementIndex": 3.376760616702656,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752702,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 57321,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 52,
    "homeLineScores": [
      14,
      24,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9927979707717896,
    "homePregameElo": 1659,
    "homePostgameElo": 1755,
    "awayId": 309,
    "awayTeam": "Louisiana",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.007202029228210449,
    "awayPregameElo": 1463,
    "awayPostgameElo": 1367,
    "excitementIndex": 2.585327124218903,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762818,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 10512,
    "venueId": 3919,
    "venue": "Scheumann Stadium",
    "homeId": 2050,
    "homeTeam": "Ball State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 34,
    "homeLineScores": [
      14,
      14,
      6,
      0
    ],
    "homePostgameWinProbability": 0.6924471259117126,
    "homePregameElo": 1070,
    "homePostgameElo": 1070,
    "awayId": 160,
    "awayTeam": "New Hampshire",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 29,
    "awayLineScores": [
      14,
      7,
      3,
      5
    ],
    "awayPostgameWinProbability": 0.30755287408828735,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 6.2521489726866895,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757168,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 17862,
    "venueId": 3695,
    "venue": "Delaware Stadium",
    "homeId": 48,
    "homeTeam": "Delaware",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 44,
    "homeLineScores": [
      14,
      14,
      7,
      3,
      6
    ],
    "homePostgameWinProbability": 0.2355707436800003,
    "homePregameElo": 1453,
    "homePostgameElo": 1454,
    "awayId": 41,
    "awayTeam": "UConn",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 41,
    "awayLineScores": [
      10,
      14,
      7,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.7644292563199997,
    "awayPregameElo": 1446,
    "awayPostgameElo": 1445,
    "excitementIndex": 7.317098297018303,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756892,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 30014,
    "venueId": 3854,
    "venue": "Nippert Stadium",
    "homeId": 2132,
    "homeTeam": "Cincinnati",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 70,
    "homeLineScores": [
      35,
      21,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9783123731613159,
    "homePregameElo": 1498,
    "homePostgameElo": 1498,
    "awayId": 2466,
    "awayTeam": "Northwestern State",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.021687626838684082,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.3762935647170007,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752705,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 101915,
    "venueId": 3853,
    "venue": "Neyland Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 41,
    "homeLineScores": [
      21,
      0,
      7,
      10,
      3
    ],
    "homePostgameWinProbability": 0.8290138840675354,
    "homePregameElo": 1799,
    "homePostgameElo": 1809,
    "awayId": 61,
    "awayTeam": "Georgia",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 44,
    "awayLineScores": [
      7,
      10,
      10,
      11,
      6
    ],
    "awayPostgameWinProbability": 0.1709861159324646,
    "awayPregameElo": 2053,
    "awayPostgameElo": 2043,
    "excitementIndex": 8.927697065894355,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752832,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 58065,
    "venueId": 3907,
    "venue": "Ross-Ade Stadium",
    "homeId": 2509,
    "homeTeam": "Purdue",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 17,
    "homeLineScores": [
      0,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.0364251509308815,
    "homePregameElo": 1293,
    "homePostgameElo": 1310,
    "awayId": 30,
    "awayTeam": "USC",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 33,
    "awayLineScores": [
      3,
      14,
      13,
      3
    ],
    "awayPostgameWinProbability": 0.9635748490691185,
    "awayPregameElo": 1895,
    "awayPostgameElo": 1878,
    "excitementIndex": 4.127607975845876,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752834,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 71301,
    "venueId": 3936,
    "venue": "Spartan Stadium",
    "homeId": 127,
    "homeTeam": "Michigan State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 41,
    "homeLineScores": [
      7,
      10,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9881170988082886,
    "homePregameElo": 1406,
    "homePostgameElo": 1406,
    "awayId": 2754,
    "awayTeam": "Youngstown State",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.011882901191711426,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.2166848075946906,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754638,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 62108,
    "venueId": 3842,
    "venue": "Milan Puskar Stadium",
    "homeId": 277,
    "homeTeam": "West Virginia",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 31,
    "homeLineScores": [
      0,
      7,
      7,
      10,
      7
    ],
    "homePostgameWinProbability": 0.6105152368545532,
    "homePregameElo": 1469,
    "homePostgameElo": 1481,
    "awayId": 221,
    "awayTeam": "Pittsburgh",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      3,
      11,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.3894847631454468,
    "awayPregameElo": 1518,
    "awayPostgameElo": 1506,
    "excitementIndex": 6.320810263190439,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754615,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15027,
    "venueId": 3878,
    "venue": "Plaster Sports Complex",
    "homeId": 2623,
    "homeTeam": "Missouri State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 10,
    "homeLineScores": [
      10,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.007379618473351002,
    "homePregameElo": 1346,
    "homePostgameElo": 1338,
    "awayId": 2567,
    "awayTeam": "SMU",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      14,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.992620381526649,
    "awayPregameElo": 1703,
    "awayPostgameElo": 1711,
    "excitementIndex": 4.819093231576694,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762819,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 22846,
    "venueId": 3739,
    "venue": "Glass Bowl",
    "homeId": 2649,
    "homeTeam": "Toledo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 60,
    "homeLineScores": [
      3,
      43,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9923451542854309,
    "homePregameElo": 1501,
    "homePostgameElo": 1501,
    "awayId": 2415,
    "awayTeam": "Morgan State",
    "awayClassification": "fcs",
    "awayConference": "MEAC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.007654845714569092,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.094625763358364,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752949,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 26837,
    "venueId": 3825,
    "venue": "DATCU Stadium",
    "homeId": 249,
    "homeTeam": "North Texas",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 59,
    "homeLineScores": [
      14,
      28,
      10,
      7
    ],
    "homePostgameWinProbability": 0.992473304271698,
    "homePregameElo": 1409,
    "homePostgameElo": 1585,
    "awayId": 265,
    "awayTeam": "Washington State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.007526695728302002,
    "awayPregameElo": 1555,
    "awayPostgameElo": 1379,
    "excitementIndex": 2.9196179755702003,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754639,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 50500,
    "venueId": 3787,
    "venue": "Kenan Stadium",
    "homeId": 153,
    "homeTeam": "North Carolina",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 41,
    "homeLineScores": [
      10,
      10,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9832761287689209,
    "homePregameElo": 1439,
    "homePostgameElo": 1439,
    "awayId": 257,
    "awayTeam": "Richmond",
    "awayClassification": "fcs",
    "awayConference": "Patriot",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      3,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.0167238712310791,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.8548324802643834,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752833,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 41011,
    "venueId": 6577,
    "venue": "SHI Stadium",
    "homeId": 164,
    "homeTeam": "Rutgers",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 60,
    "homeLineScores": [
      13,
      13,
      20,
      14
    ],
    "homePostgameWinProbability": 0.9916054010391235,
    "homePregameElo": 1594,
    "homePostgameElo": 1594,
    "awayId": 2450,
    "awayTeam": "Norfolk State",
    "awayClassification": "fcs",
    "awayConference": "MEAC",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.008394598960876465,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.0531257443572137,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752835,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 109516,
    "venueId": 3632,
    "venue": "Beaver Stadium",
    "homeId": 213,
    "homeTeam": "Penn State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 52,
    "homeLineScores": [
      7,
      14,
      10,
      21
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 2152,
    "homePostgameElo": 2152,
    "awayId": 222,
    "awayTeam": "Villanova",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      0,
      0,
      6
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.5341388565562255,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762467,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20421,
    "venueId": 3604,
    "venue": "Alamodome",
    "homeId": 2636,
    "homeTeam": "UTSA",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 48,
    "homeLineScores": [
      10,
      14,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9985087513923645,
    "homePregameElo": 1489,
    "homePostgameElo": 1489,
    "awayId": 2916,
    "awayTeam": "Incarnate Word",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      0,
      14,
      6
    ],
    "awayPostgameWinProbability": 0.001491248607635498,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.0115730752607686,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752938,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 60229,
    "venueId": 3784,
    "venue": "Jones AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 45,
    "homeLineScores": [
      14,
      14,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9839296936988831,
    "homePregameElo": 1639,
    "homePostgameElo": 1690,
    "awayId": 204,
    "awayTeam": "Oregon State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.016070306301116943,
    "awayPregameElo": 1365,
    "awayPostgameElo": 1314,
    "excitementIndex": 3.4678863962298885,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756890,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 22348,
    "venueId": 3625,
    "venue": "Centennial Bank Stadium",
    "homeId": 2032,
    "homeTeam": "Arkansas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 16,
    "homeLineScores": [
      0,
      10,
      3,
      3
    ],
    "homePostgameWinProbability": 0.10015681385993958,
    "homePregameElo": 1244,
    "homePostgameElo": 1257,
    "awayId": 66,
    "awayTeam": "Iowa State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 24,
    "awayLineScores": [
      9,
      8,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.8998431861400604,
    "awayPregameElo": 1621,
    "awayPostgameElo": 1608,
    "excitementIndex": 6.731182769771558,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752706,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 102025,
    "venueId": 3910,
    "venue": "DKR-Texas Memorial Stadium",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 27,
    "homeLineScores": [
      7,
      7,
      6,
      7
    ],
    "homePostgameWinProbability": 0.9785351157188416,
    "homePregameElo": 1896,
    "homePostgameElo": 1878,
    "awayId": 2638,
    "awayTeam": "UTEP",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.021464884281158447,
    "awayPregameElo": 1230,
    "awayPostgameElo": 1248,
    "excitementIndex": 4.283283201014982,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754535,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 66591,
    "venueId": 3948,
    "venue": "Hard Rock Stadium",
    "homeId": 2390,
    "homeTeam": "Miami",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 49,
    "homeLineScores": [
      14,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9786890745162964,
    "homePregameElo": 1743,
    "homePostgameElo": 1825,
    "awayId": 58,
    "awayTeam": "South Florida",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 12,
    "awayLineScores": [
      3,
      3,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.021310925483703613,
    "awayPregameElo": 1564,
    "awayPostgameElo": 1482,
    "excitementIndex": 3.675912828336096,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757258,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 16808,
    "venueId": 3816,
    "venue": "Mackay Stadium",
    "homeId": 2440,
    "homeTeam": "Nevada",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 13,
    "homeLineScores": [
      0,
      13,
      0,
      0
    ],
    "homePostgameWinProbability": 0.5640181303024292,
    "homePregameElo": 1284,
    "homePostgameElo": 1278,
    "awayId": 2393,
    "awayTeam": "Middle Tennessee",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.4359818696975708,
    "awayPregameElo": 1182,
    "awayPostgameElo": 1188,
    "excitementIndex": 4.244323209980611,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757256,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23159,
    "venueId": 3700,
    "venue": "Doyt L. Perry Stadium",
    "homeId": 189,
    "homeTeam": "Bowling Green",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 23,
    "homeLineScores": [
      3,
      7,
      3,
      10
    ],
    "homePostgameWinProbability": 0.607711911201477,
    "homePregameElo": 1434,
    "homePostgameElo": 1456,
    "awayId": 2335,
    "awayTeam": "Liberty",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      0,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.39228808879852295,
    "awayPregameElo": 1494,
    "awayPostgameElo": 1472,
    "excitementIndex": 4.965804416497581,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761606,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23925,
    "venueId": 3775,
    "venue": "Joan C. Edwards Stadium",
    "homeId": 276,
    "homeTeam": "Marshall",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 38,
    "homeLineScores": [
      17,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9945290088653564,
    "homePregameElo": 1492,
    "homePostgameElo": 1492,
    "awayId": 2198,
    "awayTeam": "Eastern Kentucky",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.005470991134643555,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.123035714444983,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762464,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15681,
    "venueId": 4418,
    "venue": "Jerry Richardson Stadium",
    "homeId": 2429,
    "homeTeam": "Charlotte",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 42,
    "homeLineScores": [
      0,
      7,
      21,
      14
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1170,
    "homePostgameElo": 1170,
    "awayId": 2405,
    "awayTeam": "Monmouth",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      7,
      7,
      14
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 8.551218092966522,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757235,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 11040,
    "venueId": 4899,
    "venue": "Fifth Third Stadium",
    "homeId": 338,
    "homeTeam": "Kennesaw State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 27,
    "homeLineScores": [
      0,
      7,
      17,
      3
    ],
    "homePostgameWinProbability": 0.7522923350334167,
    "homePregameElo": 1175,
    "homePostgameElo": 1175,
    "awayId": 2771,
    "awayTeam": "Merrimack",
    "awayClassification": "fcs",
    "awayConference": "FCS Independents",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      0,
      0,
      13
    ],
    "awayPostgameWinProbability": 0.24770766496658325,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.744209434880275,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757233,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 17638,
    "venueId": 2031,
    "venue": "Pitbull Stadium",
    "homeId": 2229,
    "homeTeam": "Florida International",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 38,
    "homeLineScores": [
      7,
      10,
      21,
      0
    ],
    "homePostgameWinProbability": 0.9204025864601135,
    "homePregameElo": 1358,
    "homePostgameElo": 1367,
    "awayId": 2226,
    "awayTeam": "Florida Atlantic",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      14,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.07959741353988647,
    "awayPregameElo": 1240,
    "awayPostgameElo": 1231,
    "excitementIndex": 6.29559626968601,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752701,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 49158,
    "venueId": 3693,
    "venue": "Davis Wade Stadium",
    "homeId": 344,
    "homeTeam": "Mississippi State",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 63,
    "homeLineScores": [
      28,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9959214925765991,
    "homePregameElo": 1454,
    "homePostgameElo": 1454,
    "awayId": 2016,
    "awayTeam": "Alcorn State",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.004078507423400879,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.565396611521562,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754536,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 57627,
    "venueId": 3799,
    "venue": "Lane Stadium",
    "homeId": 259,
    "homeTeam": "Virginia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 26,
    "homeLineScores": [
      0,
      0,
      7,
      19
    ],
    "homePostgameWinProbability": 0.09397724270820618,
    "homePregameElo": 1502,
    "homePostgameElo": 1452,
    "awayId": 295,
    "awayTeam": "Old Dominion",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 45,
    "awayLineScores": [
      7,
      21,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.9060227572917938,
    "awayPregameElo": 1480,
    "awayPostgameElo": 1530,
    "excitementIndex": 3.011007830057404,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761607,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24534,
    "venueId": 3815,
    "venue": "M. M. Roberts Stadium",
    "homeId": 2572,
    "homeTeam": "Southern Miss",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 38,
    "homeLineScores": [
      7,
      10,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9881961345672607,
    "homePregameElo": 1107,
    "homePostgameElo": 1178,
    "awayId": 2026,
    "awayTeam": "App State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 22,
    "awayLineScores": [
      7,
      0,
      7,
      8
    ],
    "awayPostgameWinProbability": 0.011803865432739258,
    "awayPregameElo": 1461,
    "awayPostgameElo": 1390,
    "excitementIndex": 4.71376107823059,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757234,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24585,
    "venueId": 3608,
    "venue": "Allen E. Paulson Stadium",
    "homeId": 290,
    "homeTeam": "Georgia Southern",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 41,
    "homeLineScores": [
      17,
      14,
      0,
      10
    ],
    "homePostgameWinProbability": 0.9579857587814331,
    "homePregameElo": 1328,
    "homePostgameElo": 1357,
    "awayId": 55,
    "awayTeam": "Jacksonville State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 34,
    "awayLineScores": [
      14,
      10,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.042014241218566895,
    "awayPregameElo": 1642,
    "awayPostgameElo": 1613,
    "excitementIndex": 6.485979732495877,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752700,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 65068,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 41,
    "homeLineScores": [
      7,
      24,
      7,
      3
    ],
    "homePostgameWinProbability": 0.4054233729839325,
    "homePregameElo": 1922,
    "homePostgameElo": 1918,
    "awayId": 8,
    "awayTeam": "Arkansas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      21,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.5945766270160675,
    "awayPregameElo": 1674,
    "awayPostgameElo": 1678,
    "excitementIndex": 6.476053958073642,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752827,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 105765,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 37,
    "homeLineScores": [
      3,
      10,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9870242476463318,
    "homePregameElo": 1977,
    "homePostgameElo": 2010,
    "awayId": 195,
    "awayTeam": "Ohio",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 9,
    "awayLineScores": [
      0,
      3,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.012975752353668213,
    "awayPregameElo": 1620,
    "awayPostgameElo": 1587,
    "excitementIndex": 3.5345613469090864,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761605,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 13988,
    "venueId": 4246,
    "venue": "Center Parc Stadium",
    "homeId": 2247,
    "homeTeam": "Georgia State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 37,
    "homeLineScores": [
      14,
      9,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9928389191627502,
    "homePregameElo": 1167,
    "homePostgameElo": 1167,
    "awayId": 93,
    "awayTeam": "Murray State",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.007161080837249756,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.7539187260165643,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762466,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 22260,
    "venueId": 3895,
    "venue": "Rice Stadium",
    "homeId": 242,
    "homeTeam": "Rice",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 38,
    "homeLineScores": [
      7,
      17,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9967264533042908,
    "homePregameElo": 1262,
    "homePostgameElo": 1262,
    "awayId": 2504,
    "awayTeam": "Prairie View A&M",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.0032735466957092285,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.294864729685547,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752829,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 60670,
    "venueId": 3832,
    "venue": "Memorial Stadium (Champaign, IL)",
    "homeId": 356,
    "homeTeam": "Illinois",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      3,
      7,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9919793605804443,
    "homePregameElo": 1642,
    "homePostgameElo": 1708,
    "awayId": 2711,
    "awayTeam": "Western Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.008020639419555664,
    "awayPregameElo": 1312,
    "awayPostgameElo": 1246,
    "excitementIndex": 3.1088281984789954,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752698,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 58489,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 48,
    "homeLineScores": [
      14,
      14,
      10,
      10
    ],
    "homePostgameWinProbability": 0.9979289770126343,
    "homePregameElo": 1524,
    "homePostgameElo": 1557,
    "awayId": 2199,
    "awayTeam": "Eastern Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 23,
    "awayLineScores": [
      3,
      13,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0020710229873657227,
    "awayPregameElo": 1253,
    "awayPostgameElo": 1220,
    "excitementIndex": 3.6645728040247083,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757257,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60229,
    "venueId": 3776,
    "venue": "Joe Aillet Stadium",
    "homeId": 2348,
    "homeTeam": "Louisiana Tech",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 49,
    "homeLineScores": [
      10,
      17,
      0,
      22
    ],
    "homePostgameWinProbability": 0.9940977692604065,
    "homePregameElo": 1392,
    "homePostgameElo": 1471,
    "awayId": 166,
    "awayTeam": "New Mexico State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.005902230739593506,
    "awayPregameElo": 1244,
    "awayPostgameElo": 1165,
    "excitementIndex": 3.565683321277412,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752830,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 69250,
    "venueId": 3793,
    "venue": "Kinnick Stadium",
    "homeId": 2294,
    "homeTeam": "Iowa",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 47,
    "homeLineScores": [
      20,
      10,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9895370602607727,
    "homePregameElo": 1680,
    "homePostgameElo": 1723,
    "awayId": 113,
    "awayTeam": "Massachusetts",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.010462939739227295,
    "awayPregameElo": 1101,
    "awayPostgameElo": 1058,
    "excitementIndex": 2.706172889122278,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761604,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21634,
    "venueId": 3654,
    "venue": "Brooks Stadium (SC)",
    "homeId": 324,
    "homeTeam": "Coastal Carolina",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 0,
    "homeLineScores": [
      0,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1262,
    "homePostgameElo": 1172,
    "awayId": 151,
    "awayTeam": "East Carolina",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 38,
    "awayLineScores": [
      10,
      0,
      7,
      21
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1429,
    "awayPostgameElo": 1519,
    "excitementIndex": 3.8528115010189783,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752707,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 77622,
    "venueId": 3855,
    "venue": "Notre Dame Stadium",
    "homeId": 87,
    "homeTeam": "Notre Dame",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 40,
    "homeLineScores": [
      14,
      10,
      7,
      9
    ],
    "homePostgameWinProbability": 0.3599589765071869,
    "homePregameElo": 2166,
    "homePostgameElo": 2141,
    "awayId": 245,
    "awayTeam": "Texas A&M",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 41,
    "awayLineScores": [
      7,
      21,
      3,
      10
    ],
    "awayPostgameWinProbability": 0.6400410234928131,
    "awayPregameElo": 1724,
    "awayPostgameElo": 1749,
    "excitementIndex": 8.103345635698446,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752699,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 102158,
    "venueId": 3958,
    "venue": "Tiger Stadium (LA)",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 20,
    "homeLineScores": [
      0,
      13,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9313405752182007,
    "homePregameElo": 1735,
    "homePostgameElo": 1747,
    "awayId": 57,
    "awayTeam": "Florida",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.06865942478179932,
    "awayPregameElo": 1668,
    "awayPostgameElo": 1656,
    "excitementIndex": 5.779301403355406,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752704,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-13T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 79873,
    "venueId": 3994,
    "venue": "Williams-Brice Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 7,
    "homeLineScores": [
      7,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0192426610738039,
    "homePregameElo": 1729,
    "homePostgameElo": 1645,
    "awayId": 238,
    "awayTeam": "Vanderbilt",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      7,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.9807573389261961,
    "awayPregameElo": 1570,
    "awayPostgameElo": 1654,
    "excitementIndex": 4.458445004730975,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762465,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-14T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20103,
    "venueId": 3674,
    "venue": "Chapman Stadium",
    "homeId": 202,
    "homeTeam": "Tulsa",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 23,
    "homeLineScores": [
      14,
      3,
      0,
      6
    ],
    "homePostgameWinProbability": 0.01311210636049509,
    "homePregameElo": 1043,
    "homePostgameElo": 1046,
    "awayId": 2426,
    "awayTeam": "Navy",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 42,
    "awayLineScores": [
      7,
      14,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.9868878936395049,
    "awayPregameElo": 1553,
    "awayPostgameElo": 1550,
    "excitementIndex": 4.787999254795146,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756895,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-14T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23500,
    "venueId": 3984,
    "venue": "War Memorial Stadium",
    "homeId": 2751,
    "homeTeam": "Wyoming",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 6,
    "homeLineScores": [
      0,
      0,
      0,
      6
    ],
    "homePostgameWinProbability": 0.0009106388315558434,
    "homePregameElo": 1377,
    "homePostgameElo": 1339,
    "awayId": 254,
    "awayTeam": "Utah",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 31,
    "awayLineScores": [
      3,
      0,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.9990893611684442,
    "awayPregameElo": 1630,
    "awayPostgameElo": 1668,
    "excitementIndex": 3.6670493757129026,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754534,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-14T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 30000,
    "venueId": 4729,
    "venue": "Yulman Stadium",
    "homeId": 2655,
    "homeTeam": "Tulane",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 34,
    "homeLineScores": [
      14,
      10,
      7,
      3
    ],
    "homePostgameWinProbability": 0.8578504920005798,
    "homePregameElo": 1642,
    "homePostgameElo": 1642,
    "awayId": 150,
    "awayTeam": "Duke",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      9,
      7,
      11
    ],
    "awayPostgameWinProbability": 0.14214950799942017,
    "awayPregameElo": 1462,
    "awayPostgameElo": 1462,
    "excitementIndex": 3.9642182675078077,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756894,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-14T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 48094,
    "venueId": 3616,
    "venue": "Amon G. Carter Stadium",
    "homeId": 2628,
    "homeTeam": "TCU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 42,
    "homeLineScores": [
      14,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.6292220950126648,
    "homePregameElo": 1726,
    "homePostgameElo": 1726,
    "awayId": 2000,
    "awayTeam": "Abilene Christian",
    "awayClassification": "fcs",
    "awayConference": "UAC",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      0,
      9,
      12
    ],
    "awayPostgameWinProbability": 0.3707779049873352,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.0274399303276147,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762463,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-14T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 17823,
    "venueId": 7221,
    "venue": "Protective Stadium",
    "homeId": 5,
    "homeTeam": "UAB",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 31,
    "homeLineScores": [
      14,
      17,
      0,
      0
    ],
    "homePostgameWinProbability": 0.5819172263145447,
    "homePregameElo": 1309,
    "homePostgameElo": 1307,
    "awayId": 2006,
    "awayTeam": "Akron",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 28,
    "awayLineScores": [
      17,
      3,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.4180827736854553,
    "awayPregameElo": 1058,
    "awayPostgameElo": 1060,
    "excitementIndex": 5.763485619363661,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760368,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-14T01:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17124,
    "venueId": 3905,
    "venue": "Maverik Stadium",
    "homeId": 328,
    "homeTeam": "Utah State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 49,
    "homeLineScores": [
      7,
      7,
      21,
      14
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1394,
    "homePostgameElo": 1442,
    "awayId": 2005,
    "awayTeam": "Air Force",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 30,
    "awayLineScores": [
      0,
      10,
      6,
      14
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1438,
    "awayPostgameElo": 1390,
    "excitementIndex": 5.7210732334539,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760369,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-14T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 37210,
    "venueId": 3660,
    "venue": "Valley Children's Stadium",
    "homeId": 278,
    "homeTeam": "Fresno State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 56,
    "homeLineScores": [
      14,
      21,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9841591715812683,
    "homePregameElo": 1458,
    "homePostgameElo": 1458,
    "awayId": 2582,
    "awayTeam": "Southern",
    "awayClassification": "fcs",
    "awayConference": "SWAC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.01584082841873169,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.7328645123792015,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754533,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-14T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22162,
    "venueId": 3940,
    "venue": "Stanford Stadium",
    "homeId": 24,
    "homeTeam": "Stanford",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 30,
    "homeLineScores": [
      6,
      14,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9717102646827698,
    "homePregameElo": 1260,
    "homePostgameElo": 1296,
    "awayId": 103,
    "awayTeam": "Boston College",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      20,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.028289735317230225,
    "awayPregameElo": 1506,
    "awayPostgameElo": 1470,
    "excitementIndex": 5.304368767390675,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756889,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-14T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 54005,
    "venueId": 3947,
    "venue": "Mountain America Stadium",
    "homeId": 9,
    "homeTeam": "Arizona State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 34,
    "homeLineScores": [
      3,
      17,
      14,
      0
    ],
    "homePostgameWinProbability": 0.8674847483634949,
    "homePregameElo": 1688,
    "homePostgameElo": 1725,
    "awayId": 326,
    "awayTeam": "Texas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 15,
    "awayLineScores": [
      3,
      0,
      6,
      6
    ],
    "awayPostgameWinProbability": 0.13251525163650513,
    "awayPregameElo": 1627,
    "awayPostgameElo": 1590,
    "excitementIndex": 3.6512044960993957,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752840,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-14T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 38556,
    "venueId": 3831,
    "venue": "California Memorial Stadium",
    "homeId": 25,
    "homeTeam": "California",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 27,
    "homeLineScores": [
      7,
      3,
      7,
      10
    ],
    "homePostgameWinProbability": 0.8964213728904724,
    "homePregameElo": 1554,
    "homePostgameElo": 1586,
    "awayId": 135,
    "awayTeam": "Minnesota",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.10357862710952759,
    "awayPregameElo": 1625,
    "awayPostgameElo": 1593,
    "excitementIndex": 6.143238471096987,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760370,
    "season": 2025,
    "week": 3,
    "seasonType": "regular",
    "startDate": "2025-09-14T03:59:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 11936,
    "venueId": 7220,
    "venue": "Clarence T.C. Ching Athletics Complex",
    "homeId": 62,
    "homeTeam": "Hawai'i",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 23,
    "homeLineScores": [
      0,
      14,
      3,
      6
    ],
    "homePostgameWinProbability": 0.9574030637741089,
    "homePregameElo": 1220,
    "homePostgameElo": 1220,
    "awayId": 2502,
    "awayTeam": "Portland State",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.04259693622589111,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.8012636067385865,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762468,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-18T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13397,
    "venueId": 4418,
    "venue": "Jerry Richardson Stadium",
    "homeId": 2429,
    "homeTeam": "Charlotte",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 17,
    "homeLineScores": [
      3,
      6,
      0,
      8
    ],
    "homePostgameWinProbability": 0.13469073176383972,
    "homePregameElo": 1200,
    "homePostgameElo": 1183,
    "awayId": 242,
    "awayTeam": "Rice",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.8653092682361603,
    "awayPregameElo": 1271,
    "awayPostgameElo": 1288,
    "excitementIndex": 4.3486835794294665,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756900,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-19T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 48842,
    "venueId": 3646,
    "venue": "Boone Pickens Stadium",
    "homeId": 197,
    "homeTeam": "Oklahoma State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 12,
    "homeLineScores": [
      3,
      0,
      0,
      9
    ],
    "homePostgameWinProbability": 0.15766753256320953,
    "homePregameElo": 1202,
    "homePostgameElo": 1176,
    "awayId": 202,
    "awayTeam": "Tulsa",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 19,
    "awayLineScores": [
      10,
      6,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.8423324674367905,
    "awayPregameElo": 1046,
    "awayPostgameElo": 1072,
    "excitementIndex": 4.265337484404841,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752844,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 55942,
    "venueId": 6577,
    "venue": "SHI Stadium",
    "homeId": 164,
    "homeTeam": "Rutgers",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 28,
    "homeLineScores": [
      14,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.24176590144634247,
    "homePregameElo": 1593,
    "homePostgameElo": 1583,
    "awayId": 2294,
    "awayTeam": "Iowa",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 38,
    "awayLineScores": [
      14,
      7,
      0,
      17
    ],
    "awayPostgameWinProbability": 0.7582340985536575,
    "awayPregameElo": 1723,
    "awayPostgameElo": 1733,
    "excitementIndex": 6.504062292308946,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762469,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28446,
    "venueId": 3841,
    "venue": "Michie Stadium",
    "homeId": 349,
    "homeTeam": "Army",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 38,
    "homeLineScores": [
      7,
      7,
      7,
      17,
      0
    ],
    "homePostgameWinProbability": 0.49023255705833435,
    "homePregameElo": 1615,
    "homePostgameElo": 1599,
    "awayId": 249,
    "awayTeam": "North Texas",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 45,
    "awayLineScores": [
      21,
      7,
      3,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.5097674429416656,
    "awayPregameElo": 1585,
    "awayPostgameElo": 1601,
    "excitementIndex": 5.938978446833998,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752708,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 39861,
    "venueId": 3805,
    "venue": "Simmons Bank Liberty Stadium",
    "homeId": 235,
    "homeTeam": "Memphis",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 32,
    "homeLineScores": [
      10,
      7,
      9,
      6
    ],
    "homePostgameWinProbability": 0.752167284488678,
    "homePregameElo": 1658,
    "homePostgameElo": 1659,
    "awayId": 8,
    "awayTeam": "Arkansas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      21,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.24783271551132202,
    "awayPregameElo": 1678,
    "awayPostgameElo": 1677,
    "excitementIndex": 7.701989437202119,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754642,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 49482,
    "venueId": 3873,
    "venue": "L&N Federal Credit Union Stadium",
    "homeId": 97,
    "homeTeam": "Louisville",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 40,
    "homeLineScores": [
      7,
      14,
      9,
      10
    ],
    "homePostgameWinProbability": 0.9754416346549988,
    "homePregameElo": 1727,
    "homePostgameElo": 1755,
    "awayId": 189,
    "awayTeam": "Bowling Green",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 17,
    "awayLineScores": [
      3,
      0,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.02455836534500122,
    "awayPregameElo": 1456,
    "awayPostgameElo": 1428,
    "excitementIndex": 3.683376333055965,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752845,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 68547,
    "venueId": 347,
    "venue": "Camp Randall Stadium",
    "homeId": 275,
    "homeTeam": "Wisconsin",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 10,
    "homeLineScores": [
      0,
      0,
      3,
      7
    ],
    "homePostgameWinProbability": 0.16641175746917725,
    "homePregameElo": 1591,
    "homePostgameElo": 1543,
    "awayId": 120,
    "awayTeam": "Maryland",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      13,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.8335882425308228,
    "awayPregameElo": 1526,
    "awayPostgameElo": 1574,
    "excitementIndex": 3.246110005059111,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756901,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52236,
    "venueId": 587,
    "venue": "Rice-Eccles Stadium",
    "homeId": 254,
    "homeTeam": "Utah",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 10,
    "homeLineScores": [
      0,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.0266287662088871,
    "homePregameElo": 1668,
    "homePostgameElo": 1607,
    "awayId": 2641,
    "awayTeam": "Texas Tech",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      3,
      0,
      24
    ],
    "awayPostgameWinProbability": 0.9733712337911129,
    "awayPregameElo": 1690,
    "awayPostgameElo": 1751,
    "excitementIndex": 5.001086331842076,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754636,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 43333,
    "venueId": 3616,
    "venue": "Amon G. Carter Stadium",
    "homeId": 2628,
    "homeTeam": "TCU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 35,
    "homeLineScores": [
      7,
      7,
      7,
      14
    ],
    "homePostgameWinProbability": 0.8841467499732971,
    "homePregameElo": 1713,
    "homePostgameElo": 1733,
    "awayId": 2567,
    "awayTeam": "SMU",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.11585325002670288,
    "awayPregameElo": 1711,
    "awayPostgameElo": 1691,
    "excitementIndex": 6.107027581915229,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754537,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 80225,
    "venueId": 3836,
    "venue": "Memorial Stadium (Clemson, SC)",
    "homeId": 228,
    "homeTeam": "Clemson",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 21,
    "homeLineScores": [
      7,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.07824885100126266,
    "homePregameElo": 1693,
    "homePostgameElo": 1642,
    "awayId": 183,
    "awayTeam": "Syracuse",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      10,
      14,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.9217511489987373,
    "awayPregameElo": 1484,
    "awayPostgameElo": 1535,
    "excitementIndex": 4.317694278621441,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754617,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 57229,
    "venueId": 3799,
    "venue": "Lane Stadium",
    "homeId": 259,
    "homeTeam": "Virginia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      7,
      14,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9997121095657349,
    "homePregameElo": 1449,
    "homePostgameElo": 1449,
    "awayId": 2747,
    "awayTeam": "Wofford",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      3,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.0002878904342651367,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.010808101043926,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760376,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 12625,
    "venueId": 3996,
    "venue": "Yager Stadium",
    "homeId": 193,
    "homeTeam": "Miami (OH)",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 38,
    "homeLineScores": [
      14,
      10,
      14,
      0
    ],
    "homePostgameWinProbability": 0.07785177230834961,
    "homePregameElo": 1422,
    "homePostgameElo": 1430,
    "awayId": 2439,
    "awayTeam": "UNLV",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 41,
    "awayLineScores": [
      0,
      10,
      14,
      17
    ],
    "awayPostgameWinProbability": 0.9221482276916504,
    "awayPregameElo": 1630,
    "awayPostgameElo": 1622,
    "excitementIndex": 6.068854680783486,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762470,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 28461,
    "venueId": 3886,
    "venue": "Raymond James Stadium",
    "homeId": 58,
    "homeTeam": "South Florida",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 63,
    "homeLineScores": [
      7,
      14,
      35,
      7
    ],
    "homePostgameWinProbability": 0.9767788648605347,
    "homePregameElo": 1477,
    "homePostgameElo": 1477,
    "awayId": 2569,
    "awayTeam": "South Carolina State",
    "awayClassification": "fcs",
    "awayConference": "MEAC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.023221135139465332,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.246837687818147,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752715,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 101915,
    "venueId": 3853,
    "venue": "Neyland Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 56,
    "homeLineScores": [
      21,
      21,
      14,
      0
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1809,
    "homePostgameElo": 1838,
    "awayId": 5,
    "awayTeam": "UAB",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      7,
      10,
      7
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1307,
    "awayPostgameElo": 1278,
    "excitementIndex": 3.3978832449530665,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762822,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 18787,
    "venueId": 3786,
    "venue": "Kelly/Shorts Stadium",
    "homeId": 2117,
    "homeTeam": "Central Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 49,
    "homeLineScores": [
      14,
      21,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9925546050071716,
    "homePregameElo": 1069,
    "homePostgameElo": 1069,
    "awayId": 2681,
    "awayTeam": "Wagner",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.007445394992828369,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.349095161723038,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752841,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 58571,
    "venueId": 3626,
    "venue": "Autzen Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 41,
    "homeLineScores": [
      7,
      14,
      10,
      10
    ],
    "homePostgameWinProbability": 0.9918121695518494,
    "homePregameElo": 1984,
    "homePostgameElo": 2001,
    "awayId": 204,
    "awayTeam": "Oregon State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.008187830448150635,
    "awayPregameElo": 1314,
    "awayPostgameElo": 1297,
    "excitementIndex": 3.635835349470767,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761610,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 18371,
    "venueId": 3912,
    "venue": "Rynearson Stadium",
    "homeId": 2199,
    "homeTeam": "Eastern Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 34,
    "homeLineScores": [
      7,
      14,
      0,
      13
    ],
    "homePostgameWinProbability": 0.6959960460662842,
    "homePregameElo": 1220,
    "homePostgameElo": 1223,
    "awayId": 309,
    "awayTeam": "Louisiana",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      10,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.3040039539337158,
    "awayPregameElo": 1367,
    "awayPostgameElo": 1364,
    "excitementIndex": 7.784561762400252,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757262,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 24022,
    "venueId": 3992,
    "venue": "Williams Stadium (VA)",
    "homeId": 2335,
    "homeTeam": "Liberty",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 13,
    "homeLineScores": [
      3,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0.012324569746851921,
    "homePregameElo": 1472,
    "homePostgameElo": 1442,
    "awayId": 256,
    "awayTeam": "James Madison",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 31,
    "awayLineScores": [
      3,
      7,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.9876754302531481,
    "awayPregameElo": 1606,
    "awayPostgameElo": 1636,
    "excitementIndex": 3.7421837106554343,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754541,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 67277,
    "venueId": 3697,
    "venue": "Doak Campbell Stadium",
    "homeId": 52,
    "homeTeam": "Florida State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 66,
    "homeLineScores": [
      35,
      10,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9918249249458313,
    "homePregameElo": 1477,
    "homePostgameElo": 1577,
    "awayId": 2309,
    "awayTeam": "Kent State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 10,
    "awayLineScores": [
      7,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.008175075054168701,
    "awayPregameElo": 959,
    "awayPostgameElo": 859,
    "excitementIndex": 2.8488923788051816,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762820,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20744,
    "venueId": 3980,
    "venue": "Waldo Stadium",
    "homeId": 2711,
    "homeTeam": "Western Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 14,
    "homeLineScores": [
      0,
      0,
      6,
      8
    ],
    "homePostgameWinProbability": 0.4278900921344757,
    "homePregameElo": 1246,
    "homePostgameElo": 1254,
    "awayId": 2649,
    "awayTeam": "Toledo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      3,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.5721099078655243,
    "awayPregameElo": 1505,
    "awayPostgameElo": 1497,
    "excitementIndex": 5.977110270781994,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752846,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 87278,
    "venueId": 3834,
    "venue": "Memorial Stadium (Lincoln, NE)",
    "homeId": 158,
    "homeTeam": "Nebraska",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 27,
    "homeLineScores": [
      0,
      17,
      0,
      10
    ],
    "homePostgameWinProbability": 0.362228125333786,
    "homePregameElo": 1699,
    "homePostgameElo": 1703,
    "awayId": 130,
    "awayTeam": "Michigan",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 30,
    "awayLineScores": [
      10,
      7,
      10,
      3
    ],
    "awayPostgameWinProbability": 0.637771874666214,
    "awayPregameElo": 1852,
    "awayPostgameElo": 1848,
    "excitementIndex": 6.364445124145732,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761613,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 12068,
    "venueId": 3965,
    "venue": "UB Stadium",
    "homeId": 2084,
    "homeTeam": "Buffalo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 17,
    "homeLineScores": [
      7,
      0,
      7,
      3
    ],
    "homePostgameWinProbability": 0.1638835072517395,
    "homePregameElo": 1386,
    "homePostgameElo": 1383,
    "awayId": 2653,
    "awayTeam": "Troy",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      0,
      0,
      21
    ],
    "awayPostgameWinProbability": 0.8361164927482605,
    "awayPregameElo": 1435,
    "awayPostgameElo": 1438,
    "excitementIndex": 4.636984161676919,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752711,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 65644,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 45,
    "homeLineScores": [
      10,
      13,
      0,
      22
    ],
    "homePostgameWinProbability": 0.9863547682762146,
    "homePregameElo": 1918,
    "homePostgameElo": 1981,
    "awayId": 2655,
    "awayTeam": "Tulane",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0136452317237854,
    "awayPregameElo": 1642,
    "awayPostgameElo": 1579,
    "excitementIndex": 2.8547933682003763,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754640,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 44206,
    "venueId": 3652,
    "venue": "FBC Mortgage Stadium",
    "homeId": 2116,
    "homeTeam": "UCF",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 34,
    "homeLineScores": [
      10,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9920005798339844,
    "homePregameElo": 1554,
    "homePostgameElo": 1604,
    "awayId": 153,
    "awayTeam": "North Carolina",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 9,
    "awayLineScores": [
      0,
      3,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.007999420166015625,
    "awayPregameElo": 1438,
    "awayPostgameElo": 1388,
    "excitementIndex": 3.5528065105861915,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762823,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 22312,
    "venueId": 3876,
    "venue": "Peden Stadium",
    "homeId": 195,
    "homeTeam": "Ohio",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 52,
    "homeLineScores": [
      3,
      28,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9500226378440857,
    "homePregameElo": 1572,
    "homePostgameElo": 1572,
    "awayId": 2241,
    "awayTeam": "Gardner-Webb",
    "awayClassification": "fcs",
    "awayConference": "OVC-Big South",
    "awayPoints": 35,
    "awayLineScores": [
      14,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.04997736215591431,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.182222084728986,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752848,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 77622,
    "venueId": 3855,
    "venue": "Notre Dame Stadium",
    "homeId": 87,
    "homeTeam": "Notre Dame",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 56,
    "homeLineScores": [
      14,
      21,
      21,
      0
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 2141,
    "homePostgameElo": 2126,
    "awayId": 2509,
    "awayTeam": "Purdue",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 30,
    "awayLineScores": [
      7,
      16,
      0,
      7
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1310,
    "awayPostgameElo": 1325,
    "excitementIndex": 4.592865576529613,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752714,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 83639,
    "venueId": 3835,
    "venue": "Memorial Stadium (Norman, OK)",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      3,
      7,
      3,
      11
    ],
    "homePostgameWinProbability": 0.8033507466316223,
    "homePregameElo": 1742,
    "homePostgameElo": 1748,
    "awayId": 2,
    "awayTeam": "Auburn",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      3,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.19664925336837769,
    "awayPregameElo": 1686,
    "awayPostgameElo": 1680,
    "excitementIndex": 6.932946238654773,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757169,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25025,
    "venueId": 3892,
    "venue": "Pratt & Whitney Stadium",
    "homeId": 41,
    "homeTeam": "UConn",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 31,
    "homeLineScores": [
      10,
      0,
      7,
      14
    ],
    "homePostgameWinProbability": 0.7648097276687622,
    "homePregameElo": 1445,
    "homePostgameElo": 1436,
    "awayId": 2050,
    "awayTeam": "Ball State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 25,
    "awayLineScores": [
      0,
      7,
      3,
      15
    ],
    "awayPostgameWinProbability": 0.2351902723312378,
    "awayPregameElo": 1086,
    "awayPostgameElo": 1095,
    "excitementIndex": 4.549424892343512,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754538,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30022,
    "venueId": 3982,
    "venue": "Wallace Wade Stadium",
    "homeId": 150,
    "homeTeam": "Duke",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 45,
    "homeLineScores": [
      7,
      14,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9177067875862122,
    "homePregameElo": 1462,
    "homePostgameElo": 1489,
    "awayId": 152,
    "awayTeam": "NC State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 33,
    "awayLineScores": [
      7,
      13,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.08229321241378784,
    "awayPregameElo": 1521,
    "awayPostgameElo": 1494,
    "excitementIndex": 6.954364216208502,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752712,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 45803,
    "venueId": 3693,
    "venue": "Davis Wade Stadium",
    "homeId": 344,
    "homeTeam": "Mississippi State",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 38,
    "homeLineScores": [
      7,
      7,
      10,
      14
    ],
    "homePostgameWinProbability": 0.989556610584259,
    "homePregameElo": 1436,
    "homePostgameElo": 1512,
    "awayId": 2459,
    "awayTeam": "Northern Illinois",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.010443389415740967,
    "awayPregameElo": 1453,
    "awayPostgameElo": 1377,
    "excitementIndex": 4.129907605470833,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754542,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 45123,
    "venueId": 721,
    "venue": "Bobby Dodd Stadium",
    "homeId": 59,
    "homeTeam": "Georgia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 45,
    "homeLineScores": [
      21,
      0,
      14,
      10
    ],
    "homePostgameWinProbability": 0.993176281452179,
    "homePregameElo": 1560,
    "homePostgameElo": 1576,
    "awayId": 218,
    "awayTeam": "Temple",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      7,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.006823718547821045,
    "awayPregameElo": 1221,
    "awayPostgameElo": 1205,
    "excitementIndex": 3.42030537138152,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760375,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 13155,
    "venueId": 3935,
    "venue": "CEFCU Stadium",
    "homeId": 23,
    "homeTeam": "San José State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 31,
    "homeLineScores": [
      0,
      14,
      7,
      10
    ],
    "homePostgameWinProbability": 0.6595107316970825,
    "homePregameElo": 1416,
    "homePostgameElo": 1416,
    "awayId": 70,
    "awayTeam": "Idaho",
    "awayClassification": "fcs",
    "awayConference": "Big Sky",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.3404892683029175,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 7.84032994519351,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756899,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 40320,
    "venueId": 3833,
    "venue": "Memorial Stadium",
    "homeId": 2305,
    "homeTeam": "Kansas",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 41,
    "homeLineScores": [
      7,
      13,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9924370050430298,
    "homePregameElo": 1613,
    "homePostgameElo": 1680,
    "awayId": 277,
    "awayTeam": "West Virginia",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.007562994956970215,
    "awayPregameElo": 1481,
    "awayPostgameElo": 1414,
    "excitementIndex": 3.234558752614132,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757259,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11705,
    "venueId": 2031,
    "venue": "Pitbull Stadium",
    "homeId": 2229,
    "homeTeam": "Florida International",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 16,
    "homeLineScores": [
      7,
      0,
      3,
      6
    ],
    "homePostgameWinProbability": 0.0519399419426918,
    "homePregameElo": 1367,
    "homePostgameElo": 1320,
    "awayId": 48,
    "awayTeam": "Delaware",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 38,
    "awayLineScores": [
      3,
      21,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9480600580573082,
    "awayPregameElo": 1454,
    "awayPostgameElo": 1501,
    "excitementIndex": 3.857832326216719,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762821,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 8117,
    "venueId": 3768,
    "venue": "InfoCision Stadium",
    "homeId": 2006,
    "homeTeam": "Akron",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 51,
    "homeLineScores": [
      10,
      28,
      7,
      6
    ],
    "homePostgameWinProbability": 0.988182008266449,
    "homePregameElo": 1064,
    "homePostgameElo": 1064,
    "awayId": 2184,
    "awayTeam": "Duquesne",
    "awayClassification": "fcs",
    "awayConference": "NEC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.011817991733551025,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.4655296890931564,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757261,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 10713,
    "venueId": 4899,
    "venue": "Fifth Third Stadium",
    "homeId": 338,
    "homeTeam": "Kennesaw State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 28,
    "homeLineScores": [
      21,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9578986763954163,
    "homePregameElo": 1200,
    "homePostgameElo": 1213,
    "awayId": 2032,
    "awayTeam": "Arkansas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.04210132360458374,
    "awayPregameElo": 1257,
    "awayPostgameElo": 1244,
    "excitementIndex": 5.138697633960838,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757264,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15168,
    "venueId": 3725,
    "venue": "Johnny \"Red\" Floyd Stadium",
    "homeId": 2393,
    "homeTeam": "Middle Tennessee",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 28,
    "homeLineScores": [
      14,
      6,
      8,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1188,
    "homePostgameElo": 1185,
    "awayId": 276,
    "awayTeam": "Marshall",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 42,
    "awayLineScores": [
      21,
      0,
      0,
      21
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1508,
    "awayPostgameElo": 1511,
    "excitementIndex": 7.080076248813927,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760372,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24046,
    "venueId": 3713,
    "venue": "Falcon Stadium",
    "homeId": 2005,
    "homeTeam": "Air Force",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 37,
    "homeLineScores": [
      7,
      7,
      10,
      13
    ],
    "homePostgameWinProbability": 0.19783319532871246,
    "homePregameElo": 1390,
    "homePostgameElo": 1381,
    "awayId": 68,
    "awayTeam": "Boise State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 49,
    "awayLineScores": [
      14,
      7,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.8021668046712875,
    "awayPregameElo": 1578,
    "awayPostgameElo": 1587,
    "excitementIndex": 7.33669359799025,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761611,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17050,
    "venueId": 6526,
    "venue": "Hancock Whitney Stadium",
    "homeId": 6,
    "homeTeam": "South Alabama",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 20,
    "homeLineScores": [
      0,
      14,
      3,
      3
    ],
    "homePostgameWinProbability": 0.07848616689443588,
    "homePregameElo": 1532,
    "homePostgameElo": 1445,
    "awayId": 324,
    "awayTeam": "Coastal Carolina",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 38,
    "awayLineScores": [
      0,
      7,
      14,
      17
    ],
    "awayPostgameWinProbability": 0.9215138331055641,
    "awayPregameElo": 1172,
    "awayPostgameElo": 1259,
    "excitementIndex": 6.294906926418065,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752713,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 57321,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 29,
    "homeLineScores": [
      0,
      12,
      6,
      11
    ],
    "homePostgameWinProbability": 0.890684187412262,
    "homePregameElo": 1755,
    "homePostgameElo": 1762,
    "awayId": 2579,
    "awayTeam": "South Carolina",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      14,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.10931581258773804,
    "awayPregameElo": 1645,
    "awayPostgameElo": 1638,
    "excitementIndex": 6.949105660594177,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761609,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23217,
    "venueId": 3608,
    "venue": "Allen E. Paulson Stadium",
    "homeId": 290,
    "homeTeam": "Georgia Southern",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 45,
    "homeLineScores": [
      7,
      10,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9953067302703857,
    "homePregameElo": 1347,
    "homePostgameElo": 1347,
    "awayId": 311,
    "awayTeam": "Maine",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.004693269729614258,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.557178440175789,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757265,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 14476,
    "venueId": 3878,
    "venue": "Plaster Sports Complex",
    "homeId": 2623,
    "homeTeam": "Missouri State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 42,
    "homeLineScores": [
      21,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9857033491134644,
    "homePregameElo": 1316,
    "homePostgameElo": 1316,
    "awayId": 2630,
    "awayTeam": "UT Martin",
    "awayClassification": "fcs",
    "awayConference": "OVC-Big South",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.014296650886535645,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.9102985478879524,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757260,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21426,
    "venueId": 3662,
    "venue": "AmFirst Stadium",
    "homeId": 55,
    "homeTeam": "Jacksonville State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 45,
    "homeLineScores": [
      7,
      17,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9939760565757751,
    "homePregameElo": 1623,
    "homePostgameElo": 1623,
    "awayId": 93,
    "awayTeam": "Murray State",
    "awayClassification": "fcs",
    "awayConference": "MVFC",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0060239434242248535,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.822360621855891,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757268,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 17247,
    "venueId": 3796,
    "venue": "Houchens Industries-L.T. Smith Stadium",
    "homeId": 98,
    "homeTeam": "Western Kentucky",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 31,
    "homeLineScores": [
      3,
      0,
      7,
      21
    ],
    "homePostgameWinProbability": 0.8062244057655334,
    "homePregameElo": 1390,
    "homePostgameElo": 1411,
    "awayId": 2440,
    "awayTeam": "Nevada",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 16,
    "awayLineScores": [
      3,
      7,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.19377559423446655,
    "awayPregameElo": 1278,
    "awayPostgameElo": 1257,
    "excitementIndex": 6.351029424898943,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752843,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 56088,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 63,
    "homeLineScores": [
      14,
      21,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9921911954879761,
    "homePregameElo": 1869,
    "homePostgameElo": 2010,
    "awayId": 356,
    "awayTeam": "Illinois",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 10,
    "awayLineScores": [
      7,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.007808804512023926,
    "awayPregameElo": 1708,
    "awayPostgameElo": 1567,
    "excitementIndex": 3.2365652411064496,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754539,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 36223,
    "venueId": 3923,
    "venue": "Scott Stadium",
    "homeId": 258,
    "homeTeam": "Virginia",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 48,
    "homeLineScores": [
      21,
      7,
      10,
      10
    ],
    "homePostgameWinProbability": 0.9902341961860657,
    "homePregameElo": 1518,
    "homePostgameElo": 1565,
    "awayId": 24,
    "awayTeam": "Stanford",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      7,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.009765803813934326,
    "awayPregameElo": 1296,
    "awayPostgameElo": 1249,
    "excitementIndex": 3.680080334067038,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756898,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 47213,
    "venueId": 3699,
    "venue": "Dowdy-Ficklen Stadium",
    "homeId": 151,
    "homeTeam": "East Carolina",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 13,
    "homeLineScores": [
      3,
      0,
      3,
      7
    ],
    "homePostgameWinProbability": 0.014823171310126781,
    "homePregameElo": 1519,
    "homePostgameElo": 1482,
    "awayId": 252,
    "awayTeam": "BYU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 34,
    "awayLineScores": [
      3,
      10,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.9851768286898732,
    "awayPregameElo": 1666,
    "awayPostgameElo": 1703,
    "excitementIndex": 4.208961929345976,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757263,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 17108,
    "venueId": 3776,
    "venue": "Joe Aillet Stadium",
    "homeId": 2348,
    "homeTeam": "Louisiana Tech",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 30,
    "homeLineScores": [
      17,
      13,
      0,
      0
    ],
    "homePostgameWinProbability": 0.8937344551086426,
    "homePregameElo": 1471,
    "homePostgameElo": 1468,
    "awayId": 2572,
    "awayTeam": "Southern Miss",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 20,
    "awayLineScores": [
      10,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.10626554489135742,
    "awayPregameElo": 1178,
    "awayPostgameElo": 1181,
    "excitementIndex": 4.387080863629978,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752716,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 35000,
    "venueId": 3973,
    "venue": "FirstBank Stadium",
    "homeId": 238,
    "homeTeam": "Vanderbilt",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 70,
    "homeLineScores": [
      21,
      21,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9940741062164307,
    "homePregameElo": 1654,
    "homePostgameElo": 1741,
    "awayId": 2247,
    "awayTeam": "Georgia State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 21,
    "awayLineScores": [
      3,
      6,
      6,
      6
    ],
    "awayPostgameWinProbability": 0.005925893783569336,
    "awayPregameElo": 1213,
    "awayPostgameElo": 1126,
    "excitementIndex": 3.8432566987879238,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752709,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 66713,
    "venueId": 3948,
    "venue": "Hard Rock Stadium",
    "homeId": 2390,
    "homeTeam": "Miami",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 26,
    "homeLineScores": [
      7,
      6,
      0,
      13
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1825,
    "homePostgameElo": 1852,
    "awayId": 57,
    "awayTeam": "Florida",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1656,
    "awayPostgameElo": 1629,
    "excitementIndex": 4.365869757445546,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756896,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 40964,
    "venueId": 4727,
    "venue": "McLane Stadium",
    "homeId": 239,
    "homeTeam": "Baylor",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 24,
    "homeLineScores": [
      3,
      7,
      0,
      14
    ],
    "homePostgameWinProbability": 0.8086299300193787,
    "homePregameElo": 1583,
    "homePostgameElo": 1587,
    "awayId": 9,
    "awayTeam": "Arizona State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 27,
    "awayLineScores": [
      3,
      7,
      3,
      14
    ],
    "awayPostgameWinProbability": 0.19137006998062134,
    "awayPregameElo": 1725,
    "awayPostgameElo": 1721,
    "excitementIndex": 7.112305805049334,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752842,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 32952,
    "venueId": 3820,
    "venue": "Gesa Field",
    "homeId": 265,
    "homeTeam": "Washington State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 24,
    "homeLineScores": [
      0,
      10,
      14,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1379,
    "homePostgameElo": 1307,
    "awayId": 264,
    "awayTeam": "Washington",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 59,
    "awayLineScores": [
      14,
      10,
      7,
      28
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1604,
    "awayPostgameElo": 1676,
    "excitementIndex": 4.161728481343954,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752710,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-20T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 102219,
    "venueId": 3958,
    "venue": "Tiger Stadium (LA)",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 56,
    "homeLineScores": [
      7,
      28,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9890648722648621,
    "homePregameElo": 1747,
    "homePostgameElo": 1747,
    "awayId": 2545,
    "awayTeam": "SE Louisiana",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.01093512773513794,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.9933303145607626,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761612,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-21T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 31500,
    "venueId": 3644,
    "venue": "Bobcat Stadium (TX)",
    "homeId": 326,
    "homeTeam": "Texas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 35,
    "homeLineScores": [
      7,
      21,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9768553972244263,
    "homePregameElo": 1590,
    "homePostgameElo": 1590,
    "awayId": 2447,
    "awayTeam": "Nicholls",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 3,
    "awayLineScores": [
      3,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.02314460277557373,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.4258046713262478,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760377,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-21T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 16273,
    "venueId": 3905,
    "venue": "Maverik Stadium",
    "homeId": 328,
    "homeTeam": "Utah State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 48,
    "homeLineScores": [
      13,
      21,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9917429685592651,
    "homePregameElo": 1436,
    "homePostgameElo": 1436,
    "awayId": 2377,
    "awayTeam": "McNeese",
    "awayClassification": "fcs",
    "awayConference": "Southland",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.008257031440734863,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.464450368379769,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752723,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-21T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 103003,
    "venueId": 3910,
    "venue": "DKR-Texas Memorial Stadium",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 55,
    "homeLineScores": [
      14,
      17,
      17,
      7
    ],
    "homePostgameWinProbability": 0.9902904629707336,
    "homePregameElo": 1878,
    "homePostgameElo": 1972,
    "awayId": 2534,
    "awayTeam": "Sam Houston",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.009709537029266357,
    "awayPregameElo": 1337,
    "awayPostgameElo": 1243,
    "excitementIndex": 2.8833695642232984,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757267,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-21T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15272,
    "venueId": 3946,
    "venue": "Sun Bowl",
    "homeId": 2638,
    "homeTeam": "UTEP",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 25,
    "homeLineScores": [
      7,
      0,
      3,
      15
    ],
    "homePostgameWinProbability": 0.014832880347967148,
    "homePregameElo": 1248,
    "homePostgameElo": 1227,
    "awayId": 2433,
    "awayTeam": "UL Monroe",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 31,
    "awayLineScores": [
      14,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.9851671196520329,
    "awayPregameElo": 1116,
    "awayPostgameElo": 1137,
    "excitementIndex": 5.968620563481887,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760373,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-21T01:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 32061,
    "venueId": 5388,
    "venue": "Canvas Stadium",
    "homeId": 36,
    "homeTeam": "Colorado State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 16,
    "homeLineScores": [
      0,
      3,
      0,
      13
    ],
    "homePostgameWinProbability": 0.8162055611610413,
    "homePregameElo": 1363,
    "homePostgameElo": 1368,
    "awayId": 2636,
    "awayTeam": "UTSA",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      10,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.18379443883895874,
    "awayPregameElo": 1499,
    "awayPostgameElo": 1494,
    "excitementIndex": 7.314316560895462,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756897,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-21T02:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 53442,
    "venueId": 3726,
    "venue": "Folsom Field",
    "homeId": 38,
    "homeTeam": "Colorado",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 37,
    "homeLineScores": [
      0,
      21,
      7,
      9
    ],
    "homePostgameWinProbability": 0.9935250282287598,
    "homePregameElo": 1604,
    "homePostgameElo": 1617,
    "awayId": 2751,
    "awayTeam": "Wyoming",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      3,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.006474971771240234,
    "awayPregameElo": 1339,
    "awayPostgameElo": 1326,
    "excitementIndex": 3.8866590835890054,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754540,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-21T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 31369,
    "venueId": 7311,
    "venue": "Snapdragon Stadium",
    "homeId": 21,
    "homeTeam": "San Diego State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 34,
    "homeLineScores": [
      0,
      13,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9996335506439209,
    "homePregameElo": 1283,
    "homePostgameElo": 1422,
    "awayId": 25,
    "awayTeam": "California",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.00036644935607910156,
    "awayPregameElo": 1586,
    "awayPostgameElo": 1447,
    "excitementIndex": 3.5363572091938447,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752847,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-21T03:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 67614,
    "venueId": 477,
    "venue": "Los Angeles Memorial Coliseum",
    "homeId": 30,
    "homeTeam": "USC",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 45,
    "homeLineScores": [
      10,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9655723571777344,
    "homePregameElo": 1878,
    "homePostgameElo": 1869,
    "awayId": 127,
    "awayTeam": "Michigan State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      3,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.034427642822265625,
    "awayPregameElo": 1405,
    "awayPostgameElo": 1414,
    "excitementIndex": 4.329006196144637,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760374,
    "season": 2025,
    "week": 4,
    "seasonType": "regular",
    "startDate": "2025-09-21T03:59:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13789,
    "venueId": 7220,
    "venue": "Clarence T.C. Ching Athletics Complex",
    "homeId": 62,
    "homeTeam": "Hawai'i",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 21,
    "homeLineScores": [
      0,
      9,
      6,
      6
    ],
    "homePostgameWinProbability": 0.03809016942977905,
    "homePregameElo": 1238,
    "homePostgameElo": 1250,
    "awayId": 278,
    "awayTeam": "Fresno State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 23,
    "awayLineScores": [
      0,
      7,
      6,
      10
    ],
    "awayPostgameWinProbability": 0.961909830570221,
    "awayPregameElo": 1522,
    "awayPostgameElo": 1510,
    "excitementIndex": 6.726265961961575,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762471,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-25T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 32497,
    "venueId": 3699,
    "venue": "Dowdy-Ficklen Stadium",
    "homeId": 151,
    "homeTeam": "East Carolina",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 28,
    "homeLineScores": [
      21,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9856498837471008,
    "homePregameElo": 1482,
    "homePostgameElo": 1548,
    "awayId": 349,
    "awayTeam": "Army",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      0,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.01435011625289917,
    "awayPregameElo": 1599,
    "awayPostgameElo": 1533,
    "excitementIndex": 2.818815115022702,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754543,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-26T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50107,
    "venueId": 3923,
    "venue": "Scott Stadium",
    "homeId": 258,
    "homeTeam": "Virginia",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 46,
    "homeLineScores": [
      7,
      14,
      7,
      7,
      3,
      8
    ],
    "homePostgameWinProbability": 0.3987348675727844,
    "homePregameElo": 1565,
    "homePostgameElo": 1578,
    "awayId": 52,
    "awayTeam": "Florida State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 38,
    "awayLineScores": [
      0,
      21,
      7,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.6012651324272156,
    "awayPregameElo": 1577,
    "awayPostgameElo": 1564,
    "excitementIndex": 11.482102852327786,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756902,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53774,
    "venueId": 3947,
    "venue": "Mountain America Stadium",
    "homeId": 9,
    "homeTeam": "Arizona State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 27,
    "homeLineScores": [
      0,
      14,
      3,
      10
    ],
    "homePostgameWinProbability": 0.8925284147262573,
    "homePregameElo": 1721,
    "homePostgameElo": 1722,
    "awayId": 2628,
    "awayTeam": "TCU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.10747158527374268,
    "awayPregameElo": 1733,
    "awayPostgameElo": 1732,
    "excitementIndex": 7.2247709465896754,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752939,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 29338,
    "venueId": 3893,
    "venue": "Reser Stadium",
    "homeId": 204,
    "homeTeam": "Oregon State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 24,
    "homeLineScores": [
      7,
      7,
      3,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9730728268623352,
    "homePregameElo": 1297,
    "homePostgameElo": 1304,
    "awayId": 248,
    "awayTeam": "Houston",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      10,
      0,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.026927173137664795,
    "awayPregameElo": 1497,
    "awayPostgameElo": 1490,
    "excitementIndex": 6.212626502878512,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756906,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53013,
    "venueId": 3636,
    "venue": "Bill Snyder Family Stadium",
    "homeId": 2306,
    "homeTeam": "Kansas State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 34,
    "homeLineScores": [
      0,
      17,
      14,
      3
    ],
    "homePostgameWinProbability": 0.954622745513916,
    "homePregameElo": 1640,
    "homePostgameElo": 1665,
    "awayId": 2116,
    "awayTeam": "UCF",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      7,
      10,
      3
    ],
    "awayPostgameWinProbability": 0.045377254486083984,
    "awayPregameElo": 1604,
    "awayPostgameElo": 1579,
    "excitementIndex": 4.375843907782124,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756905,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 41525,
    "venueId": 3833,
    "venue": "Memorial Stadium",
    "homeId": 2305,
    "homeTeam": "Kansas",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 34,
    "homeLineScores": [
      7,
      6,
      14,
      7
    ],
    "homePostgameWinProbability": 0.6432141065597534,
    "homePregameElo": 1680,
    "homePostgameElo": 1664,
    "awayId": 2132,
    "awayTeam": "Cincinnati",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 37,
    "awayLineScores": [
      7,
      13,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.3567858934402466,
    "awayPregameElo": 1504,
    "awayPostgameElo": 1520,
    "excitementIndex": 8.502777237602228,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754545,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44451,
    "venueId": 1964,
    "venue": "JMA Wireless Dome",
    "homeId": 183,
    "homeTeam": "Syracuse",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 3,
    "homeLineScores": [
      3,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1535,
    "homePostgameElo": 1426,
    "awayId": 150,
    "awayTeam": "Duke",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 38,
    "awayLineScores": [
      10,
      14,
      7,
      7
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1489,
    "awayPostgameElo": 1598,
    "excitementIndex": 4.2228872621589435,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754546,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30264,
    "venueId": 3630,
    "venue": "Allegacy Federal Credit Union Stadium",
    "homeId": 154,
    "homeTeam": "Wake Forest",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 29,
    "homeLineScores": [
      0,
      17,
      3,
      3,
      6
    ],
    "homePostgameWinProbability": 0.8997204899787903,
    "homePregameElo": 1383,
    "homePostgameElo": 1391,
    "awayId": 59,
    "awayTeam": "Georgia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 30,
    "awayLineScores": [
      3,
      0,
      14,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.10027951002120972,
    "awayPregameElo": 1576,
    "awayPostgameElo": 1568,
    "excitementIndex": 7.33496724032895,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752717,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 75111,
    "venueId": 3887,
    "venue": "Razorback Stadium",
    "homeId": 8,
    "homeTeam": "Arkansas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 13,
    "homeLineScores": [
      3,
      10,
      0,
      0
    ],
    "homePostgameWinProbability": 0.07294102758169174,
    "homePregameElo": 1677,
    "homePostgameElo": 1608,
    "awayId": 87,
    "awayTeam": "Notre Dame",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 56,
    "awayLineScores": [
      14,
      28,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9270589724183083,
    "awayPregameElo": 2126,
    "awayPostgameElo": 2195,
    "excitementIndex": 3.1141392481338106,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754547,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 45301,
    "venueId": 3752,
    "venue": "Acrisure Stadium",
    "homeId": 221,
    "homeTeam": "Pittsburgh",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 27,
    "homeLineScores": [
      17,
      10,
      0,
      0
    ],
    "homePostgameWinProbability": 0.19548064470291138,
    "homePregameElo": 1506,
    "homePostgameElo": 1511,
    "awayId": 97,
    "awayTeam": "Louisville",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      0,
      17,
      3,
      14
    ],
    "awayPostgameWinProbability": 0.8045193552970886,
    "awayPregameElo": 1755,
    "awayPostgameElo": 1750,
    "excitementIndex": 5.393030338489725,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762825,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20027,
    "venueId": 3876,
    "venue": "Peden Stadium",
    "homeId": 195,
    "homeTeam": "Ohio",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 35,
    "homeLineScores": [
      14,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9893947243690491,
    "homePregameElo": 1587,
    "homePostgameElo": 1604,
    "awayId": 189,
    "awayTeam": "Bowling Green",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 20,
    "awayLineScores": [
      10,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.010605275630950928,
    "awayPregameElo": 1428,
    "awayPostgameElo": 1411,
    "excitementIndex": 4.665737287908178,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761617,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 16575,
    "venueId": 3825,
    "venue": "DATCU Stadium",
    "homeId": 249,
    "homeTeam": "North Texas",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 36,
    "homeLineScores": [
      7,
      7,
      14,
      8
    ],
    "homePostgameWinProbability": 0.9907292127609253,
    "homePregameElo": 1601,
    "homePostgameElo": 1616,
    "awayId": 6,
    "awayTeam": "South Alabama",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 22,
    "awayLineScores": [
      7,
      0,
      7,
      8
    ],
    "awayPostgameWinProbability": 0.009270787239074707,
    "awayPregameElo": 1445,
    "awayPostgameElo": 1430,
    "excitementIndex": 5.824672877191597,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752849,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 46234,
    "venueId": 3953,
    "venue": "Huntington Bank Stadium",
    "homeId": 135,
    "homeTeam": "Minnesota",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 31,
    "homeLineScores": [
      0,
      14,
      10,
      7
    ],
    "homePostgameWinProbability": 0.7687037587165833,
    "homePregameElo": 1593,
    "homePostgameElo": 1594,
    "awayId": 164,
    "awayTeam": "Rutgers",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      14,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.23129624128341675,
    "awayPregameElo": 1583,
    "awayPostgameElo": 1582,
    "excitementIndex": 7.7372829888998975,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752850,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60670,
    "venueId": 3832,
    "venue": "Memorial Stadium (Champaign, IL)",
    "homeId": 356,
    "homeTeam": "Illinois",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 34,
    "homeLineScores": [
      7,
      7,
      10,
      10
    ],
    "homePostgameWinProbability": 0.6197293996810913,
    "homePregameElo": 1567,
    "homePostgameElo": 1571,
    "awayId": 30,
    "awayTeam": "USC",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 32,
    "awayLineScores": [
      7,
      3,
      7,
      15
    ],
    "awayPostgameWinProbability": 0.3802706003189087,
    "awayPregameElo": 1869,
    "awayPostgameElo": 1865,
    "excitementIndex": 6.472032101331806,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752725,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 33688,
    "venueId": 3973,
    "venue": "FirstBank Stadium",
    "homeId": 238,
    "homeTeam": "Vanderbilt",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 55,
    "homeLineScores": [
      7,
      24,
      17,
      7
    ],
    "homePostgameWinProbability": 0.9848642945289612,
    "homePregameElo": 1741,
    "homePostgameElo": 1758,
    "awayId": 328,
    "awayTeam": "Utah State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      14,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.015135705471038818,
    "awayPregameElo": 1442,
    "awayPostgameElo": 1425,
    "excitementIndex": 5.243450773818561,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762826,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28605,
    "venueId": 3786,
    "venue": "Kelly/Shorts Stadium",
    "homeId": 2117,
    "homeTeam": "Central Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 24,
    "homeLineScores": [
      14,
      7,
      0,
      3
    ],
    "homePostgameWinProbability": 0.9685516953468323,
    "homePregameElo": 1094,
    "homePostgameElo": 1124,
    "awayId": 2199,
    "awayTeam": "Eastern Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 13,
    "awayLineScores": [
      3,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.031448304653167725,
    "awayPregameElo": 1223,
    "awayPostgameElo": 1193,
    "excitementIndex": 3.138328417036706,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761614,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T17:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25029,
    "venueId": 3651,
    "venue": "Bridgeforth Stadium",
    "homeId": 256,
    "homeTeam": "James Madison",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 35,
    "homeLineScores": [
      7,
      14,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9939213395118713,
    "homePregameElo": 1636,
    "homePostgameElo": 1669,
    "awayId": 290,
    "awayTeam": "Georgia Southern",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.006078660488128662,
    "awayPregameElo": 1357,
    "awayPostgameElo": 1324,
    "excitementIndex": 3.3107124992600028,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761616,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21147,
    "venueId": 3817,
    "venue": "Malone Stadium",
    "homeId": 2433,
    "homeTeam": "UL Monroe",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 28,
    "homeLineScores": [
      0,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9769008755683899,
    "homePregameElo": 1137,
    "homePostgameElo": 1168,
    "awayId": 2032,
    "awayTeam": "Arkansas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 16,
    "awayLineScores": [
      10,
      0,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.023099124431610107,
    "awayPregameElo": 1244,
    "awayPostgameElo": 1213,
    "excitementIndex": 6.21577713542159,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756907,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 45689,
    "venueId": 3646,
    "venue": "Boone Pickens Stadium",
    "homeId": 197,
    "homeTeam": "Oklahoma State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 27,
    "homeLineScores": [
      7,
      13,
      7,
      0
    ],
    "homePostgameWinProbability": 0.02303645946085453,
    "homePregameElo": 1176,
    "homePostgameElo": 1173,
    "awayId": 239,
    "awayTeam": "Baylor",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 45,
    "awayLineScores": [
      7,
      21,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.9769635405391455,
    "awayPregameElo": 1587,
    "awayPostgameElo": 1590,
    "excitementIndex": 6.252031557586193,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752719,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 67737,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      3,
      14,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9501707553863525,
    "homePregameElo": 1981,
    "homePostgameElo": 1977,
    "awayId": 99,
    "awayTeam": "LSU",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 19,
    "awayLineScores": [
      7,
      0,
      6,
      6
    ],
    "awayPostgameWinProbability": 0.04982924461364746,
    "awayPregameElo": 1747,
    "awayPostgameElo": 1751,
    "excitementIndex": 6.351142399940396,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752853,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 69250,
    "venueId": 3793,
    "venue": "Kinnick Stadium",
    "homeId": 2294,
    "homeTeam": "Iowa",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 15,
    "homeLineScores": [
      3,
      7,
      0,
      5
    ],
    "homePostgameWinProbability": 0.13925829529762268,
    "homePregameElo": 1733,
    "homePostgameElo": 1743,
    "awayId": 84,
    "awayTeam": "Indiana",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      3,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.8607417047023773,
    "awayPregameElo": 2010,
    "awayPostgameElo": 2000,
    "excitementIndex": 7.018765473483252,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754544,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44500,
    "venueId": 3615,
    "venue": "Alumni Stadium (Chestnut Hill, MA)",
    "homeId": 103,
    "homeTeam": "Boston College",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 24,
    "homeLineScores": [
      14,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.4741590917110443,
    "homePregameElo": 1470,
    "homePostgameElo": 1462,
    "awayId": 25,
    "awayTeam": "California",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.5258409082889557,
    "awayPregameElo": 1447,
    "awayPostgameElo": 1455,
    "excitementIndex": 6.918061132137002,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762824,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24535,
    "venueId": 3739,
    "venue": "Glass Bowl",
    "homeId": 2649,
    "homeTeam": "Toledo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 45,
    "homeLineScores": [
      14,
      21,
      3,
      7
    ],
    "homePostgameWinProbability": 0.9890300631523132,
    "homePregameElo": 1497,
    "homePostgameElo": 1562,
    "awayId": 2006,
    "awayTeam": "Akron",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.010969936847686768,
    "awayPregameElo": 1060,
    "awayPostgameElo": 995,
    "excitementIndex": 2.5281850060338633,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762473,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28873,
    "venueId": 3852,
    "venue": "Navy-Marine Corps Memorial Stadium",
    "homeId": 2426,
    "homeTeam": "Navy",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 21,
    "homeLineScores": [
      7,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9932585954666138,
    "homePregameElo": 1550,
    "homePostgameElo": 1547,
    "awayId": 242,
    "awayTeam": "Rice",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      0,
      3,
      10
    ],
    "awayPostgameWinProbability": 0.0067414045333862305,
    "awayPregameElo": 1288,
    "awayPostgameElo": 1291,
    "excitementIndex": 3.2905691020692287,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757170,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 12717,
    "venueId": 3965,
    "venue": "UB Stadium",
    "homeId": 2084,
    "homeTeam": "Buffalo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 17,
    "homeLineScores": [
      0,
      7,
      3,
      7
    ],
    "homePostgameWinProbability": 0.30812010169029236,
    "homePregameElo": 1383,
    "homePostgameElo": 1382,
    "awayId": 41,
    "awayTeam": "UConn",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      7,
      10,
      3
    ],
    "awayPostgameWinProbability": 0.6918798983097076,
    "awayPregameElo": 1436,
    "awayPostgameElo": 1437,
    "excitementIndex": 5.418023678480578,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762827,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 10504,
    "venueId": 3996,
    "venue": "Yager Stadium",
    "homeId": 193,
    "homeTeam": "Miami (OH)",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 38,
    "homeLineScores": [
      7,
      10,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9914972186088562,
    "homePregameElo": 1495,
    "homePostgameElo": 1495,
    "awayId": 2815,
    "awayTeam": "Lindenwood",
    "awayClassification": "fcs",
    "awayConference": "OVC-Big South",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.008502781391143799,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.295055142641819,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760380,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 13512,
    "venueId": 3764,
    "venue": "Huskie Stadium",
    "homeId": 2459,
    "homeTeam": "Northern Illinois",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 3,
    "homeLineScores": [
      3,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.4219529628753662,
    "homePregameElo": 1377,
    "homePostgameElo": 1375,
    "awayId": 21,
    "awayTeam": "San Diego State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      3,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.5780470371246338,
    "awayPregameElo": 1422,
    "awayPostgameElo": 1424,
    "excitementIndex": 5.207526340091206,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752724,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 108449,
    "venueId": 3795,
    "venue": "Kyle Field",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 16,
    "homeLineScores": [
      7,
      6,
      0,
      3
    ],
    "homePostgameWinProbability": 0.9677963852882385,
    "homePregameElo": 1749,
    "homePostgameElo": 1753,
    "awayId": 2,
    "awayTeam": "Auburn",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.032203614711761475,
    "awayPregameElo": 1680,
    "awayPostgameElo": 1676,
    "excitementIndex": 4.577847616080531,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752852,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 72485,
    "venueId": 3765,
    "venue": "Husky Stadium",
    "homeId": 264,
    "homeTeam": "Washington",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 6,
    "homeLineScores": [
      0,
      3,
      3,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1676,
    "homePostgameElo": 1665,
    "awayId": 194,
    "awayTeam": "Ohio State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      7,
      7,
      10
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 2010,
    "awayPostgameElo": 2021,
    "excitementIndex": 3.5693821702972266,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752851,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12023,
    "venueId": 5960,
    "venue": "Lanny and Sharon Martin Stadium",
    "homeId": 77,
    "homeTeam": "Northwestern",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 17,
    "homeLineScores": [
      3,
      14,
      0,
      0
    ],
    "homePostgameWinProbability": 0.5944004058837891,
    "homePregameElo": 1411,
    "homePostgameElo": 1411,
    "awayId": 26,
    "awayTeam": "UCLA",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      3,
      3,
      8
    ],
    "awayPostgameWinProbability": 0.40559959411621094,
    "awayPregameElo": 1331,
    "awayPostgameElo": 1331,
    "excitementIndex": 3.8213794817334423,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756908,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53965,
    "venueId": 3842,
    "venue": "Milan Puskar Stadium",
    "homeId": 277,
    "homeTeam": "West Virginia",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 14,
    "homeLineScores": [
      0,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.013404934667050838,
    "homePregameElo": 1414,
    "homePostgameElo": 1341,
    "awayId": 254,
    "awayTeam": "Utah",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 48,
    "awayLineScores": [
      14,
      14,
      10,
      10
    ],
    "awayPostgameWinProbability": 0.9865950653329492,
    "awayPregameElo": 1607,
    "awayPostgameElo": 1680,
    "excitementIndex": 3.294367911328435,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760378,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22677,
    "venueId": 3713,
    "venue": "Falcon Stadium",
    "homeId": 2005,
    "homeTeam": "Air Force",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 35,
    "homeLineScores": [
      7,
      0,
      7,
      21
    ],
    "homePostgameWinProbability": 0.4892660975456238,
    "homePregameElo": 1381,
    "homePostgameElo": 1351,
    "awayId": 62,
    "awayTeam": "Hawai'i",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 44,
    "awayLineScores": [
      14,
      3,
      7,
      20
    ],
    "awayPostgameWinProbability": 0.5107339024543762,
    "awayPregameElo": 1250,
    "awayPostgameElo": 1280,
    "excitementIndex": 6.016653245970114,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757274,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 37440,
    "venueId": 3971,
    "venue": "University Stadium (NM)",
    "homeId": 167,
    "homeTeam": "New Mexico",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 38,
    "homeLineScores": [
      7,
      7,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9894112348556519,
    "homePregameElo": 1408,
    "homePostgameElo": 1426,
    "awayId": 166,
    "awayTeam": "New Mexico State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      10,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.010588765144348145,
    "awayPregameElo": 1165,
    "awayPostgameElo": 1147,
    "excitementIndex": 6.651083798281779,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762474,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16311,
    "venueId": 3674,
    "venue": "Chapman Stadium",
    "homeId": 202,
    "homeTeam": "Tulsa",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 14,
    "homeLineScores": [
      7,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.006806503981351852,
    "homePregameElo": 1072,
    "homePostgameElo": 1079,
    "awayId": 2655,
    "awayTeam": "Tulane",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      17,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.9931934960186481,
    "awayPregameElo": 1579,
    "awayPostgameElo": 1572,
    "excitementIndex": 5.984301461097488,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752720,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60417,
    "venueId": 3693,
    "venue": "Davis Wade Stadium",
    "homeId": 344,
    "homeTeam": "Mississippi State",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 34,
    "homeLineScores": [
      7,
      10,
      7,
      10,
      0
    ],
    "homePostgameWinProbability": 0.230798602104187,
    "homePregameElo": 1512,
    "homePostgameElo": 1523,
    "awayId": 2633,
    "awayTeam": "Tennessee",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 41,
    "awayLineScores": [
      10,
      7,
      3,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.769201397895813,
    "awayPregameElo": 1838,
    "awayPostgameElo": 1827,
    "excitementIndex": 12.221003244928562,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757270,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11040,
    "venueId": 4899,
    "venue": "Fifth Third Stadium",
    "homeId": 338,
    "homeTeam": "Kennesaw State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 24,
    "homeLineScores": [
      21,
      0,
      0,
      3
    ],
    "homePostgameWinProbability": 0.8154813647270203,
    "homePregameElo": 1213,
    "homePostgameElo": 1223,
    "awayId": 2393,
    "awayTeam": "Middle Tennessee",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 16,
    "awayLineScores": [
      3,
      7,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.18451863527297974,
    "awayPregameElo": 1185,
    "awayPostgameElo": 1175,
    "excitementIndex": 3.9535830288097205,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757271,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 18435,
    "venueId": 3918,
    "venue": "S.B. Ballard Stadium",
    "homeId": 295,
    "homeTeam": "Old Dominion",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 21,
    "homeLineScores": [
      0,
      14,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9896408915519714,
    "homePregameElo": 1530,
    "homePostgameElo": 1551,
    "awayId": 2335,
    "awayTeam": "Liberty",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.010359108448028564,
    "awayPregameElo": 1442,
    "awayPostgameElo": 1421,
    "excitementIndex": 4.860975275039004,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762828,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T22:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 20191,
    "venueId": 3980,
    "venue": "Waldo Stadium",
    "homeId": 2711,
    "homeTeam": "Western Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 47,
    "homeLineScores": [
      3,
      28,
      13,
      3
    ],
    "homePostgameWinProbability": 0.9985979199409485,
    "homePregameElo": 1255,
    "homePostgameElo": 1255,
    "awayId": 227,
    "awayTeam": "Rhode Island",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.0014020800590515137,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.932190889151084,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756904,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 61500,
    "venueId": 3772,
    "venue": "Jack Trice Stadium",
    "homeId": 66,
    "homeTeam": "Iowa State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 39,
    "homeLineScores": [
      8,
      14,
      14,
      3
    ],
    "homePostgameWinProbability": 0.9961305260658264,
    "homePregameElo": 1608,
    "homePostgameElo": 1655,
    "awayId": 12,
    "awayTeam": "Arizona",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.003869473934173584,
    "awayPregameElo": 1469,
    "awayPostgameElo": 1422,
    "excitementIndex": 3.4737545211492207,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757269,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25034,
    "venueId": 3815,
    "venue": "M. M. Roberts Stadium",
    "homeId": 2572,
    "homeTeam": "Southern Miss",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 42,
    "homeLineScores": [
      14,
      7,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9930472373962402,
    "homePregameElo": 1181,
    "homePostgameElo": 1265,
    "awayId": 55,
    "awayTeam": "Jacksonville State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 25,
    "awayLineScores": [
      3,
      0,
      8,
      14
    ],
    "awayPostgameWinProbability": 0.006952762603759766,
    "awayPregameElo": 1613,
    "awayPostgameElo": 1529,
    "excitementIndex": 3.523140658384396,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762472,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17733,
    "venueId": 3715,
    "venue": "FAU Stadium",
    "homeId": 2226,
    "homeTeam": "Florida Atlantic",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 26,
    "homeLineScores": [
      7,
      9,
      3,
      7
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1231,
    "homePostgameElo": 1201,
    "awayId": 235,
    "awayTeam": "Memphis",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 55,
    "awayLineScores": [
      10,
      7,
      7,
      31
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1659,
    "awayPostgameElo": 1689,
    "excitementIndex": 6.5867582029500635,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754548,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 56919,
    "venueId": 3670,
    "venue": "Carter-Finley Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 21,
    "homeLineScores": [
      7,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.41979116201400757,
    "homePregameElo": 1494,
    "homePostgameElo": 1489,
    "awayId": 259,
    "awayTeam": "Virginia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 23,
    "awayLineScores": [
      3,
      10,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.5802088379859924,
    "awayPregameElo": 1452,
    "awayPostgameElo": 1457,
    "excitementIndex": 6.646683052975088,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757273,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10068,
    "venueId": 3878,
    "venue": "Plaster Sports Complex",
    "homeId": 2623,
    "homeTeam": "Missouri State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 22,
    "homeLineScores": [
      0,
      9,
      7,
      6
    ],
    "homePostgameWinProbability": 0.07517991960048676,
    "homePregameElo": 1338,
    "homePostgameElo": 1335,
    "awayId": 98,
    "awayTeam": "Western Kentucky",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      10,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.9248200803995132,
    "awayPregameElo": 1411,
    "awayPostgameElo": 1414,
    "excitementIndex": 6.079149938303324,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760379,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 32904,
    "venueId": 3653,
    "venue": "Albertsons Stadium",
    "homeId": 68,
    "homeTeam": "Boise State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 47,
    "homeLineScores": [
      14,
      10,
      9,
      14
    ],
    "homePostgameWinProbability": 0.9969602227210999,
    "homePregameElo": 1587,
    "homePostgameElo": 1653,
    "awayId": 2026,
    "awayTeam": "App State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0030397772789001465,
    "awayPregameElo": 1390,
    "awayPostgameElo": 1324,
    "excitementIndex": 3.521296637474729,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752854,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 111015,
    "venueId": 3632,
    "venue": "Beaver Stadium",
    "homeId": 213,
    "homeTeam": "Penn State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      0,
      3,
      0,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.2777531147003174,
    "homePregameElo": 2087,
    "homePostgameElo": 2070,
    "awayId": 2483,
    "awayTeam": "Oregon",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 30,
    "awayLineScores": [
      0,
      3,
      7,
      7,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.7222468852996826,
    "awayPregameElo": 2001,
    "awayPostgameElo": 2018,
    "excitementIndex": 6.821436627621328,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754549,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 26357,
    "venueId": 3940,
    "venue": "Stanford Stadium",
    "homeId": 24,
    "homeTeam": "Stanford",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 30,
    "homeLineScores": [
      7,
      7,
      0,
      16
    ],
    "homePostgameWinProbability": 0.5865718722343445,
    "homePregameElo": 1249,
    "homePostgameElo": 1255,
    "awayId": 23,
    "awayTeam": "San José State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 29,
    "awayLineScores": [
      10,
      10,
      0,
      9
    ],
    "awayPostgameWinProbability": 0.4134281277656555,
    "awayPregameElo": 1429,
    "awayPostgameElo": 1423,
    "excitementIndex": 8.263393671122726,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752718,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 93033,
    "venueId": 3917,
    "venue": "Sanford Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 21,
    "homeLineScores": [
      0,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.22983206808567047,
    "homePregameElo": 2043,
    "homePostgameElo": 2033,
    "awayId": 333,
    "awayTeam": "Alabama",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      17,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.7701679319143295,
    "awayPregameElo": 1948,
    "awayPostgameElo": 1958,
    "excitementIndex": 6.310283181926513,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752950,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 32087,
    "venueId": 5388,
    "venue": "Canvas Stadium",
    "homeId": 36,
    "homeTeam": "Colorado State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 3,
    "homeLineScores": [
      3,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.049715470522642136,
    "homePregameElo": 1368,
    "homePostgameElo": 1320,
    "awayId": 265,
    "awayTeam": "Washington State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 20,
    "awayLineScores": [
      10,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.9502845294773579,
    "awayPregameElo": 1307,
    "awayPostgameElo": 1355,
    "excitementIndex": 4.024978427575145,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752721,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 57321,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 42,
    "homeLineScores": [
      14,
      7,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9878277778625488,
    "homePregameElo": 1762,
    "homePostgameElo": 1781,
    "awayId": 113,
    "awayTeam": "Massachusetts",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 6,
    "awayLineScores": [
      6,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.012172222137451172,
    "awayPregameElo": 1058,
    "awayPostgameElo": 1039,
    "excitementIndex": 3.1107749721445184,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752722,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-27T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 79266,
    "venueId": 3994,
    "venue": "Williams-Brice Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 35,
    "homeLineScores": [
      7,
      21,
      0,
      7
    ],
    "homePostgameWinProbability": 0.98853600025177,
    "homePregameElo": 1638,
    "homePostgameElo": 1682,
    "awayId": 96,
    "awayTeam": "Kentucky",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 13,
    "awayLineScores": [
      10,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.01146399974822998,
    "awayPregameElo": 1557,
    "awayPostgameElo": 1513,
    "excitementIndex": 4.308897836720662,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761615,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-28T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20125,
    "venueId": 3666,
    "venue": "Cajun Field",
    "homeId": 309,
    "homeTeam": "Louisiana",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 54,
    "homeLineScores": [
      3,
      14,
      3,
      21,
      7,
      6
    ],
    "homePostgameWinProbability": 0.032249175012111664,
    "homePregameElo": 1364,
    "homePostgameElo": 1367,
    "awayId": 276,
    "awayTeam": "Marshall",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 51,
    "awayLineScores": [
      3,
      14,
      17,
      7,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.9677508249878883,
    "awayPregameElo": 1511,
    "awayPostgameElo": 1508,
    "excitementIndex": 7.244884201835037,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757272,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-28T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13013,
    "venueId": 3946,
    "venue": "Sun Bowl",
    "homeId": 2638,
    "homeTeam": "UTEP",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 11,
    "homeLineScores": [
      0,
      0,
      0,
      11
    ],
    "homePostgameWinProbability": 0.09283702075481415,
    "homePregameElo": 1227,
    "homePostgameElo": 1205,
    "awayId": 2348,
    "awayTeam": "Louisiana Tech",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 30,
    "awayLineScores": [
      7,
      0,
      3,
      20
    ],
    "awayPostgameWinProbability": 0.9071629792451859,
    "awayPregameElo": 1468,
    "awayPostgameElo": 1490,
    "excitementIndex": 4.2935016288278005,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756903,
    "season": 2025,
    "week": 5,
    "seasonType": "regular",
    "startDate": "2025-09-28T02:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52265,
    "venueId": 3726,
    "venue": "Folsom Field",
    "homeId": 38,
    "homeTeam": "Colorado",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 21,
    "homeLineScores": [
      14,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.23440313339233398,
    "homePregameElo": 1617,
    "homePostgameElo": 1618,
    "awayId": 252,
    "awayTeam": "BYU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.765596866607666,
    "awayPregameElo": 1703,
    "awayPostgameElo": 1702,
    "excitementIndex": 5.397702544157396,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757275,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-03T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9089,
    "venueId": 3601,
    "venue": "Aggie Memorial Stadium",
    "homeId": 166,
    "homeTeam": "New Mexico State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 37,
    "homeLineScores": [
      0,
      10,
      3,
      24
    ],
    "homePostgameWinProbability": 0.9957097768783569,
    "homePregameElo": 1147,
    "homePostgameElo": 1229,
    "awayId": 2534,
    "awayTeam": "Sam Houston",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.004290223121643066,
    "awayPregameElo": 1243,
    "awayPostgameElo": 1161,
    "excitementIndex": 4.112097838653908,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762475,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-03T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 34577,
    "venueId": 3886,
    "venue": "Raymond James Stadium",
    "homeId": 58,
    "homeTeam": "South Florida",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 54,
    "homeLineScores": [
      23,
      10,
      0,
      21
    ],
    "homePostgameWinProbability": 0.961682915687561,
    "homePregameElo": 1482,
    "homePostgameElo": 1521,
    "awayId": 2429,
    "awayTeam": "Charlotte",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 26,
    "awayLineScores": [
      0,
      7,
      3,
      16
    ],
    "awayPostgameWinProbability": 0.038317084312438965,
    "awayPregameElo": 1183,
    "awayPostgameElo": 1144,
    "excitementIndex": 3.245227656426531,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757276,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-03T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19176,
    "venueId": 3695,
    "venue": "Delaware Stadium",
    "homeId": 48,
    "homeTeam": "Delaware",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 24,
    "homeLineScores": [
      7,
      10,
      0,
      7
    ],
    "homePostgameWinProbability": 0.081935353577137,
    "homePregameElo": 1501,
    "homePostgameElo": 1491,
    "awayId": 98,
    "awayTeam": "Western Kentucky",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      10,
      17,
      0
    ],
    "awayPostgameWinProbability": 0.918064646422863,
    "awayPregameElo": 1414,
    "awayPostgameElo": 1424,
    "excitementIndex": 5.912223443709713,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760384,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12109,
    "venueId": 3935,
    "venue": "CEFCU Stadium",
    "homeId": 23,
    "homeTeam": "San José State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 35,
    "homeLineScores": [
      7,
      14,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9446935653686523,
    "homePregameElo": 1423,
    "homePostgameElo": 1433,
    "awayId": 167,
    "awayTeam": "New Mexico",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      17,
      0,
      11
    ],
    "awayPostgameWinProbability": 0.055306434631347656,
    "awayPregameElo": 1426,
    "awayPostgameElo": 1416,
    "excitementIndex": 4.643820742347832,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760382,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 29019,
    "venueId": 7311,
    "venue": "Snapdragon Stadium",
    "homeId": 21,
    "homeTeam": "San Diego State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 45,
    "homeLineScores": [
      7,
      21,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9995191097259521,
    "homePregameElo": 1424,
    "homePostgameElo": 1463,
    "awayId": 36,
    "awayTeam": "Colorado State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      10,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.00048089027404785156,
    "awayPregameElo": 1320,
    "awayPostgameElo": 1281,
    "excitementIndex": 3.848804896588957,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756909,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 63917,
    "venueId": 3801,
    "venue": "LaVell Edwards Stadium",
    "homeId": 252,
    "homeTeam": "BYU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 38,
    "homeLineScores": [
      14,
      14,
      3,
      7
    ],
    "homePostgameWinProbability": 0.9516913294792175,
    "homePregameElo": 1702,
    "homePostgameElo": 1701,
    "awayId": 277,
    "awayTeam": "West Virginia",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      10,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.04830867052078247,
    "awayPregameElo": 1341,
    "awayPostgameElo": 1342,
    "excitementIndex": 3.686912742591524,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752728,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 93033,
    "venueId": 3917,
    "venue": "Sanford Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 35,
    "homeLineScores": [
      14,
      7,
      14,
      0
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 2033,
    "homePostgameElo": 2033,
    "awayId": 96,
    "awayTeam": "Kentucky",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1513,
    "awayPostgameElo": 1513,
    "excitementIndex": 3.7287531574740287,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752861,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 56551,
    "venueId": 3907,
    "venue": "Ross-Ade Stadium",
    "homeId": 2509,
    "homeTeam": "Purdue",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 27,
    "homeLineScores": [
      7,
      7,
      7,
      6
    ],
    "homePostgameWinProbability": 0.17251542210578918,
    "homePregameElo": 1325,
    "homePostgameElo": 1311,
    "awayId": 356,
    "awayTeam": "Illinois",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 43,
    "awayLineScores": [
      0,
      27,
      13,
      3
    ],
    "awayPostgameWinProbability": 0.8274845778942108,
    "awayPregameElo": 1571,
    "awayPostgameElo": 1585,
    "excitementIndex": 4.648508792456986,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760381,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 37517,
    "venueId": 3852,
    "venue": "Navy-Marine Corps Memorial Stadium",
    "homeId": 2426,
    "homeTeam": "Navy",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 34,
    "homeLineScores": [
      3,
      14,
      7,
      10
    ],
    "homePostgameWinProbability": 0.6760159134864807,
    "homePregameElo": 1547,
    "homePostgameElo": 1546,
    "awayId": 2005,
    "awayTeam": "Air Force",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      3,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.3239840865135193,
    "awayPregameElo": 1351,
    "awayPostgameElo": 1352,
    "excitementIndex": 7.489516700335208,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762476,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22489,
    "venueId": 7221,
    "venue": "Protective Stadium",
    "homeId": 5,
    "homeTeam": "UAB",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 13,
    "homeLineScores": [
      0,
      7,
      0,
      6
    ],
    "homePostgameWinProbability": 0.0003441516309976578,
    "homePregameElo": 1278,
    "homePostgameElo": 1260,
    "awayId": 349,
    "awayTeam": "Army",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 31,
    "awayLineScores": [
      0,
      10,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.9996558483690023,
    "awayPregameElo": 1533,
    "awayPostgameElo": 1551,
    "excitementIndex": 4.306678498592513,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756912,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 38007,
    "venueId": 3854,
    "venue": "Nippert Stadium",
    "homeId": 2132,
    "homeTeam": "Cincinnati",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 38,
    "homeLineScores": [
      17,
      14,
      0,
      7
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1520,
    "homePostgameElo": 1541,
    "awayId": 66,
    "awayTeam": "Iowa State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 30,
    "awayLineScores": [
      0,
      15,
      7,
      8
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1655,
    "awayPostgameElo": 1634,
    "excitementIndex": 4.456953828954155,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762830,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 8427,
    "venueId": 3919,
    "venue": "Scheumann Stadium",
    "homeId": 2050,
    "homeTeam": "Ball State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 20,
    "homeLineScores": [
      0,
      0,
      10,
      10
    ],
    "homePostgameWinProbability": 0.136994406580925,
    "homePregameElo": 1095,
    "homePostgameElo": 1131,
    "awayId": 195,
    "awayTeam": "Ohio",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.863005593419075,
    "awayPregameElo": 1604,
    "awayPostgameElo": 1568,
    "excitementIndex": 7.9930994539417215,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752856,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 111070,
    "venueId": 3558,
    "venue": "Michigan Stadium",
    "homeId": 130,
    "homeTeam": "Michigan",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      7,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9888097643852234,
    "homePregameElo": 1848,
    "homePostgameElo": 1851,
    "awayId": 275,
    "awayTeam": "Wisconsin",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 10,
    "awayLineScores": [
      7,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.011190235614776611,
    "awayPregameElo": 1543,
    "awayPostgameElo": 1540,
    "excitementIndex": 4.019750008330359,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754552,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50500,
    "venueId": 3787,
    "venue": "Kenan Stadium",
    "homeId": 153,
    "homeTeam": "North Carolina",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 10,
    "homeLineScores": [
      3,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.026435913518071175,
    "homePregameElo": 1388,
    "homePostgameElo": 1342,
    "awayId": 228,
    "awayTeam": "Clemson",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 38,
    "awayLineScores": [
      28,
      7,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.9735640864819288,
    "awayPregameElo": 1642,
    "awayPostgameElo": 1688,
    "excitementIndex": 3.1263997871486096,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754550,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 51101,
    "venueId": 3752,
    "venue": "Acrisure Stadium",
    "homeId": 221,
    "homeTeam": "Pittsburgh",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 48,
    "homeLineScores": [
      10,
      21,
      14,
      3
    ],
    "homePostgameWinProbability": 0.9918763637542725,
    "homePregameElo": 1511,
    "homePostgameElo": 1624,
    "awayId": 103,
    "awayTeam": "Boston College",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.008123636245727539,
    "awayPregameElo": 1462,
    "awayPostgameElo": 1349,
    "excitementIndex": 3.2821533939051295,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756911,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 35596,
    "venueId": 4727,
    "venue": "McLane Stadium",
    "homeId": 239,
    "homeTeam": "Baylor",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 35,
    "homeLineScores": [
      3,
      14,
      0,
      18
    ],
    "homePostgameWinProbability": 0.5897729992866516,
    "homePregameElo": 1590,
    "homePostgameElo": 1593,
    "awayId": 2306,
    "awayTeam": "Kansas State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      10,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.4102270007133484,
    "awayPregameElo": 1665,
    "awayPostgameElo": 1662,
    "excitementIndex": 8.2831570903209,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762479,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12132,
    "venueId": 3806,
    "venue": "Lincoln Financial Field",
    "homeId": 218,
    "homeTeam": "Temple",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 27,
    "homeLineScores": [
      3,
      0,
      21,
      3
    ],
    "homePostgameWinProbability": 0.6703002452850342,
    "homePregameElo": 1205,
    "homePostgameElo": 1228,
    "awayId": 2636,
    "awayTeam": "UTSA",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.3296997547149658,
    "awayPregameElo": 1494,
    "awayPostgameElo": 1471,
    "excitementIndex": 4.690615088294109,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754556,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 65632,
    "venueId": 3799,
    "venue": "Lane Stadium",
    "homeId": 259,
    "homeTeam": "Virginia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 23,
    "homeLineScores": [
      7,
      7,
      9,
      0
    ],
    "homePostgameWinProbability": 0.25663283467292786,
    "homePregameElo": 1457,
    "homePostgameElo": 1439,
    "awayId": 154,
    "awayTeam": "Wake Forest",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 30,
    "awayLineScores": [
      3,
      21,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.7433671653270721,
    "awayPregameElo": 1391,
    "awayPostgameElo": 1409,
    "excitementIndex": 6.575458124170345,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754557,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 56919,
    "venueId": 3670,
    "venue": "Carter-Finley Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 56,
    "homeLineScores": [
      21,
      28,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9692317843437195,
    "homePregameElo": 1488,
    "homePostgameElo": 1488,
    "awayId": 2097,
    "awayTeam": "Campbell",
    "awayClassification": "fcs",
    "awayConference": "Coastal Athletic",
    "awayPoints": 10,
    "awayLineScores": [
      7,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.030768215656280518,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.478994264761209,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762832,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T18:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10014,
    "venueId": 3985,
    "venue": "Warren McGuirk Alumni Stadium",
    "homeId": 113,
    "homeTeam": "Massachusetts",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 3,
    "homeLineScores": [
      3,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0031924161594361067,
    "homePregameElo": 1039,
    "homePostgameElo": 1017,
    "awayId": 2711,
    "awayTeam": "Western Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9968075838405639,
    "awayPregameElo": 1254,
    "awayPostgameElo": 1276,
    "excitementIndex": 4.403949342086451,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756910,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 40685,
    "venueId": 3619,
    "venue": "Arizona Stadium",
    "homeId": 12,
    "homeTeam": "Arizona",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 41,
    "homeLineScores": [
      14,
      10,
      14,
      3
    ],
    "homePostgameWinProbability": 0.9858812689781189,
    "homePregameElo": 1422,
    "homePostgameElo": 1467,
    "awayId": 197,
    "awayTeam": "Oklahoma State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 13,
    "awayLineScores": [
      3,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.014118731021881104,
    "awayPregameElo": 1173,
    "awayPostgameElo": 1128,
    "excitementIndex": 3.2078852869067482,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752855,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 39256,
    "venueId": 1056,
    "venue": "Rose Bowl",
    "homeId": 26,
    "homeTeam": "UCLA",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 42,
    "homeLineScores": [
      10,
      17,
      7,
      8
    ],
    "homePostgameWinProbability": 0.5336061120033264,
    "homePregameElo": 1331,
    "homePostgameElo": 1373,
    "awayId": 213,
    "awayTeam": "Penn State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 37,
    "awayLineScores": [
      7,
      0,
      14,
      16
    ],
    "awayPostgameWinProbability": 0.4663938879966736,
    "awayPregameElo": 2070,
    "awayPostgameElo": 2028,
    "excitementIndex": 5.9551629784389,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752727,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 90714,
    "venueId": 3634,
    "venue": "Ben Hill Griffin Stadium",
    "homeId": 57,
    "homeTeam": "Florida",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 29,
    "homeLineScores": [
      10,
      9,
      10,
      0
    ],
    "homePostgameWinProbability": 0.9474726319313049,
    "homePregameElo": 1629,
    "homePostgameElo": 1665,
    "awayId": 251,
    "awayTeam": "Texas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.05252736806869507,
    "awayPregameElo": 1972,
    "awayPostgameElo": 1936,
    "excitementIndex": 4.124699346739427,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757171,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 27310,
    "venueId": 3892,
    "venue": "Pratt & Whitney Stadium",
    "homeId": 41,
    "homeTeam": "UConn",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 51,
    "homeLineScores": [
      14,
      13,
      17,
      7
    ],
    "homePostgameWinProbability": 0.9888136386871338,
    "homePregameElo": 1437,
    "homePostgameElo": 1541,
    "awayId": 2229,
    "awayTeam": "Florida International",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.011186361312866211,
    "awayPregameElo": 1320,
    "awayPostgameElo": 1216,
    "excitementIndex": 3.4236542563969277,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761618,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19256,
    "venueId": 4246,
    "venue": "Center Parc Stadium",
    "homeId": 2247,
    "homeTeam": "Georgia State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 7,
    "homeLineScores": [
      7,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.3364444673061371,
    "homePregameElo": 1126,
    "homePostgameElo": 1150,
    "awayId": 256,
    "awayTeam": "James Madison",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.6635555326938629,
    "awayPregameElo": 1669,
    "awayPostgameElo": 1645,
    "excitementIndex": 4.209128497176163,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752940,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 35021,
    "venueId": 3792,
    "venue": "Kidd Brewer Stadium",
    "homeId": 2026,
    "homeTeam": "App State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 27,
    "homeLineScores": [
      17,
      0,
      10,
      0
    ],
    "homePostgameWinProbability": 0.7424425482749939,
    "homePregameElo": 1324,
    "homePostgameElo": 1326,
    "awayId": 204,
    "awayTeam": "Oregon State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 23,
    "awayLineScores": [
      0,
      14,
      7,
      2
    ],
    "awayPostgameWinProbability": 0.2575574517250061,
    "awayPregameElo": 1304,
    "awayPostgameElo": 1302,
    "excitementIndex": 5.6164422770416,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762829,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 8995,
    "venueId": 3768,
    "venue": "InfoCision Stadium",
    "homeId": 2006,
    "homeTeam": "Akron",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 28,
    "homeLineScores": [
      0,
      14,
      14,
      0
    ],
    "homePostgameWinProbability": 0.8367872834205627,
    "homePregameElo": 995,
    "homePostgameElo": 1009,
    "awayId": 2117,
    "awayTeam": "Central Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 22,
    "awayLineScores": [
      3,
      7,
      3,
      9
    ],
    "awayPostgameWinProbability": 0.16321271657943726,
    "awayPregameElo": 1124,
    "awayPostgameElo": 1110,
    "excitementIndex": 5.829754243974867,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752726,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 100077,
    "venueId": 3657,
    "venue": "Bryant-Denny Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 30,
    "homeLineScores": [
      0,
      14,
      6,
      10
    ],
    "homePostgameWinProbability": 0.9792400598526001,
    "homePregameElo": 1958,
    "homePostgameElo": 1974,
    "awayId": 238,
    "awayTeam": "Vanderbilt",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.020759940147399902,
    "awayPregameElo": 1758,
    "awayPostgameElo": 1742,
    "excitementIndex": 5.76137188563929,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757165,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 77622,
    "venueId": 3855,
    "venue": "Notre Dame Stadium",
    "homeId": 87,
    "homeTeam": "Notre Dame",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 28,
    "homeLineScores": [
      6,
      8,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9840602278709412,
    "homePregameElo": 2195,
    "homePostgameElo": 2194,
    "awayId": 68,
    "awayTeam": "Boise State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.015939772129058838,
    "awayPregameElo": 1653,
    "awayPostgameElo": 1654,
    "excitementIndex": 4.635698235011022,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754555,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 34845,
    "venueId": 3735,
    "venue": "Gerald J. Ford Stadium",
    "homeId": 2567,
    "homeTeam": "SMU",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 31,
    "homeLineScores": [
      3,
      21,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9434120059013367,
    "homePregameElo": 1691,
    "homePostgameElo": 1695,
    "awayId": 183,
    "awayTeam": "Syracuse",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 18,
    "awayLineScores": [
      0,
      3,
      0,
      15
    ],
    "awayPostgameWinProbability": 0.05658799409866333,
    "awayPregameElo": 1426,
    "awayPostgameElo": 1422,
    "excitementIndex": 3.828906354139435,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754554,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50032,
    "venueId": 3873,
    "venue": "L&N Federal Credit Union Stadium",
    "homeId": 97,
    "homeTeam": "Louisville",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 27,
    "homeLineScores": [
      7,
      7,
      0,
      10,
      3
    ],
    "homePostgameWinProbability": 0.8702377676963806,
    "homePregameElo": 1750,
    "homePostgameElo": 1735,
    "awayId": 258,
    "awayTeam": "Virginia",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 30,
    "awayLineScores": [
      7,
      7,
      10,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.12976223230361938,
    "awayPregameElo": 1578,
    "awayPostgameElo": 1593,
    "excitementIndex": 9.702094358757874,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752858,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 12023,
    "venueId": 5960,
    "venue": "Lanny and Sharon Martin Stadium",
    "homeId": 77,
    "homeTeam": "Northwestern",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 42,
    "homeLineScores": [
      7,
      11,
      21,
      3
    ],
    "homePostgameWinProbability": 0.9918237328529358,
    "homePregameElo": 1411,
    "homePostgameElo": 1478,
    "awayId": 2433,
    "awayTeam": "UL Monroe",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.008176267147064209,
    "awayPregameElo": 1168,
    "awayPostgameElo": 1101,
    "excitementIndex": 3.944134446791077,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752857,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 46185,
    "venueId": 3665,
    "venue": "SECU Stadium",
    "homeId": 120,
    "homeTeam": "Maryland",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 20,
    "homeLineScores": [
      10,
      3,
      7,
      0
    ],
    "homePostgameWinProbability": 0.47905972599983215,
    "homePregameElo": 1574,
    "homePostgameElo": 1573,
    "awayId": 264,
    "awayTeam": "Washington",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      0,
      3,
      21
    ],
    "awayPostgameWinProbability": 0.5209402740001678,
    "awayPregameElo": 1665,
    "awayPostgameElo": 1666,
    "excitementIndex": 4.668454458410852,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762831,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17300,
    "venueId": 3965,
    "venue": "UB Stadium",
    "homeId": 2084,
    "homeTeam": "Buffalo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 31,
    "homeLineScores": [
      7,
      7,
      7,
      3,
      7
    ],
    "homePostgameWinProbability": 0.3708692491054535,
    "homePregameElo": 1382,
    "homePostgameElo": 1377,
    "awayId": 2199,
    "awayTeam": "Eastern Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 30,
    "awayLineScores": [
      7,
      7,
      7,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.6291307508945465,
    "awayPregameElo": 1193,
    "awayPostgameElo": 1198,
    "excitementIndex": 9.748775210940412,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762873,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13827,
    "venueId": 3764,
    "venue": "Huskie Stadium",
    "homeId": 2459,
    "homeTeam": "Northern Illinois",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 14,
    "homeLineScores": [
      14,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.10726047307252884,
    "homePregameElo": 1375,
    "homePostgameElo": 1356,
    "awayId": 193,
    "awayTeam": "Miami (OH)",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 25,
    "awayLineScores": [
      0,
      10,
      12,
      3
    ],
    "awayPostgameWinProbability": 0.8927395269274712,
    "awayPregameElo": 1430,
    "awayPostgameElo": 1449,
    "excitementIndex": 4.53942701175636,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752860,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 86496,
    "venueId": 3834,
    "venue": "Memorial Stadium (Lincoln, NE)",
    "homeId": 158,
    "homeTeam": "Nebraska",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      14,
      0,
      7,
      17
    ],
    "homePostgameWinProbability": 0.8201844096183777,
    "homePregameElo": 1703,
    "homePostgameElo": 1702,
    "awayId": 127,
    "awayTeam": "Michigan State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      7,
      14,
      6
    ],
    "awayPostgameWinProbability": 0.17981559038162231,
    "awayPregameElo": 1414,
    "awayPostgameElo": 1415,
    "excitementIndex": 5.239215667116852,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752729,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 83016,
    "venueId": 3835,
    "venue": "Memorial Stadium (Norman, OK)",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 44,
    "homeLineScores": [
      10,
      13,
      21,
      0
    ],
    "homePostgameWinProbability": 0.9927051663398743,
    "homePregameElo": 1748,
    "homePostgameElo": 1769,
    "awayId": 2309,
    "awayTeam": "Kent State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.007294833660125732,
    "awayPregameElo": 859,
    "awayPostgameElo": 838,
    "excitementIndex": 2.724722460200933,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761620,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15841,
    "venueId": 3625,
    "venue": "Centennial Bank Stadium",
    "homeId": 2032,
    "homeTeam": "Arkansas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 31,
    "homeLineScores": [
      7,
      3,
      0,
      21
    ],
    "homePostgameWinProbability": 0.6157334446907043,
    "homePregameElo": 1213,
    "homePostgameElo": 1224,
    "awayId": 326,
    "awayTeam": "Texas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 30,
    "awayLineScores": [
      7,
      3,
      0,
      20
    ],
    "awayPostgameWinProbability": 0.38426655530929565,
    "awayPregameElo": 1590,
    "awayPostgameElo": 1579,
    "excitementIndex": 8.786810818748446,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761619,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20895,
    "venueId": 3918,
    "venue": "S.B. Ballard Stadium",
    "homeId": 295,
    "homeTeam": "Old Dominion",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 47,
    "homeLineScores": [
      10,
      24,
      10,
      3
    ],
    "homePostgameWinProbability": 0.9827017784118652,
    "homePregameElo": 1551,
    "homePostgameElo": 1628,
    "awayId": 324,
    "awayTeam": "Coastal Carolina",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.017298221588134766,
    "awayPregameElo": 1259,
    "awayPostgameElo": 1182,
    "excitementIndex": 2.947444134543734,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762477,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22999,
    "venueId": 3895,
    "venue": "Rice Stadium",
    "homeId": 242,
    "homeTeam": "Rice",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 21,
    "homeLineScores": [
      7,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.5182587504386902,
    "homePregameElo": 1291,
    "homePostgameElo": 1273,
    "awayId": 2226,
    "awayTeam": "Florida Atlantic",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 27,
    "awayLineScores": [
      14,
      3,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.4817412495613098,
    "awayPregameElo": 1201,
    "awayPostgameElo": 1219,
    "excitementIndex": 3.6297493058176755,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761621,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28035,
    "venueId": 3975,
    "venue": "Veterans Memorial Stadium (AL)",
    "homeId": 2653,
    "homeTeam": "Troy",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 31,
    "homeLineScores": [
      7,
      7,
      7,
      3,
      7
    ],
    "homePostgameWinProbability": 0.7369530200958252,
    "homePregameElo": 1438,
    "homePostgameElo": 1447,
    "awayId": 6,
    "awayTeam": "South Alabama",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      0,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.2630469799041748,
    "awayPregameElo": 1430,
    "awayPostgameElo": 1421,
    "excitementIndex": 7.897014974022887,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756913,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 42806,
    "venueId": 4728,
    "venue": "TDECU Stadium",
    "homeId": 248,
    "homeTeam": "Houston",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 11,
    "homeLineScores": [
      3,
      8,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0017014285549521446,
    "homePregameElo": 1490,
    "homePostgameElo": 1456,
    "awayId": 2641,
    "awayTeam": "Texas Tech",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 35,
    "awayLineScores": [
      15,
      10,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.9982985714450479,
    "awayPregameElo": 1751,
    "awayPostgameElo": 1785,
    "excitementIndex": 4.3021884566467214,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760385,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19861,
    "venueId": 3984,
    "venue": "War Memorial Stadium",
    "homeId": 2751,
    "homeTeam": "Wyoming",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 17,
    "homeLineScores": [
      3,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.024475770071148872,
    "homePregameElo": 1326,
    "homePostgameElo": 1321,
    "awayId": 2439,
    "awayTeam": "UNLV",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 31,
    "awayLineScores": [
      17,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.9755242299288511,
    "awayPregameElo": 1622,
    "awayPostgameElo": 1627,
    "excitementIndex": 3.254392040823553,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752730,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 108572,
    "venueId": 3795,
    "venue": "Kyle Field",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 31,
    "homeLineScores": [
      0,
      7,
      7,
      17
    ],
    "homePostgameWinProbability": 0.9942386746406555,
    "homePregameElo": 1753,
    "homePostgameElo": 1782,
    "awayId": 344,
    "awayTeam": "Mississippi State",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 9,
    "awayLineScores": [
      3,
      0,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.005761325359344482,
    "awayPregameElo": 1523,
    "awayPostgameElo": 1494,
    "excitementIndex": 4.4646549380802885,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756915,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 43229,
    "venueId": 3652,
    "venue": "FBC Mortgage Stadium",
    "homeId": 2116,
    "homeTeam": "UCF",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 20,
    "homeLineScores": [
      7,
      13,
      0,
      0
    ],
    "homePostgameWinProbability": 0.043001241981983185,
    "homePregameElo": 1579,
    "homePostgameElo": 1572,
    "awayId": 2305,
    "awayTeam": "Kansas",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      14,
      13,
      0
    ],
    "awayPostgameWinProbability": 0.9569987580180168,
    "awayPregameElo": 1664,
    "awayPostgameElo": 1671,
    "excitementIndex": 5.384533111657922,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756914,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 43160,
    "venueId": 3616,
    "venue": "Amon G. Carter Stadium",
    "homeId": 2628,
    "homeTeam": "TCU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 35,
    "homeLineScores": [
      0,
      14,
      0,
      21
    ],
    "homePostgameWinProbability": 0.9454600214958191,
    "homePregameElo": 1732,
    "homePostgameElo": 1751,
    "awayId": 38,
    "awayTeam": "Colorado",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      14,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.05453997850418091,
    "awayPregameElo": 1618,
    "awayPostgameElo": 1599,
    "excitementIndex": 8.301538245718836,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752859,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 105114,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 42,
    "homeLineScores": [
      7,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9900946021080017,
    "homePregameElo": 2021,
    "homePostgameElo": 2078,
    "awayId": 135,
    "awayTeam": "Minnesota",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 3,
    "awayLineScores": [
      3,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.009905397891998291,
    "awayPregameElo": 1594,
    "awayPostgameElo": 1537,
    "excitementIndex": 3.2212159500530033,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754553,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-04T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 67277,
    "venueId": 3697,
    "venue": "Doak Campbell Stadium",
    "homeId": 52,
    "homeTeam": "Florida State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 22,
    "homeLineScores": [
      3,
      0,
      0,
      19
    ],
    "homePostgameWinProbability": 0.10202304273843765,
    "homePregameElo": 1564,
    "homePostgameElo": 1573,
    "awayId": 2390,
    "awayTeam": "Miami",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      7,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.8979769572615623,
    "awayPregameElo": 1852,
    "awayPostgameElo": 1843,
    "excitementIndex": 4.2630519356314,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762478,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-05T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 27303,
    "venueId": 3805,
    "venue": "Simmons Bank Liberty Stadium",
    "homeId": 235,
    "homeTeam": "Memphis",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 45,
    "homeLineScores": [
      7,
      21,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9926255941390991,
    "homePregameElo": 1689,
    "homePostgameElo": 1723,
    "awayId": 202,
    "awayTeam": "Tulsa",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.007374405860900879,
    "awayPregameElo": 1079,
    "awayPostgameElo": 1045,
    "excitementIndex": 3.650219027829013,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754551,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-05T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 42240,
    "venueId": 3831,
    "venue": "California Memorial Stadium",
    "homeId": 25,
    "homeTeam": "California",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 21,
    "homeLineScores": [
      14,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.014589975588023663,
    "homePregameElo": 1455,
    "homePostgameElo": 1408,
    "awayId": 150,
    "awayTeam": "Duke",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 45,
    "awayLineScores": [
      7,
      24,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.9854100244119763,
    "awayPregameElo": 1598,
    "awayPostgameElo": 1645,
    "excitementIndex": 4.772030131847419,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760383,
    "season": 2025,
    "week": 6,
    "seasonType": "regular",
    "startDate": "2025-10-05T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 40005,
    "venueId": 3660,
    "venue": "Valley Children's Stadium",
    "homeId": 278,
    "homeTeam": "Fresno State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 20,
    "homeLineScores": [
      0,
      20,
      0,
      0
    ],
    "homePostgameWinProbability": 0.8731601238250732,
    "homePregameElo": 1510,
    "homePostgameElo": 1508,
    "awayId": 2440,
    "awayTeam": "Nevada",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 17,
    "awayLineScores": [
      3,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.12683987617492676,
    "awayPregameElo": 1257,
    "awayPostgameElo": 1259,
    "excitementIndex": 5.878190775237731,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757278,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-08T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9806,
    "venueId": 3725,
    "venue": "Johnny \"Red\" Floyd Stadium",
    "homeId": 2393,
    "homeTeam": "Middle Tennessee",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 20,
    "homeLineScores": [
      3,
      10,
      0,
      7
    ],
    "homePostgameWinProbability": 0.487333208322525,
    "homePregameElo": 1175,
    "homePostgameElo": 1181,
    "awayId": 2623,
    "awayTeam": "Missouri State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 22,
    "awayLineScores": [
      0,
      16,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.512666791677475,
    "awayPregameElo": 1335,
    "awayPostgameElo": 1329,
    "excitementIndex": 6.335220540226636,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757277,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-09T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9286,
    "venueId": 3946,
    "venue": "Sun Bowl",
    "homeId": 2638,
    "homeTeam": "UTEP",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 8,
    "homeLineScores": [
      0,
      0,
      0,
      8
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1205,
    "homePostgameElo": 1200,
    "awayId": 2335,
    "awayTeam": "Liberty",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 19,
    "awayLineScores": [
      7,
      6,
      6,
      0
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1421,
    "awayPostgameElo": 1426,
    "excitementIndex": 3.2463058882707863,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757280,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-09T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9585,
    "venueId": 4899,
    "venue": "Fifth Third Stadium",
    "homeId": 338,
    "homeTeam": "Kennesaw State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 35,
    "homeLineScores": [
      0,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9933742880821228,
    "homePregameElo": 1223,
    "homePostgameElo": 1332,
    "awayId": 2348,
    "awayTeam": "Louisiana Tech",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.006625711917877197,
    "awayPregameElo": 1490,
    "awayPostgameElo": 1381,
    "excitementIndex": 4.493186298095214,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762480,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-09T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20035,
    "venueId": 4729,
    "venue": "Yulman Stadium",
    "homeId": 2655,
    "homeTeam": "Tulane",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 26,
    "homeLineScores": [
      3,
      9,
      0,
      14
    ],
    "homePostgameWinProbability": 0.8402418494224548,
    "homePregameElo": 1572,
    "homePostgameElo": 1580,
    "awayId": 151,
    "awayTeam": "East Carolina",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 19,
    "awayLineScores": [
      0,
      0,
      16,
      3
    ],
    "awayPostgameWinProbability": 0.15975815057754517,
    "awayPregameElo": 1548,
    "awayPostgameElo": 1540,
    "excitementIndex": 5.865112932346798,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757279,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-10T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 5419,
    "venueId": 3631,
    "venue": "BBVA Compass Stadium",
    "homeId": 2534,
    "homeTeam": "Sam Houston",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 27,
    "homeLineScores": [
      0,
      14,
      7,
      6
    ],
    "homePostgameWinProbability": 0.05415964126586914,
    "homePregameElo": 1161,
    "homePostgameElo": 1173,
    "awayId": 55,
    "awayTeam": "Jacksonville State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 29,
    "awayLineScores": [
      7,
      10,
      0,
      12
    ],
    "awayPostgameWinProbability": 0.9458403587341309,
    "awayPregameElo": 1529,
    "awayPostgameElo": 1517,
    "excitementIndex": 7.2093854505096235,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761622,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-10T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20032,
    "venueId": 3608,
    "venue": "Allen E. Paulson Stadium",
    "homeId": 290,
    "homeTeam": "Georgia Southern",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 35,
    "homeLineScores": [
      7,
      0,
      14,
      14
    ],
    "homePostgameWinProbability": 0.17224420607089996,
    "homePregameElo": 1324,
    "homePostgameElo": 1316,
    "awayId": 2572,
    "awayTeam": "Southern Miss",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      21,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.8277557939291,
    "awayPregameElo": 1265,
    "awayPostgameElo": 1273,
    "excitementIndex": 6.0306831730253965,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762481,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-10T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 31386,
    "venueId": 3825,
    "venue": "DATCU Stadium",
    "homeId": 249,
    "homeTeam": "North Texas",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 36,
    "homeLineScores": [
      14,
      7,
      7,
      8
    ],
    "homePostgameWinProbability": 0.0036575840786099434,
    "homePregameElo": 1616,
    "homePostgameElo": 1530,
    "awayId": 58,
    "awayTeam": "South Florida",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 63,
    "awayLineScores": [
      7,
      14,
      28,
      14
    ],
    "awayPostgameWinProbability": 0.9963424159213901,
    "awayPregameElo": 1521,
    "awayPostgameElo": 1607,
    "excitementIndex": 5.324575969232542,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760388,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 27874,
    "venueId": 5388,
    "venue": "Canvas Stadium",
    "homeId": 36,
    "homeTeam": "Colorado State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 49,
    "homeLineScores": [
      14,
      21,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9986304044723511,
    "homePregameElo": 1281,
    "homePostgameElo": 1384,
    "awayId": 278,
    "awayTeam": "Fresno State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      14,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0013695955276489258,
    "awayPregameElo": 1508,
    "awayPostgameElo": 1405,
    "excitementIndex": 4.039871834972102,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752862,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 63743,
    "venueId": 3765,
    "venue": "Husky Stadium",
    "homeId": 264,
    "homeTeam": "Washington",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      0,
      10,
      21,
      7
    ],
    "homePostgameWinProbability": 0.9742462038993835,
    "homePregameElo": 1666,
    "homePostgameElo": 1701,
    "awayId": 164,
    "awayTeam": "Rutgers",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 19,
    "awayLineScores": [
      10,
      3,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.025753796100616455,
    "awayPregameElo": 1582,
    "awayPostgameElo": 1547,
    "excitementIndex": 6.731502282272816,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762483,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 31172,
    "venueId": 3841,
    "venue": "Michie Stadium",
    "homeId": 349,
    "homeTeam": "Army",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 24,
    "homeLineScores": [
      7,
      10,
      7,
      0
    ],
    "homePostgameWinProbability": 0.990699827671051,
    "homePregameElo": 1551,
    "homePostgameElo": 1552,
    "awayId": 2429,
    "awayTeam": "Charlotte",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.009300172328948975,
    "awayPregameElo": 1144,
    "awayPostgameElo": 1143,
    "excitementIndex": 2.926749973897242,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756920,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44941,
    "venueId": 3646,
    "venue": "Boone Pickens Stadium",
    "homeId": 197,
    "homeTeam": "Oklahoma State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 17,
    "homeLineScores": [
      7,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.10873417556285858,
    "homePregameElo": 1128,
    "homePostgameElo": 1107,
    "awayId": 248,
    "awayTeam": "Houston",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 39,
    "awayLineScores": [
      10,
      14,
      12,
      3
    ],
    "awayPostgameWinProbability": 0.8912658244371414,
    "awayPregameElo": 1456,
    "awayPostgameElo": 1477,
    "excitementIndex": 4.179605229194508,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762833,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 6575,
    "venueId": 3768,
    "venue": "InfoCision Stadium",
    "homeId": 2006,
    "homeTeam": "Akron",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1009,
    "homePostgameElo": 1018,
    "awayId": 193,
    "awayTeam": "Miami (OH)",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      3,
      14,
      3
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1449,
    "awayPostgameElo": 1440,
    "excitementIndex": 3.3376481574054546,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752734,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 57321,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      7,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.5290258526802063,
    "homePregameElo": 1781,
    "homePostgameElo": 1788,
    "awayId": 333,
    "awayTeam": "Alabama",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      10,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.4709741473197937,
    "awayPregameElo": 1974,
    "awayPostgameElo": 1967,
    "excitementIndex": 6.769031039615297,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752865,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60670,
    "venueId": 3832,
    "venue": "Memorial Stadium (Champaign, IL)",
    "homeId": 356,
    "homeTeam": "Illinois",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 16,
    "homeLineScores": [
      0,
      3,
      7,
      6
    ],
    "homePostgameWinProbability": 0.041837599128484726,
    "homePregameElo": 1585,
    "homePostgameElo": 1589,
    "awayId": 194,
    "awayTeam": "Ohio State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 34,
    "awayLineScores": [
      10,
      10,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9581624008715153,
    "awayPregameElo": 2078,
    "awayPostgameElo": 2074,
    "excitementIndex": 3.495212533410147,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752863,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 72109,
    "venueId": 3936,
    "venue": "Spartan Stadium",
    "homeId": 127,
    "homeTeam": "Michigan State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 13,
    "homeLineScores": [
      7,
      0,
      0,
      6
    ],
    "homePostgameWinProbability": 0.0009458241984248161,
    "homePregameElo": 1415,
    "homePostgameElo": 1343,
    "awayId": 26,
    "awayTeam": "UCLA",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 38,
    "awayLineScores": [
      10,
      14,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.9990541758015752,
    "awayPregameElo": 1373,
    "awayPostgameElo": 1445,
    "excitementIndex": 3.6543543575854267,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754561,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30654,
    "venueId": 3735,
    "venue": "Gerald J. Ford Stadium",
    "homeId": 2567,
    "homeTeam": "SMU",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 34,
    "homeLineScores": [
      7,
      10,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9821944832801819,
    "homePregameElo": 1695,
    "homePostgameElo": 1709,
    "awayId": 24,
    "awayTeam": "Stanford",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.017805516719818115,
    "awayPregameElo": 1255,
    "awayPostgameElo": 1241,
    "excitementIndex": 4.070236961857501,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762835,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24000,
    "venueId": 3700,
    "venue": "Doyt L. Perry Stadium",
    "homeId": 189,
    "homeTeam": "Bowling Green",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 28,
    "homeLineScores": [
      0,
      7,
      7,
      14
    ],
    "homePostgameWinProbability": 0.6486319303512573,
    "homePregameElo": 1411,
    "homePostgameElo": 1422,
    "awayId": 2649,
    "awayTeam": "Toledo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 23,
    "awayLineScores": [
      14,
      7,
      0,
      2
    ],
    "awayPostgameWinProbability": 0.3513680696487427,
    "awayPregameElo": 1562,
    "awayPostgameElo": 1551,
    "excitementIndex": 5.4770171226142415,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756917,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 35782,
    "venueId": 3854,
    "venue": "Nippert Stadium",
    "homeId": 2132,
    "homeTeam": "Cincinnati",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 20,
    "homeLineScores": [
      7,
      10,
      0,
      3
    ],
    "homePostgameWinProbability": 0.9451076984405518,
    "homePregameElo": 1541,
    "homePostgameElo": 1558,
    "awayId": 2116,
    "awayTeam": "UCF",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 11,
    "awayLineScores": [
      0,
      3,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.05489230155944824,
    "awayPregameElo": 1572,
    "awayPostgameElo": 1555,
    "excitementIndex": 3.4997102780038416,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754559,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 65256,
    "venueId": 3697,
    "venue": "Doak Campbell Stadium",
    "homeId": 52,
    "homeTeam": "Florida State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 31,
    "homeLineScores": [
      7,
      14,
      3,
      7
    ],
    "homePostgameWinProbability": 0.23192715644836426,
    "homePregameElo": 1573,
    "homePostgameElo": 1572,
    "awayId": 221,
    "awayTeam": "Pittsburgh",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      7,
      7,
      13
    ],
    "awayPostgameWinProbability": 0.7680728435516357,
    "awayPregameElo": 1624,
    "awayPostgameElo": 1625,
    "excitementIndex": 7.118912629143081,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761625,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": null,
    "venueId": 3651,
    "venue": "Bridgeforth Stadium",
    "homeId": 256,
    "homeTeam": "James Madison",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 24,
    "homeLineScores": [
      0,
      7,
      7,
      10
    ],
    "homePostgameWinProbability": 0.972748339176178,
    "homePregameElo": 1645,
    "homePostgameElo": 1643,
    "awayId": 309,
    "awayTeam": "Louisiana",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.02725166082382202,
    "awayPregameElo": 1367,
    "awayPostgameElo": 1369,
    "excitementIndex": 6.231799272619301,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752733,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 66392,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      0,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 0.8747900724411011,
    "homePregameElo": 1977,
    "homePostgameElo": 1971,
    "awayId": 265,
    "awayTeam": "Washington State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.12520992755889893,
    "awayPregameElo": 1355,
    "awayPostgameElo": 1361,
    "excitementIndex": 5.96501076991805,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762836,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15676,
    "venueId": 3912,
    "venue": "Rynearson Stadium",
    "homeId": 2199,
    "homeTeam": "Eastern Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 16,
    "homeLineScores": [
      3,
      3,
      0,
      10
    ],
    "homePostgameWinProbability": 0.8037484288215637,
    "homePregameElo": 1198,
    "homePostgameElo": 1213,
    "awayId": 2459,
    "awayTeam": "Northern Illinois",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.19625157117843628,
    "awayPregameElo": 1356,
    "awayPostgameElo": 1341,
    "excitementIndex": 5.782923326398062,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762837,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T18:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11523,
    "venueId": 3696,
    "venue": "Dix Stadium",
    "homeId": 2309,
    "homeTeam": "Kent State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 42,
    "homeLineScores": [
      14,
      7,
      21,
      0
    ],
    "homePostgameWinProbability": 0.9962396621704102,
    "homePregameElo": 838,
    "homePostgameElo": 966,
    "awayId": 113,
    "awayTeam": "Massachusetts",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      6,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0037603378295898438,
    "awayPregameElo": 1017,
    "awayPostgameElo": 889,
    "excitementIndex": 2.8487384351500182,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761624,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19587,
    "venueId": 4246,
    "venue": "Center Parc Stadium",
    "homeId": 2247,
    "homeTeam": "Georgia State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 20,
    "homeLineScores": [
      0,
      0,
      14,
      6
    ],
    "homePostgameWinProbability": 0.008137271739542484,
    "homePregameElo": 1150,
    "homePostgameElo": 1116,
    "awayId": 2026,
    "awayTeam": "App State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 41,
    "awayLineScores": [
      7,
      10,
      21,
      3
    ],
    "awayPostgameWinProbability": 0.9918627282604575,
    "awayPregameElo": 1326,
    "awayPostgameElo": 1360,
    "excitementIndex": 3.3372824593976382,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762834,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20032,
    "venueId": 3980,
    "venue": "Waldo Stadium",
    "homeId": 2711,
    "homeTeam": "Western Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 42,
    "homeLineScores": [
      7,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.994542121887207,
    "homePregameElo": 1276,
    "homePostgameElo": 1379,
    "awayId": 2050,
    "awayTeam": "Ball State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.005457878112792969,
    "awayPregameElo": 1131,
    "awayPostgameElo": 1028,
    "excitementIndex": 3.025974457111789,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752866,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 108121,
    "venueId": 3632,
    "venue": "Beaver Stadium",
    "homeId": 213,
    "homeTeam": "Penn State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 21,
    "homeLineScores": [
      0,
      14,
      0,
      7
    ],
    "homePostgameWinProbability": 0.8094112873077393,
    "homePregameElo": 2028,
    "homePostgameElo": 1996,
    "awayId": 77,
    "awayTeam": "Northwestern",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 22,
    "awayLineScores": [
      3,
      10,
      0,
      9
    ],
    "awayPostgameWinProbability": 0.19058871269226074,
    "awayPregameElo": 1478,
    "awayPostgameElo": 1510,
    "excitementIndex": 6.179311855515855,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754563,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 29710,
    "venueId": 3893,
    "venue": "Reser Stadium",
    "homeId": 204,
    "homeTeam": "Oregon State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 14,
    "homeLineScores": [
      0,
      0,
      0,
      14
    ],
    "homePostgameWinProbability": 0.09323949366807938,
    "homePregameElo": 1302,
    "homePostgameElo": 1248,
    "awayId": 154,
    "awayTeam": "Wake Forest",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 39,
    "awayLineScores": [
      15,
      10,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9067605063319206,
    "awayPregameElo": 1409,
    "awayPostgameElo": 1463,
    "excitementIndex": 3.0025001196704193,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760386,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 32932,
    "venueId": 6501,
    "venue": "Allegiant Stadium",
    "homeId": 2439,
    "homeTeam": "UNLV",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 51,
    "homeLineScores": [
      7,
      6,
      16,
      22
    ],
    "homePostgameWinProbability": 0.6350688338279724,
    "homePregameElo": 1627,
    "homePostgameElo": 1625,
    "awayId": 2005,
    "awayTeam": "Air Force",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 48,
    "awayLineScores": [
      7,
      14,
      7,
      20
    ],
    "awayPostgameWinProbability": 0.3649311661720276,
    "awayPregameElo": 1352,
    "awayPostgameElo": 1354,
    "excitementIndex": 10.021451733879378,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761626,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23515,
    "venueId": 3775,
    "venue": "Joan C. Edwards Stadium",
    "homeId": 276,
    "homeTeam": "Marshall",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 48,
    "homeLineScores": [
      7,
      17,
      17,
      7
    ],
    "homePostgameWinProbability": 0.9953325390815735,
    "homePregameElo": 1508,
    "homePostgameElo": 1582,
    "awayId": 295,
    "awayTeam": "Old Dominion",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      3,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.004667460918426514,
    "awayPregameElo": 1628,
    "awayPostgameElo": 1554,
    "excitementIndex": 5.311620641343362,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756918,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52698,
    "venueId": 3726,
    "venue": "Folsom Field",
    "homeId": 38,
    "homeTeam": "Colorado",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 24,
    "homeLineScores": [
      7,
      0,
      14,
      3
    ],
    "homePostgameWinProbability": 0.9247090816497803,
    "homePregameElo": 1599,
    "homePostgameElo": 1611,
    "awayId": 66,
    "awayTeam": "Iowa State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.07529091835021973,
    "awayPregameElo": 1634,
    "awayPostgameElo": 1622,
    "excitementIndex": 5.95300557410321,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754560,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50878,
    "venueId": 721,
    "venue": "Bobby Dodd Stadium",
    "homeId": 59,
    "homeTeam": "Georgia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 35,
    "homeLineScores": [
      15,
      6,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9364950656890869,
    "homePregameElo": 1568,
    "homePostgameElo": 1588,
    "awayId": 259,
    "awayTeam": "Virginia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      7,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.06350493431091309,
    "awayPregameElo": 1439,
    "awayPostgameElo": 1419,
    "excitementIndex": 3.3730818797323567,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752736,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 92100,
    "venueId": 499,
    "venue": "Cotton Bowl",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 23,
    "homeLineScores": [
      0,
      3,
      10,
      10
    ],
    "homePostgameWinProbability": 0.9862483739852905,
    "homePregameElo": 1936,
    "homePostgameElo": 1964,
    "awayId": 201,
    "awayTeam": "Oklahoma",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 6,
    "awayLineScores": [
      3,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.013751626014709473,
    "awayPregameElo": 1769,
    "awayPostgameElo": 1741,
    "excitementIndex": 5.19443888245953,
    "highlights": "",
    "notes": "Allstate Red River Rivalry",
    "playoff": null
  },
  {
    "id": 401752870,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 59625,
    "venueId": 3626,
    "venue": "Autzen Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 20,
    "homeLineScores": [
      7,
      3,
      3,
      7
    ],
    "homePostgameWinProbability": 0.4533250033855438,
    "homePregameElo": 2018,
    "homePostgameElo": 1996,
    "awayId": 84,
    "awayTeam": "Indiana",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 30,
    "awayLineScores": [
      10,
      3,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.5466749966144562,
    "awayPregameElo": 2000,
    "awayPostgameElo": 2022,
    "excitementIndex": 5.790429511289678,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752867,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 39623,
    "venueId": 3665,
    "venue": "SECU Stadium",
    "homeId": 120,
    "homeTeam": "Maryland",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 31,
    "homeLineScores": [
      0,
      17,
      14,
      0
    ],
    "homePostgameWinProbability": 0.6815001368522644,
    "homePregameElo": 1573,
    "homePostgameElo": 1576,
    "awayId": 158,
    "awayTeam": "Nebraska",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      17,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.3184998631477356,
    "awayPregameElo": 1702,
    "awayPostgameElo": 1699,
    "excitementIndex": 6.460996284830717,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754562,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 77622,
    "venueId": 3855,
    "venue": "Notre Dame Stadium",
    "homeId": 87,
    "homeTeam": "Notre Dame",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 36,
    "homeLineScores": [
      7,
      3,
      14,
      12
    ],
    "homePostgameWinProbability": 0.984958291053772,
    "homePregameElo": 2194,
    "homePostgameElo": 2196,
    "awayId": 152,
    "awayTeam": "NC State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.015041708946228027,
    "awayPregameElo": 1489,
    "awayPostgameElo": 1487,
    "excitementIndex": 4.771520212038678,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756919,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 51316,
    "venueId": 3636,
    "venue": "Bill Snyder Family Stadium",
    "homeId": 2306,
    "homeTeam": "Kansas State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 41,
    "homeLineScores": [
      0,
      14,
      14,
      13
    ],
    "homePostgameWinProbability": 0.9563628435134888,
    "homePregameElo": 1662,
    "homePostgameElo": 1695,
    "awayId": 2628,
    "awayTeam": "TCU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      7,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.04363715648651123,
    "awayPregameElo": 1751,
    "awayPostgameElo": 1718,
    "excitementIndex": 5.252362149705651,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762484,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 26149,
    "venueId": 3806,
    "venue": "Lincoln Financial Field",
    "homeId": 218,
    "homeTeam": "Temple",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 31,
    "homeLineScores": [
      7,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 0.6812015175819397,
    "homePregameElo": 1228,
    "homePostgameElo": 1241,
    "awayId": 2426,
    "awayTeam": "Navy",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 32,
    "awayLineScores": [
      7,
      0,
      14,
      11
    ],
    "awayPostgameWinProbability": 0.3187984824180603,
    "awayPregameElo": 1546,
    "awayPostgameElo": 1533,
    "excitementIndex": 6.2423048366125435,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752735,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 101915,
    "venueId": 3853,
    "venue": "Neyland Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 34,
    "homeLineScores": [
      7,
      10,
      10,
      7
    ],
    "homePostgameWinProbability": 0.7579911351203918,
    "homePregameElo": 1827,
    "homePostgameElo": 1825,
    "awayId": 8,
    "awayTeam": "Arkansas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 31,
    "awayLineScores": [
      10,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.24200886487960815,
    "awayPregameElo": 1608,
    "awayPostgameElo": 1610,
    "excitementIndex": 6.082855487023981,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762482,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20052,
    "venueId": 3715,
    "venue": "FAU Stadium",
    "homeId": 2226,
    "homeTeam": "Florida Atlantic",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 53,
    "homeLineScores": [
      21,
      14,
      15,
      3
    ],
    "homePostgameWinProbability": 0.9992316961288452,
    "homePregameElo": 1219,
    "homePostgameElo": 1270,
    "awayId": 5,
    "awayTeam": "UAB",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 33,
    "awayLineScores": [
      0,
      14,
      16,
      3
    ],
    "awayPostgameWinProbability": 0.0007683038711547852,
    "awayPregameElo": 1260,
    "awayPostgameElo": 1209,
    "excitementIndex": 2.8893400308088526,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752869,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 76064,
    "venueId": 347,
    "venue": "Camp Randall Stadium",
    "homeId": 275,
    "homeTeam": "Wisconsin",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 0,
    "homeLineScores": [
      0,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1540,
    "homePostgameElo": 1459,
    "awayId": 2294,
    "awayTeam": "Iowa",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 37,
    "awayLineScores": [
      17,
      6,
      7,
      7
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1743,
    "awayPostgameElo": 1824,
    "excitementIndex": 2.1669036104572132,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761623,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15211,
    "venueId": 3654,
    "venue": "Brooks Stadium (SC)",
    "homeId": 324,
    "homeTeam": "Coastal Carolina",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 23,
    "homeLineScores": [
      6,
      10,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9025331735610962,
    "homePregameElo": 1182,
    "homePostgameElo": 1206,
    "awayId": 2433,
    "awayTeam": "UL Monroe",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 8,
    "awayLineScores": [
      0,
      0,
      8,
      0
    ],
    "awayPostgameWinProbability": 0.09746682643890381,
    "awayPregameElo": 1101,
    "awayPostgameElo": 1077,
    "excitementIndex": 3.9665617840012355,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760391,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20970,
    "venueId": 3984,
    "venue": "War Memorial Stadium",
    "homeId": 2751,
    "homeTeam": "Wyoming",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 35,
    "homeLineScores": [
      7,
      7,
      0,
      21
    ],
    "homePostgameWinProbability": 0.48660707473754883,
    "homePregameElo": 1321,
    "homePostgameElo": 1337,
    "awayId": 23,
    "awayTeam": "San José State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 28,
    "awayLineScores": [
      14,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.5133929252624512,
    "awayPregameElo": 1433,
    "awayPostgameElo": 1417,
    "excitementIndex": 6.881816271622111,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752737,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 105086,
    "venueId": 3795,
    "venue": "Kyle Field",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 34,
    "homeLineScores": [
      14,
      7,
      3,
      10
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1782,
    "homePostgameElo": 1808,
    "awayId": 57,
    "awayTeam": "Florida",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      14,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1665,
    "awayPostgameElo": 1639,
    "excitementIndex": 4.316127091314349,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752864,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 49254,
    "venueId": 3953,
    "venue": "Huntington Bank Stadium",
    "homeId": 135,
    "homeTeam": "Minnesota",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 27,
    "homeLineScores": [
      0,
      13,
      0,
      14
    ],
    "homePostgameWinProbability": 0.22984421253204346,
    "homePregameElo": 1537,
    "homePostgameElo": 1534,
    "awayId": 2509,
    "awayTeam": "Purdue",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      10,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.7701557874679565,
    "awayPregameElo": 1311,
    "awayPostgameElo": 1314,
    "excitementIndex": 7.5970265416431575,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752731,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 10,
    "homeLineScores": [
      7,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.47338414192199707,
    "homePregameElo": 1676,
    "homePostgameElo": 1684,
    "awayId": 61,
    "awayTeam": "Georgia",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      3,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.5266158580780029,
    "awayPregameElo": 2033,
    "awayPostgameElo": 2025,
    "excitementIndex": 3.719118907344582,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754558,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 42265,
    "venueId": 3615,
    "venue": "Alumni Stadium (Chestnut Hill, MA)",
    "homeId": 103,
    "homeTeam": "Boston College",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 10,
    "homeLineScores": [
      3,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.016760792583227158,
    "homePregameElo": 1349,
    "homePostgameElo": 1303,
    "awayId": 228,
    "awayTeam": "Clemson",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 41,
    "awayLineScores": [
      10,
      24,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.9832392074167728,
    "awayPregameElo": 1688,
    "awayPostgameElo": 1734,
    "excitementIndex": 3.6232546541892043,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762485,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22058,
    "venueId": 3604,
    "venue": "Alamodome",
    "homeId": 2636,
    "homeTeam": "UTSA",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 61,
    "homeLineScores": [
      21,
      17,
      23,
      0
    ],
    "homePostgameWinProbability": 0.9894030094146729,
    "homePregameElo": 1471,
    "homePostgameElo": 1588,
    "awayId": 242,
    "awayTeam": "Rice",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 13,
    "awayLineScores": [
      3,
      7,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.010596990585327148,
    "awayPregameElo": 1273,
    "awayPostgameElo": 1156,
    "excitementIndex": 3.224471852594717,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756921,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60229,
    "venueId": 3784,
    "venue": "Jones AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 42,
    "homeLineScores": [
      18,
      3,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9723148345947266,
    "homePregameElo": 1785,
    "homePostgameElo": 1835,
    "awayId": 2305,
    "awayTeam": "Kansas",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      17,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.027685165405273438,
    "awayPregameElo": 1671,
    "awayPostgameElo": 1621,
    "excitementIndex": 4.461073915587181,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752868,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 75500,
    "venueId": 477,
    "venue": "Los Angeles Memorial Coliseum",
    "homeId": 30,
    "homeTeam": "USC",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 31,
    "homeLineScores": [
      7,
      7,
      7,
      10
    ],
    "homePostgameWinProbability": 0.980634868144989,
    "homePregameElo": 1865,
    "homePostgameElo": 1904,
    "awayId": 130,
    "awayTeam": "Michigan",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      7,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.019365131855010986,
    "awayPregameElo": 1851,
    "awayPostgameElo": 1812,
    "excitementIndex": 3.745751821245596,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752732,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-11T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 101921,
    "venueId": 3958,
    "venue": "Tiger Stadium (LA)",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 20,
    "homeLineScores": [
      3,
      7,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9308935403823853,
    "homePregameElo": 1751,
    "homePostgameElo": 1763,
    "awayId": 2579,
    "awayTeam": "South Carolina",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 10,
    "awayLineScores": [
      7,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.06910645961761475,
    "awayPregameElo": 1682,
    "awayPostgameElo": 1670,
    "excitementIndex": 5.948422849595579,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761627,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-12T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24369,
    "venueId": 3644,
    "venue": "Bobcat Stadium (TX)",
    "homeId": 326,
    "homeTeam": "Texas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 41,
    "homeLineScores": [
      28,
      3,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0.835141122341156,
    "homePregameElo": 1579,
    "homePostgameElo": 1555,
    "awayId": 2653,
    "awayTeam": "Troy",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 48,
    "awayLineScores": [
      7,
      10,
      10,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.164858877658844,
    "awayPregameElo": 1447,
    "awayPostgameElo": 1471,
    "excitementIndex": 6.582113673903993,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756916,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-12T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 47960,
    "venueId": 3619,
    "venue": "Arizona Stadium",
    "homeId": 12,
    "homeTeam": "Arizona",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 27,
    "homeLineScores": [
      7,
      10,
      0,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0.19142012298107147,
    "homePregameElo": 1467,
    "homePostgameElo": 1473,
    "awayId": 252,
    "awayTeam": "BYU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 33,
    "awayLineScores": [
      14,
      0,
      0,
      10,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.8085798770189285,
    "awayPregameElo": 1701,
    "awayPostgameElo": 1695,
    "excitementIndex": 6.0831665141987035,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760387,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-12T01:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 32982,
    "venueId": 3653,
    "venue": "Albertsons Stadium",
    "homeId": 68,
    "homeTeam": "Boise State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 41,
    "homeLineScores": [
      10,
      7,
      3,
      21
    ],
    "homePostgameWinProbability": 0.9987900853157043,
    "homePregameElo": 1654,
    "homePostgameElo": 1667,
    "awayId": 167,
    "awayTeam": "New Mexico",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 25,
    "awayLineScores": [
      0,
      14,
      3,
      8
    ],
    "awayPostgameWinProbability": 0.0012099146842956543,
    "awayPregameElo": 1416,
    "awayPostgameElo": 1403,
    "excitementIndex": 5.141023063108582,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756922,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-12T02:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 51444,
    "venueId": 587,
    "venue": "Rice-Eccles Stadium",
    "homeId": 254,
    "homeTeam": "Utah",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 42,
    "homeLineScores": [
      7,
      14,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9942936897277832,
    "homePregameElo": 1680,
    "homePostgameElo": 1773,
    "awayId": 9,
    "awayTeam": "Arizona State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.005706310272216797,
    "awayPregameElo": 1722,
    "awayPostgameElo": 1629,
    "excitementIndex": 3.272559133791891,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760390,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-12T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19473,
    "venueId": 3816,
    "venue": "Mackay Stadium",
    "homeId": 2440,
    "homeTeam": "Nevada",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 10,
    "homeLineScores": [
      0,
      0,
      0,
      10
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1259,
    "homePostgameElo": 1188,
    "awayId": 21,
    "awayTeam": "San Diego State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 44,
    "awayLineScores": [
      14,
      21,
      9,
      0
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1463,
    "awayPostgameElo": 1534,
    "excitementIndex": 2.7710207793983725,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760389,
    "season": 2025,
    "week": 7,
    "seasonType": "regular",
    "startDate": "2025-10-12T03:59:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13023,
    "venueId": 7220,
    "venue": "Clarence T.C. Ching Athletics Complex",
    "homeId": 62,
    "homeTeam": "Hawai'i",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 44,
    "homeLineScores": [
      10,
      14,
      3,
      17
    ],
    "homePostgameWinProbability": 0.8678674101829529,
    "homePregameElo": 1280,
    "homePostgameElo": 1335,
    "awayId": 328,
    "awayTeam": "Utah State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 26,
    "awayLineScores": [
      3,
      17,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.13213258981704712,
    "awayPregameElo": 1425,
    "awayPostgameElo": 1370,
    "excitementIndex": 6.965090359565352,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757282,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-14T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16312,
    "venueId": 3992,
    "venue": "Williams Stadium (VA)",
    "homeId": 2335,
    "homeTeam": "Liberty",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 30,
    "homeLineScores": [
      3,
      17,
      0,
      10
    ],
    "homePostgameWinProbability": 0.1893833577632904,
    "homePregameElo": 1426,
    "homePostgameElo": 1424,
    "awayId": 166,
    "awayTeam": "New Mexico State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      6,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.8106166422367096,
    "awayPregameElo": 1229,
    "awayPostgameElo": 1231,
    "excitementIndex": 7.243523951724202,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761628,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-14T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19634,
    "venueId": 6526,
    "venue": "Hancock Whitney Stadium",
    "homeId": 6,
    "homeTeam": "South Alabama",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 14,
    "homeLineScores": [
      7,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.3514746129512787,
    "homePregameElo": 1421,
    "homePostgameElo": 1410,
    "awayId": 2032,
    "awayTeam": "Arkansas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 15,
    "awayLineScores": [
      0,
      3,
      0,
      12
    ],
    "awayPostgameWinProbability": 0.6485253870487213,
    "awayPregameElo": 1224,
    "awayPostgameElo": 1235,
    "excitementIndex": 6.007573581603441,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757281,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-15T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12276,
    "venueId": 3796,
    "venue": "Houchens Industries-L.T. Smith Stadium",
    "homeId": 98,
    "homeTeam": "Western Kentucky",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 6,
    "homeLineScores": [
      3,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.08969080448150635,
    "homePregameElo": 1424,
    "homePostgameElo": 1352,
    "awayId": 2229,
    "awayTeam": "Florida International",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 25,
    "awayLineScores": [
      6,
      13,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.9103091955184937,
    "awayPregameElo": 1216,
    "awayPostgameElo": 1288,
    "excitementIndex": 3.3262775774847855,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757283,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-15T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16884,
    "venueId": 3662,
    "venue": "AmFirst Stadium",
    "homeId": 55,
    "homeTeam": "Jacksonville State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 38,
    "homeLineScores": [
      7,
      14,
      14,
      3
    ],
    "homePostgameWinProbability": 0.9949139356613159,
    "homePregameElo": 1517,
    "homePostgameElo": 1540,
    "awayId": 48,
    "awayTeam": "Delaware",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 25,
    "awayLineScores": [
      0,
      6,
      6,
      13
    ],
    "awayPostgameWinProbability": 0.005086064338684082,
    "awayPregameElo": 1491,
    "awayPostgameElo": 1468,
    "excitementIndex": 3.733978273085511,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757284,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-15T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 4657,
    "venueId": 3631,
    "venue": "BBVA Compass Stadium",
    "homeId": 2534,
    "homeTeam": "Sam Houston",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 17,
    "homeLineScores": [
      7,
      3,
      7,
      0
    ],
    "homePostgameWinProbability": 0.5101594924926758,
    "homePregameElo": 1173,
    "homePostgameElo": 1139,
    "awayId": 2638,
    "awayTeam": "UTEP",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      7,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.4898405075073242,
    "awayPregameElo": 1200,
    "awayPostgameElo": 1234,
    "excitementIndex": 6.415474181610054,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762486,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-16T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 31307,
    "venueId": 3699,
    "venue": "Dowdy-Ficklen Stadium",
    "homeId": 151,
    "homeTeam": "East Carolina",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 41,
    "homeLineScores": [
      10,
      14,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9648906588554382,
    "homePregameElo": 1540,
    "homePostgameElo": 1530,
    "awayId": 202,
    "awayTeam": "Tulsa",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      7,
      3,
      10
    ],
    "awayPostgameWinProbability": 0.03510934114456177,
    "awayPregameElo": 1045,
    "awayPostgameElo": 1055,
    "excitementIndex": 5.419543058010475,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754564,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-17T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 66573,
    "venueId": 3948,
    "venue": "Hard Rock Stadium",
    "homeId": 2390,
    "homeTeam": "Miami",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 21,
    "homeLineScores": [
      7,
      3,
      3,
      8
    ],
    "homePostgameWinProbability": 0.546370267868042,
    "homePregameElo": 1843,
    "homePostgameElo": 1832,
    "awayId": 97,
    "awayTeam": "Louisville",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 24,
    "awayLineScores": [
      14,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.453629732131958,
    "awayPregameElo": 1735,
    "awayPostgameElo": 1746,
    "excitementIndex": 6.084893249932992,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752872,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 48549,
    "venueId": 3953,
    "venue": "Huntington Bank Stadium",
    "homeId": 135,
    "homeTeam": "Minnesota",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      0,
      7,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9812977313995361,
    "homePregameElo": 1534,
    "homePostgameElo": 1592,
    "awayId": 158,
    "awayTeam": "Nebraska",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 6,
    "awayLineScores": [
      3,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.018702268600463867,
    "awayPregameElo": 1699,
    "awayPostgameElo": 1641,
    "excitementIndex": 3.714692951454682,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760396,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22710,
    "venueId": 3905,
    "venue": "Maverik Stadium",
    "homeId": 328,
    "homeTeam": "Utah State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 30,
    "homeLineScores": [
      7,
      3,
      14,
      6
    ],
    "homePostgameWinProbability": 0.4127255976200104,
    "homePregameElo": 1370,
    "homePostgameElo": 1376,
    "awayId": 23,
    "awayTeam": "San José State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 25,
    "awayLineScores": [
      3,
      6,
      10,
      6
    ],
    "awayPostgameWinProbability": 0.5872744023799896,
    "awayPregameElo": 1417,
    "awayPostgameElo": 1411,
    "excitementIndex": 6.966052602794608,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754371,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 33401,
    "venueId": 3831,
    "venue": "California Memorial Stadium",
    "homeId": 25,
    "homeTeam": "California",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 21,
    "homeLineScores": [
      14,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.6961370706558228,
    "homePregameElo": 1408,
    "homePostgameElo": 1408,
    "awayId": 153,
    "awayTeam": "North Carolina",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 18,
    "awayLineScores": [
      7,
      3,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.30386292934417725,
    "awayPregameElo": 1342,
    "awayPostgameElo": 1342,
    "excitementIndex": 5.406837205979555,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754566,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 27846,
    "venueId": 3982,
    "venue": "Wallace Wade Stadium",
    "homeId": 150,
    "homeTeam": "Duke",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 18,
    "homeLineScores": [
      0,
      7,
      3,
      8
    ],
    "homePostgameWinProbability": 0.1293516457080841,
    "homePregameElo": 1645,
    "homePostgameElo": 1622,
    "awayId": 59,
    "awayTeam": "Georgia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      0,
      3,
      17
    ],
    "awayPostgameWinProbability": 0.8706483542919159,
    "awayPregameElo": 1588,
    "awayPostgameElo": 1611,
    "excitementIndex": 5.815864619099065,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752873,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 110701,
    "venueId": 3558,
    "venue": "Michigan Stadium",
    "homeId": 130,
    "homeTeam": "Michigan",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      7,
      0,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9892430901527405,
    "homePregameElo": 1812,
    "homePostgameElo": 1839,
    "awayId": 264,
    "awayTeam": "Washington",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.010756909847259521,
    "awayPregameElo": 1701,
    "awayPostgameElo": 1674,
    "excitementIndex": 4.80158827623924,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756925,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28535,
    "venueId": 4728,
    "venue": "TDECU Stadium",
    "homeId": 248,
    "homeTeam": "Houston",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 31,
    "homeLineScores": [
      7,
      14,
      7,
      3
    ],
    "homePostgameWinProbability": 0.6940749287605286,
    "homePregameElo": 1477,
    "homePostgameElo": 1478,
    "awayId": 12,
    "awayTeam": "Arizona",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 28,
    "awayLineScores": [
      14,
      0,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.30592507123947144,
    "awayPregameElo": 1473,
    "awayPostgameElo": 1472,
    "excitementIndex": 5.720926212231053,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762841,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 6832,
    "venueId": 3996,
    "venue": "Yager Stadium",
    "homeId": 193,
    "homeTeam": "Miami (OH)",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 44,
    "homeLineScores": [
      7,
      14,
      7,
      16
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1440,
    "homePostgameElo": 1449,
    "awayId": 2199,
    "awayTeam": "Eastern Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 30,
    "awayLineScores": [
      0,
      14,
      0,
      16
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1213,
    "awayPostgameElo": 1204,
    "excitementIndex": 3.8024699008900793,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754569,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 38917,
    "venueId": 3615,
    "venue": "Alumni Stadium (Chestnut Hill, MA)",
    "homeId": 103,
    "homeTeam": "Boston College",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 23,
    "homeLineScores": [
      6,
      14,
      0,
      3
    ],
    "homePostgameWinProbability": 0.33645644783973694,
    "homePregameElo": 1303,
    "homePostgameElo": 1291,
    "awayId": 41,
    "awayTeam": "UConn",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      10,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.6635435521602631,
    "awayPregameElo": 1541,
    "awayPostgameElo": 1553,
    "excitementIndex": 5.78784419663085,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762488,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20027,
    "venueId": 4729,
    "venue": "Yulman Stadium",
    "homeId": 2655,
    "homeTeam": "Tulane",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 24,
    "homeLineScores": [
      0,
      3,
      7,
      14
    ],
    "homePostgameWinProbability": 0.7129696011543274,
    "homePregameElo": 1580,
    "homePostgameElo": 1588,
    "awayId": 349,
    "awayTeam": "Army",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      3,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.2870303988456726,
    "awayPregameElo": 1552,
    "awayPostgameElo": 1544,
    "excitementIndex": 6.688072236737706,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752745,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 35000,
    "venueId": 3973,
    "venue": "FirstBank Stadium",
    "homeId": 238,
    "homeTeam": "Vanderbilt",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 31,
    "homeLineScores": [
      7,
      10,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9919131994247437,
    "homePregameElo": 1742,
    "homePostgameElo": 1753,
    "awayId": 99,
    "awayTeam": "LSU",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      10,
      8,
      3
    ],
    "awayPostgameWinProbability": 0.008086800575256348,
    "awayPregameElo": 1763,
    "awayPostgameElo": 1752,
    "excitementIndex": 5.302299198534081,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762839,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23105,
    "venueId": 3700,
    "venue": "Doyt L. Perry Stadium",
    "homeId": 189,
    "homeTeam": "Bowling Green",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 6,
    "homeLineScores": [
      3,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.005095717031508684,
    "homePregameElo": 1422,
    "homePostgameElo": 1329,
    "awayId": 2117,
    "awayTeam": "Central Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      17,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.9949042829684913,
    "awayPregameElo": 1110,
    "awayPostgameElo": 1203,
    "excitementIndex": 3.6125295218185793,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756927,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 43868,
    "venueId": 3616,
    "venue": "Amon G. Carter Stadium",
    "homeId": 2628,
    "homeTeam": "TCU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 42,
    "homeLineScores": [
      0,
      21,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9653722643852234,
    "homePregameElo": 1718,
    "homePostgameElo": 1719,
    "awayId": 239,
    "awayTeam": "Baylor",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 36,
    "awayLineScores": [
      7,
      3,
      8,
      18
    ],
    "awayPostgameWinProbability": 0.03462773561477661,
    "awayPregameElo": 1593,
    "awayPostgameElo": 1592,
    "excitementIndex": 5.02281994453435,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752744,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 78680,
    "venueId": 3994,
    "venue": "Williams-Brice Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 7,
    "homeLineScores": [
      0,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.012702463194727898,
    "homePregameElo": 1670,
    "homePostgameElo": 1630,
    "awayId": 201,
    "awayTeam": "Oklahoma",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 26,
    "awayLineScores": [
      7,
      7,
      10,
      2
    ],
    "awayPostgameWinProbability": 0.9872975368052721,
    "awayPregameElo": 1741,
    "awayPostgameElo": 1781,
    "excitementIndex": 4.715052118463295,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756928,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 43445,
    "venueId": 3652,
    "venue": "FBC Mortgage Stadium",
    "homeId": 2116,
    "homeTeam": "UCF",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 45,
    "homeLineScores": [
      14,
      0,
      21,
      10
    ],
    "homePostgameWinProbability": 0.9578840732574463,
    "homePregameElo": 1555,
    "homePostgameElo": 1616,
    "awayId": 277,
    "awayTeam": "West Virginia",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      7,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.04211592674255371,
    "awayPregameElo": 1342,
    "awayPostgameElo": 1281,
    "excitementIndex": 4.458347202379033,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762842,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18417,
    "venueId": 3739,
    "venue": "Glass Bowl",
    "homeId": 2649,
    "homeTeam": "Toledo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 45,
    "homeLineScores": [
      7,
      10,
      21,
      7
    ],
    "homePostgameWinProbability": 0.9920244216918945,
    "homePregameElo": 1551,
    "homePostgameElo": 1579,
    "awayId": 2309,
    "awayTeam": "Kent State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 10,
    "awayLineScores": [
      10,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.007975578308105469,
    "awayPregameElo": 966,
    "awayPostgameElo": 938,
    "excitementIndex": 4.250967090349852,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762840,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T18:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15239,
    "venueId": 3985,
    "venue": "Warren McGuirk Alumni Stadium",
    "homeId": 113,
    "homeTeam": "Massachusetts",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 21,
    "homeLineScores": [
      0,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.5642518997192383,
    "homePregameElo": 889,
    "homePostgameElo": 910,
    "awayId": 2084,
    "awayTeam": "Buffalo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 28,
    "awayLineScores": [
      3,
      7,
      10,
      8
    ],
    "awayPostgameWinProbability": 0.4357481002807617,
    "awayPregameElo": 1377,
    "awayPostgameElo": 1356,
    "excitementIndex": 6.595531852666956,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761633,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16863,
    "venueId": 3817,
    "venue": "Malone Stadium",
    "homeId": 2433,
    "homeTeam": "UL Monroe",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 14,
    "homeLineScores": [
      0,
      8,
      6,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1077,
    "homePostgameElo": 1060,
    "awayId": 2653,
    "awayTeam": "Troy",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 37,
    "awayLineScores": [
      10,
      7,
      10,
      10
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1471,
    "awayPostgameElo": 1488,
    "excitementIndex": 5.693478891724538,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752874,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12023,
    "venueId": 5960,
    "venue": "Lanny and Sharon Martin Stadium",
    "homeId": 77,
    "homeTeam": "Northwestern",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 19,
    "homeLineScores": [
      3,
      10,
      6,
      0
    ],
    "homePostgameWinProbability": 0.9686245322227478,
    "homePregameElo": 1510,
    "homePostgameElo": 1534,
    "awayId": 2509,
    "awayTeam": "Purdue",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0313754677772522,
    "awayPregameElo": 1314,
    "awayPostgameElo": 1290,
    "excitementIndex": 3.428001164512284,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762843,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22293,
    "venueId": 3876,
    "venue": "Peden Stadium",
    "homeId": 195,
    "homeTeam": "Ohio",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 48,
    "homeLineScores": [
      14,
      7,
      13,
      14
    ],
    "homePostgameWinProbability": 0.992224931716919,
    "homePregameElo": 1568,
    "homePostgameElo": 1612,
    "awayId": 2459,
    "awayTeam": "Northern Illinois",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      8,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.007775068283081055,
    "awayPregameElo": 1341,
    "awayPostgameElo": 1297,
    "excitementIndex": 3.138666629025117,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761631,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25232,
    "venueId": 3651,
    "venue": "Bridgeforth Stadium",
    "homeId": 256,
    "homeTeam": "James Madison",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 63,
    "homeLineScores": [
      14,
      14,
      21,
      14
    ],
    "homePostgameWinProbability": 0.9325857758522034,
    "homePregameElo": 1643,
    "homePostgameElo": 1733,
    "awayId": 295,
    "awayTeam": "Old Dominion",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 27,
    "awayLineScores": [
      20,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.06741422414779663,
    "awayPregameElo": 1554,
    "awayPostgameElo": 1464,
    "excitementIndex": 5.507113326122281,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760392,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23401,
    "venueId": 3713,
    "venue": "Falcon Stadium",
    "homeId": 2005,
    "homeTeam": "Air Force",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 24,
    "homeLineScores": [
      3,
      3,
      8,
      10
    ],
    "homePostgameWinProbability": 0.6241727471351624,
    "homePregameElo": 1354,
    "homePostgameElo": 1355,
    "awayId": 2751,
    "awayTeam": "Wyoming",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.37582725286483765,
    "awayPregameElo": 1337,
    "awayPostgameElo": 1336,
    "excitementIndex": 6.22586072967788,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762838,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12248,
    "venueId": 3919,
    "venue": "Scheumann Stadium",
    "homeId": 2050,
    "homeTeam": "Ball State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 42,
    "homeLineScores": [
      14,
      0,
      14,
      14
    ],
    "homePostgameWinProbability": 0.7704926133155823,
    "homePregameElo": 1028,
    "homePostgameElo": 1055,
    "awayId": 2006,
    "awayTeam": "Akron",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 28,
    "awayLineScores": [
      8,
      7,
      10,
      3
    ],
    "awayPostgameWinProbability": 0.22950738668441772,
    "awayPregameElo": 1018,
    "awayPostgameElo": 991,
    "excitementIndex": 7.117811898214637,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762491,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25053,
    "venueId": 3825,
    "venue": "DATCU Stadium",
    "homeId": 249,
    "homeTeam": "North Texas",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 55,
    "homeLineScores": [
      17,
      7,
      21,
      10
    ],
    "homePostgameWinProbability": 0.9809975028038025,
    "homePregameElo": 1530,
    "homePostgameElo": 1648,
    "awayId": 2636,
    "awayTeam": "UTSA",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.01900249719619751,
    "awayPregameElo": 1588,
    "awayPostgameElo": 1470,
    "excitementIndex": 4.681517913552595,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752877,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 72795,
    "venueId": 347,
    "venue": "Camp Randall Stadium",
    "homeId": 275,
    "homeTeam": "Wisconsin",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 0,
    "homeLineScores": [
      0,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.041887398809194565,
    "homePregameElo": 1459,
    "homePostgameElo": 1435,
    "awayId": 194,
    "awayTeam": "Ohio State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 34,
    "awayLineScores": [
      17,
      0,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.9581126011908054,
    "awayPregameElo": 2074,
    "awayPostgameElo": 2098,
    "excitementIndex": 2.6917223168852957,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752739,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 73845,
    "venueId": 3887,
    "venue": "Razorback Stadium",
    "homeId": 8,
    "homeTeam": "Arkansas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 42,
    "homeLineScores": [
      3,
      17,
      7,
      15
    ],
    "homePostgameWinProbability": 0.3126192092895508,
    "homePregameElo": 1610,
    "homePostgameElo": 1617,
    "awayId": 245,
    "awayTeam": "Texas A&M",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 45,
    "awayLineScores": [
      7,
      14,
      17,
      7
    ],
    "awayPostgameWinProbability": 0.6873807907104492,
    "awayPregameElo": 1808,
    "awayPostgameElo": 1801,
    "excitementIndex": 7.050104190802901,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754565,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 78669,
    "venueId": 3836,
    "venue": "Memorial Stadium (Clemson, SC)",
    "homeId": 228,
    "homeTeam": "Clemson",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 24,
    "homeLineScores": [
      0,
      7,
      10,
      7
    ],
    "homePostgameWinProbability": 0.5791419744491577,
    "homePregameElo": 1734,
    "homePostgameElo": 1708,
    "awayId": 2567,
    "awayTeam": "SMU",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      9,
      7,
      12
    ],
    "awayPostgameWinProbability": 0.4208580255508423,
    "awayPregameElo": 1709,
    "awayPostgameElo": 1735,
    "excitementIndex": 5.469391383562523,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761632,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 27533,
    "venueId": 3775,
    "venue": "Joan C. Edwards Stadium",
    "homeId": 276,
    "homeTeam": "Marshall",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 40,
    "homeLineScores": [
      7,
      6,
      3,
      11,
      7,
      6
    ],
    "homePostgameWinProbability": 0.5277658104896545,
    "homePregameElo": 1582,
    "homePostgameElo": 1583,
    "awayId": 326,
    "awayTeam": "Texas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 37,
    "awayLineScores": [
      7,
      10,
      0,
      10,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.47223418951034546,
    "awayPregameElo": 1555,
    "awayPostgameElo": 1554,
    "excitementIndex": 13.192992307572979,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760393,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 32927,
    "venueId": 3653,
    "venue": "Albertsons Stadium",
    "homeId": 68,
    "homeTeam": "Boise State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 56,
    "homeLineScores": [
      14,
      14,
      21,
      7
    ],
    "homePostgameWinProbability": 0.9625915288925171,
    "homePregameElo": 1667,
    "homePostgameElo": 1725,
    "awayId": 2439,
    "awayTeam": "UNLV",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 31,
    "awayLineScores": [
      3,
      21,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.03740847110748291,
    "awayPregameElo": 1625,
    "awayPostgameElo": 1567,
    "excitementIndex": 4.723304037346108,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761629,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 33862,
    "venueId": 3792,
    "venue": "Kidd Brewer Stadium",
    "homeId": 2026,
    "homeTeam": "App State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 37,
    "homeLineScores": [
      14,
      10,
      10,
      3
    ],
    "homePostgameWinProbability": 0.2807023227214813,
    "homePregameElo": 1360,
    "homePostgameElo": 1331,
    "awayId": 324,
    "awayTeam": "Coastal Carolina",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 45,
    "awayLineScores": [
      10,
      7,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.7192976772785187,
    "awayPregameElo": 1206,
    "awayPostgameElo": 1235,
    "excitementIndex": 5.483124376722729,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762489,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13618,
    "venueId": 4418,
    "venue": "Jerry Richardson Stadium",
    "homeId": 2429,
    "homeTeam": "Charlotte",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 14,
    "homeLineScores": [
      7,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.0009986907243728638,
    "homePregameElo": 1143,
    "homePostgameElo": 1054,
    "awayId": 218,
    "awayTeam": "Temple",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 49,
    "awayLineScores": [
      7,
      21,
      21,
      0
    ],
    "awayPostgameWinProbability": 0.9990013092756271,
    "awayPregameElo": 1241,
    "awayPostgameElo": 1330,
    "excitementIndex": 3.3193001555565673,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752742,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 93033,
    "venueId": 3917,
    "venue": "Sanford Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 43,
    "homeLineScores": [
      3,
      17,
      6,
      17
    ],
    "homePostgameWinProbability": 0.8781432509422302,
    "homePregameElo": 2025,
    "homePostgameElo": 2034,
    "awayId": 145,
    "awayTeam": "Ole Miss",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      14,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.12185674905776978,
    "awayPregameElo": 1971,
    "awayPostgameElo": 1962,
    "excitementIndex": 7.5134351342636005,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752878,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 55165,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      7,
      14,
      14,
      3
    ],
    "homePostgameWinProbability": 0.9220895767211914,
    "homePregameElo": 2022,
    "homePostgameElo": 2017,
    "awayId": 127,
    "awayTeam": "Michigan State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 13,
    "awayLineScores": [
      3,
      7,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.0779104232788086,
    "awayPregameElo": 1343,
    "awayPostgameElo": 1348,
    "excitementIndex": 4.408103535343244,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756923,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 54177,
    "venueId": 3947,
    "venue": "Mountain America Stadium",
    "homeId": 9,
    "homeTeam": "Arizona State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 26,
    "homeLineScores": [
      3,
      6,
      7,
      10
    ],
    "homePostgameWinProbability": 0.6207810640335083,
    "homePregameElo": 1629,
    "homePostgameElo": 1638,
    "awayId": 2641,
    "awayTeam": "Texas Tech",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 22,
    "awayLineScores": [
      0,
      7,
      0,
      15
    ],
    "awayPostgameWinProbability": 0.3792189359664917,
    "awayPregameElo": 1835,
    "awayPostgameElo": 1826,
    "excitementIndex": 8.938142610637891,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762487,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19037,
    "venueId": 7221,
    "venue": "Protective Stadium",
    "homeId": 5,
    "homeTeam": "UAB",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 31,
    "homeLineScores": [
      7,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9770079255104065,
    "homePregameElo": 1209,
    "homePostgameElo": 1252,
    "awayId": 235,
    "awayTeam": "Memphis",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      7,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.022992074489593506,
    "awayPregameElo": 1723,
    "awayPostgameElo": 1680,
    "excitementIndex": 6.516770535855644,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752741,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 90203,
    "venueId": 3634,
    "venue": "Ben Hill Griffin Stadium",
    "homeId": 57,
    "homeTeam": "Florida",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 23,
    "homeLineScores": [
      3,
      10,
      0,
      10
    ],
    "homePostgameWinProbability": 0.7101824283599854,
    "homePregameElo": 1639,
    "homePostgameElo": 1638,
    "awayId": 344,
    "awayTeam": "Mississippi State",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.28981757164001465,
    "awayPregameElo": 1494,
    "awayPostgameElo": 1495,
    "excitementIndex": 6.916557826100512,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761668,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21047,
    "venueId": 3666,
    "venue": "Cajun Field",
    "homeId": 309,
    "homeTeam": "Louisiana",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 10,
    "homeLineScores": [
      7,
      0,
      3,
      0
    ],
    "homePostgameWinProbability": 0.4602220058441162,
    "homePregameElo": 1369,
    "homePostgameElo": 1333,
    "awayId": 2572,
    "awayTeam": "Southern Miss",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 22,
    "awayLineScores": [
      0,
      13,
      7,
      2
    ],
    "awayPostgameWinProbability": 0.5397779941558838,
    "awayPregameElo": 1273,
    "awayPostgameElo": 1309,
    "excitementIndex": 4.490560801194364,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752876,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T22:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53127,
    "venueId": 6577,
    "venue": "SHI Stadium",
    "homeId": 164,
    "homeTeam": "Rutgers",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 10,
    "homeLineScores": [
      3,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.06056581810116768,
    "homePregameElo": 1547,
    "homePostgameElo": 1468,
    "awayId": 2483,
    "awayTeam": "Oregon",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 56,
    "awayLineScores": [
      14,
      28,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.9394341818988323,
    "awayPregameElo": 1996,
    "awayPostgameElo": 2075,
    "excitementIndex": 2.8655127929578694,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752951,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T22:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 56048,
    "venueId": 3923,
    "venue": "Scott Stadium",
    "homeId": 258,
    "homeTeam": "Virginia",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 22,
    "homeLineScores": [
      7,
      0,
      3,
      12
    ],
    "homePostgameWinProbability": 0.4096009433269501,
    "homePregameElo": 1593,
    "homePostgameElo": 1590,
    "awayId": 265,
    "awayTeam": "Washington State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      10,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.5903990566730499,
    "awayPregameElo": 1361,
    "awayPostgameElo": 1364,
    "excitementIndex": 6.0728203483249565,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752743,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60937,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 13,
    "homeLineScores": [
      0,
      0,
      3,
      10,
      0
    ],
    "homePostgameWinProbability": 0.6674437522888184,
    "homePregameElo": 1513,
    "homePostgameElo": 1533,
    "awayId": 251,
    "awayTeam": "Texas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      7,
      3,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.33255624771118164,
    "awayPregameElo": 1964,
    "awayPostgameElo": 1944,
    "excitementIndex": 6.724882670426927,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752875,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 69250,
    "venueId": 3793,
    "venue": "Kinnick Stadium",
    "homeId": 2294,
    "homeTeam": "Iowa",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 25,
    "homeLineScores": [
      3,
      7,
      6,
      9
    ],
    "homePostgameWinProbability": 0.7258291840553284,
    "homePregameElo": 1824,
    "homePostgameElo": 1830,
    "awayId": 213,
    "awayTeam": "Penn State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      7,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.27417081594467163,
    "awayPregameElo": 1996,
    "awayPostgameElo": 1990,
    "excitementIndex": 6.271060684846177,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752879,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 35561,
    "venueId": 1056,
    "venue": "Rose Bowl",
    "homeId": 26,
    "homeTeam": "UCLA",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 20,
    "homeLineScores": [
      0,
      7,
      0,
      13
    ],
    "homePostgameWinProbability": 0.38513466715812683,
    "homePregameElo": 1445,
    "homePostgameElo": 1448,
    "awayId": 120,
    "awayTeam": "Maryland",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      3,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.6148653328418732,
    "awayPregameElo": 1576,
    "awayPostgameElo": 1573,
    "excitementIndex": 8.336534365982493,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760394,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 40416,
    "venueId": 5388,
    "venue": "Canvas Stadium",
    "homeId": 36,
    "homeTeam": "Colorado State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 19,
    "homeLineScores": [
      7,
      0,
      0,
      12
    ],
    "homePostgameWinProbability": 0.04967927187681198,
    "homePregameElo": 1384,
    "homePostgameElo": 1353,
    "awayId": 62,
    "awayTeam": "Hawai'i",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      7,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.950320728123188,
    "awayPregameElo": 1335,
    "awayPostgameElo": 1366,
    "excitementIndex": 5.144720454505094,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761630,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25428,
    "venueId": 3608,
    "venue": "Allen E. Paulson Stadium",
    "homeId": 290,
    "homeTeam": "Georgia Southern",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 41,
    "homeLineScores": [
      3,
      10,
      7,
      21
    ],
    "homePostgameWinProbability": 0.803580105304718,
    "homePregameElo": 1316,
    "homePostgameElo": 1335,
    "awayId": 2247,
    "awayTeam": "Georgia State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.19641989469528198,
    "awayPregameElo": 1116,
    "awayPostgameElo": 1097,
    "excitementIndex": 6.5047485621923276,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762490,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 45169,
    "venueId": 3886,
    "venue": "Raymond James Stadium",
    "homeId": 58,
    "homeTeam": "South Florida",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 48,
    "homeLineScores": [
      7,
      14,
      10,
      17
    ],
    "homePostgameWinProbability": 0.9991554617881775,
    "homePregameElo": 1607,
    "homePostgameElo": 1663,
    "awayId": 2226,
    "awayTeam": "Florida Atlantic",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 13,
    "awayLineScores": [
      3,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0008445382118225098,
    "awayPregameElo": 1270,
    "awayPostgameElo": 1214,
    "excitementIndex": 4.3790154909636065,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754568,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 40772,
    "venueId": 1964,
    "venue": "JMA Wireless Dome",
    "homeId": 183,
    "homeTeam": "Syracuse",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 13,
    "homeLineScores": [
      7,
      0,
      0,
      6
    ],
    "homePostgameWinProbability": 0.4238635003566742,
    "homePregameElo": 1422,
    "homePostgameElo": 1402,
    "awayId": 221,
    "awayTeam": "Pittsburgh",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 30,
    "awayLineScores": [
      7,
      10,
      3,
      10
    ],
    "awayPostgameWinProbability": 0.5761364996433258,
    "awayPregameElo": 1625,
    "awayPostgameElo": 1645,
    "excitementIndex": 4.623256562987445,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752871,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 77622,
    "venueId": 3855,
    "venue": "Notre Dame Stadium",
    "homeId": 87,
    "homeTeam": "Notre Dame",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 34,
    "homeLineScores": [
      7,
      7,
      13,
      7
    ],
    "homePostgameWinProbability": 0.9810776710510254,
    "homePregameElo": 2196,
    "homePostgameElo": 2193,
    "awayId": 30,
    "awayTeam": "USC",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 24,
    "awayLineScores": [
      10,
      3,
      11,
      0
    ],
    "awayPostgameWinProbability": 0.01892232894897461,
    "awayPregameElo": 1904,
    "awayPostgameElo": 1907,
    "excitementIndex": 6.843850667589161,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752738,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 100077,
    "venueId": 3657,
    "venue": "Bryant-Denny Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 37,
    "homeLineScores": [
      7,
      16,
      7,
      7
    ],
    "homePostgameWinProbability": 0.8085278272628784,
    "homePregameElo": 1967,
    "homePostgameElo": 1991,
    "awayId": 2633,
    "awayTeam": "Tennessee",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      7,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.19147217273712158,
    "awayPregameElo": 1825,
    "awayPostgameElo": 1801,
    "excitementIndex": 4.577807755089341,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752740,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-18T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 17,
    "homeLineScores": [
      7,
      0,
      7,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.3749648630619049,
    "homePregameElo": 1684,
    "homePostgameElo": 1681,
    "awayId": 142,
    "awayTeam": "Missouri",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 23,
    "awayLineScores": [
      3,
      7,
      0,
      7,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.6250351369380951,
    "awayPregameElo": 1788,
    "awayPostgameElo": 1791,
    "excitementIndex": 6.324503035415732,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756924,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-19T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 64794,
    "venueId": 3801,
    "venue": "LaVell Edwards Stadium",
    "homeId": 252,
    "homeTeam": "BYU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 24,
    "homeLineScores": [
      0,
      10,
      0,
      14
    ],
    "homePostgameWinProbability": 0.4821137487888336,
    "homePregameElo": 1695,
    "homePostgameElo": 1697,
    "awayId": 254,
    "awayTeam": "Utah",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.5178862512111664,
    "awayPregameElo": 1773,
    "awayPostgameElo": 1771,
    "excitementIndex": 6.74254611063529,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756926,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-19T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 46901,
    "venueId": 3646,
    "venue": "Boone Pickens Stadium",
    "homeId": 197,
    "homeTeam": "Oklahoma State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 17,
    "homeLineScores": [
      3,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.0426059365272522,
    "homePregameElo": 1107,
    "homePostgameElo": 1071,
    "awayId": 2132,
    "awayTeam": "Cincinnati",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 49,
    "awayLineScores": [
      7,
      21,
      0,
      21
    ],
    "awayPostgameWinProbability": 0.9573940634727478,
    "awayPregameElo": 1558,
    "awayPostgameElo": 1594,
    "excitementIndex": 4.321065221154091,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760395,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-19T01:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18233,
    "venueId": 3971,
    "venue": "University Stadium (NM)",
    "homeId": 167,
    "homeTeam": "New Mexico",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 24,
    "homeLineScores": [
      7,
      7,
      10,
      0
    ],
    "homePostgameWinProbability": 0.5816745758056641,
    "homePregameElo": 1403,
    "homePostgameElo": 1401,
    "awayId": 2440,
    "awayTeam": "Nevada",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 22,
    "awayLineScores": [
      3,
      9,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.41832542419433594,
    "awayPregameElo": 1188,
    "awayPostgameElo": 1190,
    "excitementIndex": 6.3799854516551004,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752941,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-19T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 27735,
    "venueId": 3893,
    "venue": "Reser Stadium",
    "homeId": 204,
    "homeTeam": "Oregon State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 45,
    "homeLineScores": [
      3,
      7,
      21,
      14
    ],
    "homePostgameWinProbability": 0.9941145181655884,
    "homePregameElo": 1237,
    "homePostgameElo": 1237,
    "awayId": 322,
    "awayTeam": "Lafayette",
    "awayClassification": "fcs",
    "awayConference": "Patriot",
    "awayPoints": 13,
    "awayLineScores": [
      3,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.005885481834411621,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 5.1870392139732076,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754567,
    "season": 2025,
    "week": 8,
    "seasonType": "regular",
    "startDate": "2025-10-19T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 26470,
    "venueId": 3940,
    "venue": "Stanford Stadium",
    "homeId": 24,
    "homeTeam": "Stanford",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 20,
    "homeLineScores": [
      3,
      10,
      7,
      0
    ],
    "homePostgameWinProbability": 0.6373603940010071,
    "homePregameElo": 1241,
    "homePostgameElo": 1271,
    "awayId": 52,
    "awayTeam": "Florida State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      10,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.3626396059989929,
    "awayPregameElo": 1572,
    "awayPostgameElo": 1542,
    "excitementIndex": 5.066575309309328,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757285,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-21T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12133,
    "venueId": 2031,
    "venue": "Pitbull Stadium",
    "homeId": 2229,
    "homeTeam": "Florida International",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 26,
    "homeLineScores": [
      7,
      7,
      3,
      9
    ],
    "homePostgameWinProbability": 0.1251012533903122,
    "homePregameElo": 1288,
    "homePostgameElo": 1246,
    "awayId": 338,
    "awayTeam": "Kennesaw State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 45,
    "awayLineScores": [
      14,
      10,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.8748987466096878,
    "awayPregameElo": 1332,
    "awayPostgameElo": 1374,
    "excitementIndex": 4.216063643104564,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757286,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-21T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10928,
    "venueId": 3776,
    "venue": "Joe Aillet Stadium",
    "homeId": 2348,
    "homeTeam": "Louisiana Tech",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 27,
    "homeLineScores": [
      7,
      0,
      7,
      6,
      7
    ],
    "homePostgameWinProbability": 0.7236899137496948,
    "homePregameElo": 1381,
    "homePostgameElo": 1378,
    "awayId": 98,
    "awayTeam": "Western Kentucky",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 28,
    "awayLineScores": [
      10,
      10,
      0,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.2763100862503052,
    "awayPregameElo": 1352,
    "awayPostgameElo": 1355,
    "excitementIndex": 9.038273739815125,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757287,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-22T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14102,
    "venueId": 3695,
    "venue": "Delaware Stadium",
    "homeId": 48,
    "homeTeam": "Delaware",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 31,
    "homeLineScores": [
      7,
      17,
      7,
      0
    ],
    "homePostgameWinProbability": 0.7728374600410461,
    "homePregameElo": 1468,
    "homePostgameElo": 1465,
    "awayId": 2393,
    "awayTeam": "Middle Tennessee",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 28,
    "awayLineScores": [
      14,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.22716253995895386,
    "awayPregameElo": 1181,
    "awayPostgameElo": 1184,
    "excitementIndex": 6.950549816744317,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757288,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-23T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 8790,
    "venueId": 3601,
    "venue": "Aggie Memorial Stadium",
    "homeId": 166,
    "homeTeam": "New Mexico State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 17,
    "homeLineScores": [
      0,
      7,
      0,
      10,
      0
    ],
    "homePostgameWinProbability": 0.46374601125717163,
    "homePregameElo": 1231,
    "homePostgameElo": 1225,
    "awayId": 2623,
    "awayTeam": "Missouri State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      0,
      10,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.5362539887428284,
    "awayPregameElo": 1329,
    "awayPostgameElo": 1335,
    "excitementIndex": 7.537797642472893,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761634,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-23T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13673,
    "venueId": 4246,
    "venue": "Center Parc Stadium",
    "homeId": 2247,
    "homeTeam": "Georgia State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 31,
    "homeLineScores": [
      14,
      0,
      3,
      14
    ],
    "homePostgameWinProbability": 0.07349050790071487,
    "homePregameElo": 1097,
    "homePostgameElo": 1107,
    "awayId": 6,
    "awayTeam": "South Alabama",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 38,
    "awayLineScores": [
      21,
      7,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.9265094920992851,
    "awayPregameElo": 1410,
    "awayPostgameElo": 1400,
    "excitementIndex": 6.390908995027831,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762492,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-24T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9626,
    "venueId": 4418,
    "venue": "Jerry Richardson Stadium",
    "homeId": 2429,
    "homeTeam": "Charlotte",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 20,
    "homeLineScores": [
      10,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0.20414631068706512,
    "homePregameElo": 1054,
    "homePostgameElo": 1028,
    "awayId": 249,
    "awayTeam": "North Texas",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 54,
    "awayLineScores": [
      7,
      10,
      10,
      27
    ],
    "awayPostgameWinProbability": 0.7958536893129349,
    "awayPregameElo": 1648,
    "awayPostgameElo": 1674,
    "excitementIndex": 5.201038363476169,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754372,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-24T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53837,
    "venueId": 3799,
    "venue": "Lane Stadium",
    "homeId": 259,
    "homeTeam": "Virginia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 42,
    "homeLineScores": [
      10,
      0,
      10,
      7,
      7,
      8
    ],
    "homePostgameWinProbability": 0.8125044703483582,
    "homePregameElo": 1419,
    "homePostgameElo": 1430,
    "awayId": 25,
    "awayTeam": "California",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      3,
      17,
      0,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.18749552965164185,
    "awayPregameElo": 1408,
    "awayPostgameElo": 1397,
    "excitementIndex": 11.999217742937725,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760397,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18029,
    "venueId": 3816,
    "venue": "Mackay Stadium",
    "homeId": 2440,
    "homeTeam": "Nevada",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 3,
    "homeLineScores": [
      3,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.01033131591975689,
    "homePregameElo": 1190,
    "homePostgameElo": 1191,
    "awayId": 68,
    "awayTeam": "Boise State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9896686840802431,
    "awayPregameElo": 1725,
    "awayPostgameElo": 1724,
    "excitementIndex": 5.885370695021587,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762848,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15985,
    "venueId": 3912,
    "venue": "Rynearson Stadium",
    "homeId": 2199,
    "homeTeam": "Eastern Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 21,
    "homeLineScores": [
      14,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.1510891616344452,
    "homePregameElo": 1204,
    "homePostgameElo": 1220,
    "awayId": 195,
    "awayTeam": "Ohio",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      0,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.8489108383655548,
    "awayPregameElo": 1612,
    "awayPostgameElo": 1596,
    "excitementIndex": 5.532686554097608,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756932,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": null,
    "venueId": 3833,
    "venue": "Memorial Stadium",
    "homeId": 2305,
    "homeTeam": "Kansas",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 17,
    "homeLineScores": [
      7,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0.24458609521389008,
    "homePregameElo": 1621,
    "homePostgameElo": 1563,
    "awayId": 2306,
    "awayTeam": "Kansas State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 42,
    "awayLineScores": [
      21,
      0,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.7554139047861099,
    "awayPregameElo": 1695,
    "awayPostgameElo": 1753,
    "excitementIndex": 4.163411187007522,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754573,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50500,
    "venueId": 3787,
    "venue": "Kenan Stadium",
    "homeId": 153,
    "homeTeam": "North Carolina",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 16,
    "homeLineScores": [
      0,
      10,
      0,
      0,
      6
    ],
    "homePostgameWinProbability": 0.5519071817398071,
    "homePregameElo": 1342,
    "homePostgameElo": 1352,
    "awayId": 258,
    "awayTeam": "Virginia",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 17,
    "awayLineScores": [
      3,
      7,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.44809281826019287,
    "awayPregameElo": 1590,
    "awayPostgameElo": 1580,
    "excitementIndex": 7.587525597139318,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761635,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18097,
    "venueId": 3918,
    "venue": "S.B. Ballard Stadium",
    "homeId": 295,
    "homeTeam": "Old Dominion",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 24,
    "homeLineScores": [
      7,
      3,
      14,
      0
    ],
    "homePostgameWinProbability": 0.6012321710586548,
    "homePregameElo": 1464,
    "homePostgameElo": 1463,
    "awayId": 2026,
    "awayTeam": "App State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.3987678289413452,
    "awayPregameElo": 1331,
    "awayPostgameElo": 1332,
    "excitementIndex": 5.274537527076779,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754571,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 51913,
    "venueId": 721,
    "venue": "Bobby Dodd Stadium",
    "homeId": 59,
    "homeTeam": "Georgia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 41,
    "homeLineScores": [
      3,
      17,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9990342259407043,
    "homePregameElo": 1611,
    "homePostgameElo": 1651,
    "awayId": 183,
    "awayTeam": "Syracuse",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 16,
    "awayLineScores": [
      3,
      0,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.0009657740592956543,
    "awayPregameElo": 1402,
    "awayPostgameElo": 1362,
    "excitementIndex": 4.24847225813943,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752883,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 86401,
    "venueId": 3834,
    "venue": "Memorial Stadium (Lincoln, NE)",
    "homeId": 158,
    "homeTeam": "Nebraska",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 28,
    "homeLineScores": [
      7,
      0,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9840260148048401,
    "homePregameElo": 1641,
    "homePostgameElo": 1645,
    "awayId": 77,
    "awayTeam": "Northwestern",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 21,
    "awayLineScores": [
      3,
      3,
      7,
      8
    ],
    "awayPostgameWinProbability": 0.015973985195159912,
    "awayPregameElo": 1534,
    "awayPostgameElo": 1530,
    "excitementIndex": 5.580519247770252,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752942,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28358,
    "venueId": 3630,
    "venue": "Allegacy Federal Credit Union Stadium",
    "homeId": 154,
    "homeTeam": "Wake Forest",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 13,
    "homeLineScores": [
      3,
      7,
      0,
      3
    ],
    "homePostgameWinProbability": 0.7575358748435974,
    "homePregameElo": 1463,
    "homePostgameElo": 1471,
    "awayId": 2567,
    "awayTeam": "SMU",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 12,
    "awayLineScores": [
      0,
      6,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.2424641251564026,
    "awayPregameElo": 1735,
    "awayPostgameElo": 1727,
    "excitementIndex": 8.142501079561848,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752750,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 83468,
    "venueId": 3835,
    "venue": "Memorial Stadium (Norman, OK)",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 26,
    "homeLineScores": [
      3,
      7,
      16,
      0
    ],
    "homePostgameWinProbability": 0.09089326858520508,
    "homePregameElo": 1781,
    "homePostgameElo": 1780,
    "awayId": 145,
    "awayTeam": "Ole Miss",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 34,
    "awayLineScores": [
      10,
      12,
      3,
      9
    ],
    "awayPostgameWinProbability": 0.9091067314147949,
    "awayPregameElo": 1962,
    "awayPostgameElo": 1963,
    "excitementIndex": 6.522901703271394,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752885,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 54867,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 56,
    "homeLineScores": [
      14,
      21,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9978094100952148,
    "homePregameElo": 2017,
    "homePostgameElo": 2091,
    "awayId": 26,
    "awayTeam": "UCLA",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 6,
    "awayLineScores": [
      0,
      3,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.0021905899047851562,
    "awayPregameElo": 1448,
    "awayPostgameElo": 1374,
    "excitementIndex": 2.9821040342297818,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762494,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30940,
    "venueId": 3805,
    "venue": "Simmons Bank Liberty Stadium",
    "homeId": 235,
    "homeTeam": "Memphis",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 34,
    "homeLineScores": [
      7,
      7,
      3,
      17
    ],
    "homePostgameWinProbability": 0.3881875276565552,
    "homePregameElo": 1680,
    "homePostgameElo": 1681,
    "awayId": 58,
    "awayTeam": "South Florida",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 31,
    "awayLineScores": [
      14,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.6118124723434448,
    "awayPregameElo": 1663,
    "awayPostgameElo": 1662,
    "excitementIndex": 8.277300484561323,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752884,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 55289,
    "venueId": 3907,
    "venue": "Ross-Ade Stadium",
    "homeId": 2509,
    "homeTeam": "Purdue",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      10,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.40335482358932495,
    "homePregameElo": 1290,
    "homePostgameElo": 1296,
    "awayId": 164,
    "awayTeam": "Rutgers",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      7,
      7,
      13
    ],
    "awayPostgameWinProbability": 0.596645176410675,
    "awayPregameElo": 1468,
    "awayPostgameElo": 1462,
    "excitementIndex": 6.663165101411546,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762846,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9260,
    "venueId": 3696,
    "venue": "Dix Stadium",
    "homeId": 2309,
    "homeTeam": "Kent State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 24,
    "homeLineScores": [
      0,
      3,
      14,
      7
    ],
    "homePostgameWinProbability": 0.2651918828487396,
    "homePregameElo": 938,
    "homePostgameElo": 945,
    "awayId": 189,
    "awayTeam": "Bowling Green",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.7348081171512604,
    "awayPregameElo": 1329,
    "awayPostgameElo": 1322,
    "excitementIndex": 6.259468083705375,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752746,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T16:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 68922,
    "venueId": 3887,
    "venue": "Razorback Stadium",
    "homeId": 8,
    "homeTeam": "Arkansas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      0,
      21,
      3,
      0
    ],
    "homePostgameWinProbability": 0.35182011127471924,
    "homePregameElo": 1617,
    "homePostgameElo": 1604,
    "awayId": 2,
    "awayTeam": "Auburn",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 33,
    "awayLineScores": [
      7,
      3,
      6,
      17
    ],
    "awayPostgameWinProbability": 0.6481798887252808,
    "awayPregameElo": 1681,
    "awayPostgameElo": 1694,
    "excitementIndex": 5.35366278395004,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762844,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12491,
    "venueId": 3965,
    "venue": "UB Stadium",
    "homeId": 2084,
    "homeTeam": "Buffalo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 16,
    "homeLineScores": [
      2,
      8,
      3,
      3
    ],
    "homePostgameWinProbability": 0.20765367150306702,
    "homePregameElo": 1356,
    "homePostgameElo": 1307,
    "awayId": 2006,
    "awayTeam": "Akron",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      0,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.792346328496933,
    "awayPregameElo": 991,
    "awayPostgameElo": 1040,
    "excitementIndex": 7.407073768153699,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757172,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21122,
    "venueId": 3895,
    "venue": "Rice Stadium",
    "homeId": 242,
    "homeTeam": "Rice",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 37,
    "homeLineScores": [
      3,
      14,
      0,
      7,
      7,
      6
    ],
    "homePostgameWinProbability": 0.6307185888290405,
    "homePregameElo": 1156,
    "homePostgameElo": 1163,
    "awayId": 41,
    "awayTeam": "UConn",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      14,
      3,
      0,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.3692814111709595,
    "awayPregameElo": 1553,
    "awayPostgameElo": 1546,
    "excitementIndex": 9.582349826167176,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760400,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20097,
    "venueId": 3971,
    "venue": "University Stadium (NM)",
    "homeId": 167,
    "homeTeam": "New Mexico",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 33,
    "homeLineScores": [
      7,
      19,
      0,
      7
    ],
    "homePostgameWinProbability": 0.7954603433609009,
    "homePregameElo": 1401,
    "homePostgameElo": 1442,
    "awayId": 328,
    "awayTeam": "Utah State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.20453965663909912,
    "awayPregameElo": 1377,
    "awayPostgameElo": 1336,
    "excitementIndex": 3.5724362517660464,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762874,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18025,
    "venueId": 3996,
    "venue": "Yager Stadium",
    "homeId": 193,
    "homeTeam": "Miami (OH)",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 26,
    "homeLineScores": [
      3,
      6,
      0,
      17
    ],
    "homePostgameWinProbability": 0.9412311315536499,
    "homePregameElo": 1449,
    "homePostgameElo": 1459,
    "awayId": 2711,
    "awayTeam": "Western Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      14,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.0587688684463501,
    "awayPregameElo": 1379,
    "awayPostgameElo": 1369,
    "excitementIndex": 6.224410165579504,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762847,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20489,
    "venueId": 3786,
    "venue": "Kelly/Shorts Stadium",
    "homeId": 2117,
    "homeTeam": "Central Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 38,
    "homeLineScores": [
      21,
      3,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9754047393798828,
    "homePregameElo": 1203,
    "homePostgameElo": 1234,
    "awayId": 113,
    "awayTeam": "Massachusetts",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 13,
    "awayLineScores": [
      7,
      3,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.024595260620117188,
    "awayPregameElo": 910,
    "awayPostgameElo": 879,
    "excitementIndex": 4.378498517035642,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752751,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 79537,
    "venueId": 3994,
    "venue": "Williams-Brice Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 22,
    "homeLineScores": [
      3,
      3,
      9,
      7
    ],
    "homePostgameWinProbability": 0.19009307026863098,
    "homePregameElo": 1630,
    "homePostgameElo": 1643,
    "awayId": 333,
    "awayTeam": "Alabama",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 29,
    "awayLineScores": [
      7,
      7,
      0,
      15
    ],
    "awayPostgameWinProbability": 0.809906929731369,
    "awayPregameElo": 1991,
    "awayPostgameElo": 1978,
    "excitementIndex": 6.965500888933744,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762493,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 32175,
    "venueId": 3852,
    "venue": "Navy-Marine Corps Memorial Stadium",
    "homeId": 2426,
    "homeTeam": "Navy",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 42,
    "homeLineScores": [
      14,
      7,
      0,
      21
    ],
    "homePostgameWinProbability": 0.8187264800071716,
    "homePregameElo": 1533,
    "homePostgameElo": 1529,
    "awayId": 2226,
    "awayTeam": "Florida Atlantic",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 32,
    "awayLineScores": [
      10,
      3,
      0,
      19
    ],
    "awayPostgameWinProbability": 0.18127351999282837,
    "awayPregameElo": 1214,
    "awayPostgameElo": 1218,
    "excitementIndex": 5.492484893131299,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760399,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 41535,
    "venueId": 3660,
    "venue": "Valley Children's Stadium",
    "homeId": 278,
    "homeTeam": "Fresno State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 0,
    "homeLineScores": [
      0,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1405,
    "homePostgameElo": 1360,
    "awayId": 21,
    "awayTeam": "San Diego State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 23,
    "awayLineScores": [
      7,
      6,
      0,
      10
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1534,
    "awayPostgameElo": 1579,
    "excitementIndex": 3.0376400475819985,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762845,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10124,
    "venueId": 3764,
    "venue": "Huskie Stadium",
    "homeId": 2459,
    "homeTeam": "Northern Illinois",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 21,
    "homeLineScores": [
      7,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.6112097501754761,
    "homePregameElo": 1297,
    "homePostgameElo": 1305,
    "awayId": 2050,
    "awayTeam": "Ball State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.3887902498245239,
    "awayPregameElo": 1055,
    "awayPostgameElo": 1047,
    "excitementIndex": 5.192848634865583,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752880,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 68630,
    "venueId": 3765,
    "venue": "Husky Stadium",
    "homeId": 264,
    "homeTeam": "Washington",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 42,
    "homeLineScores": [
      14,
      7,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9335861802101135,
    "homePregameElo": 1674,
    "homePostgameElo": 1703,
    "awayId": 356,
    "awayTeam": "Illinois",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 25,
    "awayLineScores": [
      3,
      14,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.06641381978988647,
    "awayPregameElo": 1589,
    "awayPostgameElo": 1560,
    "excitementIndex": 4.888917643282428,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752752,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 35000,
    "venueId": 3973,
    "venue": "FirstBank Stadium",
    "homeId": 238,
    "homeTeam": "Vanderbilt",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 17,
    "homeLineScores": [
      0,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.28633880615234375,
    "homePregameElo": 1753,
    "homePostgameElo": 1765,
    "awayId": 142,
    "awayTeam": "Missouri",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.7136611938476562,
    "awayPregameElo": 1791,
    "awayPostgameElo": 1779,
    "excitementIndex": 6.2198969474289605,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756931,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 61500,
    "venueId": 3772,
    "venue": "Jack Trice Stadium",
    "homeId": 66,
    "homeTeam": "Iowa State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 27,
    "homeLineScores": [
      17,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0.8332663774490356,
    "homePregameElo": 1622,
    "homePostgameElo": 1597,
    "awayId": 252,
    "awayTeam": "BYU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 41,
    "awayLineScores": [
      7,
      10,
      10,
      14
    ],
    "awayPostgameWinProbability": 0.16673362255096436,
    "awayPregameElo": 1697,
    "awayPostgameElo": 1722,
    "excitementIndex": 5.903255152394795,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762495,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16403,
    "venueId": 3674,
    "venue": "Chapman Stadium",
    "homeId": 202,
    "homeTeam": "Tulsa",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 37,
    "homeLineScores": [
      3,
      14,
      7,
      7,
      6
    ],
    "homePostgameWinProbability": 0.7937583327293396,
    "homePregameElo": 1055,
    "homePostgameElo": 1066,
    "awayId": 218,
    "awayTeam": "Temple",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      7,
      14,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.2062416672706604,
    "awayPregameElo": 1330,
    "awayPostgameElo": 1319,
    "excitementIndex": 10.629657665692894,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752952,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 27646,
    "venueId": 3820,
    "venue": "Gesa Field",
    "homeId": 265,
    "homeTeam": "Washington State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 28,
    "homeLineScores": [
      0,
      21,
      0,
      7
    ],
    "homePostgameWinProbability": 0.7584578990936279,
    "homePregameElo": 1364,
    "homePostgameElo": 1438,
    "awayId": 2649,
    "awayTeam": "Toledo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.24154210090637207,
    "awayPregameElo": 1579,
    "awayPostgameElo": 1505,
    "excitementIndex": 3.8357891127616592,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761637,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 27111,
    "venueId": 3815,
    "venue": "M. M. Roberts Stadium",
    "homeId": 2572,
    "homeTeam": "Southern Miss",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 49,
    "homeLineScores": [
      7,
      14,
      14,
      14
    ],
    "homePostgameWinProbability": 0.991515576839447,
    "homePregameElo": 1309,
    "homePostgameElo": 1354,
    "awayId": 2433,
    "awayTeam": "UL Monroe",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.008484423160552979,
    "awayPregameElo": 1060,
    "awayPostgameElo": 1015,
    "excitementIndex": 4.357216605487509,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754574,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 46840,
    "venueId": 3752,
    "venue": "Acrisure Stadium",
    "homeId": 221,
    "homeTeam": "Pittsburgh",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 53,
    "homeLineScores": [
      10,
      21,
      15,
      7
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1645,
    "homePostgameElo": 1673,
    "awayId": 152,
    "awayTeam": "NC State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      14,
      0,
      13
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1487,
    "awayPostgameElo": 1459,
    "excitementIndex": 4.662732411692216,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752882,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 69250,
    "venueId": 3793,
    "venue": "Kinnick Stadium",
    "homeId": 2294,
    "homeTeam": "Iowa",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 41,
    "homeLineScores": [
      17,
      14,
      3,
      7
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1830,
    "homePostgameElo": 1907,
    "awayId": 135,
    "awayTeam": "Minnesota",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      0,
      3,
      0
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1592,
    "awayPostgameElo": 1515,
    "excitementIndex": 2.768067502325409,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756933,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 59625,
    "venueId": 3784,
    "venue": "Jones AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 42,
    "homeLineScores": [
      21,
      7,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9770151972770691,
    "homePregameElo": 1826,
    "homePostgameElo": 1855,
    "awayId": 197,
    "awayTeam": "Oklahoma State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.022984802722930908,
    "awayPregameElo": 1071,
    "awayPostgameElo": 1042,
    "excitementIndex": 2.9263923453362275,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756930,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 38007,
    "venueId": 3854,
    "venue": "Nippert Stadium",
    "homeId": 2132,
    "homeTeam": "Cincinnati",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 41,
    "homeLineScores": [
      14,
      10,
      3,
      14
    ],
    "homePostgameWinProbability": 0.9231768250465393,
    "homePregameElo": 1594,
    "homePostgameElo": 1644,
    "awayId": 239,
    "awayTeam": "Baylor",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      6,
      6,
      8
    ],
    "awayPostgameWinProbability": 0.0768231749534607,
    "awayPregameElo": 1592,
    "awayPostgameElo": 1542,
    "excitementIndex": 3.1679202250819785,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752749,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T20:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52680,
    "venueId": 3693,
    "venue": "Davis Wade Stadium",
    "homeId": 344,
    "homeTeam": "Mississippi State",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 38,
    "homeLineScores": [
      7,
      17,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.12271390855312347,
    "homePregameElo": 1495,
    "homePostgameElo": 1514,
    "awayId": 251,
    "awayTeam": "Texas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 45,
    "awayLineScores": [
      7,
      7,
      0,
      24,
      7
    ],
    "awayPostgameWinProbability": 0.8772860914468765,
    "awayPregameElo": 1944,
    "awayPostgameElo": 1925,
    "excitementIndex": 9.321110708758852,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756935,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 54110,
    "venueId": 3842,
    "venue": "Milan Puskar Stadium",
    "homeId": 277,
    "homeTeam": "West Virginia",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 17,
    "homeLineScores": [
      0,
      7,
      3,
      7
    ],
    "homePostgameWinProbability": 0.34336555004119873,
    "homePregameElo": 1281,
    "homePostgameElo": 1300,
    "awayId": 2628,
    "awayTeam": "TCU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 23,
    "awayLineScores": [
      10,
      10,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.6566344499588013,
    "awayPregameElo": 1719,
    "awayPostgameElo": 1700,
    "excitementIndex": 4.075723777053685,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752886,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 58940,
    "venueId": 3626,
    "venue": "Autzen Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 21,
    "homeLineScores": [
      0,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.921492874622345,
    "homePregameElo": 2075,
    "homePostgameElo": 2055,
    "awayId": 275,
    "awayTeam": "Wisconsin",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.07850712537765503,
    "awayPregameElo": 1435,
    "awayPostgameElo": 1455,
    "excitementIndex": 4.496941102078826,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761638,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23719,
    "venueId": 3975,
    "venue": "Veterans Memorial Stadium (AL)",
    "homeId": 2653,
    "homeTeam": "Troy",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 35,
    "homeLineScores": [
      7,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.6124547719955444,
    "homePregameElo": 1488,
    "homePostgameElo": 1499,
    "awayId": 309,
    "awayTeam": "Louisiana",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 23,
    "awayLineScores": [
      7,
      10,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.38754522800445557,
    "awayPregameElo": 1333,
    "awayPostgameElo": 1322,
    "excitementIndex": 6.746593511807248,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761636,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16341,
    "venueId": 3625,
    "venue": "Centennial Bank Stadium",
    "homeId": 2032,
    "homeTeam": "Arkansas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 34,
    "homeLineScores": [
      7,
      10,
      7,
      10
    ],
    "homePostgameWinProbability": 0.8345502018928528,
    "homePregameElo": 1235,
    "homePostgameElo": 1260,
    "awayId": 290,
    "awayTeam": "Georgia Southern",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 24,
    "awayLineScores": [
      14,
      7,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.16544979810714722,
    "awayPregameElo": 1335,
    "awayPostgameElo": 1310,
    "excitementIndex": 7.334814938094461,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754572,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 63892,
    "venueId": 3948,
    "venue": "Hard Rock Stadium",
    "homeId": 2390,
    "homeTeam": "Miami",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 42,
    "homeLineScores": [
      0,
      7,
      21,
      14
    ],
    "homePostgameWinProbability": 0.9847109913825989,
    "homePregameElo": 1832,
    "homePostgameElo": 1863,
    "awayId": 24,
    "awayTeam": "Stanford",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.015289008617401123,
    "awayPregameElo": 1271,
    "awayPostgameElo": 1240,
    "excitementIndex": 4.4733997444287,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760398,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25609,
    "venueId": 3984,
    "venue": "War Memorial Stadium",
    "homeId": 2751,
    "homeTeam": "Wyoming",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 28,
    "homeLineScores": [
      7,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.8201879262924194,
    "homePregameElo": 1336,
    "homePostgameElo": 1412,
    "awayId": 36,
    "awayTeam": "Colorado State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.17981207370758057,
    "awayPregameElo": 1353,
    "awayPostgameElo": 1277,
    "excitementIndex": 3.2224574960609362,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752748,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 101924,
    "venueId": 3958,
    "venue": "Tiger Stadium (LA)",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 25,
    "homeLineScores": [
      7,
      11,
      0,
      7
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1752,
    "homePostgameElo": 1694,
    "awayId": 245,
    "awayTeam": "Texas A&M",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 49,
    "awayLineScores": [
      14,
      0,
      21,
      14
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1801,
    "awayPostgameElo": 1859,
    "excitementIndex": 5.32002098367874,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754570,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50320,
    "venueId": 3873,
    "venue": "L&N Federal Credit Union Stadium",
    "homeId": 97,
    "homeTeam": "Louisville",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      7,
      14,
      7,
      10
    ],
    "homePostgameWinProbability": 0.5133187770843506,
    "homePregameElo": 1746,
    "homePostgameElo": 1738,
    "awayId": 103,
    "awayTeam": "Boston College",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.4866812229156494,
    "awayPregameElo": 1291,
    "awayPostgameElo": 1299,
    "excitementIndex": 5.755154180508504,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752881,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 75085,
    "venueId": 3936,
    "venue": "Spartan Stadium",
    "homeId": 127,
    "homeTeam": "Michigan State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 20,
    "homeLineScores": [
      0,
      7,
      0,
      13
    ],
    "homePostgameWinProbability": 0.22799912095069885,
    "homePregameElo": 1348,
    "homePostgameElo": 1364,
    "awayId": 130,
    "awayTeam": "Michigan",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 31,
    "awayLineScores": [
      10,
      0,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.7720008790493011,
    "awayPregameElo": 1839,
    "awayPostgameElo": 1823,
    "excitementIndex": 4.5247274470283,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752747,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-25T23:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60153,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 34,
    "homeLineScores": [
      7,
      14,
      6,
      7
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1533,
    "homePostgameElo": 1506,
    "awayId": 2633,
    "awayTeam": "Tennessee",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 56,
    "awayLineScores": [
      21,
      14,
      14,
      7
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1801,
    "awayPostgameElo": 1828,
    "excitementIndex": 4.0851942581443055,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756929,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-26T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 54256,
    "venueId": 3947,
    "venue": "Mountain America Stadium",
    "homeId": 9,
    "homeTeam": "Arizona State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 16,
    "homeLineScores": [
      0,
      0,
      0,
      16
    ],
    "homePostgameWinProbability": 0.14500193297863007,
    "homePregameElo": 1638,
    "homePostgameElo": 1609,
    "awayId": 248,
    "awayTeam": "Houston",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 24,
    "awayLineScores": [
      10,
      0,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.8549980670213699,
    "awayPregameElo": 1478,
    "awayPostgameElo": 1507,
    "excitementIndex": 4.716608221900163,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756934,
    "season": 2025,
    "week": 9,
    "seasonType": "regular",
    "startDate": "2025-10-26T02:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 51949,
    "venueId": 587,
    "venue": "Rice-Eccles Stadium",
    "homeId": 254,
    "homeTeam": "Utah",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 53,
    "homeLineScores": [
      17,
      26,
      3,
      7
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1771,
    "homePostgameElo": 1887,
    "awayId": 38,
    "awayTeam": "Colorado",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1611,
    "awayPostgameElo": 1495,
    "excitementIndex": 3.371830554150792,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757289,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-10-29T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11040,
    "venueId": 4899,
    "venue": "Fifth Third Stadium",
    "homeId": 338,
    "homeTeam": "Kennesaw State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 33,
    "homeLineScores": [
      14,
      2,
      7,
      10
    ],
    "homePostgameWinProbability": 0.7935960292816162,
    "homePregameElo": 1374,
    "homePostgameElo": 1388,
    "awayId": 2638,
    "awayTeam": "UTEP",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      10,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.2064039707183838,
    "awayPregameElo": 1234,
    "awayPostgameElo": 1220,
    "excitementIndex": 6.7507915071202484,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761639,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-10-29T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17363,
    "venueId": 3644,
    "venue": "Bobcat Stadium (TX)",
    "homeId": 326,
    "homeTeam": "Texas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 20,
    "homeLineScores": [
      0,
      20,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0077347224578261375,
    "homePregameElo": 1554,
    "homePostgameElo": 1486,
    "awayId": 256,
    "awayTeam": "James Madison",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 52,
    "awayLineScores": [
      14,
      14,
      21,
      3
    ],
    "awayPostgameWinProbability": 0.9922652775421739,
    "awayPregameElo": 1733,
    "awayPostgameElo": 1801,
    "excitementIndex": 4.307558561592839,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757292,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-10-29T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10200,
    "venueId": 3725,
    "venue": "Johnny \"Red\" Floyd Stadium",
    "homeId": 2393,
    "homeTeam": "Middle Tennessee",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 21,
    "homeLineScores": [
      6,
      0,
      8,
      7
    ],
    "homePostgameWinProbability": 0.0572785958647728,
    "homePregameElo": 1184,
    "homePostgameElo": 1199,
    "awayId": 55,
    "awayTeam": "Jacksonville State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      7,
      0,
      17
    ],
    "awayPostgameWinProbability": 0.9427214041352272,
    "awayPregameElo": 1540,
    "awayPostgameElo": 1525,
    "excitementIndex": 5.738443333761415,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757291,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-10-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 8754,
    "venueId": 3878,
    "venue": "Plaster Sports Complex",
    "homeId": 2623,
    "homeTeam": "Missouri State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.5360580086708069,
    "homePregameElo": 1335,
    "homePostgameElo": 1340,
    "awayId": 2229,
    "awayTeam": "Florida International",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.4639419913291931,
    "awayPregameElo": 1246,
    "awayPostgameElo": 1241,
    "excitementIndex": 6.056074145082148,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761640,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-10-30T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17034,
    "venueId": 3654,
    "venue": "Brooks Stadium (SC)",
    "homeId": 324,
    "homeTeam": "Coastal Carolina",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 44,
    "homeLineScores": [
      3,
      14,
      20,
      7
    ],
    "homePostgameWinProbability": 0.28921860456466675,
    "homePregameElo": 1235,
    "homePostgameElo": 1309,
    "awayId": 276,
    "awayTeam": "Marshall",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 27,
    "awayLineScores": [
      10,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.7107813954353333,
    "awayPregameElo": 1583,
    "awayPostgameElo": 1509,
    "excitementIndex": 7.543310813440956,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762443,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-10-30T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16715,
    "venueId": 3604,
    "venue": "Alamodome",
    "homeId": 2636,
    "homeTeam": "UTSA",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 48,
    "homeLineScores": [
      10,
      21,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9010108709335327,
    "homePregameElo": 1470,
    "homePostgameElo": 1537,
    "awayId": 2655,
    "awayTeam": "Tulane",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 26,
    "awayLineScores": [
      6,
      6,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.09898912906646729,
    "awayPregameElo": 1588,
    "awayPostgameElo": 1521,
    "excitementIndex": 3.954352524973834,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762497,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-10-31T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20197,
    "venueId": 3895,
    "venue": "Rice Stadium",
    "homeId": 242,
    "homeTeam": "Rice",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.10178316384553909,
    "homePregameElo": 1163,
    "homePostgameElo": 1155,
    "awayId": 235,
    "awayTeam": "Memphis",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 38,
    "awayLineScores": [
      14,
      17,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.8982168361544609,
    "awayPregameElo": 1681,
    "awayPostgameElo": 1689,
    "excitementIndex": 3.0092875279502422,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754575,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-10-31T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 37184,
    "venueId": 1964,
    "venue": "JMA Wireless Dome",
    "homeId": 183,
    "homeTeam": "Syracuse",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 10,
    "homeLineScores": [
      7,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.021773574873805046,
    "homePregameElo": 1362,
    "homePostgameElo": 1320,
    "awayId": 153,
    "awayTeam": "North Carolina",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 27,
    "awayLineScores": [
      3,
      3,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.978226425126195,
    "awayPregameElo": 1352,
    "awayPostgameElo": 1394,
    "excitementIndex": 3.9698319179483317,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757290,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17841,
    "venueId": 3776,
    "venue": "Joe Aillet Stadium",
    "homeId": 2348,
    "homeTeam": "Louisiana Tech",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 55,
    "homeLineScores": [
      14,
      13,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9761862754821777,
    "homePregameElo": 1378,
    "homePostgameElo": 1465,
    "awayId": 2534,
    "awayTeam": "Sam Houston",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.023813724517822266,
    "awayPregameElo": 1139,
    "awayPostgameElo": 1052,
    "excitementIndex": 2.765058295627847,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752758,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 102338,
    "venueId": 3910,
    "venue": "DKR-Texas Memorial Stadium",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 34,
    "homeLineScores": [
      17,
      7,
      10,
      0
    ],
    "homePostgameWinProbability": 0.7722781300544739,
    "homePregameElo": 1925,
    "homePostgameElo": 1924,
    "awayId": 238,
    "awayTeam": "Vanderbilt",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 31,
    "awayLineScores": [
      0,
      10,
      0,
      21
    ],
    "awayPostgameWinProbability": 0.22772186994552612,
    "awayPregameElo": 1765,
    "awayPostgameElo": 1766,
    "excitementIndex": 3.920122530757057,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754577,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 75809,
    "venueId": 3836,
    "venue": "Memorial Stadium (Clemson, SC)",
    "homeId": 228,
    "homeTeam": "Clemson",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 45,
    "homeLineScores": [
      7,
      21,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9737728238105774,
    "homePregameElo": 1708,
    "homePostgameElo": 1703,
    "awayId": 150,
    "awayTeam": "Duke",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 46,
    "awayLineScores": [
      21,
      7,
      7,
      11
    ],
    "awayPostgameWinProbability": 0.026227176189422607,
    "awayPregameElo": 1622,
    "awayPostgameElo": 1627,
    "excitementIndex": 7.8957948169637735,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762499,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 26516,
    "venueId": 3825,
    "venue": "DATCU Stadium",
    "homeId": 249,
    "homeTeam": "North Texas",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 31,
    "homeLineScores": [
      14,
      10,
      7,
      0
    ],
    "homePostgameWinProbability": 0.943037211894989,
    "homePregameElo": 1674,
    "homePostgameElo": 1690,
    "awayId": 2426,
    "awayTeam": "Navy",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      10,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.056962788105010986,
    "awayPregameElo": 1529,
    "awayPostgameElo": 1513,
    "excitementIndex": 3.6246469328814164,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756936,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 40212,
    "venueId": 4727,
    "venue": "McLane Stadium",
    "homeId": 239,
    "homeTeam": "Baylor",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 30,
    "homeLineScores": [
      14,
      6,
      3,
      7
    ],
    "homePostgameWinProbability": 0.9800407290458679,
    "homePregameElo": 1542,
    "homePostgameElo": 1621,
    "awayId": 2116,
    "awayTeam": "UCF",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.01995927095413208,
    "awayPregameElo": 1616,
    "awayPostgameElo": 1537,
    "excitementIndex": 3.2328341065639985,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756938,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25049,
    "venueId": 4728,
    "venue": "TDECU Stadium",
    "homeId": 248,
    "homeTeam": "Houston",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 35,
    "homeLineScores": [
      7,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.06682823598384857,
    "homePregameElo": 1507,
    "homePostgameElo": 1467,
    "awayId": 277,
    "awayTeam": "West Virginia",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 45,
    "awayLineScores": [
      14,
      7,
      10,
      14
    ],
    "awayPostgameWinProbability": 0.9331717640161514,
    "awayPregameElo": 1300,
    "awayPostgameElo": 1340,
    "excitementIndex": 6.363517032629233,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752891,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60670,
    "venueId": 3832,
    "venue": "Memorial Stadium (Champaign, IL)",
    "homeId": 356,
    "homeTeam": "Illinois",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 35,
    "homeLineScores": [
      7,
      14,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9521887302398682,
    "homePregameElo": 1560,
    "homePostgameElo": 1603,
    "awayId": 164,
    "awayTeam": "Rutgers",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      6,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.047811269760131836,
    "awayPregameElo": 1462,
    "awayPostgameElo": 1419,
    "excitementIndex": 4.188323766315605,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752889,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 105517,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      7,
      10,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9644951820373535,
    "homePregameElo": 2098,
    "homePostgameElo": 2146,
    "awayId": 213,
    "awayTeam": "Penn State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.035504817962646484,
    "awayPregameElo": 1990,
    "awayPostgameElo": 1942,
    "excitementIndex": 4.216863180603837,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760401,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 39441,
    "venueId": 3713,
    "venue": "Falcon Stadium",
    "homeId": 2005,
    "homeTeam": "Air Force",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 17,
    "homeLineScores": [
      3,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.37822410464286804,
    "homePregameElo": 1355,
    "homePostgameElo": 1362,
    "awayId": 349,
    "awayTeam": "Army",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      3,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.621775895357132,
    "awayPregameElo": 1544,
    "awayPostgameElo": 1537,
    "excitementIndex": 5.535816980973042,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757173,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23170,
    "venueId": 3892,
    "venue": "Pratt & Whitney Stadium",
    "homeId": 41,
    "homeTeam": "UConn",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 38,
    "homeLineScores": [
      7,
      17,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9882107973098755,
    "homePregameElo": 1546,
    "homePostgameElo": 1561,
    "awayId": 5,
    "awayTeam": "UAB",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 19,
    "awayLineScores": [
      0,
      0,
      6,
      13
    ],
    "awayPostgameWinProbability": 0.011789202690124512,
    "awayPregameElo": 1252,
    "awayPostgameElo": 1237,
    "excitementIndex": 5.049152748034217,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754581,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 35074,
    "venueId": 3735,
    "venue": "Gerald J. Ford Stadium",
    "homeId": 2567,
    "homeTeam": "SMU",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 26,
    "homeLineScores": [
      0,
      7,
      10,
      3,
      6
    ],
    "homePostgameWinProbability": 0.58628249168396,
    "homePregameElo": 1727,
    "homePostgameElo": 1741,
    "awayId": 2390,
    "awayTeam": "Miami",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      3,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.41371750831604004,
    "awayPregameElo": 1863,
    "awayPostgameElo": 1849,
    "excitementIndex": 9.760987625430024,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762849,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T16:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11876,
    "venueId": 3700,
    "venue": "Doyt L. Perry Stadium",
    "homeId": 189,
    "homeTeam": "Bowling Green",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 3,
    "homeLineScores": [
      0,
      0,
      0,
      3
    ],
    "homePostgameWinProbability": 0.011615565046668053,
    "homePregameElo": 1322,
    "homePostgameElo": 1253,
    "awayId": 2084,
    "awayTeam": "Buffalo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      14,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.988384434953332,
    "awayPregameElo": 1307,
    "awayPostgameElo": 1376,
    "excitementIndex": 2.84265125294086,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756939,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60899,
    "venueId": 3772,
    "venue": "Jack Trice Stadium",
    "homeId": 66,
    "homeTeam": "Iowa State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 19,
    "homeLineScores": [
      3,
      13,
      3,
      0
    ],
    "homePostgameWinProbability": 0.04814131185412407,
    "homePregameElo": 1597,
    "homePostgameElo": 1589,
    "awayId": 9,
    "awayTeam": "Arizona State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      14,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.9518586881458759,
    "awayPregameElo": 1609,
    "awayPostgameElo": 1617,
    "excitementIndex": 6.789113847524804,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762498,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13168,
    "venueId": 3806,
    "venue": "Lincoln Financial Field",
    "homeId": 218,
    "homeTeam": "Temple",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 14,
    "homeLineScores": [
      7,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.02488398179411888,
    "homePregameElo": 1319,
    "homePostgameElo": 1258,
    "awayId": 151,
    "awayTeam": "East Carolina",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 45,
    "awayLineScores": [
      14,
      14,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.9751160182058811,
    "awayPregameElo": 1530,
    "awayPostgameElo": 1591,
    "excitementIndex": 4.039789827827728,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754580,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 54030,
    "venueId": 3799,
    "venue": "Lane Stadium",
    "homeId": 259,
    "homeTeam": "Virginia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 16,
    "homeLineScores": [
      9,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0018904185853898525,
    "homePregameElo": 1430,
    "homePostgameElo": 1431,
    "awayId": 97,
    "awayTeam": "Louisville",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      0,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.9981095814146101,
    "awayPregameElo": 1738,
    "awayPostgameElo": 1737,
    "excitementIndex": 6.175265038989168,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760404,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25972,
    "venueId": 6501,
    "venue": "Allegiant Stadium",
    "homeId": 2439,
    "homeTeam": "UNLV",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 35,
    "homeLineScores": [
      0,
      21,
      7,
      7
    ],
    "homePostgameWinProbability": 0.06649450212717056,
    "homePregameElo": 1567,
    "homePostgameElo": 1549,
    "awayId": 167,
    "awayTeam": "New Mexico",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 40,
    "awayLineScores": [
      7,
      24,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.9335054978728294,
    "awayPregameElo": 1442,
    "awayPostgameElo": 1460,
    "excitementIndex": 7.218828658078055,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761642,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18462,
    "venueId": 6526,
    "venue": "Hancock Whitney Stadium",
    "homeId": 6,
    "homeTeam": "South Alabama",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 22,
    "homeLineScores": [
      0,
      7,
      7,
      8
    ],
    "homePostgameWinProbability": 0.1262800246477127,
    "homePregameElo": 1400,
    "homePostgameElo": 1375,
    "awayId": 309,
    "awayTeam": "Louisiana",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 31,
    "awayLineScores": [
      10,
      14,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.8737199753522873,
    "awayPregameElo": 1322,
    "awayPostgameElo": 1347,
    "excitementIndex": 4.0834056992858185,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757294,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15023,
    "venueId": 3796,
    "venue": "Houchens Industries-L.T. Smith Stadium",
    "homeId": 98,
    "homeTeam": "Western Kentucky",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 35,
    "homeLineScores": [
      0,
      14,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9377289414405823,
    "homePregameElo": 1355,
    "homePostgameElo": 1386,
    "awayId": 166,
    "awayTeam": "New Mexico State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 16,
    "awayLineScores": [
      3,
      3,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.062271058559417725,
    "awayPregameElo": 1225,
    "awayPostgameElo": 1194,
    "excitementIndex": 5.310083448979774,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761641,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17087,
    "venueId": 3817,
    "venue": "Malone Stadium",
    "homeId": 2433,
    "homeTeam": "UL Monroe",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 6,
    "homeLineScores": [
      0,
      0,
      0,
      6
    ],
    "homePostgameWinProbability": 0.029803264886140823,
    "homePregameElo": 1015,
    "homePostgameElo": 998,
    "awayId": 295,
    "awayTeam": "Old Dominion",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 31,
    "awayLineScores": [
      17,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.9701967351138592,
    "awayPregameElo": 1463,
    "awayPostgameElo": 1480,
    "excitementIndex": 2.631088345259229,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752887,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 46185,
    "venueId": 3665,
    "venue": "SECU Stadium",
    "homeId": 120,
    "homeTeam": "Maryland",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 10,
    "homeLineScores": [
      3,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.17305046319961548,
    "homePregameElo": 1573,
    "homePostgameElo": 1506,
    "awayId": 84,
    "awayTeam": "Indiana",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 55,
    "awayLineScores": [
      7,
      13,
      21,
      14
    ],
    "awayPostgameWinProbability": 0.8269495368003845,
    "awayPregameElo": 2091,
    "awayPostgameElo": 2158,
    "excitementIndex": 3.557163403999338,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752755,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 76131,
    "venueId": 3712,
    "venue": "EverBank Stadium",
    "homeId": 57,
    "homeTeam": "Florida",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 20,
    "homeLineScores": [
      10,
      0,
      7,
      3
    ],
    "homePostgameWinProbability": 0.0881829708814621,
    "homePregameElo": 1638,
    "homePostgameElo": 1655,
    "awayId": 61,
    "awayTeam": "Georgia",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      3,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9118170291185379,
    "awayPregameElo": 2034,
    "awayPostgameElo": 2017,
    "excitementIndex": 7.501922970887811,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757293,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18455,
    "venueId": 3992,
    "venue": "Williams Stadium (VA)",
    "homeId": 2335,
    "homeTeam": "Liberty",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 59,
    "homeLineScores": [
      7,
      21,
      21,
      10
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1424,
    "homePostgameElo": 1506,
    "awayId": 48,
    "awayTeam": "Delaware",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 30,
    "awayLineScores": [
      3,
      6,
      15,
      6
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1465,
    "awayPostgameElo": 1383,
    "excitementIndex": 4.296077864596694,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760402,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 32826,
    "venueId": 3653,
    "venue": "Albertsons Stadium",
    "homeId": 68,
    "homeTeam": "Boise State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 7,
    "homeLineScores": [
      0,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1724,
    "homePostgameElo": 1616,
    "awayId": 278,
    "awayTeam": "Fresno State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 30,
    "awayLineScores": [
      7,
      3,
      14,
      6
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1360,
    "awayPostgameElo": 1468,
    "excitementIndex": 4.483067995981335,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754582,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16540,
    "venueId": 3940,
    "venue": "Stanford Stadium",
    "homeId": 24,
    "homeTeam": "Stanford",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 20,
    "homeLineScores": [
      10,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.02590952068567276,
    "homePregameElo": 1240,
    "homePostgameElo": 1245,
    "awayId": 221,
    "awayTeam": "Pittsburgh",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      14,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.9740904793143272,
    "awayPregameElo": 1673,
    "awayPostgameElo": 1668,
    "excitementIndex": 5.712078469404845,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756941,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52111,
    "venueId": 3636,
    "venue": "Bill Snyder Family Stadium",
    "homeId": 2306,
    "homeTeam": "Kansas State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 20,
    "homeLineScores": [
      7,
      0,
      7,
      6
    ],
    "homePostgameWinProbability": 0.22401078045368195,
    "homePregameElo": 1753,
    "homePostgameElo": 1705,
    "awayId": 2641,
    "awayTeam": "Texas Tech",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 43,
    "awayLineScores": [
      0,
      12,
      17,
      14
    ],
    "awayPostgameWinProbability": 0.775989219546318,
    "awayPregameElo": 1855,
    "awayPostgameElo": 1903,
    "excitementIndex": 4.938054776568564,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754583,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 44500,
    "venueId": 3615,
    "venue": "Alumni Stadium (Chestnut Hill, MA)",
    "homeId": 103,
    "homeTeam": "Boston College",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 10,
    "homeLineScores": [
      0,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1299,
    "homePostgameElo": 1339,
    "awayId": 87,
    "awayTeam": "Notre Dame",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 25,
    "awayLineScores": [
      0,
      12,
      6,
      7
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 2193,
    "awayPostgameElo": 2153,
    "excitementIndex": 5.266984922724491,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752888,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 45339,
    "venueId": 3953,
    "venue": "Huntington Bank Stadium",
    "homeId": 135,
    "homeTeam": "Minnesota",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 23,
    "homeLineScores": [
      7,
      3,
      0,
      7,
      6
    ],
    "homePostgameWinProbability": 0.20073971152305603,
    "homePregameElo": 1515,
    "homePostgameElo": 1514,
    "awayId": 127,
    "awayTeam": "Michigan State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      0,
      7,
      10,
      3
    ],
    "awayPostgameWinProbability": 0.799260288476944,
    "awayPregameElo": 1364,
    "awayPostgameElo": 1365,
    "excitementIndex": 7.6516311853107855,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754576,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T19:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30893,
    "venueId": 3831,
    "venue": "California Memorial Stadium",
    "homeId": 25,
    "homeTeam": "California",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 21,
    "homeLineScores": [
      0,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.05293559655547142,
    "homePregameElo": 1397,
    "homePostgameElo": 1392,
    "awayId": 258,
    "awayTeam": "Virginia",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 31,
    "awayLineScores": [
      10,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9470644034445286,
    "awayPregameElo": 1580,
    "awayPostgameElo": 1585,
    "excitementIndex": 5.718828438861106,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752753,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 68358,
    "venueId": 3887,
    "venue": "Razorback Stadium",
    "homeId": 8,
    "homeTeam": "Arkansas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 35,
    "homeLineScores": [
      0,
      13,
      15,
      7
    ],
    "homePostgameWinProbability": 0.47001153230667114,
    "homePregameElo": 1604,
    "homePostgameElo": 1594,
    "awayId": 344,
    "awayTeam": "Mississippi State",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      0,
      14,
      17
    ],
    "awayPostgameWinProbability": 0.5299884676933289,
    "awayPregameElo": 1514,
    "awayPostgameElo": 1524,
    "excitementIndex": 7.06341697165689,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762850,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 29299,
    "venueId": 3980,
    "venue": "Waldo Stadium",
    "homeId": 2711,
    "homeTeam": "Western Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 24,
    "homeLineScores": [
      0,
      7,
      7,
      10
    ],
    "homePostgameWinProbability": 0.568860650062561,
    "homePregameElo": 1369,
    "homePostgameElo": 1368,
    "awayId": 2117,
    "awayTeam": "Central Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.43113934993743896,
    "awayPregameElo": 1234,
    "awayPostgameElo": 1235,
    "excitementIndex": 6.32630256682886,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756940,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 39511,
    "venueId": 3833,
    "venue": "Memorial Stadium",
    "homeId": 2305,
    "homeTeam": "Kansas",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 38,
    "homeLineScores": [
      3,
      7,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9866192936897278,
    "homePregameElo": 1563,
    "homePostgameElo": 1556,
    "awayId": 197,
    "awayTeam": "Oklahoma State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.013380706310272217,
    "awayPregameElo": 1042,
    "awayPostgameElo": 1049,
    "excitementIndex": 4.262904505679054,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752756,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 67491,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 30,
    "homeLineScores": [
      10,
      7,
      3,
      10
    ],
    "homePostgameWinProbability": 0.9966846704483032,
    "homePregameElo": 1963,
    "homePostgameElo": 1969,
    "awayId": 2579,
    "awayTeam": "South Carolina",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0033153295516967773,
    "awayPregameElo": 1643,
    "awayPostgameElo": 1637,
    "excitementIndex": 5.932028676090789,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752890,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 110517,
    "venueId": 3558,
    "venue": "Michigan Stadium",
    "homeId": 130,
    "homeTeam": "Michigan",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 21,
    "homeLineScores": [
      7,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9230600595474243,
    "homePregameElo": 1823,
    "homePostgameElo": 1809,
    "awayId": 2509,
    "awayTeam": "Purdue",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      7,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.07693994045257568,
    "awayPregameElo": 1296,
    "awayPostgameElo": 1310,
    "excitementIndex": 5.6554345034414455,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756937,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 48322,
    "venueId": 3726,
    "venue": "Folsom Field",
    "homeId": 38,
    "homeTeam": "Colorado",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 17,
    "homeLineScores": [
      0,
      7,
      7,
      3
    ],
    "homePostgameWinProbability": 0.14727240800857544,
    "homePregameElo": 1495,
    "homePostgameElo": 1389,
    "awayId": 12,
    "awayTeam": "Arizona",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 52,
    "awayLineScores": [
      17,
      21,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.8527275919914246,
    "awayPregameElo": 1472,
    "awayPostgameElo": 1578,
    "excitementIndex": 2.909193799765285,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760405,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24325,
    "venueId": 7311,
    "venue": "Snapdragon Stadium",
    "homeId": 21,
    "homeTeam": "San Diego State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 24,
    "homeLineScores": [
      7,
      10,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9953889846801758,
    "homePregameElo": 1579,
    "homePostgameElo": 1601,
    "awayId": 2751,
    "awayTeam": "Wyoming",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.004611015319824219,
    "awayPregameElo": 1412,
    "awayPostgameElo": 1390,
    "excitementIndex": 4.584367757850891,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754579,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 56919,
    "venueId": 3670,
    "venue": "Carter-Finley Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 48,
    "homeLineScores": [
      14,
      10,
      14,
      10
    ],
    "homePostgameWinProbability": 0.9727997183799744,
    "homePregameElo": 1459,
    "homePostgameElo": 1498,
    "awayId": 59,
    "awayTeam": "Georgia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 36,
    "awayLineScores": [
      7,
      10,
      13,
      6
    ],
    "awayPostgameWinProbability": 0.027200281620025635,
    "awayPregameElo": 1651,
    "awayPostgameElo": 1612,
    "excitementIndex": 5.721442235800005,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754578,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 63677,
    "venueId": 3697,
    "venue": "Doak Campbell Stadium",
    "homeId": 52,
    "homeTeam": "Florida State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 42,
    "homeLineScores": [
      0,
      14,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9869140982627869,
    "homePregameElo": 1542,
    "homePostgameElo": 1631,
    "awayId": 154,
    "awayTeam": "Wake Forest",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.013085901737213135,
    "awayPregameElo": 1471,
    "awayPostgameElo": 1382,
    "excitementIndex": 4.080458428558412,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752943,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 32905,
    "venueId": 3893,
    "venue": "Reser Stadium",
    "homeId": 204,
    "homeTeam": "Oregon State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 10,
    "homeLineScores": [
      0,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.022400543093681335,
    "homePregameElo": 1248,
    "homePostgameElo": 1252,
    "awayId": 265,
    "awayTeam": "Washington State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.9775994569063187,
    "awayPregameElo": 1438,
    "awayPostgameElo": 1434,
    "excitementIndex": 6.349020346700761,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752754,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 3,
    "homeLineScores": [
      0,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.26053720712661743,
    "homePregameElo": 1694,
    "homePostgameElo": 1665,
    "awayId": 96,
    "awayTeam": "Kentucky",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.7394627928733826,
    "awayPregameElo": 1506,
    "awayPostgameElo": 1535,
    "excitementIndex": 5.095503034276599,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752757,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 101915,
    "venueId": 3853,
    "venue": "Neyland Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 27,
    "homeLineScores": [
      10,
      0,
      7,
      10
    ],
    "homePostgameWinProbability": 0.409697562456131,
    "homePregameElo": 1828,
    "homePostgameElo": 1814,
    "awayId": 201,
    "awayTeam": "Oklahoma",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 33,
    "awayLineScores": [
      7,
      9,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.590302437543869,
    "awayPregameElo": 1780,
    "awayPostgameElo": 1794,
    "excitementIndex": 7.451622569791746,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752892,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-01T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 86529,
    "venueId": 3834,
    "venue": "Memorial Stadium (Lincoln, NE)",
    "homeId": 158,
    "homeTeam": "Nebraska",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 17,
    "homeLineScores": [
      7,
      7,
      0,
      3
    ],
    "homePostgameWinProbability": 0.2626121938228607,
    "homePregameElo": 1645,
    "homePostgameElo": 1655,
    "awayId": 30,
    "awayTeam": "USC",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      6,
      8,
      7
    ],
    "awayPostgameWinProbability": 0.7373878061771393,
    "awayPregameElo": 1907,
    "awayPostgameElo": 1897,
    "excitementIndex": 4.7153808799608,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761643,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-02T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23391,
    "venueId": 3975,
    "venue": "Veterans Memorial Stadium (AL)",
    "homeId": 2653,
    "homeTeam": "Troy",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 10,
    "homeLineScores": [
      0,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.15671361982822418,
    "homePregameElo": 1499,
    "homePostgameElo": 1445,
    "awayId": 2032,
    "awayTeam": "Arkansas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 23,
    "awayLineScores": [
      17,
      0,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.8432863801717758,
    "awayPregameElo": 1260,
    "awayPostgameElo": 1314,
    "excitementIndex": 3.168595591458259,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756942,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-02T02:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 51672,
    "venueId": 587,
    "venue": "Rice-Eccles Stadium",
    "homeId": 254,
    "homeTeam": "Utah",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 45,
    "homeLineScores": [
      14,
      10,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9916237592697144,
    "homePregameElo": 1887,
    "homePostgameElo": 1941,
    "awayId": 2132,
    "awayTeam": "Cincinnati",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.008376240730285645,
    "awayPregameElo": 1644,
    "awayPostgameElo": 1590,
    "excitementIndex": 4.715953022024585,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760403,
    "season": 2025,
    "week": 10,
    "seasonType": "regular",
    "startDate": "2025-11-02T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16012,
    "venueId": 3935,
    "venue": "CEFCU Stadium",
    "homeId": 23,
    "homeTeam": "San José State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 45,
    "homeLineScores": [
      7,
      24,
      7,
      7
    ],
    "homePostgameWinProbability": 0.8009711503982544,
    "homePregameElo": 1410,
    "homePostgameElo": 1417,
    "awayId": 62,
    "awayTeam": "Hawai'i",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      7,
      14,
      10
    ],
    "awayPostgameWinProbability": 0.1990288496017456,
    "awayPregameElo": 1366,
    "awayPostgameElo": 1359,
    "excitementIndex": 6.526755676359059,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762851,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-05T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 5046,
    "venueId": 3768,
    "venue": "InfoCision Stadium",
    "homeId": 2006,
    "homeTeam": "Akron",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 44,
    "homeLineScores": [
      14,
      13,
      10,
      7
    ],
    "homePostgameWinProbability": 0.991926372051239,
    "homePregameElo": 1040,
    "homePostgameElo": 1114,
    "awayId": 113,
    "awayTeam": "Massachusetts",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 10,
    "awayLineScores": [
      10,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.008073627948760986,
    "awayPregameElo": 879,
    "awayPostgameElo": 805,
    "excitementIndex": 3.3217400816098404,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762852,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-05T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22231,
    "venueId": 3876,
    "venue": "Peden Stadium",
    "homeId": 195,
    "homeTeam": "Ohio",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 24,
    "homeLineScores": [
      0,
      3,
      7,
      14
    ],
    "homePostgameWinProbability": 0.48510420322418213,
    "homePregameElo": 1596,
    "homePostgameElo": 1595,
    "awayId": 193,
    "awayTeam": "Miami (OH)",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 20,
    "awayLineScores": [
      0,
      3,
      3,
      14
    ],
    "awayPostgameWinProbability": 0.5148957967758179,
    "awayPregameElo": 1459,
    "awayPostgameElo": 1460,
    "excitementIndex": 6.955650470255788,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762854,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-06T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22128,
    "venueId": 3739,
    "venue": "Glass Bowl",
    "homeId": 2649,
    "homeTeam": "Toledo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 42,
    "homeLineScores": [
      7,
      21,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9862786531448364,
    "homePregameElo": 1505,
    "homePostgameElo": 1591,
    "awayId": 2459,
    "awayTeam": "Northern Illinois",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 3,
    "awayLineScores": [
      3,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.013721346855163574,
    "awayPregameElo": 1305,
    "awayPostgameElo": 1219,
    "excitementIndex": 3.577276611121748,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762853,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-06T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 5225,
    "venueId": 3919,
    "venue": "Scheumann Stadium",
    "homeId": 2050,
    "homeTeam": "Ball State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 17,
    "homeLineScores": [
      3,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.5814944505691528,
    "homePregameElo": 1047,
    "homePostgameElo": 1047,
    "awayId": 2309,
    "awayTeam": "Kent State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      3,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.41850554943084717,
    "awayPregameElo": 945,
    "awayPostgameElo": 945,
    "excitementIndex": 6.84298151650683,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762500,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-07T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 27437,
    "venueId": 3886,
    "venue": "Raymond James Stadium",
    "homeId": 58,
    "homeTeam": "South Florida",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 55,
    "homeLineScores": [
      14,
      31,
      10,
      0
    ],
    "homePostgameWinProbability": 0.9891061782836914,
    "homePregameElo": 1662,
    "homePostgameElo": 1734,
    "awayId": 2636,
    "awayTeam": "UTSA",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 23,
    "awayLineScores": [
      3,
      7,
      3,
      10
    ],
    "awayPostgameWinProbability": 0.010893821716308594,
    "awayPregameElo": 1537,
    "awayPostgameElo": 1465,
    "excitementIndex": 3.5523773833316556,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761644,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-07T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 31876,
    "venueId": 3792,
    "venue": "Kidd Brewer Stadium",
    "homeId": 2026,
    "homeTeam": "App State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 23,
    "homeLineScores": [
      0,
      3,
      6,
      14
    ],
    "homePostgameWinProbability": 0.022688305005431175,
    "homePregameElo": 1332,
    "homePostgameElo": 1328,
    "awayId": 290,
    "awayTeam": "Georgia Southern",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 25,
    "awayLineScores": [
      9,
      10,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.9773116949945688,
    "awayPregameElo": 1310,
    "awayPostgameElo": 1314,
    "excitementIndex": 5.715089990728676,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756946,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44206,
    "venueId": 3652,
    "venue": "FBC Mortgage Stadium",
    "homeId": 2116,
    "homeTeam": "UCF",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 27,
    "homeLineScores": [
      3,
      21,
      3,
      0
    ],
    "homePostgameWinProbability": 0.7304641008377075,
    "homePregameElo": 1537,
    "homePostgameElo": 1528,
    "awayId": 248,
    "awayTeam": "Houston",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 30,
    "awayLineScores": [
      0,
      17,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.2695358991622925,
    "awayPregameElo": 1467,
    "awayPostgameElo": 1476,
    "excitementIndex": 6.663307882242472,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762501,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30384,
    "venueId": 3805,
    "venue": "Simmons Bank Liberty Stadium",
    "homeId": 235,
    "homeTeam": "Memphis",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 32,
    "homeLineScores": [
      7,
      10,
      0,
      15
    ],
    "homePostgameWinProbability": 0.1007533147931099,
    "homePregameElo": 1689,
    "homePostgameElo": 1665,
    "awayId": 2655,
    "awayTeam": "Tulane",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 38,
    "awayLineScores": [
      14,
      21,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.8992466852068901,
    "awayPregameElo": 1521,
    "awayPostgameElo": 1545,
    "excitementIndex": 5.2354917806746215,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752896,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 67179,
    "venueId": 477,
    "venue": "Los Angeles Memorial Coliseum",
    "homeId": 30,
    "homeTeam": "USC",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      7,
      14,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9854589104652405,
    "homePregameElo": 1897,
    "homePostgameElo": 1911,
    "awayId": 77,
    "awayTeam": "Northwestern",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.014541089534759521,
    "awayPregameElo": 1530,
    "awayPostgameElo": 1516,
    "excitementIndex": 4.5728441639476936,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756947,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 55510,
    "venueId": 3842,
    "venue": "Milan Puskar Stadium",
    "homeId": 277,
    "homeTeam": "West Virginia",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 29,
    "homeLineScores": [
      9,
      10,
      3,
      7
    ],
    "homePostgameWinProbability": 0.8557804822921753,
    "homePregameElo": 1340,
    "homePostgameElo": 1352,
    "awayId": 38,
    "awayTeam": "Colorado",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 22,
    "awayLineScores": [
      0,
      9,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.1442195177078247,
    "awayPregameElo": 1389,
    "awayPostgameElo": 1377,
    "excitementIndex": 6.34381918133446,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752762,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 53017,
    "venueId": 3693,
    "venue": "Davis Wade Stadium",
    "homeId": 344,
    "homeTeam": "Mississippi State",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 21,
    "homeLineScores": [
      7,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.00030286144465208054,
    "homePregameElo": 1524,
    "homePostgameElo": 1523,
    "awayId": 61,
    "awayTeam": "Georgia",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 41,
    "awayLineScores": [
      3,
      21,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.9996971385553479,
    "awayPregameElo": 2017,
    "awayPostgameElo": 2018,
    "excitementIndex": 3.785267348604506,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752893,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 105231,
    "venueId": 3632,
    "venue": "Beaver Stadium",
    "homeId": 213,
    "homeTeam": "Penn State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      0,
      7,
      3,
      14
    ],
    "homePostgameWinProbability": 0.7747411727905273,
    "homePregameElo": 1942,
    "homePostgameElo": 1950,
    "awayId": 84,
    "awayTeam": "Indiana",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      10,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.22525882720947266,
    "awayPregameElo": 2158,
    "awayPostgameElo": 2150,
    "excitementIndex": 6.664598569819111,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762503,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30594,
    "venueId": 3841,
    "venue": "Michie Stadium",
    "homeId": 349,
    "homeTeam": "Army",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.609444260597229,
    "homePregameElo": 1537,
    "homePostgameElo": 1529,
    "awayId": 218,
    "awayTeam": "Temple",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      10,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.390555739402771,
    "awayPregameElo": 1258,
    "awayPostgameElo": 1266,
    "excitementIndex": 4.983308218309781,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761647,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15441,
    "venueId": 3625,
    "venue": "Centennial Bank Stadium",
    "homeId": 2032,
    "homeTeam": "Arkansas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 21,
    "homeLineScores": [
      7,
      0,
      0,
      14
    ],
    "homePostgameWinProbability": 0.058736804872751236,
    "homePregameElo": 1314,
    "homePostgameElo": 1306,
    "awayId": 2572,
    "awayTeam": "Southern Miss",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 27,
    "awayLineScores": [
      10,
      7,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.9412631951272488,
    "awayPregameElo": 1354,
    "awayPostgameElo": 1362,
    "excitementIndex": 5.968283460300001,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754584,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 38345,
    "venueId": 3615,
    "venue": "Alumni Stadium (Chestnut Hill, MA)",
    "homeId": 103,
    "homeTeam": "Boston College",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 13,
    "homeLineScores": [
      0,
      6,
      0,
      7
    ],
    "homePostgameWinProbability": 0.05360548943281174,
    "homePregameElo": 1339,
    "homePostgameElo": 1298,
    "awayId": 2567,
    "awayTeam": "SMU",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 45,
    "awayLineScores": [
      10,
      7,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.9463945105671883,
    "awayPregameElo": 1741,
    "awayPostgameElo": 1782,
    "excitementIndex": 4.415965398815328,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761646,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 26727,
    "venueId": 3775,
    "venue": "Joan C. Edwards Stadium",
    "homeId": 276,
    "homeTeam": "Marshall",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 23,
    "homeLineScores": [
      0,
      12,
      8,
      3
    ],
    "homePostgameWinProbability": 0.3584602475166321,
    "homePregameElo": 1509,
    "homePostgameElo": 1508,
    "awayId": 256,
    "awayTeam": "James Madison",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      14,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.6415397524833679,
    "awayPregameElo": 1801,
    "awayPostgameElo": 1802,
    "excitementIndex": 6.114623013796852,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756945,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60229,
    "venueId": 3784,
    "venue": "Jones AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 29,
    "homeLineScores": [
      10,
      3,
      6,
      10
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1903,
    "homePostgameElo": 1937,
    "awayId": 252,
    "awayTeam": "BYU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1722,
    "awayPostgameElo": 1688,
    "excitementIndex": 3.917651770566797,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752761,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 67326,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 49,
    "homeLineScores": [
      21,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.8396538496017456,
    "homePregameElo": 1980,
    "homePostgameElo": 1980,
    "awayId": 2643,
    "awayTeam": "The Citadel",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.1603461503982544,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.860293866698971,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762855,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11889,
    "venueId": 3912,
    "venue": "Rynearson Stadium",
    "homeId": 2199,
    "homeTeam": "Eastern Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 27,
    "homeLineScores": [
      10,
      0,
      7,
      10
    ],
    "homePostgameWinProbability": 0.8906720876693726,
    "homePregameElo": 1220,
    "homePostgameElo": 1229,
    "awayId": 189,
    "awayTeam": "Bowling Green",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.10932791233062744,
    "awayPregameElo": 1253,
    "awayPostgameElo": 1244,
    "excitementIndex": 6.8630174962960036,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757299,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18407,
    "venueId": 3992,
    "venue": "Williams Stadium (VA)",
    "homeId": 2335,
    "homeTeam": "Liberty",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 17,
    "homeLineScores": [
      7,
      3,
      0,
      7
    ],
    "homePostgameWinProbability": 0.737902820110321,
    "homePregameElo": 1506,
    "homePostgameElo": 1488,
    "awayId": 2623,
    "awayTeam": "Missouri State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      0,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.26209717988967896,
    "awayPregameElo": 1340,
    "awayPostgameElo": 1358,
    "excitementIndex": 5.833908836982461,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752897,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 57701,
    "venueId": 3907,
    "venue": "Ross-Ade Stadium",
    "homeId": 2509,
    "homeTeam": "Purdue",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 10,
    "homeLineScores": [
      3,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.00806874968111515,
    "homePregameElo": 1310,
    "homePostgameElo": 1331,
    "awayId": 194,
    "awayTeam": "Ohio State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 34,
    "awayLineScores": [
      0,
      24,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.9919312503188848,
    "awayPregameElo": 2146,
    "awayPostgameElo": 2125,
    "excitementIndex": 3.172106994027828,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762502,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22671,
    "venueId": 3895,
    "venue": "Rice Stadium",
    "homeId": 242,
    "homeTeam": "Rice",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 24,
    "homeLineScores": [
      7,
      7,
      10,
      0
    ],
    "homePostgameWinProbability": 0.8724786639213562,
    "homePregameElo": 1155,
    "homePostgameElo": 1169,
    "awayId": 5,
    "awayTeam": "UAB",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 17,
    "awayLineScores": [
      7,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.1275213360786438,
    "awayPregameElo": 1237,
    "awayPostgameElo": 1223,
    "excitementIndex": 5.172895885749528,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752894,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 41032,
    "venueId": 6577,
    "venue": "SHI Stadium",
    "homeId": 164,
    "homeTeam": "Rutgers",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 35,
    "homeLineScores": [
      0,
      21,
      7,
      7
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1419,
    "homePostgameElo": 1458,
    "awayId": 120,
    "awayTeam": "Maryland",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      10,
      0,
      3
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1506,
    "awayPostgameElo": 1467,
    "excitementIndex": 5.298712917874017,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757296,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12227,
    "venueId": 3725,
    "venue": "Johnny \"Red\" Floyd Stadium",
    "homeId": 2393,
    "homeTeam": "Middle Tennessee",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 30,
    "homeLineScores": [
      7,
      10,
      7,
      6
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1199,
    "homePostgameElo": 1134,
    "awayId": 2229,
    "awayTeam": "Florida International",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 56,
    "awayLineScores": [
      0,
      21,
      13,
      22
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1241,
    "awayPostgameElo": 1306,
    "excitementIndex": 7.259780064557759,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762505,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16170,
    "venueId": 3715,
    "venue": "FAU Stadium",
    "homeId": 2226,
    "homeTeam": "Florida Atlantic",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 40,
    "homeLineScores": [
      10,
      21,
      3,
      6
    ],
    "homePostgameWinProbability": 0.9932003021240234,
    "homePregameElo": 1218,
    "homePostgameElo": 1247,
    "awayId": 202,
    "awayTeam": "Tulsa",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      6,
      12,
      3
    ],
    "awayPostgameWinProbability": 0.0067996978759765625,
    "awayPregameElo": 1066,
    "awayPostgameElo": 1037,
    "excitementIndex": 4.589572527938528,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762504,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 39096,
    "venueId": 3699,
    "venue": "Dowdy-Ficklen Stadium",
    "homeId": 151,
    "homeTeam": "East Carolina",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 48,
    "homeLineScores": [
      21,
      14,
      10,
      3
    ],
    "homePostgameWinProbability": 0.9722951054573059,
    "homePregameElo": 1591,
    "homePostgameElo": 1599,
    "awayId": 2429,
    "awayTeam": "Charlotte",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 22,
    "awayLineScores": [
      0,
      14,
      8,
      0
    ],
    "awayPostgameWinProbability": 0.027704894542694092,
    "awayPregameElo": 1028,
    "awayPostgameElo": 1020,
    "excitementIndex": 3.048260088986414,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757295,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17912,
    "venueId": 3695,
    "venue": "Delaware Stadium",
    "homeId": 48,
    "homeTeam": "Delaware",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 25,
    "homeLineScores": [
      3,
      6,
      7,
      9
    ],
    "homePostgameWinProbability": 0.19434231519699097,
    "homePregameElo": 1383,
    "homePostgameElo": 1386,
    "awayId": 2348,
    "awayTeam": "Louisiana Tech",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      0,
      0,
      17
    ],
    "awayPostgameWinProbability": 0.805657684803009,
    "awayPregameElo": 1465,
    "awayPostgameElo": 1462,
    "excitementIndex": 9.334417335939435,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757297,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9536,
    "venueId": 3946,
    "venue": "Sun Bowl",
    "homeId": 2638,
    "homeTeam": "UTEP",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 27,
    "homeLineScores": [
      7,
      6,
      7,
      7
    ],
    "homePostgameWinProbability": 0.27030807733535767,
    "homePregameElo": 1220,
    "homePostgameElo": 1233,
    "awayId": 55,
    "awayTeam": "Jacksonville State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 30,
    "awayLineScores": [
      10,
      10,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.7296919226646423,
    "awayPregameElo": 1525,
    "awayPostgameElo": 1512,
    "excitementIndex": 8.723114109384603,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752898,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 69250,
    "venueId": 3793,
    "venue": "Kinnick Stadium",
    "homeId": 2294,
    "homeTeam": "Iowa",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 16,
    "homeLineScores": [
      0,
      7,
      0,
      9
    ],
    "homePostgameWinProbability": 0.19565224647521973,
    "homePregameElo": 1907,
    "homePostgameElo": 1912,
    "awayId": 2483,
    "awayTeam": "Oregon",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 18,
    "awayLineScores": [
      2,
      10,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.8043477535247803,
    "awayPregameElo": 2055,
    "awayPostgameElo": 2050,
    "excitementIndex": 5.293227062970093,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756944,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44197,
    "venueId": 3616,
    "venue": "Amon G. Carter Stadium",
    "homeId": 2628,
    "homeTeam": "TCU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 17,
    "homeLineScores": [
      0,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.7886301279067993,
    "homePregameElo": 1700,
    "homePostgameElo": 1689,
    "awayId": 66,
    "awayTeam": "Iowa State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 20,
    "awayLineScores": [
      6,
      0,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.21136987209320068,
    "awayPregameElo": 1589,
    "awayPostgameElo": 1600,
    "excitementIndex": 6.215050875410496,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752763,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 57321,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 17,
    "homeLineScores": [
      0,
      0,
      7,
      10
    ],
    "homePostgameWinProbability": 0.04629594460129738,
    "homePregameElo": 1779,
    "homePostgameElo": 1734,
    "awayId": 245,
    "awayTeam": "Texas A&M",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      7,
      10,
      14
    ],
    "awayPostgameWinProbability": 0.9537040553987026,
    "awayPregameElo": 1859,
    "awayPostgameElo": 1904,
    "excitementIndex": 3.262741592650687,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756943,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 41115,
    "venueId": 3619,
    "venue": "Arizona Stadium",
    "homeId": 12,
    "homeTeam": "Arizona",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 24,
    "homeLineScores": [
      7,
      7,
      3,
      7
    ],
    "homePostgameWinProbability": 0.4165548086166382,
    "homePregameElo": 1578,
    "homePostgameElo": 1580,
    "awayId": 2305,
    "awayTeam": "Kansas",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      10,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.5834451913833618,
    "awayPregameElo": 1556,
    "awayPostgameElo": 1554,
    "excitementIndex": 6.916815613183976,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754587,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60337,
    "venueId": 3948,
    "venue": "Hard Rock Stadium",
    "homeId": 2390,
    "homeTeam": "Miami",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      0,
      14,
      17,
      7
    ],
    "homePostgameWinProbability": 0.9172752499580383,
    "homePregameElo": 1849,
    "homePostgameElo": 1865,
    "awayId": 183,
    "awayTeam": "Syracuse",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.08272475004196167,
    "awayPregameElo": 1320,
    "awayPostgameElo": 1304,
    "excitementIndex": 4.651239050972079,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754590,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 38106,
    "venueId": 3892,
    "venue": "Pratt & Whitney Stadium",
    "homeId": 41,
    "homeTeam": "UConn",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 37,
    "homeLineScores": [
      10,
      10,
      3,
      14
    ],
    "homePostgameWinProbability": 0.6942955255508423,
    "homePregameElo": 1561,
    "homePostgameElo": 1563,
    "awayId": 150,
    "awayTeam": "Duke",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      7,
      14,
      6
    ],
    "awayPostgameWinProbability": 0.3057044744491577,
    "awayPregameElo": 1627,
    "awayPostgameElo": 1625,
    "excitementIndex": 8.169094014073593,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761645,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18878,
    "venueId": 3654,
    "venue": "Brooks Stadium (SC)",
    "homeId": 324,
    "homeTeam": "Coastal Carolina",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 40,
    "homeLineScores": [
      14,
      9,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9960300326347351,
    "homePregameElo": 1309,
    "homePostgameElo": 1318,
    "awayId": 2247,
    "awayTeam": "Georgia State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 27,
    "awayLineScores": [
      14,
      0,
      0,
      13
    ],
    "awayPostgameWinProbability": 0.003969967365264893,
    "awayPregameElo": 1107,
    "awayPostgameElo": 1098,
    "excitementIndex": 4.3751025673075485,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752764,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 35000,
    "venueId": 3973,
    "venue": "FirstBank Stadium",
    "homeId": 238,
    "homeTeam": "Vanderbilt",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 45,
    "homeLineScores": [
      0,
      10,
      14,
      14,
      7
    ],
    "homePostgameWinProbability": 0.6538436412811279,
    "homePregameElo": 1766,
    "homePostgameElo": 1770,
    "awayId": 2,
    "awayTeam": "Auburn",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 38,
    "awayLineScores": [
      7,
      13,
      10,
      8,
      0
    ],
    "awayPostgameWinProbability": 0.34615635871887207,
    "awayPregameElo": 1665,
    "awayPostgameElo": 1661,
    "excitementIndex": 9.654093646665734,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757298,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11473,
    "venueId": 3601,
    "venue": "Aggie Memorial Stadium",
    "homeId": 166,
    "homeTeam": "New Mexico State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 21,
    "homeLineScores": [
      0,
      7,
      0,
      14
    ],
    "homePostgameWinProbability": 0.06049735099077225,
    "homePregameElo": 1194,
    "homePostgameElo": 1201,
    "awayId": 338,
    "awayTeam": "Kennesaw State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 24,
    "awayLineScores": [
      17,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.9395026490092278,
    "awayPregameElo": 1388,
    "awayPostgameElo": 1381,
    "excitementIndex": 5.516987729558563,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754588,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T21:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50500,
    "venueId": 3787,
    "venue": "Kenan Stadium",
    "homeId": 153,
    "homeTeam": "North Carolina",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 20,
    "homeLineScores": [
      3,
      0,
      7,
      10
    ],
    "homePostgameWinProbability": 0.43635404109954834,
    "homePregameElo": 1394,
    "homePostgameElo": 1393,
    "awayId": 24,
    "awayTeam": "Stanford",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 15,
    "awayLineScores": [
      0,
      3,
      0,
      12
    ],
    "awayPostgameWinProbability": 0.5636459589004517,
    "awayPregameElo": 1245,
    "awayPostgameElo": 1246,
    "excitementIndex": 6.069590950578316,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752899,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T21:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 71217,
    "venueId": 347,
    "venue": "Camp Randall Stadium",
    "homeId": 275,
    "homeTeam": "Wisconsin",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 13,
    "homeLineScores": [
      0,
      3,
      10,
      0
    ],
    "homePostgameWinProbability": 0.7089943885803223,
    "homePregameElo": 1455,
    "homePostgameElo": 1459,
    "awayId": 264,
    "awayTeam": "Washington",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.29100561141967773,
    "awayPregameElo": 1703,
    "awayPostgameElo": 1699,
    "excitementIndex": 5.867666507061793,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761648,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14231,
    "venueId": 3666,
    "venue": "Cajun Field",
    "homeId": 309,
    "homeTeam": "Louisiana",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 42,
    "homeLineScores": [
      7,
      28,
      0,
      7
    ],
    "homePostgameWinProbability": 0.550256609916687,
    "homePregameElo": 1347,
    "homePostgameElo": 1350,
    "awayId": 326,
    "awayTeam": "Texas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 39,
    "awayLineScores": [
      10,
      7,
      3,
      19
    ],
    "awayPostgameWinProbability": 0.449743390083313,
    "awayPregameElo": 1486,
    "awayPostgameElo": 1483,
    "excitementIndex": 6.100831798852394,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760406,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-08T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13637,
    "venueId": 3935,
    "venue": "CEFCU Stadium",
    "homeId": 23,
    "homeTeam": "San José State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 16,
    "homeLineScores": [
      3,
      0,
      3,
      10
    ],
    "homePostgameWinProbability": 0.5757960677146912,
    "homePregameElo": 1417,
    "homePostgameElo": 1391,
    "awayId": 2005,
    "awayTeam": "Air Force",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 26,
    "awayLineScores": [
      0,
      16,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.42420393228530884,
    "awayPregameElo": 1362,
    "awayPostgameElo": 1388,
    "excitementIndex": 4.285756759162298,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754589,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-09T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 55568,
    "venueId": 3923,
    "venue": "Scott Stadium",
    "homeId": 258,
    "homeTeam": "Virginia",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 9,
    "homeLineScores": [
      3,
      3,
      3,
      0
    ],
    "homePostgameWinProbability": 0.4460456073284149,
    "homePregameElo": 1585,
    "homePostgameElo": 1555,
    "awayId": 154,
    "awayTeam": "Wake Forest",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      10,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.5539543926715851,
    "awayPregameElo": 1382,
    "awayPostgameElo": 1412,
    "excitementIndex": 6.244289362830801,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754586,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-09T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 81500,
    "venueId": 3836,
    "venue": "Memorial Stadium (Clemson, SC)",
    "homeId": 228,
    "homeTeam": "Clemson",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 24,
    "homeLineScores": [
      8,
      10,
      3,
      3
    ],
    "homePostgameWinProbability": 0.9389448165893555,
    "homePregameElo": 1703,
    "homePostgameElo": 1725,
    "awayId": 52,
    "awayTeam": "Florida State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      7,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.06105518341064453,
    "awayPregameElo": 1631,
    "awayPostgameElo": 1609,
    "excitementIndex": 3.8373446690837896,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754585,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-09T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 51381,
    "venueId": 3873,
    "venue": "L&N Federal Credit Union Stadium",
    "homeId": 97,
    "homeTeam": "Louisville",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 26,
    "homeLineScores": [
      7,
      6,
      7,
      3,
      3
    ],
    "homePostgameWinProbability": 0.5194576382637024,
    "homePregameElo": 1737,
    "homePostgameElo": 1709,
    "awayId": 25,
    "awayTeam": "California",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 29,
    "awayLineScores": [
      7,
      10,
      6,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.4805423617362976,
    "awayPregameElo": 1392,
    "awayPostgameElo": 1420,
    "excitementIndex": 8.99296986382329,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757166,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-09T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 77622,
    "venueId": 3855,
    "venue": "Notre Dame Stadium",
    "homeId": 87,
    "homeTeam": "Notre Dame",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 49,
    "homeLineScores": [
      7,
      14,
      21,
      7
    ],
    "homePostgameWinProbability": 0.9965944290161133,
    "homePregameElo": 2153,
    "homePostgameElo": 2186,
    "awayId": 2426,
    "awayTeam": "Navy",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0034055709838867188,
    "awayPregameElo": 1513,
    "awayPostgameElo": 1480,
    "excitementIndex": 3.485669518425278,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752760,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-09T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 56388,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 38,
    "homeLineScores": [
      3,
      21,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9859484434127808,
    "homePregameElo": 1535,
    "homePostgameElo": 1635,
    "awayId": 57,
    "awayTeam": "Florida",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.014051556587219238,
    "awayPregameElo": 1655,
    "awayPostgameElo": 1555,
    "excitementIndex": 4.399998272900254,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760409,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-09T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19418,
    "venueId": 3905,
    "venue": "Maverik Stadium",
    "homeId": 328,
    "homeTeam": "Utah State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 51,
    "homeLineScores": [
      24,
      17,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9874172210693359,
    "homePregameElo": 1336,
    "homePostgameElo": 1422,
    "awayId": 2440,
    "awayTeam": "Nevada",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.012582778930664062,
    "awayPregameElo": 1191,
    "awayPostgameElo": 1105,
    "excitementIndex": 3.126605527106751,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752759,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-09T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 100077,
    "venueId": 3657,
    "venue": "Bryant-Denny Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 20,
    "homeLineScores": [
      3,
      14,
      0,
      3
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1978,
    "homePostgameElo": 1977,
    "awayId": 99,
    "awayTeam": "LSU",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 9,
    "awayLineScores": [
      0,
      3,
      3,
      3
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1694,
    "awayPostgameElo": 1695,
    "excitementIndex": 4.702523288331052,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752895,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-09T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44481,
    "venueId": 1056,
    "venue": "Rose Bowl",
    "homeId": 26,
    "homeTeam": "UCLA",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 21,
    "homeLineScores": [
      0,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.4979483187198639,
    "homePregameElo": 1374,
    "homePostgameElo": 1381,
    "awayId": 158,
    "awayTeam": "Nebraska",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      14,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.5020516812801361,
    "awayPregameElo": 1655,
    "awayPostgameElo": 1648,
    "excitementIndex": 3.712969991617385,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760407,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-09T02:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 27970,
    "venueId": 5388,
    "venue": "Canvas Stadium",
    "homeId": 36,
    "homeTeam": "Colorado State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 10,
    "homeLineScores": [
      7,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.010899788700044155,
    "homePregameElo": 1277,
    "homePostgameElo": 1221,
    "awayId": 2439,
    "awayTeam": "UNLV",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 42,
    "awayLineScores": [
      0,
      21,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.9891002112999558,
    "awayPregameElo": 1549,
    "awayPostgameElo": 1605,
    "excitementIndex": 3.8275123302837475,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752944,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-09T03:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 31626,
    "venueId": 3893,
    "venue": "Reser Stadium",
    "homeId": 204,
    "homeTeam": "Oregon State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 17,
    "homeLineScores": [
      10,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.6110923886299133,
    "homePregameElo": 1252,
    "homePostgameElo": 1232,
    "awayId": 2534,
    "awayTeam": "Sam Houston",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.38890761137008667,
    "awayPregameElo": 1052,
    "awayPostgameElo": 1072,
    "excitementIndex": 5.62729618296782,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760408,
    "season": 2025,
    "week": 11,
    "seasonType": "regular",
    "startDate": "2025-11-09T04:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15194,
    "venueId": 7220,
    "venue": "Clarence T.C. Ching Athletics Complex",
    "homeId": 62,
    "homeTeam": "Hawai'i",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 38,
    "homeLineScores": [
      14,
      10,
      14,
      0
    ],
    "homePostgameWinProbability": 0.9866335391998291,
    "homePregameElo": 1359,
    "homePostgameElo": 1480,
    "awayId": 21,
    "awayTeam": "San Diego State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 6,
    "awayLineScores": [
      3,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.013366460800170898,
    "awayPregameElo": 1601,
    "awayPostgameElo": 1480,
    "excitementIndex": 4.130753475832267,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762856,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-12T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 8501,
    "venueId": 3768,
    "venue": "InfoCision Stadium",
    "homeId": 2006,
    "homeTeam": "Akron",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 35,
    "homeLineScores": [
      3,
      14,
      0,
      18,
      0
    ],
    "homePostgameWinProbability": 0.26191046833992004,
    "homePregameElo": 1114,
    "homePostgameElo": 1087,
    "awayId": 2309,
    "awayTeam": "Kent State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 42,
    "awayLineScores": [
      7,
      7,
      14,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.73808953166008,
    "awayPregameElo": 945,
    "awayPostgameElo": 972,
    "excitementIndex": 7.404795806309063,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762857,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-12T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10849,
    "venueId": 3980,
    "venue": "Waldo Stadium",
    "homeId": 2711,
    "homeTeam": "Western Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 17,
    "homeLineScores": [
      3,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.8629486560821533,
    "homePregameElo": 1368,
    "homePostgameElo": 1378,
    "awayId": 195,
    "awayTeam": "Ohio",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 13,
    "awayLineScores": [
      7,
      0,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.13705134391784668,
    "awayPregameElo": 1595,
    "awayPostgameElo": 1585,
    "excitementIndex": 5.865414628480906,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762859,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-13T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 6155,
    "venueId": 3985,
    "venue": "Warren McGuirk Alumni Stadium",
    "homeId": 113,
    "homeTeam": "Massachusetts",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 3,
    "homeLineScores": [
      0,
      0,
      0,
      3
    ],
    "homePostgameWinProbability": 0.005873220972716808,
    "homePregameElo": 805,
    "homePostgameElo": 735,
    "awayId": 2459,
    "awayTeam": "Northern Illinois",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 45,
    "awayLineScores": [
      10,
      21,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.9941267790272832,
    "awayPregameElo": 1219,
    "awayPostgameElo": 1289,
    "excitementIndex": 2.806565714977987,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762858,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-13T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 6833,
    "venueId": 3786,
    "venue": "Kelly/Shorts Stadium",
    "homeId": 2117,
    "homeTeam": "Central Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 38,
    "homeLineScores": [
      7,
      7,
      10,
      14
    ],
    "homePostgameWinProbability": 0.8471727967262268,
    "homePregameElo": 1235,
    "homePostgameElo": 1293,
    "awayId": 2084,
    "awayTeam": "Buffalo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 19,
    "awayLineScores": [
      3,
      7,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.1528272032737732,
    "awayPregameElo": 1376,
    "awayPostgameElo": 1318,
    "excitementIndex": 4.971371681547711,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762860,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-13T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10825,
    "venueId": 3996,
    "venue": "Yager Stadium",
    "homeId": 193,
    "homeTeam": "Miami (OH)",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 3,
    "homeLineScores": [
      0,
      0,
      3,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1460,
    "homePostgameElo": 1421,
    "awayId": 2649,
    "awayTeam": "Toledo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      14,
      10,
      0
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1591,
    "awayPostgameElo": 1630,
    "excitementIndex": 4.9239712173484955,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761649,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-14T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18831,
    "venueId": 3918,
    "venue": "S.B. Ballard Stadium",
    "homeId": 295,
    "homeTeam": "Old Dominion",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 33,
    "homeLineScores": [
      10,
      10,
      6,
      7
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1480,
    "homePostgameElo": 1566,
    "awayId": 2653,
    "awayTeam": "Troy",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1445,
    "awayPostgameElo": 1359,
    "excitementIndex": 3.2122380345480894,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754591,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 51234,
    "venueId": 3873,
    "venue": "L&N Federal Credit Union Stadium",
    "homeId": 97,
    "homeTeam": "Louisville",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 19,
    "homeLineScores": [
      3,
      6,
      10,
      0
    ],
    "homePostgameWinProbability": 0.7156305313110352,
    "homePregameElo": 1709,
    "homePostgameElo": 1709,
    "awayId": 228,
    "awayTeam": "Clemson",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      7,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.28436946868896484,
    "awayPregameElo": 1725,
    "awayPostgameElo": 1725,
    "excitementIndex": 7.815486053722058,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752904,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 58830,
    "venueId": 3626,
    "venue": "Autzen Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 42,
    "homeLineScores": [
      14,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9859622120857239,
    "homePregameElo": 2050,
    "homePostgameElo": 2068,
    "awayId": 135,
    "awayTeam": "Minnesota",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      6,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.014037787914276123,
    "awayPregameElo": 1514,
    "awayPostgameElo": 1496,
    "excitementIndex": 2.8395112406775915,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756952,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 46340,
    "venueId": 3646,
    "venue": "Boone Pickens Stadium",
    "homeId": 197,
    "homeTeam": "Oklahoma State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 6,
    "homeLineScores": [
      3,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.153341144323349,
    "homePregameElo": 1049,
    "homePostgameElo": 1080,
    "awayId": 2306,
    "awayTeam": "Kansas State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.846658855676651,
    "awayPregameElo": 1705,
    "awayPostgameElo": 1674,
    "excitementIndex": 5.0820189698298535,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754597,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 68400,
    "venueId": 3752,
    "venue": "Acrisure Stadium",
    "homeId": 221,
    "homeTeam": "Pittsburgh",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 15,
    "homeLineScores": [
      0,
      3,
      6,
      6
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1668,
    "homePostgameElo": 1665,
    "awayId": 87,
    "awayTeam": "Notre Dame",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 37,
    "awayLineScores": [
      14,
      7,
      9,
      7
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 2186,
    "awayPostgameElo": 2189,
    "excitementIndex": 3.9008140389274337,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762507,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9831,
    "venueId": 4418,
    "venue": "Jerry Richardson Stadium",
    "homeId": 2429,
    "homeTeam": "Charlotte",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0.008371274918317795,
    "homePregameElo": 1020,
    "homePostgameElo": 1013,
    "awayId": 2636,
    "awayTeam": "UTSA",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      0,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.9916287250816822,
    "awayPregameElo": 1465,
    "awayPostgameElo": 1472,
    "excitementIndex": 3.426061002724206,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752905,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 38223,
    "venueId": 4250,
    "venue": "Wrigley Field",
    "homeId": 77,
    "homeTeam": "Northwestern",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 22,
    "homeLineScores": [
      0,
      6,
      3,
      13
    ],
    "homePostgameWinProbability": 0.33105868101119995,
    "homePregameElo": 1516,
    "homePostgameElo": 1526,
    "awayId": 130,
    "awayTeam": "Michigan",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      7,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.6689413189888,
    "awayPregameElo": 1809,
    "awayPostgameElo": 1799,
    "excitementIndex": 6.608091433028607,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756951,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 37099,
    "venueId": 3854,
    "venue": "Nippert Stadium",
    "homeId": 2132,
    "homeTeam": "Cincinnati",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 24,
    "homeLineScores": [
      14,
      0,
      3,
      7
    ],
    "homePostgameWinProbability": 0.06054854020476341,
    "homePregameElo": 1590,
    "homePostgameElo": 1578,
    "awayId": 12,
    "awayTeam": "Arizona",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 30,
    "awayLineScores": [
      7,
      3,
      10,
      10
    ],
    "awayPostgameWinProbability": 0.9394514597952366,
    "awayPregameElo": 1580,
    "awayPostgameElo": 1592,
    "excitementIndex": 5.649878575059863,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762510,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 34856,
    "venueId": 3852,
    "venue": "Navy-Marine Corps Memorial Stadium",
    "homeId": 2426,
    "homeTeam": "Navy",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 41,
    "homeLineScores": [
      14,
      10,
      0,
      17
    ],
    "homePostgameWinProbability": 0.8824848532676697,
    "homePregameElo": 1480,
    "homePostgameElo": 1485,
    "awayId": 58,
    "awayTeam": "South Florida",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 38,
    "awayLineScores": [
      3,
      6,
      7,
      22
    ],
    "awayPostgameWinProbability": 0.11751514673233032,
    "awayPregameElo": 1734,
    "awayPostgameElo": 1729,
    "excitementIndex": 6.582655336220061,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762861,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 8430,
    "venueId": 3919,
    "venue": "Scheumann Stadium",
    "homeId": 2050,
    "homeTeam": "Ball State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 9,
    "homeLineScores": [
      0,
      3,
      3,
      3
    ],
    "homePostgameWinProbability": 0.03734716773033142,
    "homePregameElo": 1047,
    "homePostgameElo": 1030,
    "awayId": 2199,
    "awayTeam": "Eastern Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      10,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.9626528322696686,
    "awayPregameElo": 1229,
    "awayPostgameElo": 1246,
    "excitementIndex": 3.3275831010822574,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752901,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 55042,
    "venueId": 3830,
    "venue": "Memorial Stadium (Bloomington, IN)",
    "homeId": 84,
    "homeTeam": "Indiana",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 31,
    "homeLineScores": [
      7,
      3,
      14,
      7
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 2150,
    "homePostgameElo": 2142,
    "awayId": 275,
    "awayTeam": "Wisconsin",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1459,
    "awayPostgameElo": 1467,
    "excitementIndex": 4.3108632726061495,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752772,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 108582,
    "venueId": 3795,
    "venue": "Kyle Field",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 31,
    "homeLineScores": [
      3,
      0,
      21,
      7
    ],
    "homePostgameWinProbability": 0.7916420698165894,
    "homePregameElo": 1904,
    "homePostgameElo": 1896,
    "awayId": 2579,
    "awayTeam": "South Carolina",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 30,
    "awayLineScores": [
      17,
      13,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.20835793018341064,
    "awayPregameElo": 1637,
    "awayPostgameElo": 1645,
    "excitementIndex": 6.900620804326157,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757174,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 31457,
    "venueId": 3892,
    "venue": "Pratt & Whitney Stadium",
    "homeId": 41,
    "homeTeam": "UConn",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 26,
    "homeLineScores": [
      6,
      3,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9545078873634338,
    "homePregameElo": 1563,
    "homePostgameElo": 1568,
    "awayId": 2005,
    "awayTeam": "Air Force",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 16,
    "awayLineScores": [
      7,
      0,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.04549211263656616,
    "awayPregameElo": 1388,
    "awayPostgameElo": 1383,
    "excitementIndex": 4.495044477917889,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752768,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T17:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 100212,
    "venueId": 3958,
    "venue": "Tiger Stadium (LA)",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 23,
    "homeLineScores": [
      0,
      16,
      0,
      7
    ],
    "homePostgameWinProbability": 0.3887782096862793,
    "homePregameElo": 1695,
    "homePostgameElo": 1693,
    "awayId": 8,
    "awayTeam": "Arkansas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 22,
    "awayLineScores": [
      14,
      0,
      8,
      0
    ],
    "awayPostgameWinProbability": 0.6112217903137207,
    "awayPregameElo": 1594,
    "awayPostgameElo": 1596,
    "excitementIndex": 7.210588919979645,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756948,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 54101,
    "venueId": 3947,
    "venue": "Mountain America Stadium",
    "homeId": 9,
    "homeTeam": "Arizona State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 25,
    "homeLineScores": [
      0,
      22,
      0,
      3
    ],
    "homePostgameWinProbability": 0.19627684354782104,
    "homePregameElo": 1617,
    "homePostgameElo": 1614,
    "awayId": 277,
    "awayTeam": "West Virginia",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 23,
    "awayLineScores": [
      3,
      7,
      0,
      13
    ],
    "awayPostgameWinProbability": 0.803723156452179,
    "awayPregameElo": 1352,
    "awayPostgameElo": 1355,
    "excitementIndex": 6.13494151401993,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752945,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 15034,
    "venueId": 3674,
    "venue": "Chapman Stadium",
    "homeId": 202,
    "homeTeam": "Tulsa",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 31,
    "homeLineScores": [
      14,
      3,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9970397353172302,
    "homePregameElo": 1037,
    "homePostgameElo": 1094,
    "awayId": 204,
    "awayTeam": "Oregon State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.0029602646827697754,
    "awayPregameElo": 1232,
    "awayPostgameElo": 1175,
    "excitementIndex": 3.4555215959668275,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752767,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T18:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 53686,
    "venueId": 3683,
    "venue": "Kroger Field",
    "homeId": 96,
    "homeTeam": "Kentucky",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 42,
    "homeLineScores": [
      14,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.979343593120575,
    "homePregameElo": 1622,
    "homePostgameElo": 1622,
    "awayId": 2635,
    "awayTeam": "Tennessee Tech",
    "awayClassification": "fcs",
    "awayConference": "OVC-Big South",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.02065640687942505,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.6540988779681784,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762506,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16190,
    "venueId": 7221,
    "venue": "Protective Stadium",
    "homeId": 5,
    "homeTeam": "UAB",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 24,
    "homeLineScores": [
      0,
      7,
      11,
      6
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1223,
    "homePostgameElo": 1197,
    "awayId": 249,
    "awayTeam": "North Texas",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 53,
    "awayLineScores": [
      21,
      10,
      15,
      7
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1690,
    "awayPostgameElo": 1716,
    "excitementIndex": 2.859409142957384,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761651,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12871,
    "venueId": 4246,
    "venue": "Center Parc Stadium",
    "homeId": 2247,
    "homeTeam": "Georgia State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 18,
    "homeLineScores": [
      7,
      3,
      8,
      0
    ],
    "homePostgameWinProbability": 0.02686028741300106,
    "homePregameElo": 1098,
    "homePostgameElo": 1107,
    "awayId": 276,
    "awayTeam": "Marshall",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 30,
    "awayLineScores": [
      7,
      14,
      0,
      9
    ],
    "awayPostgameWinProbability": 0.9731397125869989,
    "awayPregameElo": 1508,
    "awayPostgameElo": 1499,
    "excitementIndex": 5.23590983843582,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757304,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13298,
    "venueId": 3878,
    "venue": "Plaster Sports Complex",
    "homeId": 2623,
    "homeTeam": "Missouri State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 38,
    "homeLineScores": [
      10,
      14,
      0,
      14
    ],
    "homePostgameWinProbability": 0.8918401002883911,
    "homePregameElo": 1358,
    "homePostgameElo": 1376,
    "awayId": 2638,
    "awayTeam": "UTEP",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      7,
      17,
      0
    ],
    "awayPostgameWinProbability": 0.10815989971160889,
    "awayPregameElo": 1233,
    "awayPostgameElo": 1215,
    "excitementIndex": 4.913057065339874,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760411,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 27526,
    "venueId": 3971,
    "venue": "University Stadium (NM)",
    "homeId": 167,
    "homeTeam": "New Mexico",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 20,
    "homeLineScores": [
      0,
      10,
      0,
      10
    ],
    "homePostgameWinProbability": 0.9313487410545349,
    "homePregameElo": 1460,
    "homePostgameElo": 1458,
    "awayId": 36,
    "awayTeam": "Colorado State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      0,
      10,
      7
    ],
    "awayPostgameWinProbability": 0.06865125894546509,
    "awayPregameElo": 1221,
    "awayPostgameElo": 1223,
    "excitementIndex": 7.143939901413607,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756953,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60229,
    "venueId": 3784,
    "venue": "Jones AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 48,
    "homeLineScores": [
      14,
      24,
      10,
      0
    ],
    "homePostgameWinProbability": 0.9889745712280273,
    "homePregameElo": 1937,
    "homePostgameElo": 1997,
    "awayId": 2116,
    "awayTeam": "UCF",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 9,
    "awayLineScores": [
      0,
      2,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.011025428771972656,
    "awayPregameElo": 1528,
    "awayPostgameElo": 1468,
    "excitementIndex": 2.6824450368435704,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752906,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 56416,
    "venueId": 3832,
    "venue": "Memorial Stadium (Champaign, IL)",
    "homeId": 356,
    "homeTeam": "Illinois",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 24,
    "homeLineScores": [
      7,
      7,
      7,
      3
    ],
    "homePostgameWinProbability": 0.8684515953063965,
    "homePregameElo": 1603,
    "homePostgameElo": 1630,
    "awayId": 120,
    "awayTeam": "Maryland",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 6,
    "awayLineScores": [
      3,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.13154840469360352,
    "awayPregameElo": 1467,
    "awayPostgameElo": 1440,
    "excitementIndex": 4.134975374918965,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754595,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 59157,
    "venueId": 3948,
    "venue": "Hard Rock Stadium",
    "homeId": 2390,
    "homeTeam": "Miami",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 41,
    "homeLineScores": [
      10,
      14,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9875534176826477,
    "homePregameElo": 1865,
    "homePostgameElo": 1914,
    "awayId": 152,
    "awayTeam": "NC State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.012446582317352295,
    "awayPregameElo": 1498,
    "awayPostgameElo": 1449,
    "excitementIndex": 3.570872354314906,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754592,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 37879,
    "venueId": 3615,
    "venue": "Alumni Stadium (Chestnut Hill, MA)",
    "homeId": 103,
    "homeTeam": "Boston College",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 34,
    "homeLineScores": [
      0,
      14,
      14,
      6
    ],
    "homePostgameWinProbability": 0.2614707946777344,
    "homePregameElo": 1298,
    "homePostgameElo": 1311,
    "awayId": 59,
    "awayTeam": "Georgia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 36,
    "awayLineScores": [
      7,
      7,
      3,
      19
    ],
    "awayPostgameWinProbability": 0.7385292053222656,
    "awayPregameElo": 1612,
    "awayPostgameElo": 1599,
    "excitementIndex": 7.421454423157309,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754593,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 27215,
    "venueId": 3982,
    "venue": "Wallace Wade Stadium",
    "homeId": 150,
    "homeTeam": "Duke",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 17,
    "homeLineScores": [
      0,
      3,
      0,
      14
    ],
    "homePostgameWinProbability": 0.006992544047534466,
    "homePregameElo": 1625,
    "homePostgameElo": 1576,
    "awayId": 258,
    "awayTeam": "Virginia",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      10,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.9930074559524655,
    "awayPregameElo": 1555,
    "awayPostgameElo": 1604,
    "excitementIndex": 3.6041656880268382,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752765,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 100077,
    "venueId": 3657,
    "venue": "Bryant-Denny Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 21,
    "homeLineScores": [
      0,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.22482722997665405,
    "homePregameElo": 1977,
    "homePostgameElo": 1964,
    "awayId": 201,
    "awayTeam": "Oklahoma",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 23,
    "awayLineScores": [
      10,
      7,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.775172770023346,
    "awayPregameElo": 1794,
    "awayPostgameElo": 1807,
    "excitementIndex": 6.7106854101740625,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752907,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 65216,
    "venueId": 477,
    "venue": "Los Angeles Memorial Coliseum",
    "homeId": 30,
    "homeTeam": "USC",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 26,
    "homeLineScores": [
      0,
      10,
      9,
      7
    ],
    "homePostgameWinProbability": 0.11785394698381424,
    "homePregameElo": 1911,
    "homePostgameElo": 1916,
    "awayId": 2294,
    "awayTeam": "Iowa",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.8821460530161858,
    "awayPregameElo": 1912,
    "awayPostgameElo": 1907,
    "excitementIndex": 5.5940330305607,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752903,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 61671,
    "venueId": 3936,
    "venue": "Spartan Stadium",
    "homeId": 127,
    "homeTeam": "Michigan State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 10,
    "homeLineScores": [
      7,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.007504538632929325,
    "homePregameElo": 1365,
    "homePostgameElo": 1377,
    "awayId": 213,
    "awayTeam": "Penn State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.9924954613670707,
    "awayPregameElo": 1950,
    "awayPostgameElo": 1938,
    "excitementIndex": 3.8044415586011677,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761654,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 27223,
    "venueId": 3815,
    "venue": "M. M. Roberts Stadium",
    "homeId": 2572,
    "homeTeam": "Southern Miss",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 14,
    "homeLineScores": [
      0,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.047236330807209015,
    "homePregameElo": 1362,
    "homePostgameElo": 1303,
    "awayId": 326,
    "awayTeam": "Texas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 41,
    "awayLineScores": [
      10,
      17,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.952763669192791,
    "awayPregameElo": 1483,
    "awayPostgameElo": 1542,
    "excitementIndex": 3.3067316100380326,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760413,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14491,
    "venueId": 3816,
    "venue": "Mackay Stadium",
    "homeId": 2440,
    "homeTeam": "Nevada",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 55,
    "homeLineScores": [
      14,
      17,
      7,
      17
    ],
    "homePostgameWinProbability": 0.995261013507843,
    "homePregameElo": 1105,
    "homePostgameElo": 1288,
    "awayId": 23,
    "awayTeam": "San José State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.004738986492156982,
    "awayPregameElo": 1391,
    "awayPostgameElo": 1208,
    "excitementIndex": 3.1484315818987154,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761652,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25298,
    "venueId": 3651,
    "venue": "Bridgeforth Stadium",
    "homeId": 256,
    "homeTeam": "James Madison",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 58,
    "homeLineScores": [
      7,
      20,
      10,
      21
    ],
    "homePostgameWinProbability": 0.9881057739257812,
    "homePregameElo": 1802,
    "homePostgameElo": 1882,
    "awayId": 2026,
    "awayTeam": "App State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      0,
      10
    ],
    "awayPostgameWinProbability": 0.01189422607421875,
    "awayPregameElo": 1328,
    "awayPostgameElo": 1248,
    "excitementIndex": 3.4345058009638003,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757303,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16547,
    "venueId": 3796,
    "venue": "Houchens Industries-L.T. Smith Stadium",
    "homeId": 98,
    "homeTeam": "Western Kentucky",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 42,
    "homeLineScores": [
      7,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.909025251865387,
    "homePregameElo": 1386,
    "homePostgameElo": 1398,
    "awayId": 2393,
    "awayTeam": "Middle Tennessee",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 26,
    "awayLineScores": [
      0,
      10,
      13,
      3
    ],
    "awayPostgameWinProbability": 0.09097474813461304,
    "awayPregameElo": 1134,
    "awayPostgameElo": 1122,
    "excitementIndex": 8.600669560279652,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761653,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19872,
    "venueId": 3817,
    "venue": "Malone Stadium",
    "homeId": 2433,
    "homeTeam": "UL Monroe",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 14,
    "homeLineScores": [
      14,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.06452474743127823,
    "homePregameElo": 998,
    "homePostgameElo": 1004,
    "awayId": 6,
    "awayTeam": "South Alabama",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 26,
    "awayLineScores": [
      0,
      7,
      13,
      6
    ],
    "awayPostgameWinProbability": 0.9354752525687218,
    "awayPregameElo": 1375,
    "awayPostgameElo": 1369,
    "excitementIndex": 4.425007568004904,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762509,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30000,
    "venueId": 4729,
    "venue": "Yulman Stadium",
    "homeId": 2655,
    "homeTeam": "Tulane",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 35,
    "homeLineScores": [
      7,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9301554560661316,
    "homePregameElo": 1545,
    "homePostgameElo": 1543,
    "awayId": 2226,
    "awayTeam": "Florida Atlantic",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      3,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.06984454393386841,
    "awayPregameElo": 1247,
    "awayPostgameElo": 1249,
    "excitementIndex": 4.833262636519825,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762508,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 37348,
    "venueId": 3699,
    "venue": "Dowdy-Ficklen Stadium",
    "homeId": 151,
    "homeTeam": "East Carolina",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 31,
    "homeLineScores": [
      7,
      3,
      14,
      7
    ],
    "homePostgameWinProbability": 0.8550935983657837,
    "homePregameElo": 1599,
    "homePostgameElo": 1604,
    "awayId": 235,
    "awayTeam": "Memphis",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      17,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.1449064016342163,
    "awayPregameElo": 1665,
    "awayPostgameElo": 1660,
    "excitementIndex": 8.951178706496506,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752771,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T21:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 101915,
    "venueId": 3853,
    "venue": "Neyland Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 42,
    "homeLineScores": [
      14,
      7,
      21,
      0
    ],
    "homePostgameWinProbability": 0.9926851391792297,
    "homePregameElo": 1814,
    "homePostgameElo": 1834,
    "awayId": 166,
    "awayTeam": "New Mexico State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 9,
    "awayLineScores": [
      0,
      3,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.007314860820770264,
    "awayPregameElo": 1201,
    "awayPostgameElo": 1181,
    "excitementIndex": 3.97396494136495,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754596,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T21:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 32390,
    "venueId": 3630,
    "venue": "Allegacy Federal Credit Union Stadium",
    "homeId": 154,
    "homeTeam": "Wake Forest",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.937673807144165,
    "homePregameElo": 1412,
    "homePostgameElo": 1444,
    "awayId": 153,
    "awayTeam": "North Carolina",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 12,
    "awayLineScores": [
      0,
      6,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.06232619285583496,
    "awayPregameElo": 1393,
    "awayPostgameElo": 1361,
    "excitementIndex": 3.566914317981715,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757301,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14167,
    "venueId": 2031,
    "venue": "Pitbull Stadium",
    "homeId": 2229,
    "homeTeam": "Florida International",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 34,
    "homeLineScores": [
      7,
      10,
      7,
      3,
      7
    ],
    "homePostgameWinProbability": 0.9747364521026611,
    "homePregameElo": 1306,
    "homePostgameElo": 1326,
    "awayId": 2335,
    "awayTeam": "Liberty",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      14,
      0,
      6,
      0
    ],
    "awayPostgameWinProbability": 0.025263547897338867,
    "awayPregameElo": 1488,
    "awayPostgameElo": 1468,
    "excitementIndex": 9.756861058689491,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761650,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-15T23:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22738,
    "venueId": 3608,
    "venue": "Allen E. Paulson Stadium",
    "homeId": 290,
    "homeTeam": "Georgia Southern",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 45,
    "homeLineScores": [
      21,
      14,
      7,
      3
    ],
    "homePostgameWinProbability": 0.7072704434394836,
    "homePregameElo": 1314,
    "homePostgameElo": 1319,
    "awayId": 324,
    "awayTeam": "Coastal Carolina",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 40,
    "awayLineScores": [
      17,
      10,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.29272955656051636,
    "awayPregameElo": 1318,
    "awayPostgameElo": 1313,
    "excitementIndex": 6.94842202309528,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756949,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-16T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 38186,
    "venueId": 4727,
    "venue": "McLane Stadium",
    "homeId": 239,
    "homeTeam": "Baylor",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 28,
    "homeLineScores": [
      0,
      17,
      3,
      8
    ],
    "homePostgameWinProbability": 0.0010659834370017052,
    "homePregameElo": 1621,
    "homePostgameElo": 1585,
    "awayId": 254,
    "awayTeam": "Utah",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 55,
    "awayLineScores": [
      14,
      14,
      7,
      20
    ],
    "awayPostgameWinProbability": 0.9989340165629983,
    "awayPregameElo": 1941,
    "awayPostgameElo": 1977,
    "excitementIndex": 4.191336628760744,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760414,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-16T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 31682,
    "venueId": 6501,
    "venue": "Allegiant Stadium",
    "homeId": 2439,
    "homeTeam": "UNLV",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 29,
    "homeLineScores": [
      3,
      7,
      7,
      6,
      6
    ],
    "homePostgameWinProbability": 0.5962734818458557,
    "homePregameElo": 1605,
    "homePostgameElo": 1604,
    "awayId": 328,
    "awayTeam": "Utah State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 26,
    "awayLineScores": [
      6,
      7,
      3,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.4037265181541443,
    "awayPregameElo": 1422,
    "awayPostgameElo": 1423,
    "excitementIndex": 8.954224614353794,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757300,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-16T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 3713,
    "venueId": 3631,
    "venue": "BBVA Compass Stadium",
    "homeId": 2534,
    "homeTeam": "Sam Houston",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 26,
    "homeLineScores": [
      0,
      10,
      13,
      3
    ],
    "homePostgameWinProbability": 0.2634277045726776,
    "homePregameElo": 1072,
    "homePostgameElo": 1094,
    "awayId": 48,
    "awayTeam": "Delaware",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 23,
    "awayLineScores": [
      7,
      3,
      0,
      13
    ],
    "awayPostgameWinProbability": 0.7365722954273224,
    "awayPregameElo": 1386,
    "awayPostgameElo": 1364,
    "excitementIndex": 6.522844953162938,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752769,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-16T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 68138,
    "venueId": 3974,
    "venue": "Vaught-Hemingway Stadium",
    "homeId": 145,
    "homeTeam": "Ole Miss",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 34,
    "homeLineScores": [
      10,
      10,
      0,
      14
    ],
    "homePostgameWinProbability": 0.914693295955658,
    "homePregameElo": 1969,
    "homePostgameElo": 1959,
    "awayId": 57,
    "awayTeam": "Florida",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      17,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.08530670404434204,
    "awayPregameElo": 1555,
    "awayPostgameElo": 1565,
    "excitementIndex": 7.26444436261108,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752902,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-16T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 67229,
    "venueId": 3765,
    "venue": "Husky Stadium",
    "homeId": 264,
    "homeTeam": "Washington",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 49,
    "homeLineScores": [
      7,
      21,
      14,
      7
    ],
    "homePostgameWinProbability": 0.8856524229049683,
    "homePregameElo": 1699,
    "homePostgameElo": 1754,
    "awayId": 2509,
    "awayTeam": "Purdue",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      0,
      3,
      10
    ],
    "awayPostgameWinProbability": 0.11434757709503174,
    "awayPregameElo": 1331,
    "awayPostgameElo": 1276,
    "excitementIndex": 3.6277786334780107,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752900,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-16T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 104168,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 48,
    "homeLineScores": [
      10,
      17,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9827536344528198,
    "homePregameElo": 2125,
    "homePostgameElo": 2145,
    "awayId": 26,
    "awayTeam": "UCLA",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      0,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.017246365547180176,
    "awayPregameElo": 1381,
    "awayPostgameElo": 1361,
    "excitementIndex": 2.7737161997960937,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752766,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-16T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 93033,
    "venueId": 3917,
    "venue": "Sanford Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 35,
    "homeLineScores": [
      7,
      7,
      0,
      21
    ],
    "homePostgameWinProbability": 0.9908798336982727,
    "homePregameElo": 2018,
    "homePostgameElo": 2070,
    "awayId": 251,
    "awayTeam": "Texas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.009120166301727295,
    "awayPregameElo": 1924,
    "awayPostgameElo": 1872,
    "excitementIndex": 4.144425955685069,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754594,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-16T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 64937,
    "venueId": 3697,
    "venue": "Doak Campbell Stadium",
    "homeId": 52,
    "homeTeam": "Florida State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 34,
    "homeLineScores": [
      0,
      10,
      14,
      10
    ],
    "homePostgameWinProbability": 0.8882288336753845,
    "homePregameElo": 1609,
    "homePostgameElo": 1638,
    "awayId": 259,
    "awayTeam": "Virginia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.11177116632461548,
    "awayPregameElo": 1431,
    "awayPostgameElo": 1402,
    "excitementIndex": 4.788901362559164,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752770,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-16T00:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 57321,
    "venueId": 3838,
    "venue": "Memorial Stadium",
    "homeId": 142,
    "homeTeam": "Missouri",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 49,
    "homeLineScores": [
      14,
      7,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9947172403335571,
    "homePregameElo": 1734,
    "homePostgameElo": 1765,
    "awayId": 344,
    "awayTeam": "Mississippi State",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 27,
    "awayLineScores": [
      10,
      0,
      14,
      3
    ],
    "awayPostgameWinProbability": 0.005282759666442871,
    "awayPregameElo": 1523,
    "awayPostgameElo": 1492,
    "excitementIndex": 5.392068244437288,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757302,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-16T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24166,
    "venueId": 3662,
    "venue": "AmFirst Stadium",
    "homeId": 55,
    "homeTeam": "Jacksonville State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 35,
    "homeLineScores": [
      7,
      15,
      3,
      10
    ],
    "homePostgameWinProbability": 0.9312290549278259,
    "homePregameElo": 1512,
    "homePostgameElo": 1518,
    "awayId": 338,
    "awayTeam": "Kennesaw State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 26,
    "awayLineScores": [
      7,
      3,
      3,
      13
    ],
    "awayPostgameWinProbability": 0.06877094507217407,
    "awayPregameElo": 1381,
    "awayPostgameElo": 1375,
    "excitementIndex": 6.976912591837693,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752953,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-16T03:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 21186,
    "venueId": 3820,
    "venue": "Gesa Field",
    "homeId": 265,
    "homeTeam": "Washington State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 28,
    "homeLineScores": [
      7,
      7,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9945715665817261,
    "homePregameElo": 1434,
    "homePostgameElo": 1500,
    "awayId": 2348,
    "awayTeam": "Louisiana Tech",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.005428433418273926,
    "awayPregameElo": 1462,
    "awayPostgameElo": 1396,
    "excitementIndex": 3.0924295766837604,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756950,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-16T03:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 64447,
    "venueId": 3801,
    "venue": "LaVell Edwards Stadium",
    "homeId": 252,
    "homeTeam": "BYU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 44,
    "homeLineScores": [
      10,
      17,
      3,
      14
    ],
    "homePostgameWinProbability": 0.9406208992004395,
    "homePregameElo": 1688,
    "homePostgameElo": 1772,
    "awayId": 2628,
    "awayTeam": "TCU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      10,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.05937910079956055,
    "awayPregameElo": 1689,
    "awayPostgameElo": 1605,
    "excitementIndex": 4.881351816028414,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760410,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-16T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 29201,
    "venueId": 7311,
    "venue": "Snapdragon Stadium",
    "homeId": 21,
    "homeTeam": "San Diego State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 17,
    "homeLineScores": [
      0,
      14,
      0,
      3
    ],
    "homePostgameWinProbability": 0.5283172726631165,
    "homePregameElo": 1480,
    "homePostgameElo": 1507,
    "awayId": 68,
    "awayTeam": "Boise State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.47168272733688354,
    "awayPregameElo": 1616,
    "awayPostgameElo": 1589,
    "excitementIndex": 4.49702102683922,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760412,
    "season": 2025,
    "week": 12,
    "seasonType": "regular",
    "startDate": "2025-11-16T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 35076,
    "venueId": 3660,
    "venue": "Valley Children's Stadium",
    "homeId": 278,
    "homeTeam": "Fresno State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 24,
    "homeLineScores": [
      7,
      3,
      0,
      14
    ],
    "homePostgameWinProbability": 0.8938388228416443,
    "homePregameElo": 1468,
    "homePostgameElo": 1510,
    "awayId": 2751,
    "awayTeam": "Wyoming",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 3,
    "awayLineScores": [
      3,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.10616117715835571,
    "awayPregameElo": 1390,
    "awayPostgameElo": 1348,
    "excitementIndex": 4.945463204251494,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762862,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-19T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9867,
    "venueId": 3700,
    "venue": "Doyt L. Perry Stadium",
    "homeId": 189,
    "homeTeam": "Bowling Green",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 16,
    "homeLineScores": [
      3,
      3,
      7,
      3
    ],
    "homePostgameWinProbability": 0.6382849216461182,
    "homePregameElo": 1244,
    "homePostgameElo": 1230,
    "awayId": 2006,
    "awayTeam": "Akron",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 19,
    "awayLineScores": [
      3,
      3,
      10,
      3
    ],
    "awayPostgameWinProbability": 0.36171507835388184,
    "awayPregameElo": 1087,
    "awayPostgameElo": 1101,
    "excitementIndex": 7.499807813687292,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762863,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-19T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12438,
    "venueId": 3876,
    "venue": "Peden Stadium",
    "homeId": 195,
    "homeTeam": "Ohio",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 42,
    "homeLineScores": [
      7,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9950482845306396,
    "homePregameElo": 1585,
    "homePostgameElo": 1572,
    "awayId": 113,
    "awayTeam": "Massachusetts",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0049517154693603516,
    "awayPregameElo": 735,
    "awayPostgameElo": 748,
    "excitementIndex": 4.74227531654747,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762864,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-19T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 4734,
    "venueId": 3764,
    "venue": "Huskie Stadium",
    "homeId": 2459,
    "homeTeam": "Northern Illinois",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 19,
    "homeLineScores": [
      10,
      3,
      0,
      6
    ],
    "homePostgameWinProbability": 0.12934772670269012,
    "homePregameElo": 1289,
    "homePostgameElo": 1260,
    "awayId": 2711,
    "awayTeam": "Western Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 35,
    "awayLineScores": [
      0,
      14,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.8706522732973099,
    "awayPregameElo": 1378,
    "awayPostgameElo": 1407,
    "excitementIndex": 3.4626707730844215,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762865,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-20T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15246,
    "venueId": 3965,
    "venue": "UB Stadium",
    "homeId": 2084,
    "homeTeam": "Buffalo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 20,
    "homeLineScores": [
      3,
      7,
      10,
      0
    ],
    "homePostgameWinProbability": 0.1364663541316986,
    "homePregameElo": 1318,
    "homePostgameElo": 1288,
    "awayId": 193,
    "awayTeam": "Miami (OH)",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 37,
    "awayLineScores": [
      0,
      17,
      14,
      6
    ],
    "awayPostgameWinProbability": 0.8635336458683014,
    "awayPregameElo": 1421,
    "awayPostgameElo": 1451,
    "excitementIndex": 5.921445750564814,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762866,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-20T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 8112,
    "venueId": 3696,
    "venue": "Dix Stadium",
    "homeId": 2309,
    "homeTeam": "Kent State",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 16,
    "homeLineScores": [
      0,
      3,
      0,
      13
    ],
    "homePostgameWinProbability": 0.04668497294187546,
    "homePregameElo": 972,
    "homePostgameElo": 974,
    "awayId": 2117,
    "awayTeam": "Central Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      7,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.9533150270581245,
    "awayPregameElo": 1293,
    "awayPostgameElo": 1291,
    "excitementIndex": 4.460429434556407,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761655,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-21T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13571,
    "venueId": 3625,
    "venue": "Centennial Bank Stadium",
    "homeId": 2032,
    "homeTeam": "Arkansas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 30,
    "homeLineScores": [
      10,
      17,
      0,
      3
    ],
    "homePostgameWinProbability": 0.14582644402980804,
    "homePregameElo": 1306,
    "homePostgameElo": 1302,
    "awayId": 309,
    "awayTeam": "Louisiana",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      17,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.854173555970192,
    "awayPregameElo": 1350,
    "awayPostgameElo": 1354,
    "excitementIndex": 8.711359626652017,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754598,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 56919,
    "venueId": 3670,
    "venue": "Carter-Finley Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 21,
    "homeLineScores": [
      7,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.72925865650177,
    "homePregameElo": 1449,
    "homePostgameElo": 1481,
    "awayId": 52,
    "awayTeam": "Florida State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 11,
    "awayLineScores": [
      0,
      3,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.27074134349823,
    "awayPregameElo": 1638,
    "awayPostgameElo": 1606,
    "excitementIndex": 4.720332964140075,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760418,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 37106,
    "venueId": 6501,
    "venue": "Allegiant Stadium",
    "homeId": 2439,
    "homeTeam": "UNLV",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 38,
    "homeLineScores": [
      10,
      14,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9917385578155518,
    "homePregameElo": 1604,
    "homePostgameElo": 1663,
    "awayId": 62,
    "awayTeam": "Hawai'i",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 10,
    "awayLineScores": [
      7,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.008261442184448242,
    "awayPregameElo": 1480,
    "awayPostgameElo": 1421,
    "excitementIndex": 3.609955771696005,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754603,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 65632,
    "venueId": 3799,
    "venue": "Lane Stadium",
    "homeId": 259,
    "homeTeam": "Virginia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 17,
    "homeLineScores": [
      3,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.28536638617515564,
    "homePregameElo": 1402,
    "homePostgameElo": 1409,
    "awayId": 2390,
    "awayTeam": "Miami",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      7,
      13,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.7146336138248444,
    "awayPregameElo": 1914,
    "awayPostgameElo": 1907,
    "excitementIndex": 3.9113358309470994,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754606,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 26950,
    "venueId": 3630,
    "venue": "Allegacy Federal Credit Union Stadium",
    "homeId": 154,
    "homeTeam": "Wake Forest",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 52,
    "homeLineScores": [
      15,
      20,
      14,
      3
    ],
    "homePostgameWinProbability": 0.9899044036865234,
    "homePregameElo": 1444,
    "homePostgameElo": 1542,
    "awayId": 48,
    "awayTeam": "Delaware",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.010095596313476562,
    "awayPregameElo": 1364,
    "awayPostgameElo": 1266,
    "excitementIndex": 3.057955735193439,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756958,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 58275,
    "venueId": 3772,
    "venue": "Jack Trice Stadium",
    "homeId": 66,
    "homeTeam": "Iowa State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 38,
    "homeLineScores": [
      7,
      10,
      14,
      7
    ],
    "homePostgameWinProbability": 0.9919295310974121,
    "homePregameElo": 1600,
    "homePostgameElo": 1655,
    "awayId": 2305,
    "awayTeam": "Kansas",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.00807046890258789,
    "awayPregameElo": 1554,
    "awayPostgameElo": 1499,
    "excitementIndex": 3.2876366410776248,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754602,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 32713,
    "venueId": 3735,
    "venue": "Gerald J. Ford Stadium",
    "homeId": 2567,
    "homeTeam": "SMU",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      7,
      14,
      3,
      14
    ],
    "homePostgameWinProbability": 0.9910668134689331,
    "homePregameElo": 1782,
    "homePostgameElo": 1860,
    "awayId": 97,
    "awayTeam": "Louisville",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 6,
    "awayLineScores": [
      3,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.008933186531066895,
    "awayPregameElo": 1709,
    "awayPostgameElo": 1631,
    "excitementIndex": 3.7331319170940747,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752778,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 83541,
    "venueId": 3835,
    "venue": "Memorial Stadium (Norman, OK)",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 17,
    "homeLineScores": [
      0,
      14,
      3,
      0
    ],
    "homePostgameWinProbability": 0.5228720903396606,
    "homePregameElo": 1807,
    "homePostgameElo": 1824,
    "awayId": 142,
    "awayTeam": "Missouri",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 6,
    "awayLineScores": [
      3,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.47712790966033936,
    "awayPregameElo": 1765,
    "awayPostgameElo": 1748,
    "excitementIndex": 3.8866845198095876,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752912,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": null,
    "venueId": 3861,
    "venue": "Ohio Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 42,
    "homeLineScores": [
      7,
      7,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9874398112297058,
    "homePregameElo": 2145,
    "homePostgameElo": 2158,
    "awayId": 164,
    "awayTeam": "Rutgers",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 9,
    "awayLineScores": [
      0,
      3,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.01256018877029419,
    "awayPregameElo": 1458,
    "awayPostgameElo": 1445,
    "excitementIndex": 3.630035748868403,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762512,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28705,
    "venueId": 3841,
    "venue": "Michie Stadium",
    "homeId": 349,
    "homeTeam": "Army",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 25,
    "homeLineScores": [
      7,
      15,
      3,
      0
    ],
    "homePostgameWinProbability": 0.1432495415210724,
    "homePregameElo": 1529,
    "homePostgameElo": 1504,
    "awayId": 202,
    "awayTeam": "Tulsa",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 26,
    "awayLineScores": [
      7,
      7,
      0,
      12
    ],
    "awayPostgameWinProbability": 0.8567504584789276,
    "awayPregameElo": 1094,
    "awayPostgameElo": 1119,
    "excitementIndex": 6.910777336301107,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752909,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 15323,
    "venueId": 4250,
    "venue": "Wrigley Field",
    "homeId": 77,
    "homeTeam": "Northwestern",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      10,
      3,
      15,
      10
    ],
    "homePostgameWinProbability": 0.8243551254272461,
    "homePregameElo": 1526,
    "homePostgameElo": 1531,
    "awayId": 135,
    "awayTeam": "Minnesota",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 35,
    "awayLineScores": [
      0,
      21,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.1756448745727539,
    "awayPregameElo": 1496,
    "awayPostgameElo": 1491,
    "excitementIndex": 7.305459827041887,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752781,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 104877,
    "venueId": 3795,
    "venue": "Kyle Field",
    "homeId": 245,
    "homeTeam": "Texas A&M",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 48,
    "homeLineScores": [
      21,
      10,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9767223000526428,
    "homePregameElo": 1896,
    "homePostgameElo": 1896,
    "awayId": 2535,
    "awayTeam": "Samford",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.023277699947357178,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.0027037724665457,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752776,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T17:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 93033,
    "venueId": 3917,
    "venue": "Sanford Stadium",
    "homeId": 61,
    "homeTeam": "Georgia",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 35,
    "homeLineScores": [
      14,
      14,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9921115636825562,
    "homePregameElo": 2070,
    "homePostgameElo": 2048,
    "awayId": 2429,
    "awayTeam": "Charlotte",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.007888436317443848,
    "awayPregameElo": 1013,
    "awayPostgameElo": 1035,
    "excitementIndex": 2.676535798551931,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756954,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 40199,
    "venueId": 3619,
    "venue": "Arizona Stadium",
    "homeId": 12,
    "homeTeam": "Arizona",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 41,
    "homeLineScores": [
      7,
      7,
      7,
      20
    ],
    "homePostgameWinProbability": 0.9967034459114075,
    "homePregameElo": 1592,
    "homePostgameElo": 1651,
    "awayId": 239,
    "awayTeam": "Baylor",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 17,
    "awayLineScores": [
      14,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.0032965540885925293,
    "awayPregameElo": 1585,
    "awayPostgameElo": 1526,
    "excitementIndex": 6.223066337170956,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752954,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 25156,
    "venueId": 3651,
    "venue": "Bridgeforth Stadium",
    "homeId": 256,
    "homeTeam": "James Madison",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 24,
    "homeLineScores": [
      3,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.5653398036956787,
    "homePregameElo": 1882,
    "homePostgameElo": 1874,
    "awayId": 265,
    "awayTeam": "Washington State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      14,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.4346601963043213,
    "awayPregameElo": 1500,
    "awayPostgameElo": 1508,
    "excitementIndex": 6.595652422164998,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761657,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 19247,
    "venueId": 3608,
    "venue": "Allen E. Paulson Stadium",
    "homeId": 290,
    "homeTeam": "Georgia Southern",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 10,
    "homeLineScores": [
      0,
      0,
      3,
      7
    ],
    "homePostgameWinProbability": 0.0013588489964604378,
    "homePregameElo": 1319,
    "homePostgameElo": 1250,
    "awayId": 295,
    "awayTeam": "Old Dominion",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 45,
    "awayLineScores": [
      14,
      17,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.9986411510035396,
    "awayPregameElo": 1566,
    "awayPostgameElo": 1635,
    "excitementIndex": 3.476384076018411,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752773,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 100077,
    "venueId": 3657,
    "venue": "Bryant-Denny Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 56,
    "homeLineScores": [
      14,
      14,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9774519801139832,
    "homePregameElo": 1966,
    "homePostgameElo": 1966,
    "awayId": 2197,
    "awayTeam": "Eastern Illinois",
    "awayClassification": "fcs",
    "awayConference": "OVC-Big South",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.022548019886016846,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 2.8102442053527406,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757306,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11040,
    "venueId": 4899,
    "venue": "Fifth Third Stadium",
    "homeId": 338,
    "homeTeam": "Kennesaw State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 41,
    "homeLineScores": [
      14,
      0,
      13,
      14
    ],
    "homePostgameWinProbability": 0.9273834824562073,
    "homePregameElo": 1375,
    "homePostgameElo": 1385,
    "awayId": 2623,
    "awayTeam": "Missouri State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 34,
    "awayLineScores": [
      3,
      10,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.07261651754379272,
    "awayPregameElo": 1376,
    "awayPostgameElo": 1366,
    "excitementIndex": 8.731697139583876,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760419,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25650,
    "venueId": 3984,
    "venue": "War Memorial Stadium",
    "homeId": 2751,
    "homeTeam": "Wyoming",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      7,
      0
    ],
    "homePostgameWinProbability": 0.06490600109100342,
    "homePregameElo": 1348,
    "homePostgameElo": 1333,
    "awayId": 2440,
    "awayTeam": "Nevada",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      7,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.9350939989089966,
    "awayPregameElo": 1288,
    "awayPostgameElo": 1303,
    "excitementIndex": 4.960683280349936,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762867,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15127,
    "venueId": 3739,
    "venue": "Glass Bowl",
    "homeId": 2649,
    "homeTeam": "Toledo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 38,
    "homeLineScores": [
      14,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9851285219192505,
    "homePregameElo": 1630,
    "homePostgameElo": 1642,
    "awayId": 2050,
    "awayTeam": "Ball State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 9,
    "awayLineScores": [
      0,
      3,
      0,
      6
    ],
    "awayPostgameWinProbability": 0.014871478080749512,
    "awayPregameElo": 1030,
    "awayPostgameElo": 1018,
    "excitementIndex": 3.9451780489615396,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752774,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 62,
    "homeLineScores": [
      14,
      21,
      14,
      13
    ],
    "homePostgameWinProbability": 0.9926486015319824,
    "homePregameElo": 1660,
    "homePostgameElo": 1660,
    "awayId": 2382,
    "awayTeam": "Mercer",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 17,
    "awayLineScores": [
      14,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.007351398468017578,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 4.767887295781225,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761656,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 31322,
    "venueId": 3792,
    "venue": "Kidd Brewer Stadium",
    "homeId": 2026,
    "homeTeam": "App State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 26,
    "homeLineScores": [
      3,
      13,
      7,
      3
    ],
    "homePostgameWinProbability": 0.2184579074382782,
    "homePregameElo": 1248,
    "homePostgameElo": 1252,
    "awayId": 276,
    "awayTeam": "Marshall",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 24,
    "awayLineScores": [
      7,
      14,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.7815420925617218,
    "awayPregameElo": 1499,
    "awayPostgameElo": 1495,
    "excitementIndex": 7.4641602063129895,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757309,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16677,
    "venueId": 3946,
    "venue": "Sun Bowl",
    "homeId": 2638,
    "homeTeam": "UTEP",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 31,
    "homeLineScores": [
      21,
      0,
      3,
      7
    ],
    "homePostgameWinProbability": 0.3657667636871338,
    "homePregameElo": 1215,
    "homePostgameElo": 1208,
    "awayId": 166,
    "awayTeam": "New Mexico State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 34,
    "awayLineScores": [
      0,
      21,
      3,
      10
    ],
    "awayPostgameWinProbability": 0.6342332363128662,
    "awayPregameElo": 1181,
    "awayPostgameElo": 1188,
    "excitementIndex": 7.161423595259868,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757175,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 16306,
    "venueId": 3715,
    "venue": "FAU Stadium",
    "homeId": 2226,
    "homeTeam": "Florida Atlantic",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 45,
    "homeLineScores": [
      3,
      14,
      14,
      14
    ],
    "homePostgameWinProbability": 0.46710923314094543,
    "homePregameElo": 1249,
    "homePostgameElo": 1263,
    "awayId": 41,
    "awayTeam": "UConn",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 48,
    "awayLineScores": [
      24,
      3,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.5328907668590546,
    "awayPregameElo": 1568,
    "awayPostgameElo": 1554,
    "excitementIndex": 8.729593024822146,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757308,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 7605,
    "venueId": 3725,
    "venue": "Johnny \"Red\" Floyd Stadium",
    "homeId": 2393,
    "homeTeam": "Middle Tennessee",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 31,
    "homeLineScores": [
      0,
      10,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9829244017601013,
    "homePregameElo": 1122,
    "homePostgameElo": 1148,
    "awayId": 2534,
    "awayTeam": "Sam Houston",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 17,
    "awayLineScores": [
      10,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.01707559823989868,
    "awayPregameElo": 1094,
    "awayPostgameElo": 1068,
    "excitementIndex": 5.92583521036406,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757307,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 10107,
    "venueId": 3776,
    "venue": "Joe Aillet Stadium",
    "homeId": 2348,
    "homeTeam": "Louisiana Tech",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 34,
    "homeLineScores": [
      7,
      0,
      7,
      14,
      6
    ],
    "homePostgameWinProbability": 0.7309790849685669,
    "homePregameElo": 1396,
    "homePostgameElo": 1407,
    "awayId": 2335,
    "awayTeam": "Liberty",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 28,
    "awayLineScores": [
      3,
      10,
      15,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.2690209150314331,
    "awayPregameElo": 1468,
    "awayPostgameElo": 1457,
    "excitementIndex": 7.27530017878221,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762511,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16376,
    "venueId": 7221,
    "venue": "Protective Stadium",
    "homeId": 5,
    "homeTeam": "UAB",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 18,
    "homeLineScores": [
      10,
      0,
      0,
      8
    ],
    "homePostgameWinProbability": 0.0039056341629475355,
    "homePregameElo": 1197,
    "homePostgameElo": 1175,
    "awayId": 58,
    "awayTeam": "South Florida",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 48,
    "awayLineScores": [
      7,
      10,
      17,
      14
    ],
    "awayPostgameWinProbability": 0.9960943658370525,
    "awayPregameElo": 1729,
    "awayPostgameElo": 1751,
    "excitementIndex": 4.383208136782565,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761658,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17601,
    "venueId": 6526,
    "venue": "Hancock Whitney Stadium",
    "homeId": 6,
    "homeTeam": "South Alabama",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 42,
    "homeLineScores": [
      7,
      14,
      14,
      7
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1369,
    "homePostgameElo": 1375,
    "awayId": 2572,
    "awayTeam": "Southern Miss",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 35,
    "awayLineScores": [
      0,
      7,
      7,
      21
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1303,
    "awayPostgameElo": 1297,
    "excitementIndex": 4.629778731009781,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752913,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 69250,
    "venueId": 3793,
    "venue": "Kinnick Stadium",
    "homeId": 2294,
    "homeTeam": "Iowa",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 20,
    "homeLineScores": [
      7,
      0,
      0,
      13
    ],
    "homePostgameWinProbability": 0.5728206634521484,
    "homePregameElo": 1907,
    "homePostgameElo": 1902,
    "awayId": 127,
    "awayTeam": "Michigan State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      3,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.42717933654785156,
    "awayPregameElo": 1377,
    "awayPostgameElo": 1382,
    "excitementIndex": 5.8560481726197,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752911,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 59588,
    "venueId": 3626,
    "venue": "Autzen Stadium",
    "homeId": 2483,
    "homeTeam": "Oregon",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 42,
    "homeLineScores": [
      14,
      14,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9968926906585693,
    "homePregameElo": 2068,
    "homePostgameElo": 2086,
    "awayId": 30,
    "awayTeam": "USC",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      7,
      7,
      6
    ],
    "awayPostgameWinProbability": 0.003107309341430664,
    "awayPregameElo": 1916,
    "awayPostgameElo": 1898,
    "excitementIndex": 5.135430654086582,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752782,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 35000,
    "venueId": 3973,
    "venue": "FirstBank Stadium",
    "homeId": 238,
    "homeTeam": "Vanderbilt",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 45,
    "homeLineScores": [
      3,
      21,
      21,
      0
    ],
    "homePostgameWinProbability": 0.9704754948616028,
    "homePregameElo": 1770,
    "homePostgameElo": 1827,
    "awayId": 96,
    "awayTeam": "Kentucky",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      3,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.029524505138397217,
    "awayPregameElo": 1635,
    "awayPostgameElo": 1578,
    "excitementIndex": 3.2319062565762313,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752780,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 102361,
    "venueId": 3910,
    "venue": "DKR-Texas Memorial Stadium",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 52,
    "homeLineScores": [
      14,
      10,
      21,
      7
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1872,
    "homePostgameElo": 1880,
    "awayId": 8,
    "awayTeam": "Arkansas",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 37,
    "awayLineScores": [
      6,
      14,
      3,
      14
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1596,
    "awayPostgameElo": 1588,
    "excitementIndex": 5.379994843795397,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762513,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 18573,
    "venueId": 3604,
    "venue": "Alamodome",
    "homeId": 2636,
    "homeTeam": "UTSA",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 58,
    "homeLineScores": [
      14,
      20,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9928389191627502,
    "homePregameElo": 1472,
    "homePostgameElo": 1585,
    "awayId": 151,
    "awayTeam": "East Carolina",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 24,
    "awayLineScores": [
      0,
      3,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.007161080837249756,
    "awayPregameElo": 1604,
    "awayPostgameElo": 1491,
    "excitementIndex": 3.4460992661189365,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757305,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 9504,
    "venueId": 2031,
    "venue": "Pitbull Stadium",
    "homeId": 2229,
    "homeTeam": "Florida International",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 27,
    "homeLineScores": [
      7,
      0,
      10,
      10
    ],
    "homePostgameWinProbability": 0.3575092554092407,
    "homePregameElo": 1326,
    "homePostgameElo": 1343,
    "awayId": 55,
    "awayTeam": "Jacksonville State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      7,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.6424907445907593,
    "awayPregameElo": 1518,
    "awayPostgameElo": 1501,
    "excitementIndex": 7.66191105255291,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754600,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50500,
    "venueId": 3787,
    "venue": "Kenan Stadium",
    "homeId": 153,
    "homeTeam": "North Carolina",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 25,
    "homeLineScores": [
      7,
      3,
      8,
      7
    ],
    "homePostgameWinProbability": 0.6972442865371704,
    "homePregameElo": 1361,
    "homePostgameElo": 1364,
    "awayId": 150,
    "awayTeam": "Duke",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 32,
    "awayLineScores": [
      7,
      10,
      7,
      8
    ],
    "awayPostgameWinProbability": 0.3027557134628296,
    "awayPregameElo": 1576,
    "awayPostgameElo": 1573,
    "excitementIndex": 6.197711451448148,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754604,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 77622,
    "venueId": 3855,
    "venue": "Notre Dame Stadium",
    "homeId": 87,
    "homeTeam": "Notre Dame",
    "homeClassification": "fbs",
    "homeConference": "FBS Independents",
    "homePoints": 70,
    "homeLineScores": [
      35,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9941574335098267,
    "homePregameElo": 2189,
    "homePostgameElo": 2263,
    "awayId": 183,
    "awayTeam": "Syracuse",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.00584256649017334,
    "awayPregameElo": 1304,
    "awayPostgameElo": 1230,
    "excitementIndex": 3.3386299156731587,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762515,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T20:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13366,
    "venueId": 3806,
    "venue": "Lincoln Financial Field",
    "homeId": 218,
    "homeTeam": "Temple",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 13,
    "homeLineScores": [
      7,
      0,
      0,
      6
    ],
    "homePostgameWinProbability": 0.013555897399783134,
    "homePregameElo": 1266,
    "homePostgameElo": 1234,
    "awayId": 2655,
    "awayTeam": "Tulane",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 37,
    "awayLineScores": [
      10,
      10,
      6,
      11
    ],
    "awayPostgameWinProbability": 0.9864441026002169,
    "awayPregameElo": 1543,
    "awayPostgameElo": 1575,
    "excitementIndex": 3.574444017848902,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756957,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30852,
    "venueId": 4728,
    "venue": "TDECU Stadium",
    "homeId": 248,
    "homeTeam": "Houston",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      7,
      0
    ],
    "homePostgameWinProbability": 0.5768406391143799,
    "homePregameElo": 1476,
    "homePostgameElo": 1479,
    "awayId": 2628,
    "awayTeam": "TCU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 17,
    "awayLineScores": [
      14,
      0,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.4231593608856201,
    "awayPregameElo": 1605,
    "awayPostgameElo": 1602,
    "excitementIndex": 6.5693837600173905,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756959,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 41723,
    "venueId": 3652,
    "venue": "FBC Mortgage Stadium",
    "homeId": 2116,
    "homeTeam": "UCF",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 17,
    "homeLineScores": [
      0,
      0,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9978678822517395,
    "homePregameElo": 1468,
    "homePostgameElo": 1464,
    "awayId": 197,
    "awayTeam": "Oklahoma State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 14,
    "awayLineScores": [
      7,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.002132117748260498,
    "awayPregameElo": 1080,
    "awayPostgameElo": 1084,
    "excitementIndex": 6.068326629734767,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756960,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 51444,
    "venueId": 587,
    "venue": "Rice-Eccles Stadium",
    "homeId": 254,
    "homeTeam": "Utah",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 51,
    "homeLineScores": [
      7,
      14,
      14,
      16
    ],
    "homePostgameWinProbability": 0.2940085530281067,
    "homePregameElo": 1977,
    "homePostgameElo": 1971,
    "awayId": 2306,
    "awayTeam": "Kansas State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 47,
    "awayLineScores": [
      7,
      24,
      7,
      9
    ],
    "awayPostgameWinProbability": 0.7059914469718933,
    "awayPregameElo": 1674,
    "awayPostgameElo": 1680,
    "excitementIndex": 10.539370561113188,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752914,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 46185,
    "venueId": 3665,
    "venue": "SECU Stadium",
    "homeId": 120,
    "homeTeam": "Maryland",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 20,
    "homeLineScores": [
      7,
      3,
      3,
      7
    ],
    "homePostgameWinProbability": 0.002435908652842045,
    "homePregameElo": 1440,
    "homePostgameElo": 1414,
    "awayId": 130,
    "awayTeam": "Michigan",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 45,
    "awayLineScores": [
      7,
      14,
      14,
      10
    ],
    "awayPostgameWinProbability": 0.997564091347158,
    "awayPregameElo": 1799,
    "awayPostgameElo": 1825,
    "excitementIndex": 3.802841750717656,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761660,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20243,
    "venueId": 3975,
    "venue": "Veterans Memorial Stadium (AL)",
    "homeId": 2653,
    "homeTeam": "Troy",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 31,
    "homeLineScores": [
      0,
      10,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9729332327842712,
    "homePregameElo": 1359,
    "homePostgameElo": 1362,
    "awayId": 2247,
    "awayTeam": "Georgia State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 19,
    "awayLineScores": [
      0,
      6,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.02706676721572876,
    "awayPregameElo": 1107,
    "awayPostgameElo": 1104,
    "excitementIndex": 6.059723295053843,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752779,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T21:15:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 78452,
    "venueId": 3994,
    "venue": "Williams-Brice Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 51,
    "homeLineScores": [
      20,
      17,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9924185276031494,
    "homePregameElo": 1645,
    "homePostgameElo": 1730,
    "awayId": 324,
    "awayTeam": "Coastal Carolina",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.007581472396850586,
    "awayPregameElo": 1313,
    "awayPostgameElo": 1228,
    "excitementIndex": 3.502150295620211,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754605,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T21:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 78403,
    "venueId": 3836,
    "venue": "Memorial Stadium (Clemson, SC)",
    "homeId": 228,
    "homeTeam": "Clemson",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 45,
    "homeLineScores": [
      17,
      14,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9877793192863464,
    "homePregameElo": 1727,
    "homePostgameElo": 1727,
    "awayId": 231,
    "awayTeam": "Furman",
    "awayClassification": "fcs",
    "awayConference": "Southern",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.012220680713653564,
    "awayPregameElo": null,
    "awayPostgameElo": null,
    "excitementIndex": 3.1907836309783715,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761659,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-22T22:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17078,
    "venueId": 3644,
    "venue": "Bobcat Stadium (TX)",
    "homeId": 326,
    "homeTeam": "Texas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 31,
    "homeLineScores": [
      0,
      3,
      14,
      14
    ],
    "homePostgameWinProbability": 0.8567688465118408,
    "homePregameElo": 1542,
    "homePostgameElo": 1533,
    "awayId": 2433,
    "awayTeam": "UL Monroe",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      0,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.14323115348815918,
    "awayPregameElo": 1004,
    "awayPostgameElo": 1013,
    "excitementIndex": 4.779916081017038,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760416,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-23T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 32819,
    "venueId": 3653,
    "venue": "Albertsons Stadium",
    "homeId": 68,
    "homeTeam": "Boise State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 49,
    "homeLineScores": [
      7,
      20,
      7,
      15
    ],
    "homePostgameWinProbability": 0.9962014555931091,
    "homePregameElo": 1589,
    "homePostgameElo": 1621,
    "awayId": 36,
    "awayTeam": "Colorado State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.003798544406890869,
    "awayPregameElo": 1223,
    "awayPostgameElo": 1191,
    "excitementIndex": 4.346051359634192,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760415,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-23T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 20218,
    "venueId": 3713,
    "venue": "Falcon Stadium",
    "homeId": 2005,
    "homeTeam": "Air Force",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 3,
    "homeLineScores": [
      0,
      0,
      0,
      3
    ],
    "homePostgameWinProbability": 0.014733248390257359,
    "homePregameElo": 1383,
    "homePostgameElo": 1350,
    "awayId": 167,
    "awayTeam": "New Mexico",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 20,
    "awayLineScores": [
      7,
      10,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.9852667516097426,
    "awayPregameElo": 1458,
    "awayPostgameElo": 1491,
    "excitementIndex": 2.9671530551482315,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752908,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-23T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 105038,
    "venueId": 3632,
    "venue": "Beaver Stadium",
    "homeId": 213,
    "homeTeam": "Penn State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 37,
    "homeLineScores": [
      7,
      16,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9944369196891785,
    "homePregameElo": 1938,
    "homePostgameElo": 1975,
    "awayId": 158,
    "awayTeam": "Nebraska",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.005563080310821533,
    "awayPregameElo": 1648,
    "awayPostgameElo": 1611,
    "excitementIndex": 3.2286130019262984,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754601,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-23T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 52413,
    "venueId": 721,
    "venue": "Bobby Dodd Stadium",
    "homeId": 59,
    "homeTeam": "Georgia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 28,
    "homeLineScores": [
      0,
      14,
      0,
      14
    ],
    "homePostgameWinProbability": 0.16961883008480072,
    "homePregameElo": 1599,
    "homePostgameElo": 1573,
    "awayId": 221,
    "awayTeam": "Pittsburgh",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 42,
    "awayLineScores": [
      21,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.8303811699151993,
    "awayPregameElo": 1665,
    "awayPostgameElo": 1691,
    "excitementIndex": 4.477657732122358,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752775,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-23T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 90465,
    "venueId": 3634,
    "venue": "Ben Hill Griffin Stadium",
    "homeId": 57,
    "homeTeam": "Florida",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 11,
    "homeLineScores": [
      0,
      0,
      3,
      8
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1565,
    "homePostgameElo": 1543,
    "awayId": 2633,
    "awayTeam": "Tennessee",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 31,
    "awayLineScores": [
      14,
      17,
      0,
      0
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1834,
    "awayPostgameElo": 1856,
    "excitementIndex": 2.205107309922417,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754599,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-23T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 50039,
    "venueId": 3940,
    "venue": "Stanford Stadium",
    "homeId": 24,
    "homeTeam": "Stanford",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 31,
    "homeLineScores": [
      0,
      14,
      3,
      14
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1246,
    "homePostgameElo": 1315,
    "awayId": 25,
    "awayTeam": "California",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1420,
    "awayPostgameElo": 1351,
    "excitementIndex": 5.2862318349905895,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762514,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-23T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24598,
    "venueId": 3895,
    "venue": "Rice Stadium",
    "homeId": 242,
    "homeTeam": "Rice",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 24,
    "homeLineScores": [
      14,
      0,
      7,
      3
    ],
    "homePostgameWinProbability": 0.1891024261713028,
    "homePregameElo": 1169,
    "homePostgameElo": 1144,
    "awayId": 249,
    "awayTeam": "North Texas",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 56,
    "awayLineScores": [
      7,
      21,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.8108975738286972,
    "awayPregameElo": 1716,
    "awayPostgameElo": 1741,
    "excitementIndex": 3.2991485915013485,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752915,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-23T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": null,
    "venueId": 347,
    "venue": "Camp Randall Stadium",
    "homeId": 275,
    "homeTeam": "Wisconsin",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 27,
    "homeLineScores": [
      7,
      3,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9873610138893127,
    "homePregameElo": 1467,
    "homePostgameElo": 1521,
    "awayId": 356,
    "awayTeam": "Illinois",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      7,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.012638986110687256,
    "awayPregameElo": 1630,
    "awayPostgameElo": 1576,
    "excitementIndex": 5.001122438154633,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752777,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-23T00:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 100923,
    "venueId": 3958,
    "venue": "Tiger Stadium (LA)",
    "homeId": 99,
    "homeTeam": "LSU",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 13,
    "homeLineScores": [
      0,
      7,
      3,
      3
    ],
    "homePostgameWinProbability": 0.6907662153244019,
    "homePregameElo": 1693,
    "homePostgameElo": 1690,
    "awayId": 98,
    "awayTeam": "Western Kentucky",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 10,
    "awayLineScores": [
      3,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.30923378467559814,
    "awayPregameElo": 1398,
    "awayPostgameElo": 1401,
    "excitementIndex": 5.332586354905082,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756955,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-23T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 38034,
    "venueId": 3854,
    "venue": "Nippert Stadium",
    "homeId": 2132,
    "homeTeam": "Cincinnati",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.31679895520210266,
    "homePregameElo": 1578,
    "homePostgameElo": 1569,
    "awayId": 252,
    "awayTeam": "BYU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 26,
    "awayLineScores": [
      7,
      3,
      7,
      9
    ],
    "awayPostgameWinProbability": 0.6832010447978973,
    "awayPregameElo": 1772,
    "awayPostgameElo": 1781,
    "excitementIndex": 4.566544103656873,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756956,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-23T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 43348,
    "venueId": 3726,
    "venue": "Folsom Field",
    "homeId": 38,
    "homeTeam": "Colorado",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 17,
    "homeLineScores": [
      7,
      0,
      10,
      0
    ],
    "homePostgameWinProbability": 0.009020018391311169,
    "homePregameElo": 1377,
    "homePostgameElo": 1338,
    "awayId": 9,
    "awayTeam": "Arizona State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 42,
    "awayLineScores": [
      3,
      10,
      8,
      21
    ],
    "awayPostgameWinProbability": 0.9909799816086888,
    "awayPregameElo": 1614,
    "awayPostgameElo": 1653,
    "excitementIndex": 6.681236701530058,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752910,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-23T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 38201,
    "venueId": 1056,
    "venue": "Rose Bowl",
    "homeId": 26,
    "homeTeam": "UCLA",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 14,
    "homeLineScores": [
      0,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.0028976621106266975,
    "homePregameElo": 1361,
    "homePostgameElo": 1313,
    "awayId": 264,
    "awayTeam": "Washington",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 48,
    "awayLineScores": [
      3,
      17,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.9971023378893733,
    "awayPregameElo": 1754,
    "awayPostgameElo": 1802,
    "excitementIndex": 3.192641077921975,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760417,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-23T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 37551,
    "venueId": 3660,
    "venue": "Valley Children's Stadium",
    "homeId": 278,
    "homeTeam": "Fresno State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 17,
    "homeLineScores": [
      7,
      10,
      0,
      0
    ],
    "homePostgameWinProbability": 0.21230269968509674,
    "homePregameElo": 1510,
    "homePostgameElo": 1478,
    "awayId": 328,
    "awayTeam": "Utah State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      0,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.7876973003149033,
    "awayPregameElo": 1423,
    "awayPostgameElo": 1455,
    "excitementIndex": 7.5268344203989095,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760420,
    "season": 2025,
    "week": 13,
    "seasonType": "regular",
    "startDate": "2025-11-23T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22595,
    "venueId": 7311,
    "venue": "Snapdragon Stadium",
    "homeId": 21,
    "homeTeam": "San Diego State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 25,
    "homeLineScores": [
      11,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.9587395191192627,
    "homePregameElo": 1507,
    "homePostgameElo": 1530,
    "awayId": 23,
    "awayTeam": "San José State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.041260480880737305,
    "awayPregameElo": 1208,
    "awayPostgameElo": 1185,
    "excitementIndex": 3.342700102602753,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762868,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-25T21:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 6043,
    "venueId": 3985,
    "venue": "Warren McGuirk Alumni Stadium",
    "homeId": 113,
    "homeTeam": "Massachusetts",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 14,
    "homeLineScores": [
      0,
      14,
      0,
      0
    ],
    "homePostgameWinProbability": 0.006251768674701452,
    "homePregameElo": 748,
    "homePostgameElo": 718,
    "awayId": 189,
    "awayTeam": "Bowling Green",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 45,
    "awayLineScores": [
      14,
      14,
      7,
      10
    ],
    "awayPostgameWinProbability": 0.9937482313252985,
    "awayPregameElo": 1230,
    "awayPostgameElo": 1260,
    "excitementIndex": 2.1605811274523727,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762869,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-26T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11818,
    "venueId": 3912,
    "venue": "Rynearson Stadium",
    "homeId": 2199,
    "homeTeam": "Eastern Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 21,
    "homeLineScores": [
      7,
      0,
      0,
      14
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1246,
    "homePostgameElo": 1239,
    "awayId": 2711,
    "awayTeam": "Western Michigan",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 31,
    "awayLineScores": [
      0,
      17,
      14,
      0
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1407,
    "awayPostgameElo": 1414,
    "excitementIndex": 3.7143168825044937,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762516,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-28T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 27082,
    "venueId": 3805,
    "venue": "Simmons Bank Liberty Stadium",
    "homeId": 235,
    "homeTeam": "Memphis",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 17,
    "homeLineScores": [
      3,
      14,
      0,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1660,
    "homePostgameElo": 1620,
    "awayId": 2426,
    "awayTeam": "Navy",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      14,
      7,
      7
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1485,
    "awayPostgameElo": 1525,
    "excitementIndex": 5.624486611217874,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756964,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-28T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 32811,
    "venueId": 3833,
    "venue": "Memorial Stadium",
    "homeId": 2305,
    "homeTeam": "Kansas",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 21,
    "homeLineScores": [
      0,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0.18204674124717712,
    "homePregameElo": 1499,
    "homePostgameElo": 1516,
    "awayId": 254,
    "awayTeam": "Utah",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 31,
    "awayLineScores": [
      3,
      7,
      0,
      21
    ],
    "awayPostgameWinProbability": 0.8179532587528229,
    "awayPregameElo": 1971,
    "awayPostgameElo": 1954,
    "excitementIndex": 6.276140375244612,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752916,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-28T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 86410,
    "venueId": 3834,
    "venue": "Memorial Stadium (Lincoln, NE)",
    "homeId": 158,
    "homeTeam": "Nebraska",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 16,
    "homeLineScores": [
      10,
      6,
      0,
      0
    ],
    "homePostgameWinProbability": 0.03046702966094017,
    "homePregameElo": 1611,
    "homePostgameElo": 1580,
    "awayId": 2294,
    "awayTeam": "Iowa",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 40,
    "awayLineScores": [
      10,
      14,
      9,
      7
    ],
    "awayPostgameWinProbability": 0.9695329703390598,
    "awayPregameElo": 1902,
    "awayPostgameElo": 1933,
    "excitementIndex": 3.966240038437885,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762870,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-28T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11096,
    "venueId": 3965,
    "venue": "UB Stadium",
    "homeId": 2084,
    "homeTeam": "Buffalo",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 26,
    "homeLineScores": [
      0,
      7,
      6,
      13
    ],
    "homePostgameWinProbability": 0.5063985586166382,
    "homePregameElo": 1288,
    "homePostgameElo": 1298,
    "awayId": 195,
    "awayTeam": "Ohio",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      14,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.4936014413833618,
    "awayPregameElo": 1572,
    "awayPostgameElo": 1562,
    "excitementIndex": 4.941688531055923,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762871,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-28T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 3090,
    "venueId": 3764,
    "venue": "Huskie Stadium",
    "homeId": 2459,
    "homeTeam": "Northern Illinois",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 31,
    "homeLineScores": [
      7,
      14,
      0,
      10
    ],
    "homePostgameWinProbability": 0.5420212745666504,
    "homePregameElo": 1260,
    "homePostgameElo": 1233,
    "awayId": 2309,
    "awayTeam": "Kent State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 35,
    "awayLineScores": [
      3,
      14,
      3,
      15
    ],
    "awayPostgameWinProbability": 0.4579787254333496,
    "awayPregameElo": 974,
    "awayPostgameElo": 1001,
    "excitementIndex": 7.06656686791855,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752788,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-28T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60417,
    "venueId": 3693,
    "venue": "Davis Wade Stadium",
    "homeId": 344,
    "homeTeam": "Mississippi State",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 19,
    "homeLineScores": [
      7,
      3,
      3,
      6
    ],
    "homePostgameWinProbability": 0.037043988704681396,
    "homePregameElo": 1492,
    "homePostgameElo": 1491,
    "awayId": 145,
    "awayTeam": "Ole Miss",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 38,
    "awayLineScores": [
      14,
      7,
      3,
      14
    ],
    "awayPostgameWinProbability": 0.9629560112953186,
    "awayPregameElo": 1959,
    "awayPostgameElo": 1960,
    "excitementIndex": 4.644830935938228,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760421,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-28T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25873,
    "venueId": 5388,
    "venue": "Canvas Stadium",
    "homeId": 36,
    "homeTeam": "Colorado State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 21,
    "homeLineScores": [
      0,
      7,
      7,
      7
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1191,
    "homePostgameElo": 1155,
    "awayId": 2005,
    "awayTeam": "Air Force",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 42,
    "awayLineScores": [
      14,
      7,
      7,
      14
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1350,
    "awayPostgameElo": 1386,
    "excitementIndex": 3.654887940296669,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760426,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-28T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 30575,
    "venueId": 3971,
    "venue": "University Stadium (NM)",
    "homeId": 167,
    "homeTeam": "New Mexico",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 23,
    "homeLineScores": [
      3,
      7,
      7,
      0,
      6
    ],
    "homePostgameWinProbability": 0.1694977879524231,
    "homePregameElo": 1491,
    "homePostgameElo": 1500,
    "awayId": 21,
    "awayTeam": "San Diego State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      14,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.8305022120475769,
    "awayPregameElo": 1530,
    "awayPostgameElo": 1521,
    "excitementIndex": 8.259158428099113,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762442,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-28T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24492,
    "venueId": 3825,
    "venue": "DATCU Stadium",
    "homeId": 249,
    "homeTeam": "North Texas",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 52,
    "homeLineScores": [
      14,
      21,
      10,
      7
    ],
    "homePostgameWinProbability": 0.9109395146369934,
    "homePregameElo": 1741,
    "homePostgameElo": 1756,
    "awayId": 218,
    "awayTeam": "Temple",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 25,
    "awayLineScores": [
      7,
      0,
      7,
      11
    ],
    "awayPostgameWinProbability": 0.08906048536300659,
    "awayPregameElo": 1234,
    "awayPostgameElo": 1219,
    "excitementIndex": 3.517130738315427,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752786,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-28T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 73728,
    "venueId": 5348,
    "venue": "Mercedes-Benz Stadium",
    "homeId": 59,
    "homeTeam": "Georgia Tech",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 9,
    "homeLineScores": [
      3,
      0,
      3,
      3
    ],
    "homePostgameWinProbability": 0.5011671185493469,
    "homePregameElo": 1573,
    "homePostgameElo": 1595,
    "awayId": 61,
    "awayTeam": "Georgia",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      13,
      0,
      3
    ],
    "awayPostgameWinProbability": 0.4988328814506531,
    "awayPregameElo": 2048,
    "awayPostgameElo": 2026,
    "excitementIndex": 3.7309061341517817,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760422,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-28T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21115,
    "venueId": 3905,
    "venue": "Maverik Stadium",
    "homeId": 328,
    "homeTeam": "Utah State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 24,
    "homeLineScores": [
      14,
      7,
      3,
      0
    ],
    "homePostgameWinProbability": 0.34251150488853455,
    "homePregameElo": 1455,
    "homePostgameElo": 1462,
    "awayId": 68,
    "awayTeam": "Boise State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 25,
    "awayLineScores": [
      10,
      3,
      6,
      6
    ],
    "awayPostgameWinProbability": 0.6574884951114655,
    "awayPregameElo": 1621,
    "awayPostgameElo": 1614,
    "excitementIndex": 6.623730275130599,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752924,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 59807,
    "venueId": 3907,
    "venue": "Ross-Ade Stadium",
    "homeId": 2509,
    "homeTeam": "Purdue",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 3,
    "homeLineScores": [
      3,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1276,
    "homePostgameElo": 1227,
    "awayId": 84,
    "awayTeam": "Indiana",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 56,
    "awayLineScores": [
      7,
      21,
      21,
      7
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 2142,
    "awayPostgameElo": 2191,
    "excitementIndex": 4.180747607485243,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752792,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 103632,
    "venueId": 3910,
    "venue": "DKR-Texas Memorial Stadium",
    "homeId": 251,
    "homeTeam": "Texas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 27,
    "homeLineScores": [
      0,
      3,
      10,
      14
    ],
    "homePostgameWinProbability": 0.6624485850334167,
    "homePregameElo": 1880,
    "homePostgameElo": 1898,
    "awayId": 245,
    "awayTeam": "Texas A&M",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 17,
    "awayLineScores": [
      0,
      10,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.33755141496658325,
    "awayPregameElo": 1896,
    "awayPostgameElo": 1878,
    "excitementIndex": 6.110871723010601,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756961,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 54037,
    "venueId": 3947,
    "venue": "Mountain America Stadium",
    "homeId": 9,
    "homeTeam": "Arizona State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 7,
    "homeLineScores": [
      0,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0.08919469267129898,
    "homePregameElo": 1653,
    "homePostgameElo": 1615,
    "awayId": 12,
    "awayTeam": "Arizona",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 23,
    "awayLineScores": [
      0,
      3,
      10,
      10
    ],
    "awayPostgameWinProbability": 0.910805307328701,
    "awayPregameElo": 1651,
    "awayPostgameElo": 1689,
    "excitementIndex": 4.291838806190243,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752921,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 111373,
    "venueId": 3558,
    "venue": "Michigan Stadium",
    "homeId": 130,
    "homeTeam": "Michigan",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 9,
    "homeLineScores": [
      6,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.006825553253293037,
    "homePregameElo": 1825,
    "homePostgameElo": 1814,
    "awayId": 194,
    "awayTeam": "Ohio State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 27,
    "awayLineScores": [
      3,
      14,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.993174446746707,
    "awayPregameElo": 2158,
    "awayPostgameElo": 2169,
    "excitementIndex": 3.9042299668833054,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752790,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 79827,
    "venueId": 3994,
    "venue": "Williams-Brice Stadium",
    "homeId": 2579,
    "homeTeam": "South Carolina",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 14,
    "homeLineScores": [
      0,
      14,
      0,
      0
    ],
    "homePostgameWinProbability": 0.009317152202129364,
    "homePregameElo": 1730,
    "homePostgameElo": 1697,
    "awayId": 228,
    "awayTeam": "Clemson",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      17,
      3,
      8
    ],
    "awayPostgameWinProbability": 0.9906828477978706,
    "awayPregameElo": 1725,
    "awayPostgameElo": 1758,
    "excitementIndex": 6.0292124586193445,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756962,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 34720,
    "venueId": 4727,
    "venue": "McLane Stadium",
    "homeId": 239,
    "homeTeam": "Baylor",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 24,
    "homeLineScores": [
      0,
      9,
      0,
      15
    ],
    "homePostgameWinProbability": 0.4149612486362457,
    "homePregameElo": 1526,
    "homePostgameElo": 1509,
    "awayId": 248,
    "awayTeam": "Houston",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      10,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.5850387513637543,
    "awayPregameElo": 1479,
    "awayPostgameElo": 1496,
    "excitementIndex": 5.676516189652465,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762519,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14712,
    "venueId": 3715,
    "venue": "FAU Stadium",
    "homeId": 2226,
    "homeTeam": "Florida Atlantic",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 3,
    "homeLineScores": [
      3,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.0007016126764938235,
    "homePregameElo": 1263,
    "homePostgameElo": 1178,
    "awayId": 151,
    "awayTeam": "East Carolina",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 42,
    "awayLineScores": [
      21,
      21,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.9992983873235062,
    "awayPregameElo": 1491,
    "awayPostgameElo": 1576,
    "excitementIndex": 3.066490242501596,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762875,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 11137,
    "venueId": 3996,
    "venue": "Yager Stadium",
    "homeId": 193,
    "homeTeam": "Miami (OH)",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 45,
    "homeLineScores": [
      21,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 0.9936692118644714,
    "homePregameElo": 1451,
    "homePostgameElo": 1459,
    "awayId": 2050,
    "awayTeam": "Ball State",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 24,
    "awayLineScores": [
      10,
      0,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.0063307881355285645,
    "awayPregameElo": 1018,
    "awayPostgameElo": 1010,
    "excitementIndex": 4.145491298442376,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756965,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 49549,
    "venueId": 3636,
    "venue": "Bill Snyder Family Stadium",
    "homeId": 2306,
    "homeTeam": "Kansas State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 24,
    "homeLineScores": [
      7,
      0,
      7,
      10
    ],
    "homePostgameWinProbability": 0.9838504195213318,
    "homePregameElo": 1680,
    "homePostgameElo": 1674,
    "awayId": 38,
    "awayTeam": "Colorado",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      7,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.016149580478668213,
    "awayPregameElo": 1338,
    "awayPostgameElo": 1344,
    "excitementIndex": 5.30959740233998,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754611,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 49845,
    "venueId": 3752,
    "venue": "Acrisure Stadium",
    "homeId": 221,
    "homeTeam": "Pittsburgh",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 7,
    "homeLineScores": [
      0,
      7,
      0,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1691,
    "homePostgameElo": 1631,
    "awayId": 2390,
    "awayTeam": "Miami",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 38,
    "awayLineScores": [
      3,
      14,
      14,
      7
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1907,
    "awayPostgameElo": 1967,
    "excitementIndex": 3.695876450099734,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756966,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 35127,
    "venueId": 3646,
    "venue": "Boone Pickens Stadium",
    "homeId": 197,
    "homeTeam": "Oklahoma State",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 13,
    "homeLineScores": [
      0,
      7,
      3,
      3
    ],
    "homePostgameWinProbability": 0.06585004180669785,
    "homePregameElo": 1084,
    "homePostgameElo": 1110,
    "awayId": 66,
    "awayTeam": "Iowa State",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 20,
    "awayLineScores": [
      3,
      7,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.9341499581933022,
    "awayPregameElo": 1655,
    "awayPostgameElo": 1629,
    "excitementIndex": 5.347888626270137,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752787,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 50634,
    "venueId": 3873,
    "venue": "L&N Federal Credit Union Stadium",
    "homeId": 97,
    "homeTeam": "Louisville",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 41,
    "homeLineScores": [
      7,
      13,
      7,
      14
    ],
    "homePostgameWinProbability": 0.9749041199684143,
    "homePregameElo": 1631,
    "homePostgameElo": 1744,
    "awayId": 96,
    "awayTeam": "Kentucky",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.025095880031585693,
    "awayPregameElo": 1578,
    "awayPostgameElo": 1465,
    "excitementIndex": 3.079453613424045,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762872,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 6673,
    "venueId": 3786,
    "venue": "Kelly/Shorts Stadium",
    "homeId": 2117,
    "homeTeam": "Central Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 3,
    "homeLineScores": [
      0,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.011706745252013206,
    "homePregameElo": 1291,
    "homePostgameElo": 1282,
    "awayId": 2649,
    "awayTeam": "Toledo",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      0,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.9882932547479868,
    "awayPregameElo": 1642,
    "awayPostgameElo": 1651,
    "excitementIndex": 4.719029622814196,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756968,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 44250,
    "venueId": 3842,
    "venue": "Milan Puskar Stadium",
    "homeId": 277,
    "homeTeam": "West Virginia",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 0,
    "homeLineScores": [
      0,
      0,
      0,
      0
    ],
    "homePostgameWinProbability": 0.008271883241832256,
    "homePregameElo": 1355,
    "homePostgameElo": 1291,
    "awayId": 2641,
    "awayTeam": "Texas Tech",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 49,
    "awayLineScores": [
      21,
      7,
      14,
      7
    ],
    "awayPostgameWinProbability": 0.9917281167581677,
    "awayPregameElo": 1997,
    "awayPostgameElo": 2061,
    "excitementIndex": 2.852444568793713,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757311,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 4237,
    "venueId": 3631,
    "venue": "BBVA Compass Stadium",
    "homeId": 2534,
    "homeTeam": "Sam Houston",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 16,
    "homeLineScores": [
      7,
      3,
      0,
      6
    ],
    "homePostgameWinProbability": 0.010444926097989082,
    "homePregameElo": 1068,
    "homePostgameElo": 994,
    "awayId": 2229,
    "awayTeam": "Florida International",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 56,
    "awayLineScores": [
      22,
      6,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.9895550739020109,
    "awayPregameElo": 1343,
    "awayPostgameElo": 1417,
    "excitementIndex": 3.4981768926733956,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756963,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 60389,
    "venueId": 3801,
    "venue": "LaVell Edwards Stadium",
    "homeId": 252,
    "homeTeam": "BYU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 41,
    "homeLineScores": [
      0,
      17,
      21,
      3
    ],
    "homePostgameWinProbability": 0.9982386231422424,
    "homePregameElo": 1781,
    "homePostgameElo": 1797,
    "awayId": 2116,
    "awayTeam": "UCF",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 21,
    "awayLineScores": [
      14,
      0,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.0017613768577575684,
    "awayPregameElo": 1464,
    "awayPostgameElo": 1448,
    "excitementIndex": 5.023789960551446,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757310,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T18:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13560,
    "venueId": 3695,
    "venue": "Delaware Stadium",
    "homeId": 48,
    "homeTeam": "Delaware",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 61,
    "homeLineScores": [
      7,
      24,
      10,
      20
    ],
    "homePostgameWinProbability": 0.9987398386001587,
    "homePregameElo": 1266,
    "homePostgameElo": 1339,
    "awayId": 2638,
    "awayTeam": "UTEP",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      13,
      11,
      0
    ],
    "awayPostgameWinProbability": 0.0012601613998413086,
    "awayPregameElo": 1208,
    "awayPostgameElo": 1135,
    "excitementIndex": 4.838235459533286,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761663,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T18:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21524,
    "venueId": 3775,
    "venue": "Joan C. Edwards Stadium",
    "homeId": 276,
    "homeTeam": "Marshall",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 19,
    "homeLineScores": [
      3,
      3,
      6,
      7
    ],
    "homePostgameWinProbability": 0.47366154193878174,
    "homePregameElo": 1495,
    "homePostgameElo": 1468,
    "awayId": 290,
    "awayTeam": "Georgia Southern",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 24,
    "awayLineScores": [
      14,
      0,
      10,
      0
    ],
    "awayPostgameWinProbability": 0.5263384580612183,
    "awayPregameElo": 1250,
    "awayPostgameElo": 1277,
    "excitementIndex": 4.427883667668173,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757314,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 7656,
    "venueId": 3878,
    "venue": "Plaster Sports Complex",
    "homeId": 2623,
    "homeTeam": "Missouri State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 30,
    "homeLineScores": [
      0,
      10,
      7,
      13
    ],
    "homePostgameWinProbability": 0.11619581282138824,
    "homePregameElo": 1366,
    "homePostgameElo": 1344,
    "awayId": 2348,
    "awayTeam": "Louisiana Tech",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 42,
    "awayLineScores": [
      7,
      7,
      7,
      21
    ],
    "awayPostgameWinProbability": 0.8838041871786118,
    "awayPregameElo": 1407,
    "awayPostgameElo": 1429,
    "excitementIndex": 5.571557280944688,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761664,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 17126,
    "venueId": 3918,
    "venue": "S.B. Ballard Stadium",
    "homeId": 295,
    "homeTeam": "Old Dominion",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 27,
    "homeLineScores": [
      0,
      10,
      17,
      0
    ],
    "homePostgameWinProbability": 0.8773381114006042,
    "homePregameElo": 1635,
    "homePostgameElo": 1627,
    "awayId": 2247,
    "awayTeam": "Georgia State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.12266188859939575,
    "awayPregameElo": 1104,
    "awayPostgameElo": 1112,
    "excitementIndex": 4.902601426948072,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757312,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T19:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16733,
    "venueId": 3662,
    "venue": "AmFirst Stadium",
    "homeId": 55,
    "homeTeam": "Jacksonville State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 37,
    "homeLineScores": [
      7,
      17,
      7,
      6
    ],
    "homePostgameWinProbability": 0.8640779852867126,
    "homePregameElo": 1501,
    "homePostgameElo": 1501,
    "awayId": 98,
    "awayTeam": "Western Kentucky",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 34,
    "awayLineScores": [
      14,
      14,
      3,
      3
    ],
    "awayPostgameWinProbability": 0.13592201471328735,
    "awayPregameElo": 1401,
    "awayPostgameElo": 1401,
    "excitementIndex": 7.675753951059409,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761661,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T19:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 23876,
    "venueId": 3792,
    "venue": "Kidd Brewer Stadium",
    "homeId": 2026,
    "homeTeam": "App State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 29,
    "homeLineScores": [
      3,
      13,
      7,
      6
    ],
    "homePostgameWinProbability": 0.6557454466819763,
    "homePregameElo": 1252,
    "homePostgameElo": 1253,
    "awayId": 2032,
    "awayTeam": "Arkansas State",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 30,
    "awayLineScores": [
      3,
      13,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.3442545533180237,
    "awayPregameElo": 1302,
    "awayPostgameElo": 1301,
    "excitementIndex": 7.627218506792508,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754608,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 32457,
    "venueId": 1964,
    "venue": "JMA Wireless Dome",
    "homeId": 183,
    "homeTeam": "Syracuse",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 12,
    "homeLineScores": [
      0,
      6,
      0,
      6
    ],
    "homePostgameWinProbability": 0.00022920966148376465,
    "homePregameElo": 1230,
    "homePostgameElo": 1182,
    "awayId": 103,
    "awayTeam": "Boston College",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 34,
    "awayLineScores": [
      3,
      3,
      14,
      14
    ],
    "awayPostgameWinProbability": 0.9997707903385162,
    "awayPregameElo": 1311,
    "awayPostgameElo": 1359,
    "excitementIndex": 4.428296929054098,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762517,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 13026,
    "venueId": 3674,
    "venue": "Chapman Stadium",
    "homeId": 202,
    "homeTeam": "Tulsa",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 24,
    "homeLineScores": [
      3,
      14,
      0,
      7
    ],
    "homePostgameWinProbability": 0.38257190585136414,
    "homePregameElo": 1119,
    "homePostgameElo": 1110,
    "awayId": 5,
    "awayTeam": "UAB",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      3,
      7,
      14
    ],
    "awayPostgameWinProbability": 0.6174280941486359,
    "awayPregameElo": 1175,
    "awayPostgameElo": 1184,
    "excitementIndex": 6.10812785672287,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757315,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 7381,
    "venueId": 3601,
    "venue": "Aggie Memorial Stadium",
    "homeId": 166,
    "homeTeam": "New Mexico State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 24,
    "homeLineScores": [
      7,
      0,
      7,
      10,
      0
    ],
    "homePostgameWinProbability": 0.045983873307704926,
    "homePregameElo": 1188,
    "homePostgameElo": 1172,
    "awayId": 2393,
    "awayTeam": "Middle Tennessee",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      7,
      3,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9540161266922951,
    "awayPregameElo": 1148,
    "awayPostgameElo": 1164,
    "excitementIndex": 9.08819484044069,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761665,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16270,
    "venueId": 3666,
    "venue": "Cajun Field",
    "homeId": 309,
    "homeTeam": "Louisiana",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 30,
    "homeLineScores": [
      14,
      3,
      0,
      10,
      3
    ],
    "homePostgameWinProbability": 0.07988160848617554,
    "homePregameElo": 1354,
    "homePostgameElo": 1351,
    "awayId": 2433,
    "awayTeam": "UL Monroe",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 27,
    "awayLineScores": [
      13,
      0,
      0,
      14,
      0
    ],
    "awayPostgameWinProbability": 0.9201183915138245,
    "awayPregameElo": 1013,
    "awayPostgameElo": 1016,
    "excitementIndex": 8.585493350532403,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761667,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 16169,
    "venueId": 3644,
    "venue": "Bobcat Stadium (TX)",
    "homeId": 326,
    "homeTeam": "Texas State",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 49,
    "homeLineScores": [
      10,
      11,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9943795204162598,
    "homePregameElo": 1533,
    "homePostgameElo": 1572,
    "awayId": 6,
    "awayTeam": "South Alabama",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 26,
    "awayLineScores": [
      7,
      0,
      0,
      19
    ],
    "awayPostgameWinProbability": 0.005620479583740234,
    "awayPregameElo": 1375,
    "awayPostgameElo": 1336,
    "excitementIndex": 4.018895429295734,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401757313,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 12695,
    "venueId": 3992,
    "venue": "Williams Stadium (VA)",
    "homeId": 2335,
    "homeTeam": "Liberty",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 42,
    "homeLineScores": [
      7,
      7,
      7,
      14,
      7
    ],
    "homePostgameWinProbability": 0.3788453936576843,
    "homePregameElo": 1457,
    "homePostgameElo": 1441,
    "awayId": 338,
    "awayTeam": "Kennesaw State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 48,
    "awayLineScores": [
      7,
      7,
      7,
      14,
      13
    ],
    "awayPostgameWinProbability": 0.6211546063423157,
    "awayPregameElo": 1385,
    "awayPostgameElo": 1401,
    "excitementIndex": 11.482716748256323,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761666,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 25987,
    "venueId": 3815,
    "venue": "M. M. Roberts Stadium",
    "homeId": 2572,
    "homeTeam": "Southern Miss",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 18,
    "homeLineScores": [
      0,
      3,
      7,
      8
    ],
    "homePostgameWinProbability": 0.27414801716804504,
    "homePregameElo": 1297,
    "homePostgameElo": 1282,
    "awayId": 2653,
    "awayTeam": "Troy",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      14,
      0,
      14
    ],
    "awayPostgameWinProbability": 0.725851982831955,
    "awayPregameElo": 1362,
    "awayPostgameElo": 1377,
    "excitementIndex": 5.637155890398114,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752917,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 72376,
    "venueId": 3765,
    "venue": "Husky Stadium",
    "homeId": 264,
    "homeTeam": "Washington",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.0651833564043045,
    "homePregameElo": 1802,
    "homePostgameElo": 1801,
    "awayId": 2483,
    "awayTeam": "Oregon",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 26,
    "awayLineScores": [
      3,
      10,
      6,
      7
    ],
    "awayPostgameWinProbability": 0.9348166435956955,
    "awayPregameElo": 2086,
    "awayPostgameElo": 2087,
    "excitementIndex": 4.952081684431378,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401756967,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 37259,
    "venueId": 3616,
    "venue": "Amon G. Carter Stadium",
    "homeId": 2628,
    "homeTeam": "TCU",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 45,
    "homeLineScores": [
      21,
      10,
      7,
      7
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1602,
    "homePostgameElo": 1652,
    "awayId": 2132,
    "awayTeam": "Cincinnati",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 23,
    "awayLineScores": [
      7,
      10,
      0,
      6
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1569,
    "awayPostgameElo": 1519,
    "excitementIndex": 3.827532930675581,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754610,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 21045,
    "venueId": 3982,
    "venue": "Wallace Wade Stadium",
    "homeId": 150,
    "homeTeam": "Duke",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 49,
    "homeLineScores": [
      14,
      7,
      14,
      14
    ],
    "homePostgameWinProbability": 0.9172453284263611,
    "homePregameElo": 1573,
    "homePostgameElo": 1607,
    "awayId": 154,
    "awayTeam": "Wake Forest",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 32,
    "awayLineScores": [
      3,
      14,
      8,
      7
    ],
    "awayPostgameWinProbability": 0.08275467157363892,
    "awayPregameElo": 1542,
    "awayPostgameElo": 1508,
    "excitementIndex": 5.445564503199554,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762441,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22620,
    "venueId": 3604,
    "venue": "Alamodome",
    "homeId": 2636,
    "homeTeam": "UTSA",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 24,
    "homeLineScores": [
      7,
      3,
      0,
      14
    ],
    "homePostgameWinProbability": 0.23011034727096558,
    "homePregameElo": 1585,
    "homePostgameElo": 1575,
    "awayId": 349,
    "awayTeam": "Army",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 27,
    "awayLineScores": [
      0,
      17,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.7698896527290344,
    "awayPregameElo": 1504,
    "awayPostgameElo": 1514,
    "excitementIndex": 5.737582221587653,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752920,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 55212,
    "venueId": 6577,
    "venue": "SHI Stadium",
    "homeId": 164,
    "homeTeam": "Rutgers",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 36,
    "homeLineScores": [
      14,
      7,
      7,
      8
    ],
    "homePostgameWinProbability": 0.3370431661605835,
    "homePregameElo": 1445,
    "homePostgameElo": 1469,
    "awayId": 213,
    "awayTeam": "Penn State",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 40,
    "awayLineScores": [
      14,
      10,
      9,
      7
    ],
    "awayPostgameWinProbability": 0.6629568338394165,
    "awayPregameElo": 1975,
    "awayPostgameElo": 1951,
    "excitementIndex": 6.920961256797671,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752918,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 46038,
    "venueId": 3953,
    "venue": "Huntington Bank Stadium",
    "homeId": 135,
    "homeTeam": "Minnesota",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 17,
    "homeLineScores": [
      0,
      10,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9795013070106506,
    "homePregameElo": 1491,
    "homePostgameElo": 1510,
    "awayId": 275,
    "awayTeam": "Wisconsin",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      7,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.020498692989349365,
    "awayPregameElo": 1521,
    "awayPostgameElo": 1502,
    "excitementIndex": 4.846401502929096,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752789,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 83734,
    "venueId": 3835,
    "venue": "Memorial Stadium (Norman, OK)",
    "homeId": 201,
    "homeTeam": "Oklahoma",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 17,
    "homeLineScores": [
      3,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.7494428753852844,
    "homePregameElo": 1824,
    "homePostgameElo": 1823,
    "awayId": 99,
    "awayTeam": "LSU",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 13,
    "awayLineScores": [
      0,
      3,
      7,
      3
    ],
    "awayPostgameWinProbability": 0.2505571246147156,
    "awayPregameElo": 1690,
    "awayPostgameElo": 1691,
    "excitementIndex": 8.369552819047248,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752783,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 61508,
    "venueId": 3887,
    "venue": "Razorback Stadium",
    "homeId": 8,
    "homeTeam": "Arkansas",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 17,
    "homeLineScores": [
      7,
      10,
      0,
      0
    ],
    "homePostgameWinProbability": 0.3151633143424988,
    "homePregameElo": 1588,
    "homePostgameElo": 1571,
    "awayId": 142,
    "awayTeam": "Missouri",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 31,
    "awayLineScores": [
      7,
      7,
      6,
      11
    ],
    "awayPostgameWinProbability": 0.6848366856575012,
    "awayPregameElo": 1748,
    "awayPostgameElo": 1765,
    "excitementIndex": 5.336043578812519,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752791,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 101915,
    "venueId": 3853,
    "venue": "Neyland Stadium",
    "homeId": 2633,
    "homeTeam": "Tennessee",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 24,
    "homeLineScores": [
      7,
      14,
      0,
      3
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1856,
    "homePostgameElo": 1799,
    "awayId": 238,
    "awayTeam": "Vanderbilt",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 45,
    "awayLineScores": [
      7,
      14,
      10,
      14
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1827,
    "awayPostgameElo": 1884,
    "excitementIndex": 6.4644006771448,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401761662,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T20:45:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15137,
    "venueId": 3654,
    "venue": "Brooks Stadium (SC)",
    "homeId": 324,
    "homeTeam": "Coastal Carolina",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 10,
    "homeLineScores": [
      0,
      10,
      0,
      0
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1228,
    "homePostgameElo": 1165,
    "awayId": 256,
    "awayTeam": "James Madison",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 59,
    "awayLineScores": [
      17,
      3,
      11,
      28
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 1874,
    "awayPostgameElo": 1937,
    "excitementIndex": 3.262323910654704,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752785,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T21:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 90007,
    "venueId": 3634,
    "venue": "Ben Hill Griffin Stadium",
    "homeId": 57,
    "homeTeam": "Florida",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 40,
    "homeLineScores": [
      10,
      7,
      14,
      9
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1543,
    "homePostgameElo": 1593,
    "awayId": 52,
    "awayTeam": "Florida State",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      14,
      0,
      7
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1606,
    "awayPostgameElo": 1556,
    "excitementIndex": 4.469059448621237,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752946,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-29T23:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 24806,
    "venueId": 3820,
    "venue": "Gesa Field",
    "homeId": 265,
    "homeTeam": "Washington State",
    "homeClassification": "fbs",
    "homeConference": "Pac-12",
    "homePoints": 32,
    "homeLineScores": [
      3,
      16,
      6,
      7
    ],
    "homePostgameWinProbability": 0.9974702596664429,
    "homePregameElo": 1508,
    "homePostgameElo": 1533,
    "awayId": 204,
    "awayTeam": "Oregon State",
    "awayClassification": "fbs",
    "awayConference": "Pac-12",
    "awayPoints": 8,
    "awayLineScores": [
      0,
      0,
      0,
      8
    ],
    "awayPostgameWinProbability": 0.002529740333557129,
    "awayPregameElo": 1175,
    "awayPostgameElo": 1150,
    "excitementIndex": 3.7653671517568634,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754613,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 58832,
    "venueId": 3923,
    "venue": "Scott Stadium",
    "homeId": 258,
    "homeTeam": "Virginia",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 27,
    "homeLineScores": [
      7,
      7,
      10,
      3
    ],
    "homePostgameWinProbability": 0.9284532070159912,
    "homePregameElo": 1604,
    "homePostgameElo": 1631,
    "awayId": 259,
    "awayTeam": "Virginia Tech",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 7,
    "awayLineScores": [
      0,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.07154679298400879,
    "awayPregameElo": 1409,
    "awayPostgameElo": 1382,
    "excitementIndex": 3.413907505600506,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762520,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28813,
    "venueId": 3886,
    "venue": "Raymond James Stadium",
    "homeId": 58,
    "homeTeam": "South Florida",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 52,
    "homeLineScores": [
      14,
      14,
      10,
      14
    ],
    "homePostgameWinProbability": 0.9913873672485352,
    "homePregameElo": 1751,
    "homePostgameElo": 1817,
    "awayId": 242,
    "awayTeam": "Rice",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 3,
    "awayLineScores": [
      0,
      3,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.008612632751464844,
    "awayPregameElo": 1144,
    "awayPostgameElo": 1078,
    "excitementIndex": 2.8888965809025615,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752923,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-30T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 30317,
    "venueId": 3727,
    "venue": "Ford Field",
    "homeId": 127,
    "homeTeam": "Michigan State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 38,
    "homeLineScores": [
      7,
      17,
      7,
      7
    ],
    "homePostgameWinProbability": 0.6489320397377014,
    "homePregameElo": 1382,
    "homePostgameElo": 1409,
    "awayId": 120,
    "awayTeam": "Maryland",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 28,
    "awayLineScores": [
      0,
      7,
      21,
      0
    ],
    "awayPostgameWinProbability": 0.3510679602622986,
    "awayPregameElo": 1414,
    "awayPostgameElo": 1387,
    "excitementIndex": 6.190327597611802,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754612,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-30T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 56919,
    "venueId": 3670,
    "venue": "Carter-Finley Stadium",
    "homeId": 152,
    "homeTeam": "NC State",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 42,
    "homeLineScores": [
      14,
      14,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9995241761207581,
    "homePregameElo": 1481,
    "homePostgameElo": 1525,
    "awayId": 153,
    "awayTeam": "North Carolina",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 19,
    "awayLineScores": [
      0,
      10,
      3,
      6
    ],
    "awayPostgameWinProbability": 0.00047582387924194336,
    "awayPregameElo": 1364,
    "awayPostgameElo": 1320,
    "excitementIndex": 3.756003950760385,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752922,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-30T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": null,
    "venueId": 3832,
    "venue": "Memorial Stadium (Champaign, IL)",
    "homeId": 356,
    "homeTeam": "Illinois",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 20,
    "homeLineScores": [
      0,
      14,
      3,
      3
    ],
    "homePostgameWinProbability": 1,
    "homePregameElo": 1576,
    "homePostgameElo": 1583,
    "awayId": 77,
    "awayTeam": "Northwestern",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 13,
    "awayLineScores": [
      3,
      7,
      0,
      3
    ],
    "awayPostgameWinProbability": 0,
    "awayPregameElo": 1531,
    "awayPostgameElo": 1524,
    "excitementIndex": 5.589426056465866,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401762518,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-30T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 22245,
    "venueId": 4729,
    "venue": "Yulman Stadium",
    "homeId": 2655,
    "homeTeam": "Tulane",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 27,
    "homeLineScores": [
      14,
      7,
      0,
      6
    ],
    "homePostgameWinProbability": 0.976479172706604,
    "homePregameElo": 1575,
    "homePostgameElo": 1587,
    "awayId": 2429,
    "awayTeam": "Charlotte",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 0,
    "awayLineScores": [
      0,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.023520827293395996,
    "awayPregameElo": 1035,
    "awayPostgameElo": 1023,
    "excitementIndex": 2.8879023551198375,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752919,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-30T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 69614,
    "venueId": 477,
    "venue": "Los Angeles Memorial Coliseum",
    "homeId": 30,
    "homeTeam": "USC",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 29,
    "homeLineScores": [
      7,
      0,
      7,
      15
    ],
    "homePostgameWinProbability": 0.9810897707939148,
    "homePregameElo": 1898,
    "homePostgameElo": 1889,
    "awayId": 26,
    "awayTeam": "UCLA",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 10,
    "awayLineScores": [
      0,
      10,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.018910229206085205,
    "awayPregameElo": 1313,
    "awayPostgameElo": 1322,
    "excitementIndex": 5.114873290335889,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401752784,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-30T00:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 88043,
    "venueId": 3785,
    "venue": "Jordan-Hare Stadium",
    "homeId": 2,
    "homeTeam": "Auburn",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 20,
    "homeLineScores": [
      0,
      6,
      7,
      7
    ],
    "homePostgameWinProbability": 0.6541077494621277,
    "homePregameElo": 1661,
    "homePostgameElo": 1670,
    "awayId": 333,
    "awayTeam": "Alabama",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 27,
    "awayLineScores": [
      10,
      7,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.3458922505378723,
    "awayPregameElo": 1964,
    "awayPostgameElo": 1955,
    "excitementIndex": 6.498412085382101,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754609,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-30T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 28956,
    "venueId": 3831,
    "venue": "California Memorial Stadium",
    "homeId": 25,
    "homeTeam": "California",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 38,
    "homeLineScores": [
      3,
      14,
      7,
      14
    ],
    "homePostgameWinProbability": 0.8880766034126282,
    "homePregameElo": 1351,
    "homePostgameElo": 1360,
    "awayId": 2567,
    "awayTeam": "SMU",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 35,
    "awayLineScores": [
      7,
      0,
      7,
      21
    ],
    "awayPostgameWinProbability": 0.11192339658737183,
    "awayPregameElo": 1860,
    "awayPostgameElo": 1851,
    "excitementIndex": 6.145828609445121,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760425,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-30T02:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": null,
    "venueId": 3816,
    "venue": "Mackay Stadium",
    "homeId": 2440,
    "homeTeam": "Nevada",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 17,
    "homeLineScores": [
      3,
      0,
      7,
      7
    ],
    "homePostgameWinProbability": 0.007143768481910229,
    "homePregameElo": 1303,
    "homePostgameElo": 1277,
    "awayId": 2439,
    "awayTeam": "UNLV",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 42,
    "awayLineScores": [
      7,
      21,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9928562315180898,
    "awayPregameElo": 1663,
    "awayPostgameElo": 1689,
    "excitementIndex": 2.8375864235482773,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760423,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-30T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 14194,
    "venueId": 3935,
    "venue": "CEFCU Stadium",
    "homeId": 23,
    "homeTeam": "San José State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 14,
    "homeLineScores": [
      0,
      7,
      0,
      7
    ],
    "homePostgameWinProbability": 0.029034025967121124,
    "homePregameElo": 1185,
    "homePostgameElo": 1146,
    "awayId": 278,
    "awayTeam": "Fresno State",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 41,
    "awayLineScores": [
      3,
      18,
      3,
      17
    ],
    "awayPostgameWinProbability": 0.9709659740328789,
    "awayPregameElo": 1478,
    "awayPostgameElo": 1517,
    "excitementIndex": 4.315561969842375,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401754614,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-30T03:30:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 27456,
    "venueId": 3940,
    "venue": "Stanford Stadium",
    "homeId": 24,
    "homeTeam": "Stanford",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 20,
    "homeLineScores": [
      0,
      3,
      3,
      14
    ],
    "homePostgameWinProbability": 0.009813349694013596,
    "homePregameElo": 1315,
    "homePostgameElo": 1335,
    "awayId": 87,
    "awayTeam": "Notre Dame",
    "awayClassification": "fbs",
    "awayConference": "FBS Independents",
    "awayPoints": 49,
    "awayLineScores": [
      14,
      21,
      7,
      7
    ],
    "awayPostgameWinProbability": 0.9901866503059864,
    "awayPregameElo": 2263,
    "awayPostgameElo": 2243,
    "excitementIndex": 2.554831192981494,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401760424,
    "season": 2025,
    "week": 14,
    "seasonType": "regular",
    "startDate": "2025-11-30T04:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": true,
    "attendance": 15194,
    "venueId": 7220,
    "venue": "Clarence T.C. Ching Athletics Complex",
    "homeId": 62,
    "homeTeam": "Hawai'i",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 27,
    "homeLineScores": [
      7,
      13,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9785661697387695,
    "homePregameElo": 1421,
    "homePostgameElo": 1459,
    "awayId": 2751,
    "awayTeam": "Wyoming",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.02143383026123047,
    "awayPregameElo": 1333,
    "awayPostgameElo": 1295,
    "excitementIndex": 4.8549964443267974,
    "highlights": "",
    "notes": null,
    "playoff": null
  },
  {
    "id": 401777325,
    "season": 2025,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2025-12-06T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 18142,
    "venueId": 3662,
    "venue": "AmFirst Stadium",
    "homeId": 55,
    "homeTeam": "Jacksonville State",
    "homeClassification": "fbs",
    "homeConference": "Conference USA",
    "homePoints": 15,
    "homeLineScores": [
      0,
      0,
      0,
      15
    ],
    "homePostgameWinProbability": 0.3228997588157654,
    "homePregameElo": 1501,
    "homePostgameElo": 1488,
    "awayId": 338,
    "awayTeam": "Kennesaw State",
    "awayClassification": "fbs",
    "awayConference": "Conference USA",
    "awayPoints": 19,
    "awayLineScores": [
      0,
      7,
      3,
      9
    ],
    "awayPostgameWinProbability": 0.6771002411842346,
    "awayPregameElo": 1401,
    "awayPostgameElo": 1414,
    "excitementIndex": 6.1899316067275025,
    "highlights": "",
    "notes": "Conference USA Championship",
    "playoff": null
  },
  {
    "id": 401777352,
    "season": 2025,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2025-12-06T00:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 19836,
    "venueId": 3651,
    "venue": "Bridgeforth Stadium",
    "homeId": 256,
    "homeTeam": "James Madison",
    "homeClassification": "fbs",
    "homeConference": "Sun Belt",
    "homePoints": 31,
    "homeLineScores": [
      3,
      14,
      0,
      14
    ],
    "homePostgameWinProbability": 0.9025601744651794,
    "homePregameElo": 1937,
    "homePostgameElo": 1927,
    "awayId": 2653,
    "awayTeam": "Troy",
    "awayClassification": "fbs",
    "awayConference": "Sun Belt",
    "awayPoints": 14,
    "awayLineScores": [
      0,
      14,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.09743982553482056,
    "awayPregameElo": 1377,
    "awayPostgameElo": 1387,
    "excitementIndex": 6.535969570648908,
    "highlights": "",
    "notes": "Sun Belt Championship",
    "playoff": null
  },
  {
    "id": 401777326,
    "season": 2025,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2025-12-06T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 27152,
    "venueId": 3653,
    "venue": "Albertsons Stadium",
    "homeId": 68,
    "homeTeam": "Boise State",
    "homeClassification": "fbs",
    "homeConference": "Mountain West",
    "homePoints": 38,
    "homeLineScores": [
      14,
      14,
      0,
      10
    ],
    "homePostgameWinProbability": 0.9515297412872314,
    "homePregameElo": 1614,
    "homePostgameElo": 1659,
    "awayId": 2439,
    "awayTeam": "UNLV",
    "awayClassification": "fbs",
    "awayConference": "Mountain West",
    "awayPoints": 21,
    "awayLineScores": [
      0,
      14,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.048470258712768555,
    "awayPregameElo": 1689,
    "awayPostgameElo": 1644,
    "excitementIndex": 4.510762404061435,
    "highlights": "",
    "notes": "Mountain West Championship",
    "playoff": null
  },
  {
    "id": 401777324,
    "season": 2025,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2025-12-06T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": false,
    "conferenceGame": false,
    "attendance": 23986,
    "venueId": 4729,
    "venue": "Yulman Stadium",
    "homeId": 2655,
    "homeTeam": "Tulane",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 34,
    "homeLineScores": [
      7,
      17,
      7,
      3
    ],
    "homePostgameWinProbability": 0.9926076531410217,
    "homePregameElo": 1587,
    "homePostgameElo": 1627,
    "awayId": 249,
    "awayTeam": "North Texas",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 21,
    "awayLineScores": [
      7,
      0,
      6,
      8
    ],
    "awayPostgameWinProbability": 0.0073923468589782715,
    "awayPregameElo": 1756,
    "awayPostgameElo": 1716,
    "excitementIndex": 4.824688014209357,
    "highlights": "",
    "notes": "American Championship",
    "playoff": null
  },
  {
    "id": 401777327,
    "season": 2025,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2025-12-06T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 85519,
    "venueId": 3687,
    "venue": "AT&T Stadium",
    "homeId": 2641,
    "homeTeam": "Texas Tech",
    "homeClassification": "fbs",
    "homeConference": "Big 12",
    "homePoints": 34,
    "homeLineScores": [
      0,
      13,
      8,
      13
    ],
    "homePostgameWinProbability": 0.9256317019462585,
    "homePregameElo": 2061,
    "homePostgameElo": 2108,
    "awayId": 252,
    "awayTeam": "BYU",
    "awayClassification": "fbs",
    "awayConference": "Big 12",
    "awayPoints": 7,
    "awayLineScores": [
      7,
      0,
      0,
      0
    ],
    "awayPostgameWinProbability": 0.07436829805374146,
    "awayPregameElo": 1797,
    "awayPostgameElo": 1750,
    "excitementIndex": 5.334101709692606,
    "highlights": "",
    "notes": "Big 12 Championship",
    "playoff": null
  },
  {
    "id": 401777329,
    "season": 2025,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2025-12-06T17:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 19114,
    "venueId": 3727,
    "venue": "Ford Field",
    "homeId": 2711,
    "homeTeam": "Western Michigan",
    "homeClassification": "fbs",
    "homeConference": "Mid-American",
    "homePoints": 23,
    "homeLineScores": [
      10,
      6,
      7,
      0
    ],
    "homePostgameWinProbability": 0.9063781499862671,
    "homePregameElo": 1414,
    "homePostgameElo": 1442,
    "awayId": 193,
    "awayTeam": "Miami (OH)",
    "awayClassification": "fbs",
    "awayConference": "Mid-American",
    "awayPoints": 13,
    "awayLineScores": [
      6,
      0,
      0,
      7
    ],
    "awayPostgameWinProbability": 0.09362185001373291,
    "awayPregameElo": 1459,
    "awayPostgameElo": 1431,
    "excitementIndex": 4.19486619977604,
    "highlights": "",
    "notes": "MAC Championship",
    "playoff": null
  },
  {
    "id": 401777351,
    "season": 2025,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2025-12-06T21:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 77247,
    "venueId": 5348,
    "venue": "Mercedes-Benz Stadium",
    "homeId": 333,
    "homeTeam": "Alabama",
    "homeClassification": "fbs",
    "homeConference": "SEC",
    "homePoints": 7,
    "homeLineScores": [
      0,
      0,
      0,
      7
    ],
    "homePostgameWinProbability": 0,
    "homePregameElo": 1955,
    "homePostgameElo": 1917,
    "awayId": 61,
    "awayTeam": "Georgia",
    "awayClassification": "fbs",
    "awayConference": "SEC",
    "awayPoints": 28,
    "awayLineScores": [
      7,
      7,
      7,
      7
    ],
    "awayPostgameWinProbability": 1,
    "awayPregameElo": 2026,
    "awayPostgameElo": 2064,
    "excitementIndex": 2.4679018249346374,
    "highlights": "",
    "notes": "SEC Championship",
    "playoff": null
  },
  {
    "id": 401777353,
    "season": 2025,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2025-12-07T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 68214,
    "venueId": 3812,
    "venue": "Lucas Oil Stadium",
    "homeId": 194,
    "homeTeam": "Ohio State",
    "homeClassification": "fbs",
    "homeConference": "Big Ten",
    "homePoints": 10,
    "homeLineScores": [
      7,
      3,
      0,
      0
    ],
    "homePostgameWinProbability": 0.33121785521507263,
    "homePregameElo": 2169,
    "homePostgameElo": 2169,
    "awayId": 84,
    "awayTeam": "Indiana",
    "awayClassification": "fbs",
    "awayConference": "Big Ten",
    "awayPoints": 13,
    "awayLineScores": [
      3,
      3,
      7,
      0
    ],
    "awayPostgameWinProbability": 0.6687821447849274,
    "awayPregameElo": 2191,
    "awayPostgameElo": 2191,
    "excitementIndex": 5.124939123123214,
    "highlights": "",
    "notes": "Big Ten Championship",
    "playoff": null
  },
  {
    "id": 401777328,
    "season": 2025,
    "week": 15,
    "seasonType": "regular",
    "startDate": "2025-12-07T01:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": false,
    "attendance": 41672,
    "venueId": 3628,
    "venue": "Bank of America Stadium",
    "homeId": 258,
    "homeTeam": "Virginia",
    "homeClassification": "fbs",
    "homeConference": "ACC",
    "homePoints": 20,
    "homeLineScores": [
      0,
      7,
      3,
      10,
      0
    ],
    "homePostgameWinProbability": 0.024038726463913918,
    "homePregameElo": 1631,
    "homePostgameElo": 1622,
    "awayId": 150,
    "awayTeam": "Duke",
    "awayClassification": "fbs",
    "awayConference": "ACC",
    "awayPoints": 27,
    "awayLineScores": [
      7,
      7,
      3,
      3,
      7
    ],
    "awayPostgameWinProbability": 0.9759612735360861,
    "awayPregameElo": 1607,
    "awayPostgameElo": 1616,
    "excitementIndex": 7.446460983945154,
    "highlights": "",
    "notes": "ACC Championship",
    "playoff": null
  },
  {
    "id": 401762521,
    "season": 2025,
    "week": 16,
    "seasonType": "regular",
    "startDate": "2025-12-13T20:00:00.000Z",
    "startTimeTBD": false,
    "completed": true,
    "neutralSite": true,
    "conferenceGame": true,
    "attendance": 70936,
    "venueId": 3814,
    "venue": "M&T Bank Stadium",
    "homeId": 2426,
    "homeTeam": "Navy",
    "homeClassification": "fbs",
    "homeConference": "American Athletic",
    "homePoints": 17,
    "homeLineScores": [
      7,
      0,
      3,
      7
    ],
    "homePostgameWinProbability": 0.6679408550262451,
    "homePregameElo": 1525,
    "homePostgameElo": 1527,
    "awayId": 349,
    "awayTeam": "Army",
    "awayClassification": "fbs",
    "awayConference": "American Athletic",
    "awayPoints": 16,
    "awayLineScores": [
      0,
      13,
      3,
      0
    ],
    "awayPostgameWinProbability": 0.3320591449737549,
    "awayPregameElo": 1514,
    "awayPostgameElo": 1512,
    "excitementIndex": 5.784244018596906,
    "highlights": "",
    "notes": null,
    "playoff": null
  }
]